(function() {
  'use strict';

  angular
    .module('app', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize',
      'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap',
      'mwaCore', 'drupalHelper','angularFileUpload','signature', 
      'angular.filter', 'duScroll', 'ng.deviceDetector', 
      'ui.bootstrap.datetimepicker', 'minicolors', 'infinite-scroll']);

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('VaeContenuMenuStandard2018Controller', VaeContenuMenuStandard2018Controller);

  /** @ngInject */
  function VaeContenuMenuStandard2018Controller($log, $scope, $document, $stateParams, ProjetService, EditeBoard, VisuelSolide) {
    var vm = this;

    $document.scrollTop(0);

    /**
     * Declare variables
     */
    vm.ctx = ProjetService.getProjectContext();

    vm.submitted = false;

    vm.board = EditeBoard.getEditBoard();

    vm.solide = VisuelSolide.viewsLoad();

    vm.brief = {};

    vm.choiceFormule = 1; // Formule 1 par défault
    vm.texteChoiceSolide = 'Choix des solides pour la première formule.';

    // Limit of check solid
    vm.limit = 2;
    
    vm.formule2Enabled = false;

    /**
     * Show autre formule option
     */
    vm.sansOption = $stateParams.sansOption ? $stateParams.sansOption : false;
    
    /**
     * Case if menu 2 item capri-sun
     * Hide Price Second Formule
     */
    vm.isCapri = (vm.board.data.state == 'menu-double-pet-2-items-mm'
    || vm.board.data.state == 'menu-double-can-2-items-mm') ? true : false;

    // Save old data to rollback on cancelled
    
    if (angular.isDefined(vm.ctx.project.boards[vm.board.index].brief)){
      vm.brief = angular.copy(vm.ctx.project.boards[vm.board.index].brief);
      if(vm.brief.Formule1.solide) {
        vm.brief.solide1 = {};
        vm.brief.solide1[vm.brief.Formule1.solide.parent] = {};
        vm.brief.solide1[vm.brief.Formule1.solide.parent][vm.brief.Formule1.solide.indexSolide] = {};
        vm.brief.solide1[vm.brief.Formule1.solide.parent][vm.brief.Formule1.solide.indexSolide].name = angular.copy(vm.brief.Formule1.solide.name);
      }

      vm.formule2Enabled = angular.isDefined(vm.brief.Formule2);
      if(vm.brief.Formule2 && vm.brief.Formule2.solide) {
        vm.brief.solide2 = {};
        vm.brief.solide2[vm.brief.Formule2.solide.parent] = {};
        vm.brief.solide2[vm.brief.Formule2.solide.parent][vm.brief.Formule2.solide.indexSolide] = {};      
        vm.brief.solide2[vm.brief.Formule2.solide.parent][vm.brief.Formule2.solide.indexSolide].name = angular.copy(vm.brief.Formule2.solide.name);
      }
    }
    
    /**
     * Enable or disable Formule 2
     */
    vm.toogleFormule2 = function(formule2Enabled) {
      if(formule2Enabled) {
        vm.brief.Formule2 = {};
      } else {
        vm.choiceFormule = 1;
        delete vm.brief.Formule2;
        delete vm.brief.solide2;
      }
    };

    /**
     * Choice to which formule add solide picture
     * @param formule
     */
    vm.switchSolideFormule = function(formule){
      vm.choiceFormule = formule;
      if(formule == 1){
        vm.texteChoiceSolide = 'Choix du solide pour la première formule.';
      }
      if(formule == 2)
        vm.texteChoiceSolide = 'Choix du solide pour la seconde formule.';
    };

    /**
     * onChange, add img chosen
     * @param ele
     * @param parent
     * @param enfant
     * @param index
     */
    vm.solideChange = function(ele, parent, enfant, index){
      if(vm.choiceFormule == 1){
        vm.brief.solide1[parent][index].imageSolide = enfant.field_image_visuel_solide;
        if(angular.isUndefined(vm.brief.Formule1)){
          vm.brief.Formule1 = {solide: {}};
        }
        if(angular.isUndefined(vm.brief.Formule1.solide) && angular.isDefined(vm.brief.Formule1)){
          vm.brief.Formule1.solide = {};
        }
        vm.brief.Formule1.solide = {
          name: vm.brief.solide1[parent][index].name,
          image: vm.brief.solide1[parent][index].imageSolide,
          parent: parent,
          indexSolide: index
        };
      } else if(vm.choiceFormule == 2){
        vm.brief.solide2[parent][index].imageSolide = enfant.field_image_visuel_solide;
        if(angular.isUndefined(vm.brief.Formule2)){
          vm.brief.Formule2 = {solide: {}};
        }
        if(angular.isUndefined(vm.brief.Formule2.solide) && angular.isDefined(vm.brief.Formule2)){
          vm.brief.Formule2.solide = {};
        }
        vm.brief.Formule2.solide = {
          name: vm.brief.solide2[parent][index].name,
          image: vm.brief.solide2[parent][index].imageSolide,
          parent: parent,
          indexSolide: index
        };
      }
    };

    /**
     * Go back to previous state
     * backup data brief
     */
    vm.cancel = function(){
      $scope.$emit('CallpreviousSate', {});
    };

    /**
     * Validation Form
     * @param form
     */
    vm.validate = function(form){
      vm.submitted = true;

      // TODO VERIFICATION NOMBRE DE VISUEL SELECTIONNE
      form.solid1_nok = angular.isUndefined(vm.brief.Formule1) 
        || angular.isUndefined(vm.brief.Formule1.solide);
      form.solid2_nok = angular.isDefined(vm.brief.Formule2) 
        && angular.isUndefined(vm.brief.Formule2.solide);
      if(form.$invalid || form.solid1_nok || form.solid2_nok){
        var errorMenuItems = angular.element('#errorMenu2Items');
        $document.scrollTo(errorMenuItems, 30, 500);
        return;
      }

      // Insert data in brief board
      delete vm.brief.solide1;
      delete vm.brief.solide2;
      vm.ctx.project.boards[vm.board.index].brief = angular.copy(vm.brief);

      $scope.$emit('CallnextState', {});
    };

  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('VaeContenuSimplePet2Controller', VaeContenuSimplePet2Controller);

  /** @ngInject */
  function VaeContenuSimplePet2Controller($log, $scope, $document, ProjetService, EditeBoard, VisuelSolide) {
    var vm = this;

    $document.scrollTop(0);

    /**
     * Declare variables
     */
    vm.submitted = false;

    vm.ctx = ProjetService.getProjectContext();

    vm.board = EditeBoard.getEditBoard();

    vm.solide = VisuelSolide.viewsLoad();

    vm.brief = {};

    vm.labelPrixAutreFormule = '';

    /**
     * Show libelé autre formule
     * according to the menu
     */
    switch (vm.board.data.state){
      case 'menu-simple-pet-2-items':
        vm.labelPrixAutreFormule = 'Prix de la formule avec CAN 33cl';
        break;
      case 'menu-can-2-items-coke':
        vm.labelPrixAutreFormule = 'Prix de la formule avec PET 50cl';
        break;
      case 'menu-can-2-items-mm':
        vm.labelPrixAutreFormule = 'Prix de la formule avec PET 33cl';
        break;
    }

    /**
     * case if menu 2 item capri-sun
     * Hide Price Other Formule
     */
    vm.isCapri = (vm.board.data.state == 'menu-autres-2-items-capri') ? true : false;

    // Save old data to rollback on cancelled
    if (angular.isDefined(vm.ctx.project.boards[vm.board.index].brief)){
      vm.brief = {};
      vm.brief.nomFormule = vm.ctx.project.boards[vm.board.index].brief.nomFormule;
      vm.brief.nomsolide = vm.ctx.project.boards[vm.board.index].brief.nomsolide;
      vm.brief.prixformule = vm.ctx.project.boards[vm.board.index].brief.prixformule;
      vm.brief.prixbarre = vm.ctx.project.boards[vm.board.index].brief.prixbarre;
      vm.brief.prixAutreFormule = vm.ctx.project.boards[vm.board.index].brief.prixAutreFormule;
      vm.brief.nameSolide = vm.ctx.project.boards[vm.board.index].brief.nameSolide;
      vm.brief.imgSolide = vm.ctx.project.boards[vm.board.index].brief.imgSolide;
    }

    /**
     * onChange, add img chosen
     * @param imgTheme
     */
    vm.solideChange = function(imgTheme){
      vm.brief.imgSolide = imgTheme;
    };

    /**
     * Go back to previous state
     * backup data brief
     */
    vm.cancel = function(){
      $scope.$emit('CallpreviousSate', {});
    };

    /**
     * Validation Form
     * @param form
     */
    vm.validate = function(form){
      vm.submitted = true;
      if(form.$invalid){
        var errorMenuItems = angular.element('#errorMenu2Items');
        $document.scrollTo(errorMenuItems, 30, 500);
        return;
      }

      // Insert data in brief board
      vm.ctx.project.boards[vm.board.index].brief = angular.copy(vm.brief);

      $scope.$emit('CallnextState', {});
    };

  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('VaeContenuSimple3Controller', VaeContenuSimple3Controller);

  /** @ngInject */
  function VaeContenuSimple3Controller($log, $scope, $document, $stateParams, ProjetService, EditeBoard, VisuelSolide) {
    var vm = this;

    $document.scrollTop(0);

    vm.submitted = false;

    vm.ctx = ProjetService.getProjectContext();

    vm.brief = {};

    vm.board = EditeBoard.getEditBoard();

    VisuelSolide.viewsLoad().$promise.then(function(data){
      vm.solide = data;
    });

    vm.labelPrixAutreFormule = '';

    // Limit of check solid
    vm.limit = 2;

    /**
     * Init nbr checked solid
     * @type {number}
     */
    vm.checked = 0;
    if(angular.isDefined(vm.ctx.project.boards[vm.board.index].brief)){
      angular.forEach(vm.ctx.project.boards[vm.board.index].brief.solide, function(key){
        var poids = Object.keys(key);
        vm.checked += poids.length;
      });
    }

    /**
     * Show autre formule option
     */
    vm.sansOption = $stateParams.sansOption ? $stateParams.sansOption : false;
    
    /**
     * Show libelé autre formule
     * according to the menu
     */
    switch (vm.board.data.state){
      case 'menu-simple-pet-3-items':
        vm.labelPrixAutreFormule = 'Prix de la formule avec CAN 33cl';
        break;
      case 'menu-can-3-items-coke':
        vm.labelPrixAutreFormule = 'Prix de la formule avec PET 50cl';
        break;
      case 'menu-can-3-items-mm':
        vm.labelPrixAutreFormule = 'Prix de la formule avec PET 33cl';
        break;
    }

    // Save old data to rollback on cancelled
    if (angular.isDefined(vm.ctx.project.boards[vm.board.index].brief)){
      vm.brief = angular.copy(vm.ctx.project.boards[vm.board.index].brief);
    }

    /**
     * onChange, add img chosen
     * @param ele
     * @param parent
     * @param enfant
     * @param index
     */
    vm.solideChange = function(ele, parent, enfant, index){
      if(ele.name != false) {
        vm.brief.solide[parent][index].imageSolide = enfant.field_image_visuel_solide;
        vm.checked++;
        vm.brief.solide[parent][index].numSolide = vm.checked;
      } else if(ele.name == false){
        delete vm.brief.solide[parent][index];
        if(Object.keys(vm.brief.solide[parent]).length == 0){
          delete vm.brief.solide[parent];
        }
        vm.checked--;
      }
    };

    /**
     * Go back to previous state
     * backup data brief
     */
    vm.cancel = function(){
      $scope.$emit('CallpreviousSate', {});
    };

    /**
     * Validation Form
     * @param form
     */
    vm.validate = function(form){
      vm.submitted = true;
      if(form.$invalid || vm.checked < 2){
        var errorFormule = angular.element('#errorFormule');
        $document.scrollTo(errorFormule, 30, 500);
        return;
      }

      // Insert data in brief board
      vm.ctx.project.boards[vm.board.index].brief = angular.copy(vm.brief);

      $scope.$emit('CallnextState', {});
    };

  }
})();
(function(){
  'use strict';

  angular
    .module('app')
    .controller('VaeContenuDoublePet3Controller',VaeContenuDoublePet3Controller);

  /** @ngInject */
  function VaeContenuDoublePet3Controller($log, $scope, $document, ProjetService, EditeBoard, VisuelSolide){
    var vm = this;

    $document.scrollTop(0);

    /**
     * Declare variables
     */
    vm.ctx = ProjetService.getProjectContext();

    vm.submitted = false;

    vm.board = EditeBoard.getEditBoard();

    vm.solide = VisuelSolide.viewsLoad();

    vm.labelPrixAutreFormule = '';

    vm.brief = {};

    vm.checked = vm.checked1 = vm.checked2 = 0;

    vm.choiceFormule = 1; // Formule 1 par défault
    vm.texteChoiceSolide = 'Choix des solides pour la première formule.';

    // Limit of check solid
    vm.limit = 2;

    /**
     * Show libelé autre formule
     * according to the menu
     */
    switch (vm.board.data.state){
      case 'menu-double-pet-3-items-coke':
        vm.labelPrixAutreFormule = 'Prix de la formule avec CAN 33cl';
        break;
      case 'menu-double-can-3-items-coke':
        vm.labelPrixAutreFormule = 'Prix de la formule avec PET 50cl';
        break;
    }

    // Save old data to rollback on cancelled
    if (angular.isDefined(vm.ctx.project.boards[vm.board.index].brief)){
      vm.brief = angular.copy(vm.ctx.project.boards[vm.board.index].brief);
      vm.brief.solide1 = angular.copy(vm.ctx.project.boards[vm.board.index].brief.Formule1.solide);
      vm.brief.solide2 = angular.copy(vm.ctx.project.boards[vm.board.index].brief.Formule2.solide);
    }

    /**
     * Init nbr checked solid
     */
    if(angular.isDefined(vm.ctx.project.boards[vm.board.index].brief)){
      angular.forEach(vm.ctx.project.boards[vm.board.index].brief.solide, function(key){
        var poids = Object.keys(key);
        vm.checked += poids.length;
      });

      if(angular.isDefined(vm.ctx.project.boards[vm.board.index].brief.Formule1)){
        angular.forEach(vm.ctx.project.boards[vm.board.index].brief.Formule1.solide, function(key){
          var poids = Object.keys(key);
          vm.checked1 += poids.length;
        });
      }

      if(angular.isDefined(vm.ctx.project.boards[vm.board.index].brief.Formule2)){
        angular.forEach(vm.ctx.project.boards[vm.board.index].brief.Formule2.solide, function(key){
          var poids = Object.keys(key);
          vm.checked2 += poids.length;
        });
      }

      vm.checked = vm.checked1 + vm.checked2;
    }

    /**
     * Choice to which formule add solide picture
     * @param formule
     */
    vm.switchSolideFormule = function(formule){
      vm.choiceFormule = formule;
      if(formule == 1){
        vm.texteChoiceSolide = 'Choix des solides pour la première formule.';
      }
      if(formule == 2)
        vm.texteChoiceSolide = 'Choix des solides pour la seconde formule.';
    };

    /**
     * Add solide to right Formule
     * @param parent
     * @param imageSolide
     * @param index
     */
    var addToFormule = function(parent, imageSolide, index){
      if(vm.choiceFormule == 1){
        vm.checked1++;
        vm.brief.solide1[parent][index].imageSolide = imageSolide.field_image_visuel_solide;
        vm.brief.solide1[parent][index].numSolide = vm.checked1;
        if(angular.isUndefined(vm.brief.Formule1)){
          vm.brief.Formule1 = {solide: []};
        }
        if(angular.isUndefined(vm.brief.Formule1.solide) && angular.isDefined(vm.brief.Formule1)){
          vm.brief.Formule1.solide = [];
        }
        vm.brief.Formule1.solide = angular.copy(vm.brief.solide1);
      } else if(vm.choiceFormule == 2){
        vm.checked2++;
        vm.brief.solide2[parent][index].imageSolide = imageSolide.field_image_visuel_solide;
        vm.brief.solide2[parent][index].numSolide = vm.checked2;
        if(angular.isUndefined(vm.brief.Formule2)){
          vm.brief.Formule2 = {solide: []};
        }
        if(angular.isUndefined(vm.brief.Formule2.solide) && angular.isDefined(vm.brief.Formule2)){
          vm.brief.Formule2.solide = [];
        }
        vm.brief.Formule2.solide = angular.copy((vm.brief.solide2));
      }
    };

    /**
     * Remove solide from Right Formule
     * @param parent
     * @param index
     */
    var removeToFormule = function(parent, index){
      if(vm.choiceFormule == 1){
        vm.checked1--;
        delete vm.brief.solide1[parent][index];
        if(Object.keys(vm.brief.solide1[parent]).length == 0)
          delete vm.brief.solide1[parent];
        delete vm.brief.Formule1.solide[parent][index];
        if(Object.keys(vm.brief.Formule1.solide[parent]).length == 0)
          delete vm.brief.Formule1.solide[parent];
      } else if(vm.choiceFormule == 2){
        vm.checked2--;
        delete vm.brief.solide2[parent][index];
        if(Object.keys(vm.brief.solide2[parent]).length == 0){
          delete vm.brief.solide2[parent];
        }
        delete vm.brief.Formule2.solide[parent][index];
        if(Object.keys(vm.brief.Formule2.solide[parent]).length == 0)
          delete vm.brief.Formule2.solide[parent];
      }
    };

    /**
     * onChange, add img chosen
     * @param ele
     * @param parent
     * @param enfant
     * @param index
     */
    vm.solideChange = function(ele, parent, enfant, index){
      if(ele.name != false) {
        vm.checked++;
        addToFormule(parent, enfant, index);
      } else if(ele.name == false){
        vm.checked--;
        removeToFormule(parent, index);
      }
    };

    /**
     * Go back to previous state
     * backup data brief
     */
    vm.cancel = function(){
      $scope.$emit('CallpreviousSate', {});
    };

    /**
     * Validation Form
     * @param form
     */
    vm.validate = function(form){
      vm.submitted = true;
      if(form.$invalid || vm.checked < 4){
        var errorMenuItems = angular.element('#errorMenu2Items');
        $document.scrollTo(errorMenuItems, 30, 500);
        return;
      }

      // Insert data in brief board
      delete vm.brief.solide1;
      delete vm.brief.solide2;
      vm.ctx.project.boards[vm.board.index].brief = angular.copy(vm.brief);

      $scope.$emit('CallnextState', {});
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('VaeContenuDoublePet2Controller', VaeContenuDoublePet2Controller);

  /** @ngInject */
  function VaeContenuDoublePet2Controller($log, $scope, $document, $stateParams, ProjetService, EditeBoard, VisuelSolide) {
    var vm = this;

    $document.scrollTop(0);

    /**
     * Declare variables
     */
    vm.ctx = ProjetService.getProjectContext();

    vm.submitted = false;

    vm.board = EditeBoard.getEditBoard();

    vm.solide = VisuelSolide.viewsLoad();

    vm.labelPrixAutreFormule = '';

    vm.brief = {};

    vm.checked = vm.checked1 = vm.checked2 = 0;

    vm.choiceFormule = 1; // Formule 1 par défault
    vm.texteChoiceSolide = 'Choix des solides pour la première formule.';

    // Limit of check solid
    vm.limit = 2;

    /**
     * Show autre formule option
     */
    vm.sansOption = $stateParams.sansOption ? $stateParams.sansOption : false;
    
    /**
     * Show libelé autre formule
     * according to the menu
     */
    switch (vm.board.data.state){
      case 'menu-double-pet-2-items-coke':
        vm.labelPrixAutreFormule = 'Prix de la formule avec CAN 33cl';
        break;
      case 'menu-double-can-2-items-coke':
        vm.labelPrixAutreFormule = 'Prix de la formule avec PET 50cl';
        break;
      case 'menu-double-pet-2-items-mm':
        vm.labelPrixAutreFormule = 'Prix de la formule avec CAN 33cl';
        break;
      case 'menu-double-can-2-items-mm':
        vm.labelPrixAutreFormule = 'Prix de la formule avec PET 33cl';
        break;
    }

    /**
     * Case if menu 2 item capri-sun
     * Hide Price Second Formule
     */
    vm.isCapri = (vm.board.data.state == 'menu-double-pet-2-items-mm'
    || vm.board.data.state == 'menu-double-can-2-items-mm') ? true : false;

    // Save old data to rollback on cancelled
    if (angular.isDefined(vm.ctx.project.boards[vm.board.index].brief)){
      vm.brief = angular.copy(vm.ctx.project.boards[vm.board.index].brief);
      vm.brief.solide1 = {};
      vm.brief.solide1[vm.brief.Formule1.solide.parent] = {};
      vm.brief.solide1[vm.brief.Formule1.solide.parent][vm.brief.Formule1.solide.indexSolide] = {};

      vm.brief.solide2 = {};
      vm.brief.solide2[vm.brief.Formule2.solide.parent] = {};
      vm.brief.solide2[vm.brief.Formule2.solide.parent][vm.brief.Formule2.solide.indexSolide] = {};

      vm.brief.solide1[vm.brief.Formule1.solide.parent][vm.brief.Formule1.solide.indexSolide].name = angular.copy(vm.brief.Formule1.solide.name);
      vm.brief.solide2[vm.brief.Formule2.solide.parent][vm.brief.Formule2.solide.indexSolide].name = angular.copy(vm.brief.Formule2.solide.name);
    }

    /**
     * Init nbr checked solid
     */
    if(angular.isDefined(vm.ctx.project.boards[vm.board.index].brief)){
      if(angular.isDefined(vm.ctx.project.boards[vm.board.index].brief.Formule1)){
        vm.checked += Object.keys(vm.ctx.project.boards[vm.board.index].brief.Formule1.solide).length;
      }

      if(angular.isDefined(vm.ctx.project.boards[vm.board.index].brief.Formule2)) {
        vm.checked += Object.keys(vm.ctx.project.boards[vm.board.index].brief.Formule2.solide).length;
      }
    }

    //$log.debug(vm.checked);

    /**
     * Choice to which formule add solide picture
     * @param formule
     */
    vm.switchSolideFormule = function(formule){
      vm.choiceFormule = formule;
      if(formule == 1){
        vm.texteChoiceSolide = 'Choix du solide pour la première formule.';
      }
      if(formule == 2)
        vm.texteChoiceSolide = 'Choix du solide pour la seconde formule.';
    };

    /**
     * onChange, add img chosen
     * @param ele
     * @param parent
     * @param enfant
     * @param index
     */
    vm.solideChange = function(ele, parent, enfant, index){
      if(vm.choiceFormule == 1){
        vm.brief.solide1[parent][index].imageSolide = enfant.field_image_visuel_solide;
        if(angular.isUndefined(vm.brief.Formule1)){
          vm.brief.Formule1 = {solide: {}};
        }
        if(angular.isUndefined(vm.brief.Formule1.solide) && angular.isDefined(vm.brief.Formule1)){
          vm.brief.Formule1.solide = {};
        }
        vm.brief.Formule1.solide = {
          name: vm.brief.solide1[parent][index].name,
          image: vm.brief.solide1[parent][index].imageSolide,
          parent: parent,
          indexSolide: index
        };
      } else if(vm.choiceFormule == 2){
        vm.brief.solide2[parent][index].imageSolide = enfant.field_image_visuel_solide;
        if(angular.isUndefined(vm.brief.Formule2)){
          vm.brief.Formule2 = {solide: {}};
        }
        if(angular.isUndefined(vm.brief.Formule2.solide) && angular.isDefined(vm.brief.Formule2)){
          vm.brief.Formule2.solide = {};
        }
        vm.brief.Formule2.solide = {
          name: vm.brief.solide2[parent][index].name,
          image: vm.brief.solide2[parent][index].imageSolide,
          parent: parent,
          indexSolide: index
        };
      }
      //$log.debug(vm.checked);
    };

    /**
     * Go back to previous state
     * backup data brief
     */
    vm.cancel = function(){
      $scope.$emit('CallpreviousSate', {});
    };

    /**
     * Validation Form
     * @param form
     */
    vm.validate = function(form){
      vm.submitted = true;
      if(angular.isDefined(vm.brief.solide1))
        vm.checked = Object.keys(vm.brief.solide1).length;
      if(angular.isDefined(vm.brief.solide2))
        vm.checked += Object.keys(vm.brief.solide2).length;

      if(form.$invalid || vm.checked < 2){
        var errorMenuItems = angular.element('#errorMenu2Items');
        $document.scrollTo(errorMenuItems, 30, 500);
        return;
      }

      // Insert data in brief board
      delete vm.brief.solide1;
      delete vm.brief.solide2;
      vm.ctx.project.boards[vm.board.index].brief = angular.copy(vm.brief);

      $scope.$emit('CallnextState', {});
    };

  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('VaeContenuPricelistController', VaeContenuPricelistController);

  /** @ngInject */
  function VaeContenuPricelistController($log, $scope, $uibModal, $document, $window, ProjetService, EditeBoard, AnnotationPopin, FilesProjecttService) {
    var vm = this;
    $document.scrollTop(0);

    vm.submitted = vm.errorPricelist = false;

    // get Project
    vm.ctx = ProjetService.getProjectContext();

    // Init var brief
    vm.brief = {};

    // get Select Board to Edit
    vm.board = EditeBoard.getEditBoard();

    vm.file_type = 'photo_pricelist';
    vm.uploader = vm.ctx.getUploader(vm.file_type); // get Uploader Project
    //vm.uploader.queueLimit = 1; Limit number File to Upload

    /**
     * Annotation Photo Vars
     * @type {null}
     */
    vm.file = null;
    vm.fileSrc = null;
    var fileNameAnnotate = ''; // Filename to annotate
    var arraySrcFile = {};

    // Save old data to rollback on cancelled
    if (angular.isDefined(vm.ctx.project.boards[vm.board.index].brief)){
      vm.brief = {
        texte: vm.ctx.project.boards[vm.board.index].brief.texte,
        photo: angular.copy(vm.ctx.project.boards[vm.board.index].brief.photo)
      };
      vm.hasPhoto = false;
      if(vm.ctx.project.boards[vm.board.index].brief.photo != undefined)
        vm.hasPhoto = Object.keys(vm.ctx.project.boards[vm.board.index].brief.photo).length > 0 ? true : false;
    }

    /**
     * Fonction Annotation
     */
    $scope.$watch('main.file', function () {
      $log.debug(vm.file);
      if (vm.file) {
        vm.fileSrc = ($window.URL || $window.webkitURL).createObjectURL(vm.file);
        AnnotationPopin.open(vm.fileSrc, onAnnotationPopinClosed);
      } else {
        vm.fileSrc = null;
      }
      $log.debug(vm.fileSrc);
    });

    // Get files Project

    if(angular.isDefined(vm.ctx.project.boards[vm.board.index].brief) && angular.isDefined(vm.ctx.project.boards[vm.board.index].brief.photo) && Object.keys(vm.ctx.project.boards[vm.board.index].brief.photo).length > 0){
      FilesProjecttService.get({id: vm.ctx.project._id.$oid})
        .$promise.then(function (result) {
          vm.filesProject = result;
        });
    }

    var onAnnotationPopinClosed = function (updatedAnnotations) {
      //$log.debug('onAnnotationPopinClosed()', updatedAnnotations);
      var fileName;
      // A la fermeture de la popin, on ajoute les annotations au projet
      if(fileNameAnnotate != ''){
        fileName = fileNameAnnotate;
        fileNameAnnotate = '';
      }
      else{
        fileName = vm.uploader.queue[vm.uploader.queue.length - 1].file.firtsName;
        arraySrcFile[fileName] = {
          fileSrc: vm.fileSrc
        };
      }

      vm.brief.photo[fileName].anno = updatedAnnotations;
    };

    /**
     * Open popin to annotate Image
     * @param file: file from service files project
     */
    vm.annotate = function(file, k){
      var keep = true;
      var annotations = getAnnotations(file);
      if(angular.isDefined(arraySrcFile[k]) && arraySrcFile[k].fileSrc != ''){
        AnnotationPopin.open(vm.fileSrc, onAnnotationPopinClosed, annotations);
      } else {
        angular.forEach(vm.filesProject, function(photo){
          if(keep){
            var test = photo.filename.replace('photo_pricelist_','');
            if(test == file.name){
              fileNameAnnotate = k;
              if (photo.url != null) {
                AnnotationPopin.open(photo.url, onAnnotationPopinClosed, annotations);
              }
              keep = false;
            }
          }
        });
      }
    };

    /**
     * Return list anno photo
     * @param photo
     * @returns {Array}
     */
    var getAnnotations = function(photo){
      var arrayAnno = [];
      angular.forEach(photo.anno, function(annot){
        arrayAnno.push(annot);
      });
      return arrayAnno;
    };

    /**
     * Modifier Modification carte existante
     * @param photo
     */
    vm.modifCarte = function (photo){
      var modalModifPhoto = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'modifPhoto.html',
        controller: ['$uibModalInstance', 'photo', modifPhoto],
        controllerAs: 'vm',
        resolve:{
          photo: function(){
            return photo;
          }
        }
      });

      // Si on valide, on remplace les anciennes modification par les nouvelles
      modalModifPhoto.result.then(function(result){
        photo.texte = result;
      });
    };

    /**
     * Remove photo pricelist
     * @param index
     * @param item
     */
    vm.deletePhoto = function (index, item) {
      var modalDelePhoto = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'confirmDelePhoto.html'
      });

      modalDelePhoto.result.then(function () {
        item.remove(); // Remove from Uploader
        delete vm.brief.photo[item.file.firtsName]; // remove in data brief
      });
    };

    /**
     * Save brief Board
     */
    vm.validate = function () {
      vm.submitted = true;
      if ((angular.isUndefined(vm.brief.texte) || vm.brief.texte == '') && (angular.isUndefined(vm.brief.photo) || Object.keys(vm.brief.photo).length == 0)) {
        vm.errorPricelist = true;
        var error = angular.element('#errorPriceList');
        $document.scrollTo(error, 30, 500);
        return;
      }

      vm.ctx.project.boards[vm.board.index].brief = vm.brief;

      vm.errorPricelist = false;
      $scope.$emit('CallnextState', {});
    };

    /**
     * Go back to previous state
     * backup data brief
     */
    vm.cancel = function(){
      // Delete brief if no data create
      if(vm.brief.texte == '' && Object.keys(vm.brief.photo).length == 0){
        delete vm.brief;
      }

      // Delete uploader queue if Picture added
      if(angular.isDefined(vm.brief.photo) && Object.keys(vm.brief.photo).length != 0){
        vm.uploader.clearQueue();
      }

      $scope.$emit('CallpreviousSate', {});
    };
  }

  /** @ngInject */
  function modifPhoto($uibModalInstance, photo){
    var vm = this;

    // On récupère les modifs dans une variable
    vm.photoModif = photo.texte;

    // Lors de la validation, on récupère les modifications
    // Pour quelles remplace les anciennes
    vm.validate = function(){
      $uibModalInstance.close(vm.photoModif);
    };
  }

})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('VaeContenuGammePrixController', VaeContenuGammePrixController);

  /** @ngInject */
  function VaeContenuGammePrixController($log, $scope, $state, $document, $uibModal, ProjetService, EditeBoard, PrixGammeBoissons) {
    var vm = this;
    $document.scrollTop(0);

    vm.submitted = vm.btnLinkBoissons = vm.error = false;

    // Get Project
    vm.ctx = ProjetService.getProjectContext();

    // Get Board to Edit
    vm.board = EditeBoard.getEditBoard();

    // Save old data to rollback on cancelled
    if (angular.isDefined(vm.ctx.project.boards[vm.board.index].brief)){
      vm.brief = new Array();
      vm.brief = angular.copy(vm.ctx.project.boards[vm.board.index].brief);
    }

    // Init brief gamme
    vm.editedBoissons = PrixGammeBoissons.getPrixGammeBoissons();
    if (vm.editedBoissons != null) {
      vm.brief = vm.editedBoissons.prix;
      PrixGammeBoissons.cleanPrixGammeBoissons();
    } else if (angular.isUndefined(vm.ctx.project.boards[vm.board.index].brief)) {
      vm.brief = new Array();
      vm.brief.push({
        prix: null,
        boissons: {}
      });
    }

    /**
     * Show BTN or list boisssons
     * @param index
     * @returns {boolean}
     */
    vm.hasBoissons = function (index) {
      return Object.keys(vm.brief[index].boissons).length != 0;
    };

    /**
     * Keep last Zero float
     * @param prix
     */
    /*vm.roundFloat = function(prix){
      if(prix !== null);
        prix = prix.toFixed(2);
    };
*/
    /**
     * Link to associate drinks on price
     * @param index
     * @param prix
     */
    vm.linkBoisson = function (form, index, gamme) {
      vm.btnLinkBoissons = true;
      // if Not Price enter
      if (form.$invalid) {
        return;
      }
      PrixGammeBoissons.setPrixGammeBoissoons(index, gamme);
      $state.go($state.params.editState);
    };

    /**
     * Add Gamme Price
     */
    vm.addPrix = function () {
      if(angular.isDefined(vm.brief)){
        vm.brief.push({
          prix: null,
          boissons: {}
        })
      } else {
        vm.brief = [];
        vm.brief.push({
          prix: null,
          boissons: {}
        })
      }
    };

    /**
     * Delete gamme Price
     * @param index
     */
    vm.deletePrix = function (index) {
      var modalDelePrix = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'confirmDelePrix.html'
      });

      modalDelePrix.result.then(function(){
        vm.brief.splice(index, 1);
        // If no more price, delete brief
        if(vm.brief.length == 0)
          delete vm.brief;
      });
    };

    /**
     * Validate Brief Gamme
     * @param form
     */
    vm.validate = function () {
      vm.submitted = true;

      // Check if each price has boissons
      angular.forEach(vm.brief, function (data) {
        if(!vm.error) {
          if (Object.keys(data.boissons).length == 0) {
            vm.error = true;
            var errorPrix = angular.element('#errorPrix');
            $document.scrollTo(errorPrix, 30, 500);
            return;
          }
        }
      });

      // No error, get to nextstate and save project
      if(!vm.error){
        vm.ctx.project.boards[vm.board.index].brief = angular.copy(vm.brief);
        $scope.$emit('CallnextState', {});
      }
    };

    /**
     * Cancel, restaure value
     * and go to previous state
     */
    vm.cancel = function(){
      delete vm.brief;
      $scope.$emit('CallpreviousSate', {});
    };
  }

})();
(function(){
  'use strict';

  angular
    .module('app')
    .controller('VaeContenuGammeBoissonsController',VaeContenuGammeBoissonsController);

  /** @ngInject */
  function VaeContenuGammeBoissonsController($log, $document, $state, PrixGammeBoissons, EditeBoard, ProjetService, GammeService){
    var vm = this;
    $document.scrollTop(0);

    vm.submitted = false;

    vm.nbrChecked = 0;

    vm.ctx = ProjetService.getProjectContext();

    vm.board = EditeBoard.getEditBoard();

    /**
     * Load list gamme boissons
     */
    GammeService.viewsLoad().$promise.then(function(data){
      vm.gammes = data.filter(function(itm){
        if (!itm.field_disponibilite.split(", ")) {
          return false;
        }
        if(!itm.field_disponibilite.split(", ").includes(vm.ctx.project.typeProjet)) {
          return false;
        }
        if(itm.field_gamme_format_boissons.indexOf('IVC') == -1
        && itm.field_gamme_format_boissons.indexOf('IVP') == -1){
          return true;
        }
        return false;
      });
    });

    /**
     * Get price to edit
     */
    vm.prixGamme = PrixGammeBoissons.getPrixGammeBoissons();
    vm.savePrixGamme = angular.copy(vm.prixGamme);

    /**
     * Init nbrChecked variable
     */
    if(angular.isDefined(vm.prixGamme.prix[vm.prixGamme.index].boissons)) {
      angular.forEach(vm.prixGamme.prix[vm.prixGamme.index].boissons, function (key) {
        var lenght = Object.keys(key);
        vm.nbrChecked += lenght.length;
      });
    }

    /**
     * Onchange increment nbr boissons
     * if uncheck, remove boissons from array boissons
     * @param ele
     * @param parent
     * @param index
     */
    vm.onChangeBoissons = function (ele, parent, item, index) {
      if (ele[index].name != false) {
        ele[index].image = item.field_gamme_image_boissons;
        vm.nbrChecked++;
      } else if (ele[index].name == false) {
        // Delete item from Object array
        delete vm.savePrixGamme.prix[vm.savePrixGamme.index].boissons[parent][index];
        if(Object.keys(vm.savePrixGamme.prix[vm.savePrixGamme.index].boissons[parent]).length == 0)
          delete vm.savePrixGamme.prix[vm.savePrixGamme.index].boissons[parent];
        vm.nbrChecked--;
      }
    };

    /**
     * Validate boissons Prix
     * and Go back to Gamme Prix
     */
    vm.validate = function(){
      vm.submitted = true;

      if(vm.nbrChecked < 1){
        return;
      }

      PrixGammeBoissons.setPrixGammeBoissoons(vm.savePrixGamme.index, vm.savePrixGamme.prix);
      $state.go($state.params.nextState);
    };

    /**
     * Remove boissons
     * and go back to
     */
    vm.canceled = function(){
      $state.go($state.params.previousState);
    };
  }
})();
(function(){
  'use strict';

  angular
    .module('app')
    .controller('VaeFormatController', VaeFormatController);

  /** @ngInject */
  function VaeFormatController($log, $scope, $document, $uibModal, ProjetService){
    var vm = this;
    $document.scrollTop(0);

    vm.submitted = false;
    vm.NB_MAX_STOPTROTTOIR = 2;

    /**
     * Récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();

    /**
     * Liste format boards
     */
    vm.formatBoards = [];
    if(vm.ctx.project.type == 'Caissons Lumineux')
      vm.formatBoards = ['Horizontal 40x60cm','Vertical 60x40cm'];
    if(vm.ctx.project.type == 'Boards PVC')
      vm.formatBoards = ['Horizontal 40x60cm','Vertical 60x40cm','Horizontal 60x90cm','Vertical 90x60cm','Carré 50x50cm'];
    if(vm.ctx.project.type == 'Digital')
        vm.formatBoards = ['16:9 horizontal','16:9 vertical'];

    vm.formatStopTrottoirs = ['75x47 cm (bois)', '42x59,4 cm (métal)'];

      // Calcule nbr board PET and Gamme/Pricelist
    var reglesChoiceBoard = function(boards){
      vm.boardPET = vm.boardGL = 0;
      angular.forEach(boards, function(key){
        if(key.type.indexOf('PET') != -1){
          vm.boardPET++;
        }
        if(key.type.indexOf('Gamme') != -1){
          vm.boardGL++;
        }
      });
    };

    reglesChoiceBoard(vm.ctx.project.boards);

    /**
     * Delete Board
     * @param index
     * @param board
     */
    vm.deleteBoard = function(index){
      var alert = angular.element('#alert-message');
      // controle des règles de sélection des boards: Nbr Boards
      if(vm.ctx.project.boards.length == 3){
        vm.alert = {
          type: 'danger',
          msg: 'Attention, vous devez avoir au minimum 3 boards. Avec cette supression, vous ne respectez pas les règles de gestion.'
        };
        $document.scrollTo(alert, 30, 500);
        return;
      }

      // Controle si board Gamme ou Pricelist
      var type = vm.ctx.project.boards[index].type;
      if((type.indexOf('PET') != -1 && (vm.boardPET - 1) == 0)){
        vm.alert = {
          type: 'danger',
          msg: 'Attention, vous devez avoir au moins un board de type Menu PET. Avec cette supression, vous ne respectez pas les règles de gestion.'
        };
        $document.scrollTo(alert, 30, 500);
        return;
      }

      if((type.indexOf('Gamme') != -1 && (vm.boardGL - 1) == 0)){
        vm.alert = {
          type: 'danger',
          msg: 'Attention, vous devez avoir au moins un board de type Gamme ou Pricelist. Avec cette supression, vous ne respectez pas les règles de gestion.'
        };
        $document.scrollTo(alert, 30, 500);
        return;
      }

      var modalDeleBoard = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'confirmDeleBoard.html'
      });

      modalDeleBoard.result.then(function(){
        delete vm.ctx.project.boards[index];
        vm.ctx.project.boards.splice(index, 1);
        // recalcule le nombre de board PEt et Gamme/Pricelis
        reglesChoiceBoard(vm.ctx.project.boards);
      });
    };

    /**
     * Close arte message
     */
    vm.closeAlert = function() {
      vm.alert = {};
    };

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.validate = function(form){
      vm.submitted = true;
      if(form.$invalid || vm.nbStopTrottoir() > vm.NB_MAX_STOPTROTTOIR){
        var errorValidation = angular.element('#errorFormat');
        $document.scrollTo(errorValidation, 30, 500);
        return;
      }
      $scope.$emit('CallnextState', {});
    };

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.save = function(form){
      vm.submitted = true;
      if(form.$invalid || vm.nbStopTrottoir() > vm.NB_MAX_STOPTROTTOIR){
        var errorValidation = angular.element('#errorFormat');
        $document.scrollTo(errorValidation, 30, 500);
        return;
      }
      $scope.$emit('UpdateProject', {});
    }

    /**
     * Callback for optionStopTrottoir checkbox
     * @param {*} value
     * @param {*} board
     */
    vm.changeOptionStopTrottoir = function (value, board) {
      if(!value) {
        delete board.formatStopTrottoir;
      }
    }

    /**
     * Return number of board with option StopTrottoir enabled.
     */
    vm.nbStopTrottoir = function() {
      var result = 0;
      angular.forEach(vm.ctx.project.boards, function(board) {
        if(board.optionStopTrottoir) {
          result++
        }
      });
      return result;
    }
  }

})();
(function(){
  'use strict';

  angular
    .module('app')
    .controller('VaeChoixBoardsController', VaeChoixBoardsController);

  /** @ngInject */
  function VaeChoixBoardsController($log, $scope, $document, ProjetService, BoardsService, $uibModal){
    var vm = this;
    vm.loading = true;
    $document.scrollTop(0);

    vm.submitted = vm.error = false;

    /**
     * Get All Boards and do some actions
     */
    BoardsService.viewsLoad().$promise.then(function(result){
      vm.boards = result;
      vm.boardsChoice = {};
      /**
       * Récupère le current projet en cours de création
       */
      vm.ctx = ProjetService.getProjectContext();

      /**
       * On créer les propiétés qui si elles ne sont pas définit. Si elle le sont
       * ça veut dire qu'elles contiennent des données et elle seront chargées dans le formulaire
       */
      if (angular.isUndefined(vm.ctx.project.boards)) {
        vm.ctx.project.boards = [];
      }

      vm.countBoard = vm.ctx.project.boards.length;

      vm.boardPET = vm.boardGL = 0;

      vm.boardToAdd = [];

      vm.tabAccordion = new Array(); // List accordion to open or not

      if(vm.ctx.project.boards.length == 0 || angular.isUndefined(vm.ctx.project.boards)){
        angular.forEach(result, function(key){
          vm.boardsChoice[key.name] = {
            quantite: 0,
            orgQuantite: 0
          };
        });
      } else {
        vm.oldQuantite = vm.ctx.project.boards.length;
        angular.forEach(vm.ctx.project.boards, function(key){
          if(angular.isUndefined(vm.boardsChoice[key.name])){
            vm.boardsChoice[key.name] = {
              quantite: 0,
              orgQuantite: 0
            };
          }
          vm.boardsChoice[key.name].quantite += 1;
          vm.boardsChoice[key.name].orgQuantite += 1;
          if(key.type.indexOf('PET') != -1){
            vm.boardPET++;
          }
					if(key.type.indexOf('Gamme') != -1){
						vm.boardGL++;
					}
        });
        angular.forEach(result, function(key){
          if(angular.isUndefined(vm.boardsChoice[key.name])) {
            vm.boardsChoice[key.name] = {
              quantite: 0,
              orgQuantite: 0
            };
          }
        });
        vm.oldBoardsChoice = angular.copy(vm.boardsChoice);
      }
      vm.loading = false;
    });

    /**
     * Zoom Boards img
     * @param img
     */
    vm.zoomBoard = function (img, themeName) {
      /** Open Popin Alert **/
      $uibModal.open({
        animation: true,
        backdrop: 'static',
        backdropClass: 'zoom-modal-backdrop',
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        windowTopClass: 'modal-zoom-board',
        templateUrl: 'zoomBoards.html',
        controller: ['$uibModalInstance', 'imgBoard', 'boardName', zoomBoardsModal],
        controllerAs: 'vm',
        resolve: {
          imgBoard: function () {
            return img;
          },
          boardName: function () {
            return themeName;
          }
        }
      });
    };

    /**
     * Return texte catégorie Board
     * @param parent
     */
    vm.textCategorieBoard = function (parent){
      var text = '';
      var textAdded = 'avec';
      var position;

      if(parent.indexOf('PET') != -1){
        position = parent.indexOf('PET');
        text = [parent.slice(0, position), textAdded, parent.slice(position - 1)].join('');
        return text;
      }

      if(parent.indexOf('CAN') != -1){
        position = parent.indexOf('CAN');
        text = [parent.slice(0, position), textAdded, parent.slice(position - 1)].join('');
        return text;
      }

      if(parent.indexOf('CAN') == -1 && parent.indexOf('PET') == -1){
        if(parent.indexOf('Gamme') != -1)
          return parent+' (obligatoire)';
        return parent;
      }
    };

    /**
     * Open accordion on init page
     * @param index
     */
    vm.isOpen = function(index){
      if(index < 2)
        vm.tabAccordion[index] = true;
      else
        vm.tabAccordion[index] = false;
    };

    /**
     * Increment le nombre de boards
     * @param quantite
     */
    vm.increment = function(board){
      if(vm.boardsChoice[board.name].quantite == 0 || (angular.isDefined(vm.oldBoardsChoice))){
        vm.boardToAdd[board.name] = {
          type: board.field_type_de_board,
          image: board.field_image_board,
          stateNameBrief: board.field_state_name_brief
        };
      }

      // Check if Board is PET type ou Gamme/Pricelist
      if(board.field_type_de_board.indexOf('PET') != -1){
        vm.boardPET++;
      }
			if(board.field_type_de_board.indexOf('Gamme') != -1){
				vm.boardGL++;
			}

      // Increment
      vm.boardsChoice[board.name].quantite += 1;

      vm.countBoard++;
    };

    /**
     * Decrement le nombre de boards
     * @param quantite
     */
    vm.decrement = function(board){
      // Return if quantite == 0 or undefined or is old number boards
      if(angular.isUndefined(vm.boardsChoice[board.name])
        || vm.boardsChoice[board.name].quantite == 0
        || (angular.isDefined(vm.oldBoardsChoice) && (vm.oldBoardsChoice[board.name].quantite == vm.boardsChoice[board.name].quantite)))
        return;

      // Check if Board is PET type or Gamme/Pricelist
      if(board.field_type_de_board.indexOf('PET') != -1){
        vm.boardPET--;
      }
			if(board.field_type_de_board.indexOf('Gamme') != -1){
				vm.boardGL--;
			}

      // Decrement
      vm.boardsChoice[board.name].quantite -= 1;
      vm.countBoard--;
    };

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.validate = function(){
      vm.submitted = true;

      if(vm.countBoard < 3 || vm.boardPET < 1 || vm.boardGL < 1){
        var errorTemplate = angular.element('#regle-board');
        $document.scrollTo(errorTemplate, 30, 500);
        return;
      }
      if (angular.isUndefined(vm.ctx.project.boards)) {
        vm.ctx.project.boards = [];
      }

			// Si nbr noiveau board egal ancien nbr board, on retourne sur la page format
      if(vm.countBoard == vm.oldQuantite){
        $scope.$emit('CallnextState', {});
        return;
      }

			// Ajout des boards au projet en cours
      angular.forEach(vm.boardsChoice, function(key, value){
				// Si quantite board = 0 ou Ancien quantite = nouvel quantite
				// skip
        if(key.quantite == 0 || (key.quantite == key.orgQuantite))
          return;

        var addItem = (key.quantite - key.orgQuantite);
        for (var i = 1; i <= addItem; i++){
          vm.ctx.project.boards.push({
            type: vm.boardToAdd[value].type,
            name: value,
            displayName: value+' - '+(i + key.orgQuantite),
            state: vm.boardToAdd[value].stateNameBrief,
            imageBoard: vm.boardToAdd[value].image
          });
        }
      });

      $scope.$emit('CallnextState', {});
    };

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.save = function(form){
      vm.submitted = true;
      if(form.$invalid)
        return;
      $scope.$emit('UpdateProject', {});
    };
  }

  /** @ngInject */
  function zoomBoardsModal($uibModalInstance, imgBoard, boardName) {
    var vm = this;

    vm.img = imgBoard;
    vm.boardName = boardName;
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('VaeIdProjetController', VaeIdProjetController);

  /** @ngInject */
  function VaeIdProjetController($log, $scope, $document, ProjetService) {
    var vm = this;
    $document.scrollTop(0);

    /**
     * récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();

    /**
     * Go to previousState
     */
    vm.previousState = function(){
      $scope.$emit('CallpreviousSate', {});
    };

    /**
     * Go to nextState
     */
    vm.validate = function(){
      $scope.$emit('CallnextState', {});
    };

    /**
     * Go to nextState
     */
    vm.save = function(){
      $scope.$emit('UpdateProject', {});
    };

  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('SmEditionUpdateController', SmEditionUpdateController);

  /** @ngInject */
  function SmEditionUpdateController($log, $document, $scope, $state, 
      ProjetService, FilesProjectService) {
    var vm = this;
    vm.submitted = false;

    // edited support
    vm.support = null
    
    // Editied creation (clone of support's one)

    $document.scrollTop(0);

    /**
     * Récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);
    vm.uploader = vm.ctx.getUploaderV2();

    function init() {
      vm.support = vm.ctx.project.supports[$state.params.index];
      vm.creation = angular.merge({}, vm.support.creation);       

      FilesProjectService.get({id: vm.ctx.project._id.$oid})
        .$promise.then(function (result) {
          vm.filesProject = result;
        });
    }

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.validate = function () {
      vm.support.creation = vm.creation;
      $scope.$emit('CallnextState', {});      
    };

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.save = function () {
      vm.support.creation = vm.creation;
      $scope.$emit('UpdateProject', {});
    };
  }

})();
(function(){
  'use strict';

  angular
    .module('app')
    .controller('SmEditionController', SmEditionController);

  /** @ngInject */
  function SmEditionController($log, $document, $scope, $state, ProjetService, Alert){
    var vm = this;
    vm.submitted = false;

    $document.scrollTop(0);

    /**
     * Récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      
    }
    
    vm.isValidCreation = function(support) {
      return angular.isObject(support.creation) && 
        Object.keys(support.creation).length > 0;
    };
    
    vm.editCreation = function(support, index) {
      $state.go('sm.contenu.edition-update', {'index': index});
    };
    
    function isAllSupportValid() {
      var i=0;       
      for(i=0; i<vm.ctx.project.supports.length; ++i) {
        if(!vm.isValidCreation(vm.ctx.project.supports[i])) {
          return false;
        }
      }
      return true;
    }

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.validate = function(){
      vm.submitted = true;
      if(!isAllSupportValid()) {
        Alert.show("Formulaire invalide. Veuillez vérifier les données entourées en jaune.");
        return;
      }
      $scope.$emit('CallnextState', {});
    };

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.save = function(){
      vm.submitted = true;
      if(!isAllSupportValid()) {
        Alert.show("Formulaire invalide. Veuillez vérifier les données entourées en jaune.");
        return;
      }
      $scope.$emit('UpdateProject', {});
    };
  }

})();
(function(){
  'use strict';

  angular
    .module('app')
    .controller('SmGammeSelectController', SmGammeSelectController);

  /** @ngInject */
  function SmGammeSelectController($log, $state, $scope, $document, $uibModal, ProjetService){
    var vm = this;
    vm.submitted = false;
    
    // Support to attach boissons.
    vm.support = null;

    $document.scrollTop(0);

    /**
     * Récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      if (angular.isDefined(vm.ctx.project.supports)) {
        vm.support = vm.ctx.project.supports[$state.params.index];
        vm.boissonsObj = angular.extend({}, vm.support.boissons);
      } else {
        vm.boissonsObj = [];
      }
    }
    
    /*vm.onBoissonAdded = function(addedBoisson, boissonModel, boissonType, addedIndex) {
      $log.debug("onBoissonAdded()");
      $log.debug(" - addedBoisson:", addedBoisson);
      $log.debug(" - boissonModel:", boissonModel);
      $log.debug(" - boissonType:", boissonType);
      $log.debug(" - addedIndex:", addedIndex);
      addedBoisson.image = boissonModel.field_gamme_image_boissons;
    };
    vm.onBoissonRemoved = function(boissonModel, boissonType, removedIndex) {
      $log.debug("onBoissonRemoved()");
      $log.debug(" - boissonModel:", boissonModel);
      $log.debug(" - boissonType:", boissonType);
      $log.debug(" - removedIndex:", removedIndex);
    };*/
    
    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.validate = function(){
      vm.submitted = true;
      vm.support.boissons = vm.boissonsObj;

      if(vm.ctx.project.supports.length <= 1) {
        // No applyToAllSupport modal if only one support.
        goNextState();
        return ;
      }
      var modal = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'applyToAllSupport.html'
      });

      modal.result.then(function(){
        // Confirm
        angular.forEach(vm.ctx.project.supports, function(cSupport) {
          cSupport.boissons = vm.boissonsObj;
          cSupport.isGamme = true;
        });
        goNextState();
      }, function() {
        // Cancel        
        goNextState()
      });
    };

    function goNextState() {
      $scope.$emit('CallnextState', {});
    }
  }

})();
(function(){
  'use strict';

  angular
    .module('app')
    .controller('SmGammeController', SmGammeController);

  /** @ngInject */
  function SmGammeController($log, $document, $scope, $state, ProjetService, Alert){
    var vm = this;
    vm.submitted = false;

    $document.scrollTop(0);

    /**
     * Récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      
    }
    
    /**
     * Callback when isGamme is changed in support     
     */
    vm.changeIsGamme = function(support, index) {
     if(support.isGamme) {
       support.boissons = {};
       $state.go('sm.contenu.gamme-select', {'index': index});
     } else {
       delete support.boissons;
     }
    };
    
    vm.hasBoissons = function(support) {
      var hasBoisson = angular.isObject(support.boissons) && 
          Object.keys(support.boissons).length > 0;
        
      // Reset isGamme if needed
      if(support.isGamme && !hasBoisson) {
        delete support.isGamme;
      }
        
      return hasBoisson;
    };
    
    /**
     * Reset support boissons
     */
    vm.cleanBoissons = function(support) {
      delete support.boissons;
      support.isGamme = false;
    };
    
    /**
     * 
     */
    vm.editGamme = function(support, index) {
      $state.go('sm.contenu.gamme-select', {'index': index});
    }

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.validate = function(form){
      vm.submitted = true;
      vm.submitted = true;
      if(form.$invalid){
        Alert.show("Formulaire invalide. Veuillez vérifier les données entourées en jaune.");
        return;
      }
      $scope.$emit('CallnextState', {});
    };

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.save = function(form){
      vm.submitted = true;
      vm.submitted = true;
      if(form.$invalid){
        Alert.show("Formulaire invalide. Veuillez vérifier les données entourées en jaune.");
        return;
      }
      $scope.$emit('UpdateProject', {});
    };
  }

})();
(function () {
  'use strict';


  angular
    .module('app')
    .controller('SmCharteController', SmCharteController);

  /** @ngInject */
  function SmCharteController($log, $scope, $document,
                              ProjetService, FilesProjectService, Alert, TaxonomyService) {
    var vm = this;
    $document.scrollTop(0);

    vm.submitted = false;
    vm.photo_charte_invalid = false;
    vm.photo_typo_invalid = false;
    vm.photo_logo_invalid = false;

    // Charte CCE list.
    vm.availableCharteCCE = TaxonomyService.getChartesCCE();

    /**
     * Récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);
    vm.uploader = vm.ctx.getUploaderV2();

    function init() {
      if (angular.isUndefined(vm.ctx.project.charte)) {
        vm.ctx.project.charte = {};
      }
      fixEmptyArrayFromMongo();
      FilesProjectService.get({id: vm.ctx.project._id.$oid})
        .$promise.then(function (result) {
        vm.filesProject = result;
      });
    }

    /**
     * Color picker settings
     */
    vm.settingsL = {
      control: 'brightness',
      theme: 'bootstrap',
      position: 'bottom right',
      defaultValue: 'fff'
    };
    vm.settingsR = angular.extend({}, vm.settingsL);
    vm.settingsR.position = 'bottom left';
    
    /**
     * Validate and go to next page
     * @param form
     */
    vm.validate = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        Alert.show("Formulaire invalide. Veuillez vérifier les données entourées en jaune.");
        return;
      }

      $scope.$emit('CallnextState', {});
    };

    /**
     * Save project
     * @param form
     */
    vm.save = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        Alert.show("Formulaire incorrect. Veuillez vérifier les données.");
        return;
      }

      $scope.$emit('UpdateProject', {});
    };

    /**
     * Mongo driver replaces empty object with empty array.
     * Fix that.
     */
    function fixEmptyArrayFromMongo() {
      if (angular.isUndefined(vm.ctx.project.charte) || angular.isArray(vm.ctx.project.charte) &&
        vm.ctx.project.charte.length === 0) {
        vm.ctx.project.charte = {};
      }
      if (angular.isUndefined(vm.ctx.project.charte.photo_charte) || angular.isArray(vm.ctx.project.charte.photo_charte) &&
        vm.ctx.project.charte.photo_charte.length === 0) {
        vm.ctx.project.charte.photo_charte = {};
      }
      if (angular.isUndefined(vm.ctx.project.charte.photo_typo) || angular.isArray(vm.ctx.project.charte.photo_typo) &&
        vm.ctx.project.charte.photo_typo.length === 0) {
        vm.ctx.project.charte.photo_typo = {};
      }
      if (angular.isUndefined(vm.ctx.project.charte.photo_logo) || angular.isArray(vm.ctx.project.charte.photo_logo) &&
        vm.ctx.project.charte.photo_logo.length === 0) {
        vm.ctx.project.charte.photo_logo = {};
      }
    }
  }
})();





(function(){
  'use strict';

  angular
    .module('app')
    .controller('SmChoixSupportController', SmChoixSupportController);

  /** @ngInject */
  function SmChoixSupportController($log, $scope, $document, 
    ProjetService, Alert, TaxonomyService){
    var vm = this;
    vm.loading = true;
    $document.scrollTop(0);

    vm.submitted = vm.error = false;

    // Support list
    vm.availableSupports = TaxonomyService.getSupportsSurMesure();
    
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      vm.loading = false;
      if(!vm.ctx.project.supports) {
        vm.ctx.project.supports = [];
        vm.addNewSupport();
      }
    }
    
    /**
     * Adds a new empty support to projet.
     */
    vm.addNewSupport = function() {
      vm.ctx.project.supports.push({
        name:null
      });
    };
     
    vm.deleteSupport = function(index) {
      vm.ctx.project.supports.splice(index, 1);
    };
    
    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.validate = function(form){
      $log.debug("validate()", form);
      vm.submitted = true;
      if(form.$invalid) {
        Alert.show("Certains champs ne sont pas renseignés. A l'exception de 'matière', tous les champs sont obligatoires.");
        return;
      }
    
      $scope.$emit('CallnextState', {});
    };

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.save = function(form){
      $log.debug("save()", form);
      vm.submitted = true;
      if(form.$invalid) {
        Alert.show("Certains champs ne sont pas renseignés. A l'exception de 'matière', tous les champs sont obligatoires.");
        return;
      }
      $scope.$emit('UpdateProject', {});
    };
  }

})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('SmIdProjetController', SmIdProjetController);

  /** @ngInject */
  function SmIdProjetController($log, $scope, $document, ProjetService) {
    var vm = this;
    $document.scrollTop(0);

    /**
     * récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      
    }

    /**
     * Go to previousState
     */
    vm.previousState = function(){
      $scope.$emit('CallpreviousSate', {});
    };

    /**
     * Go to nextState
     */
    vm.validate = function(){
      $scope.$emit('CallnextState', {});
    };

    /**
     * Go to nextState
     */
    vm.save = function(){
      $scope.$emit('UpdateProject', {});
    };

  }
})();
(function () {
    'use strict';
  
    angular
        .module('app')
        .controller('DaDcGammeController', DaDcGammeController);

    /** @ngInject */
    function DaDcGammeController($log, $state, $scope, $uibModal, $document, ProjetService, ChangeStatutService, CurrentUser) {
        var vm = this;
        vm.submitted = false;
        vm.user = CurrentUser;

        $document.scrollTop(0);
    
        /**
         * Récupère le current projet en cours de création
         */
        vm.ctx = ProjetService.getProjectContext();
        vm.ctx.$promise.then(init);

        function init() {
          if (angular.isDefined(vm.ctx.project.boissons)) {
            vm.boissonsObj = angular.extend({}, vm.ctx.project.boissons);
          } else {
            vm.boissonsObj = {};
          }
        }
        
        /**
         * Check rules form and redirect to next state
         * @param form
         */
        vm.validate = function(){
            vm.submitted = true;
            vm.ctx.project.boissons = vm.boissonsObj;
            if (vm.ctx.project.statut == "Brouillon" && vm.user.hasRole('dc')) {
              changeStatut(vm.ctx.project, 'Vous avez bien envoyé le projet au client');
            } else {
              goNextState();
            }
        };
    
        function changeStatut(projet, text) {
            vm.blockUI = true;
            ChangeStatutService.update(projet, "Brouillon", null)
              .then(function() {
                vm.blockUI = false;
                var modalStatut = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-bottom',
                  ariaDescribedBy: 'modal-body-bottom',
                  templateUrl: 'sendMsg.html',
                  controller: ['$uibModalInstance', 'projet', 'text', statutModal],
                  controllerAs: 'vm',
                  resolve:{
                    projet: function(){
                      return projet;
                    },
                    text: function(){
                      return text;
                    }
                  }
                });
                
                modalStatut.result.then(function(){
                  $state.go('dashboard');
                });
            });        
        }

        function goNextState() {
          $scope.$emit('CallnextState', {});
        }
    }

    /** @ngInject */
    function statutModal($uibModalInstance, projet, text){
        var vm = this;
        vm.text = text;
        vm.project = projet;
    }
})();
(function () {
    'use strict';
  
    angular
        .module('app')
        .controller('DaDcInfoProjetController', DaDcInfoProjetController);

    /** @ngInject */
    function DaDcInfoProjetController($log, $document, $scope, ProjetService) {
        var vm = this;
        vm.submitted = false;

        $document.scrollTop(0);

        /**
         * récupère le current projet en cours de création
         */
        vm.ctx = ProjetService.getProjectContext();
        vm.ctx.$promise.then(init);

        function init() {
        
        }

        /**
         * Go to previousState
         */
        vm.previousState = function(){
            $scope.$emit('CallpreviousSate', {});
        };
    
        /**
         * Go to nextState
         */
        vm.validate = function(){
            $scope.$emit('CallnextState', {});
        };
    
        /**
         * Go to nextState
         */
        vm.save = function(){
            $scope.$emit('UpdateProject', {});
        };
    }
})();
(function () {
    'use strict';
  
    angular
        .module('app')
        .controller('DaDcInfoClientController', DaDcInfoClientController);

    /** @ngInject */
    function DaDcInfoClientController($log, $state, $document, $scope, ProjetService, PdvInfoService, CurrentUser) {
        var vm = this;
        vm.submitted = false;

        vm.updateProject = false;
        vm.user = CurrentUser;

        $document.scrollTop(0);

        /**
         * récupère le current projet en cours de création
         * ou celui à modifier
         */
        vm.ctx = ProjetService.getProjectContext();
        vm.ctx.$promise.then(init);

        function init() {
            // If project to update or not
            vm.updateProject = vm.ctx.project && 
                            (angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC));
            vm.name = $state.current.name;
      
            if (angular.isUndefined(vm.ctx.project.pdv) || vm.ctx.project.pdv.length == 0) {
              vm.ctx.project.pdv = {};
            }
        }

        /**
         * Enregistre les données du projet et redirige le user
         * @param form
         */
        vm.validate = function (form) {
            vm.submitted = true;
            if (form.$invalid) {
                return;
            }
            $scope.$emit('CallnextState', {});
        };
        
        /**
         * Recupere les infos du point de vente.
         */
        vm.getPdvInfo = function () {
            var pdvInfo = PdvInfoService.get({'outlet': vm.ctx.project.pdv.nOutlet});
            pdvInfo.$promise.then(function (data) {
                if (data) {
                vm.ctx.project.pdv.nomPDV = data.Outlet_Name;
                vm.ctx.project.pdv.adresse = (data.House_Number__c ? data.House_Number__c + " " : "") +
                    (data.Street__c ? data.Street__c : "") +
                    (data.Street2__c ? "\n" + data.Street2__c : "") +
                    (data.Street3__c ? "\n" + data.Street3__c : "");
                vm.ctx.project.pdv.codePostal = data.Postal_Code__c;
                vm.ctx.project.pdv.ville = data.City__c;
                vm.ctx.project.pdv.telephone = formatTel(data.Telephone__c);
                //vm.ctx.project.pdv.fax = data.Fax;
                vm.ctx.project.pdv.nSiret = data.SIRET__c;
                //vm.ctx.project.pdv.rcs = data.TO_BE_DEFINED;
                vm.ctx.project.pdv.nomClient = data.Owner_Name;
                vm.ctx.project.pdv.telephoneCLient = formatTel(data.Phone);
                vm.ctx.project.pdv.emailCLient = data.Email;
                vm.ctx.project.pdv.rcs = '';
                }
            });

        };

        var formatTel = function (tel) {
            if (tel) {
                tel = tel.replace("+33", "0");
            }
            return tel;
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('ChrFormulesController', ChrFormulesController);

  /** @ngInject **/
  function ChrFormulesController($log, $scope, $uibModal, $document, ProjetService) {
    var vm = this;
    vm.submitted = false;
    $document.scrollTop(0);

    /**
     * récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      // If project to update or not
      vm.requiredNoformule = true;
      vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);
      if (angular.isUndefined(vm.ctx.project.infopdv)) {
        vm.ctx.project.infopdv = {
          formules: [{
              nomFormule: "Formule Déjeuner",
              compoFormule: "*Entrée + Plat + Boisson \n*ou Plat + Dessert + Boisson\n*ou Plat + Boisson\n*Soft 25cl ou 33cl, verre de vin ou bière 25cl",
              tarifFormule: 13
            }],
          noFormule: false
        };
        vm.requiredNoformule = false;
        vm.nbFormule = 1;
      } else if (angular.isDefined(vm.ctx.project.infopdv.noFormule) && vm.ctx.project.infopdv.noFormule) {
        vm.nbFormule = 0;
      } else {
        vm.requiredNoformule = false;
      }
    }

    /**
     * Remove formulaire if "Aucune formule" is checked
     */
    vm.onNoFormule = function (item) {
      if (item == 'Aucune formule') {
        delete vm.ctx.project.infopdv.formules;
        vm.ctx.project.infopdv = {
          noFormule: item
        };
      } else if (angular.isUndefined(item)) {
        vm.ctx.project.infopdv.noFormule = 'Aucune formule';
      }
    };

    if (angular.isDefined(vm.ctx.project.infopdv) 
      && angular.isDefined(vm.ctx.project.infopdv.noFormule) 
      && vm.ctx.project.infopdv.noFormule == 'Aucune formule') {
      vm.requiredNoformule = true;
    }

    /**
     * Add formule to formules property of project
     */
    vm.addFormules = function () {
      vm.requiredNoformule = false;
      if (angular.isUndefined(vm.ctx.project.infopdv)) {
        vm.ctx.project.infopdv = {
          formules: [{
              nomFormule: null,
              compoFormule: null,
              tarifFormule: null
            }]
        };
        return;
      } else if (angular.isUndefined(vm.ctx.project.infopdv.formules)) {
        vm.ctx.project.infopdv = {
          formules: [{
              nomFormule: null,
              compoFormule: null,
              tarifFormule: null
            }]
        };
      } else {
        vm.ctx.project.infopdv.formules.push({
          nomFormule: null,
          compoFormule: null,
          tarifFormule: null
        });
      }
      if (angular.isDefined(vm.ctx.project.infopdv.noFormule)) {
        delete vm.ctx.project.infopdv.noFormule;
      }
      vm.nbFormule = Object.keys(vm.ctx.project.infopdv.formules).length;
    };

    /**
     * remove formule from formules property of project
     * @param index
     */
    vm.deleteFormule = function (index) {
      var modalDeleFormule = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'confirmDeleFormule.html'
      });

      modalDeleFormule.result.then(function () {
        vm.ctx.project.infopdv.formules.splice(index, 1);
        vm.nbFormule = Object.keys(vm.ctx.project.infopdv.formules).length;
        //$log.debug('length Delete: ' + Object.keys(vm.ctx.project.infopdv.formules).length);
        if (Object.keys(vm.ctx.project.infopdv.formules).length == 0) {
          vm.requiredNoformule = true;
          vm.ctx.project.infopdv.noFormule = 'Aucune formule';
        }
      });
    };

    /**
     * Enregistre les données du projet et redirige le user
     * @param form
     */
    vm.validateFormules = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        var errorFormules = angular.element('#errorFormules');
        $document.scrollTo(errorFormules, 30, 500);
        return;
      }
      $scope.$emit('CallnextState', {});
    };

    /**
     * Update project and redirect to
     */
    vm.save = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        var errorFormules = angular.element('#errorFormules');
        $document.scrollTo(errorFormules, 30, 500);
        return;
      }
      $scope.$emit('UpdateProject', {});
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('ChrIllustrationsController', ChrIllustrationsController);

  /** @ngInject **/
  function ChrIllustrationsController($log, $scope, $document, ProjetService, IllustrationsService) {
    var vm = this;
    vm.submitted = false;
    vm.loading = true;
    $document.scrollTop(0);

    /**
     * récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      // If project to update or not
      vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);

      /**
       * Load List Illustration
       */
      IllustrationsService.viewsLoad().$promise.then(function(result){
        vm.illustrations = result.filter(function(itm){
          return itm.field_type === "Illustration";
        });
        vm.frises = result.filter(function(itm){
          return itm.field_type === "Frise";
        });
        vm.loading = false;
      });
    }

    /**
     * Remove element unchecked
     * @param ele
     */
    vm.removeIllustrat = function (ele, img, index) {
      if (angular.isDefined(ele.name)) {
        ele.image = img;
      } else if (angular.isUndefined(ele.name)) {
        delete vm.ctx.project.infocarte.illustrations[index];
      }
    };

    /**
     * Enregistre les données du projet et redirige le user
     * @param form
     */
    vm.validateIllustrations = function () {
      vm.submitted = true;
      if ( angular.isObject(vm.ctx.project.infocarte.illustrations) && !Object.keys(vm.ctx.project.infocarte.illustrations).length
        || vm.ctx.project.infocarte.illustrations instanceof Array && !vm.ctx.project.infocarte.illustrations.filter(function(n) {return n}).length) {
        var errorIllustrations = angular.element('#errorIllustrations');
        $document.scrollTo(errorIllustrations, 30, 500);
        return;
      }
      if (!vm.ctx.project.infocarte.frise.name) {
        var errorFrise = angular.element('#errorFrise');
        $document.scrollTo(errorFrise, 30, 500);
        return;
      }
      $scope.$emit('CallnextState', {});
    };

    /**
     * Update project and redirect to
     */
    vm.save = function() {
      vm.submitted = true;
      if ( angular.isObject(vm.ctx.project.infocarte.illustrations) && !Object.keys(vm.ctx.project.infocarte.illustrations).length
        || vm.ctx.project.infocarte.illustrations instanceof Array && !vm.ctx.project.infocarte.illustrations.filter(function(n) {return n}).length) {
        var errorIllustrations = angular.element('#errorIllustrations');
        $document.scrollTo(errorIllustrations, 30, 500);
        return;
      }
      if (!vm.ctx.project.infocarte.frise.name) {
        var errorFrise = angular.element('#errorFrise');
        $document.scrollTo(errorFrise, 30, 500);
        return;
      }
      $scope.$emit('UpdateProject', {});
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('ChrCocktailsController', ChrCocktailsController);

  /** @ngInject **/
  function ChrCocktailsController($log, $scope, $uibModal, $document, ProjetService, CocktailsService) {
    var vm = this;
    vm.submitted = false;
    vm.loading = true;
    $document.scrollTop(0);

    /**
     * récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      // If project to update or not
      vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);

      /**
       * Gestion cas checked cocktails
       * @param ele
       */
      vm.nbCocktails = -1; // Nbr Cocktails choisit

      if (angular.isDefined(vm.ctx.project.infocarte)) {
        if (angular.isDefined(vm.ctx.project.infocarte.cocktails)) {
          if (angular.isDefined(vm.ctx.project.infocarte.cocktails.name))
            vm.nbCocktails = 1;
          else {
            angular.forEach(vm.ctx.project.infocarte.cocktails, function (key, value) {
              var lenght = Object.keys(value);
              vm.nbCocktails += lenght.length;
            });
          }
        }
      }
    }
    /**
     * Load list cocktails
     */
    CocktailsService.viewsLoad().$promise.then(function(result){
      vm.cocktails = result;
      vm.loading = false;
    });


    var anchorSubmitCocktails = angular.element('#submit-cocktails');
    vm.onChangeCocktail = function (ele, cocktail, index) {
      if (ele == 'Aucun Cocktail' || ele == undefined) {
        // uncheck other checkbox
        angular.forEach(vm.ctx.project.infocarte.cocktails, function (key, value) {
          delete vm.ctx.project.infocarte.cocktails[value];
        });
        vm.ctx.project.infocarte.cocktails.name = 'Aucun Cocktail';
        vm.nbCocktails = 0;
        $document.scrollTo(anchorSubmitCocktails, 30, 1000);
      } else if (angular.isDefined(ele.name)) {
        if (vm.nbCocktails == -1)
          vm.nbCocktails = 0;
        ele.image = cocktail.field_media_image_cocktails;
        ele.ingredient = cocktail.field_media_ingredients_cocktail;
        if (angular.isDefined(vm.ctx.project.infocarte.cocktails.name))
          delete vm.ctx.project.infocarte.cocktails.name;// uncheck aucunCocktails checkbox
        vm.nbCocktails++;
      } else if (angular.isUndefined(ele.name)) {
        delete vm.ctx.project.infocarte.cocktails[index];
        vm.nbCocktails = Object.keys(vm.ctx.project.infocarte.cocktails).length;
        if (vm.nbCocktails == 0) {
          vm.ctx.project.infocarte.cocktails.name = 'Aucun Cocktail';
          $document.scrollTo(anchorSubmitCocktails, 30, 1000);
        }
      }
    };

    /**
     * Enregistre les données du projet et redirige le user
     * @param form
     */
    vm.validateCocktails = function () {
      vm.submitted = true;
      if (vm.nbCocktails < 0) {
        var errorCocktails = angular.element('#errorCocktails');
        $document.scrollTo(errorCocktails, 30, 500);
        return;
      }

      // Si aucun cocktails choisis, on passe à l'écran suivant
      if (angular.isDefined(vm.ctx.project.infocarte.cocktails.name)) {
        $scope.$emit('CallnextState', {});
      } else {
        var modalCocktail = $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title-bottom',
          ariaDescribedBy: 'modal-body-bottom',
          templateUrl: 'visuelCocktail.html',
          controller: ['$uibModalInstance', 'ctx', cocktailsModal],
          controllerAs: 'vm',
          resolve: {
            ctx: function () {
              return vm.ctx;
            }
          }
        });
        modalCocktail.result.then(function () {
          $scope.$emit('CallnextState', {});
        });
      }
    };

    /**
     * Update project and redirect to
     */
    vm.save = function () {
      vm.submitted = true;
      if (vm.nbCocktails < 0) {
        var errorCocktails = angular.element('#errorCocktails');
        $document.scrollTo(errorCocktails, 30, 500);
        return;
      }

      // Si aucun cocktails choisis, on passe à l'écran suivant
      if (angular.isDefined(vm.ctx.project.infocarte.cocktails.name)) {
        $scope.$emit('CallnextState', {});
      } else {
        var modalCocktail = $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title-bottom',
          ariaDescribedBy: 'modal-body-bottom',
          templateUrl: 'visuelCocktail.html',
          controller: ['$uibModalInstance', 'ctx', cocktailsModal],
          controllerAs: 'vm',
          resolve: {
            ctx: function () {
              return vm.ctx;
            }
          }
        });
        modalCocktail.result.then(function () {
          $scope.$emit('UpdateProject', {});
        });
      }
    };
  }

  /** @ngInject */
  function cocktailsModal($uibModalInstance, ctx) {
    var vm = this;
    vm.submitted = false;

    vm.ctx = ctx;

    /**
     * Supprime un project
     * et change le statut en fonction du statut de départ
     */
    vm.visuelCocktail = function visuelCocktail(form) {
      vm.submitted = true;
      if (form.$invalid) {
        return;
      }
      $uibModalInstance.close();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('ChrGammeController', ChrGammeController);

  /** @ngInject */
  function ChrGammeController($log, $filter, $scope, $uibModal, $document, GammeService, ProjetService) {
    var vm = this;
    vm.submitted = false;
    vm.loading = true;
    $document.scrollTop(0);

    /**
     * récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      // If project to update or not
      vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);

      /**
       * Load list gamme boissons
       */
      GammeService.viewsLoad().$promise.then(function(data) {
        vm.gammes = data.filter(function(itm){
          if (!itm.field_disponibilite.split(", ")) {
            return false;
          }
          return itm.field_disponibilite.split(", ").includes(vm.ctx.project.typeProjet);
        });
        vm.loading = false;
      });

      /**
       * On créer les propiétés qui si elles ne sont pas définit. Si elle le sont
       * ça veut dire qu'elles contiennent des données et elle seront chargées dans le formulaire
       */
      if (angular.isUndefined(vm.ctx.project.infocarte)) {
        vm.ctx.project.infocarte = {
          boissons: {}
        }
      }

      vm.nbrChecked = 0; // Nbr boissons choisit

      if (angular.isDefined(vm.ctx.project.infocarte)) {
        angular.forEach(vm.ctx.project.infocarte.boissons, function (key) {
          var lenght = Object.keys(key);
          vm.nbrChecked += lenght.length;
        });
      }
    }

    /**
     * Onchange increment nbr boissons
     * if uncheck, remove boissons from array boissons
     * @param ele
     * @param parent
     * @param index
     */
    vm.onChangeBoissons = function (ele, parent, index) {
      if (ele.name != false) {
        vm.nbrChecked++;
      } else if (ele.name == false) {
        delete vm.ctx.project.infocarte.boissons[parent][index];
        vm.nbrChecked--;
      }
    };

    /**
     * Redirige le user
     * @param form
     */
    vm.validateGame = function () {
      vm.submitted = true;
      if (vm.nbrChecked < 4) {
        /** Open Popin Alert **/
        $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title-bottom',
          ariaDescribedBy: 'modal-body-bottom',
          templateUrl: 'boissonsChoices.html'
        });
        return;
      }
      $scope.$emit('CallnextState', {});
    };

    /**
     * Update project and redirect to
     */
    vm.save = function () {
      vm.submitted = true;
      if (vm.nbrChecked < 4) {
        /** Open Popin Alert **/
        $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title-bottom',
          ariaDescribedBy: 'modal-body-bottom',
          templateUrl: 'boissonsChoices.html'
        });
        return;
      }
      $scope.$emit('UpdateProject', {});
    };

    vm.selectAll = function (parent) {
      var gamme = vm.gammes.filter(function(e) {
        return e.name.toLowerCase() === parent.toLowerCase();
      });
      gamme = $filter('orderBy')(gamme, 'weight_children');

      if(angular.isDefined(vm.ctx.project.infocarte.boissons[parent]) && 
        Object.keys(vm.ctx.project.infocarte.boissons[parent]).length === gamme.length) {
        delete vm.ctx.project.infocarte.boissons[parent];
        vm.nbrChecked -= gamme.length;
        return;
      }

      var obj = {}
      if (angular.isDefined(vm.ctx.project.infocarte.boissons[parent])) {
        vm.nbrChecked += (gamme.length - Object.keys(vm.ctx.project.infocarte.boissons[parent]).length);
      } else {
        vm.nbrChecked += gamme.length;
      }
      for(var i = 0; i < gamme.length; i++) {
        obj[i] = {'name' : gamme[i].name_1+' '+gamme[i].field_gamme_format_boissons };
      }
      vm.ctx.project.infocarte.boissons[parent] = obj;
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('ChrFormatController', ChrFormatController);

  /** @ngInject */
  function ChrFormatController($log, $scope, $document, FormatService, ProjetService, TaxonomyService) {
    var vm = this;
    vm.submitted = false;
    $document.scrollTop(0);

    // Get all format
    vm.formats = FormatService.viewsLoad();
    vm.materials = TaxonomyService.getCHRMaterials();

    /**
     * récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      // If project to update or not
      vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);
      //unset format if project is on old format structure to force reselection
      if (!vm.ctx.project.infocarte.format.code_produit) {
        vm.ctx.project.infocarte.format = null;
      }
    }

    /**
     * Ajoute l'url de image sélectionner
     * @param theme
     */
    var anchorSubmitFormat = angular.element('#submit-format');
    vm.formatChange = function (format) {
      vm.ctx.project.infocarte.format.image = format.field_media_image;
      vm.ctx.project.infocarte.format.media_format = format.field_media_format;
      vm.ctx.project.infocarte.format.code_produit = format.field_code_produit;
      $document.scrollTo(anchorSubmitFormat, 30, 1000);
    };

    /**
     * Valide le Format et passe à la page boissons
     * @param form
     */
    vm.validateFormat = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        if (!vm.ctx.project.infocarte.format) {
          var errorFormat = angular.element('#errorFormat');
          $document.scrollTo(errorFormat, 30, 500);
          return;
        }
        if (!vm.ctx.project.infocarte.matiere) {
          var errorMatiere = angular.element('#errorMatiere');
          $document.scrollTo(errorMatiere, 30, 500);
          return;
        }
      }
      $scope.$emit('CallnextState', {});
    };

    /**
     * Update project and redirect to
     */
    vm.save = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        if (!vm.ctx.project.infocarte.format) {
          var errorFormat = angular.element('#errorFormat');
          $document.scrollTo(errorFormat, 30, 500);
          return;
        }
        if (!vm.ctx.project.infocarte.matiere) {
          var errorMatiere = angular.element('#errorMatiere');
          $document.scrollTo(errorMatiere, 30, 500);
          return;
        }
      }
      $scope.$emit('UpdateProject', {});
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('ChrThemeController', ChrThemeController);

  /** @ngInject */
  function ChrThemeController($log, $scope, $uibModal, $document, ProjetService, ThemeService) {
    var vm = this;
    vm.submitted = false;
    vm.loading = true;
    $document.scrollTop(0);

    // Get theme graphique
    ThemeService.viewsLoad().$promise.then(function (result) {
      var regex = /&#039;/;
      angular.forEach(result, function (key) {
        if (regex.test(key.name)) {
          key.name = key.name.replace(regex, "'");
        }
      });
      vm.themeGraphique = result;
      vm.loading = false;
    });

    /**
     * récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      // If project to update or not
      vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);

		/**
		 * On créer les propiétés qui si elles ne sont pas définit. Si elle le sont
		 * ça veut dire qu'elles contiennent des données et elle seront chargées dans le formulaire
		 */
		if (angular.isUndefined(vm.ctx.project.infocarte) || vm.ctx.project.infocarte.length == 0){
			vm.ctx.project.infocarte = {};
		}
  }

    /**
     * Ajoute l'url de image sélectionner
     * @param theme
     */
    var anchorSubmitTpl = angular.element('#submit-template');
    vm.themeChange = function (imgTheme) {
      vm.ctx.project.infocarte.template.image = imgTheme;
      $document.scrollTo(anchorSubmitTpl, 30, 1000);
    };

    /**
     * Zoom template img
     * @param img
     */
    vm.zoomTemplate = function (img, themeName) {
      /** Open Popin Alert **/
      $uibModal.open({
        animation: true,
        backdrop: 'static',
        backdropClass: 'zoom-modal-backdrop',
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        windowTopClass: 'modal-zoom-template',
        templateUrl: 'zoomTemplates.html',
        controller: ['$uibModalInstance', 'imgTpl', 'themeName', zoomTepmplatesModal],
        controllerAs: 'vm',
        resolve: {
          imgTpl: function () {
            return img;
          },
          themeName: function () {
            return themeName;
          }
        }
      });
    };

    /**
     * Valide le thème graphique et passe à l'onglet Format
     * @param form
     */
    vm.validateTemplates = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        var errorTemplate = angular.element('#errorTemplate');
        $document.scrollTo(errorTemplate, 30, 500);
        return;
      }
      $scope.$emit('CallnextState', {});
    };

    /**
     * Update project and redirect to
     */
    vm.save = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        var errorTemplate = angular.element('#errorTemplate');
        $document.scrollTo(errorTemplate, 30, 500);
        return;
      }
      $scope.$emit('UpdateProject', {});
    };
  }

  /** @ngInject */
  function zoomTepmplatesModal($uibModalInstance, imgTpl, themeName) {
    var vm = this;

    vm.img = imgTpl;
    vm.themeName = themeName;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('ChrIdController', ChrIdController);

  /** @ngInject */
  function ChrIdController($log, $scope, ProjetService) {
    var vm = this;
    var oldCodeProjet = null;

    /**
     * Format code Projet with date : YYYY_MM_DD
     * @type {Date}
     */
    var codeOutlet = new Date();
    var month = codeOutlet.getUTCMonth() < 10 ? '0' + (codeOutlet.getUTCMonth() + 1) : codeOutlet.getUTCMonth() + 1;
    var day = codeOutlet.getUTCDate() < 10 ? '0' + codeOutlet.getUTCDate() : codeOutlet.getUTCDate();

    vm.submitted = false;

    /**
     * récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      // If project to update or not
      vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);
      
      /**
       * On créer les propiétés qui si elles ne sont pas définit. Si elle le sont
       * ça veut dire qu'elles contiennent des données et elle seront chargées dans le formulaire
       */
      if (angular.isUndefined(vm.ctx.project.idprojet)) {
        vm.ctx.project.idprojet = {
          nameProjet: vm.ctx.project.pdv.nomPDV,
          codeProjet: '',
          numProjet: ''
        };
      } else {
        oldCodeProjet = vm.ctx.project.idprojet.codeProjet;
        vm.ctx.project.idprojet.nameProjet = vm.ctx.project.pdv.nomPDV;
      }
    }

    /**
     * Valid le nom Projet et passe à l'onglet Theme graphique
     * @param form
     */
    vm.validateNomProjet = function (form) {
      if (vm.ctx.project.idprojet.codeProjet === '' || angular.isUndefined(vm.ctx.project.idprojet.codeProjet))
        vm.ctx.project.idprojet.codeProjet = codeOutlet.getFullYear() + '_' + month + '_' + day;

      vm.ctx.project.idprojet.numProjet = vm.ctx.project.pdv.nOutlet + '_' + vm.ctx.project.idprojet.codeProjet;

      vm.submitted = true;
      if (form.$invalid) {
        return;
      }
      $scope.$emit('CallnextState', {});
    };

    /**
     * Update project and redirect to
     */
    vm.save = function (form) {
      if (vm.ctx.project.idprojet.codeProjet == '')
        vm.ctx.project.idprojet.codeProjet = oldCodeProjet;
      //vm.ctx.project.idprojet.codeProjet = codeOutlet.getFullYear()+'_'+month+'_'+day;

      vm.ctx.project.idprojet.numProjet = vm.ctx.project.pdv.nOutlet + '_' + vm.ctx.project.idprojet.codeProjet;

      vm.submitted = true;
      if (form.$invalid) {
        return;
      }
      $scope.$emit('UpdateProject', {});
    };
  }
})();

(function(){
  'use strict';

  angular
    .module('app')
    .controller('VaeRecapitulatifController', VaeRecapitulatifController);

  /** @ngInject */
  function VaeRecapitulatifController($log, $scope, $state, $uibModal, $document, ProjetService, CurrentUser, canUpdateProject){
    var vm = this;
    $document.scrollTop(0);

    /**
     * récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    /**
     * Si retour pas vide, il s'agit d'une mise à jour
     * Sinon, c'est un nouveau projet
     * @returns {*}
     */
    vm.isUpdate = function () {
      if (angular.isDefined(vm.ctx.project))
        return vm.ctx.project._id;
      return false;
    };

    /**
     * Close arte message
     */
    vm.closeAlert = function() {
      vm.alert = {};
    };

    /**
     * If user Can Update Project
     * @type {boolean}
     */
    vm.canProjetUpdate = false;
    canUpdateProject.get({id: vm.ctx.project._id.$oid}).$promise.then(function(result){
      vm.canProjetUpdate = result[0];
    });

    /**
     * Enregistre le projet en bdd Mongo et redirige vers le suivi du projet
     */
    vm.validate = function () {
      var alert = angular.element('#alert-message');
      if (angular.isUndefined(vm.ctx.project.signatureClient) || angular.isUndefined(vm.ctx.project.signatureDC)) {
        var modalSignatureClient = $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title-bottom',
          ariaDescribedBy: 'modal-body-bottom',
          templateUrl: 'signatureClient.html',
          windowTopClass: 'signature-client-modal',
          controller: ['$uibModalInstance', '$scope', signatureModalInstance],
          controllerAs: 'vm'
        });

        modalSignatureClient.result.then(function (result) {
          vm.ctx.project.signatureClient = result;

          var modalSignatureDC = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: 'signatureDC.html',
            windowTopClass: 'signature-dc-modal',
            controller: ['$uibModalInstance', '$scope', signatureModalInstance],
            controllerAs: 'vm'
          });

          modalSignatureDC.result.then(function (result) {
            vm.ctx.project.signatureDC = result;
            vm.ctx.project.nextState = null;
            vm.ctx.project.create = true;
            ProjetService.save().then(function () {
              vm.ctx.project.popin = true;
              $state.go('suivi-projet');
            });
          }).catch(function(reason){
            if(reason == 'empty'){
              vm.alert = {
                type: 'danger',
                msg: 'La signature du DC est obligatoire pour finaliser le projet.'
              };
              $document.scrollTo(alert, 30, 500);
            }
          });
        }).catch(function(reason){
          if(reason == 'empty'){
            vm.alert = {
              type: 'danger',
              msg: 'La signature du Client est obligatoire pour finaliser le projet.'
            };
            $document.scrollTo(alert, 30, 500);
          }
        });
      } else if (angular.isDefined(vm.ctx.project._id)) {
        ProjetService.save().then(function () {
          $state.go('suivi-projet');
        });
      }
    };

    /**
     * Met à jour le projet
     */
    vm.update = function () {
      vm.ctx.project.$update().then(function () {
        //$window.location.href = "#/suivi-projet";
        $state.go('suivi-projet');
      });
    };

    /**
     * Back to Suivi Projet
     */
    vm.backSuiviProjet = function(){
      ProjetService.setProject(vm.ctx.project);
      $state.go('suivi-projet', {'id': vm.ctx.project._id.$oid});
    };

    /**
     * If User allowedto update Project
     * @returns {boolean}
     */
    vm.allowedUpdate = function () {
      if (CurrentUser.hasRole('agence') || CurrentUser.hasRole('imprimeur') || CurrentUser.hasRole('installateur'))
        return false;
      if(CurrentUser.getRoles()[1] == 'dc' && vm.ctx.project.statut != 'Brouillon')
        return false;
      return true;
    };
  }

  /** @ngInject */
  function signatureModalInstance($uibModalInstance, $scope) {
    var vm = this;
    vm.done = function () {
      var signature = $scope.accept();
      if (angular.isUndefined(signature.dataUrl)) {
        $uibModalInstance.dismiss('empty');
      } else {
        $uibModalInstance.close(signature.dataUrl);
      }
    };
  }
})();
(function(){
  'use strict';

  angular
    .module('app')
    .controller('VaeLivraisonController', VaeLivraisonController);

  /** @ngInject */
  function VaeLivraisonController($log, $scope, $document, ProjetService){
    var vm = this;
    $document.scrollTop(0);

    vm.ctx = ProjetService.getProjectContext();

    vm.nbrCarte = [1,2,3,4,5];

    /**
     * Validate and got to Suivi projet (or Recapitulatif)
     * @param form
     */
    vm.validate = function(form){
      vm.submitted = true;
      if(form.$invalid){
        var error = angular.element('#errorLivraison');
        $document.scrollTo(error, 30, 500);
        return;
      }

      $scope.$emit('CallnextState', {});
    };

    /**
     * Update project and Go to Suiv Projet (or Recapitulatif)
     * @param form
     */
    vm.save = function(form){
      vm.submitted = true;
      if(form.$invalid){
        var error = angular.element('#errorLivraison');
        $document.scrollTo(error, 30, 500);
        return;
      }

      $scope.$emit('UpdateProject', {});
    };
  }
})();
(function(){
  'use strict';

  angular
    .module('app')
    .controller('VaeVideoController', VaeVideoController);

  /** @ngInject */
  function VaeVideoController($log, $scope, $document, ProjetService){
    var vm = this;
    $document.scrollTop(0);

    vm.ctx = ProjetService.getProjectContext();

    if(angular.isUndefined(vm.ctx.project.livraison) || vm.ctx.project.livraison.length == 0){
      vm.ctx.project.livraison = {
        video_email : vm.ctx.project.pdv.emailCLient
      };

    }


    /**
     * Validate and got to Suivi projet (or Recapitulatif)
     * @param form
     */
    vm.validate = function(form){
      vm.submitted = true;
      if(form.$invalid){
        var error = angular.element('#errorLivraison');
        $document.scrollTo(error, 30, 500);
        return;
      }

      $scope.$emit('CallnextState', {});
    };

    /**
     * Update project and Go to Suiv Projet (or Recapitulatif)
     * @param form
     */
    vm.save = function(form){
      vm.submitted = true;
      if(form.$invalid){
        var error = angular.element('#errorLivraison');
        $document.scrollTo(error, 30, 500);
        return;
      }

      $scope.$emit('UpdateProject', {});
    };
  }
})();
(function(){
  'use strict';

  angular
    .module('app')
    .controller('VaePoseController', VaePoseController);

  /** @ngInject */
  function VaePoseController($log, $scope, $document, ProjetService){
    var vm = this;
    vm.submitted = false;

    $document.scrollTop(0);

    vm.ctx = ProjetService.getProjectContext();
    // List Open days
    vm.arrayDays = ['Lundi','Mardi','Mercredi','Jeudi','Vendredi'];

    vm.isPoseDisabled = ProjetService.isPoseDisabled(vm.ctx.project);

    var savePose = {};

    /**
     * Init value pose
     */
    if(angular.isUndefined(vm.ctx.project.pose) || vm.ctx.project.pose.length == 0){
      vm.ctx.project.pose = {};

        if(vm.isPoseDisabled){
            vm.ctx.project.pose = {
                pose : 'non'
            };
        }
    }

    /**
     * Init date value with réel date
     */
    if (angular.isDefined(vm.ctx.project.pose)) {
      if (angular.isDefined(vm.ctx.project.pose.heureouverture))
        vm.ctx.project.pose.heureouverture = new Date(vm.ctx.project.pose.heureouverture);
      if (angular.isDefined(vm.ctx.project.pose.heurefermeture))
        vm.ctx.project.pose.heurefermeture = new Date(vm.ctx.project.pose.heurefermeture);
    }

    /**
     * onChange and if non
     * delete other data
     * @param item
     */
    vm.changePose = function(){
      if(vm.ctx.project.pose.pose == 'non'){
        savePose = angular.copy(vm.ctx.project.pose);
        savePose.pose = 'oui';

        if(angular.isDefined(vm.ctx.project.pose.jours))
          delete vm.ctx.project.pose.jours;

        if(angular.isDefined(vm.ctx.project.pose.contact))
          delete vm.ctx.project.pose.contact;

        if(angular.isDefined(vm.ctx.project.pose.heureouverture))
          delete vm.ctx.project.pose.heureouverture;

        if(angular.isDefined(vm.ctx.project.pose.heurefermeture))
          delete vm.ctx.project.pose.heurefermeture;

        if(angular.isDefined(vm.ctx.project.pose.tringle))
          delete vm.ctx.project.pose.tringle;
      }
      else if(vm.ctx.project.pose.pose == 'oui'){
        if(Object.keys(savePose).length > 0)
          vm.ctx.project.pose = angular.copy(savePose);
      }
    };

    /**
     * On change delete uncheck Days
     * @param item
     * @param index
     */
    vm.choseDay = function(item, index){
      if(item[index] == false)
        delete vm.ctx.project.pose.jours[index];
    };

    /**
     * Validate and go to livraison
     * @param form
     */
    vm.validate = function(form){
      vm.submitted = true;
      if(form.$invalid)
        return;

      $scope.$emit('CallnextState', {});
    };

    /**
     * Update and go to livraison
     * @param form
     */
    vm.save = function(form){
      vm.submitted = true;
      if(form.$invalid){
        return;
      }

      $scope.$emit('UpdateProject', {});
    };
  }
})();
(function(){
  'use strict';

  angular
    .module('app')
    .controller('VaeContenuController', VaeContenuController);

  /** @ngInject */
  function VaeContenuController($log, $document, $scope, $uibModal, $state, ProjetService, EditeBoard){
    var vm = this;
    vm.submitted = false;

    $document.scrollTop(0);

    /**
     * Récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();

    // All boards edited
    vm.editedAll = true;

    // Init edited board, and check if board is edited
    angular.forEach(vm.ctx.project.boards, function(data){
      if(vm.editedAll){
        if(angular.isUndefined(data.brief)){
          vm.editedAll = false;
        }
      }
    });

    // Calcule nbr board PET and Gamme/Pricelist
    var reglesChoiceBoard = function(boards){
      vm.boardPET = vm.boardGL = 0;
      angular.forEach(boards, function(key){
        if(key.type.indexOf('PET') != -1){
          vm.boardPET++;
        }
        if(key.type.indexOf('Gamme') != -1){
          vm.boardGL++;
        }
      });
    };

    reglesChoiceBoard(vm.ctx.project.boards);

    /**
     * Delete board
     * @param index
     * @param board
     */
    vm.deleteBoard = function(index){
      var alert = angular.element('#alert-message');
      // controle des règles de sélection des boards: Nbr Boards
      if(vm.ctx.project.boards.length == 3){
        vm.alert = {
          type: 'danger',
          msg: 'Attention, vous devez avoir au minimum 3 boards. Avec cette supression, vous ne respectez pas les règles de gestion.'
        };
        $document.scrollTo(alert, 30, 500);
        return;
      }

      // Controle si board Gamme ou Pricelist
      var type = vm.ctx.project.boards[index].type;
      if((type.indexOf('PET') != -1 && (vm.boardPET - 1) == 0)){
        vm.alert = {
          type: 'danger',
          msg: 'Attention, vous devez avoir au moins un board de type Menu PET. Avec cette supression, vous ne respectez pas les règles de gestion.'
        };
        $document.scrollTo(alert, 30, 500);
        return;
      }

      if((type.indexOf('Gamme') != -1 && (vm.boardGL - 1) == 0)){
        vm.alert = {
          type: 'danger',
          msg: 'Attention, vous devez avoir au moins un board de type Gamme ou Pricelist. Avec cette supression, vous ne respectez pas les règles de gestion.'
        };
        $document.scrollTo(alert, 30, 500);
        return;
      }

      var modalDeleBoard = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'confirmDeleBoard.html'
      });

      modalDeleBoard.result.then(function(){
        delete vm.ctx.project.boards[index];
        vm.ctx.project.boards.splice(index, 1);

        // recalcule le nombre de board PEt et Gamme/Pricelis
        reglesChoiceBoard(vm.ctx.project.boards);

        // Recheck list of board is editing or not
        vm.editedAll = true;
        angular.forEach(vm.ctx.project.boards, function(data){
          if(vm.editedAll){
            if(angular.isUndefined(data.brief)){
              vm.editedAll = false;
            }
          }
        });
      });
    };

    /**
     * Close arte message
     */
    vm.closeAlert = function() {
      vm.alert = {};
    };

    /**
     * Redirect to brief board
     * @param board
     */
    vm.editeBoard = function(index, board){
			EditeBoard.setEditBoard(index, board);
			if(vm.ctx.project.type === 'Digital'){
        $state.go('vae-digital.contenu.'+board.state);
      }else{
        $state.go('vae.contenu.'+board.state);
      }
    };

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.validate = function(){
      vm.submitted = true;
      if(!vm.editedAll)
        return;
      $scope.$emit('CallnextState', {});
    };

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.save = function(){
      vm.submitted = true;
      if(!vm.editedAll)
        return;

      $scope.$emit('UpdateProject', {});
    }
  }

})();
(function () {
  'use strict';

  angular
      .module('app')
      .controller('VaeInfoPdvController', VaeInfoPdvController);

  /** @ngInject */
  function VaeInfoPdvController($log, $document, $scope, ProjetService) {
    var vm = this;
    vm.submitted = false;

    vm.updateProject = false;

    $document.scrollTop(0);

    /**
     * récupère le current projet en cours de création
     * ou celui à modifier
     */
    vm.ctx = ProjetService.getProjectContext();

    // If project to update or not
    vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);

    if (angular.isUndefined(vm.ctx.project.pdv) || vm.ctx.project.pdv.length == 0) {
      vm.ctx.project.pdv = {};
    }

    /**
     * Enregistre les données du projet et redirige le user
     * @param form
     */
    vm.validate = function () {
      $scope.$emit('CallnextState', {});
    };

    /**
     * Update project and redirect to
     */
    vm.save = function(){
      $scope.$emit('UpdateProject', {});
    };
  }
})();

(function(){
  'use strict';

  angular
    .module('app')
    .controller('SmRecapitulatifController', SmRecapitulatifController);

  /** @ngInject */
  function SmRecapitulatifController($log, $scope, $state, $uibModal, $document, ProjetService, FilesProjecttService, CurrentUser, canUpdateProject){
    var vm = this;
    $document.scrollTop(0);

    /**
     * Récupère le current projet en cours
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    /**
     * If user Can Update Project
     * @type {boolean}
     */
    vm.canProjetUpdate = false;

    vm.files = [];    

    function init() {
      canUpdateProject.get({id: vm.ctx.project._id.$oid}).$promise.then(function(result){
        vm.canProjetUpdate = result[0];
      });

      FilesProjecttService.get({id: vm.ctx.project._id.$oid}).$promise.then(function (result) {
        vm.files = result;
      })
    }

    
    /**
     * Si retour pas vide, il s'agit d'une mise à jour
     * Sinon, c'est un nouveau projet
     * @returns {*}
     */
    vm.isUpdate = function () {
      if (angular.isDefined(vm.ctx.project))
        return vm.ctx.project._id;
      return false;
    };

    /**
     * Close arte message
     */
    vm.closeAlert = function() {
      vm.alert = {};
    };    

    /**
     * Enregistre le projet en bdd Mongo et redirige vers le suivi du projet
     */
    vm.validate = function () {
      var alert = angular.element('#alert-message');
      if (angular.isUndefined(vm.ctx.project.signatureClient) || angular.isUndefined(vm.ctx.project.signatureDC)) {
        var modalSignatureClient = $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title-bottom',
          ariaDescribedBy: 'modal-body-bottom',
          templateUrl: 'signatureClient.html',
          windowTopClass: 'signature-client-modal',
          controller: ['$uibModalInstance', '$scope', signatureModalInstance],
          controllerAs: 'vm'
        });

        modalSignatureClient.result.then(function (result) {
          vm.ctx.project.signatureClient = result;

          var modalSignatureDC = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: 'signatureDC.html',
            windowTopClass: 'signature-dc-modal',
            controller: ['$uibModalInstance', '$scope', signatureModalInstance],
            controllerAs: 'vm'
          });

          modalSignatureDC.result.then(function (result) {
            vm.ctx.project.signatureDC = result;
            vm.ctx.project.nextState = null;
            vm.ctx.project.create = true;
            ProjetService.save().then(function () {
              vm.ctx.project.popin = true;
              $state.go('suivi-projet');
            });
          }).catch(function(reason){
            if(reason == 'empty'){
              vm.alert = {
                type: 'danger',
                msg: 'La signature du DC est obligatoire pour finaliser le projet.'
              };
              $document.scrollTo(alert, 30, 500);
            }
          });
        }).catch(function(reason){
          if(reason == 'empty'){
            vm.alert = {
              type: 'danger',
              msg: 'La signature du Client est obligatoire pour finaliser le projet.'
            };
            $document.scrollTo(alert, 30, 500);
          }
        });
      } else if (angular.isDefined(vm.ctx.project._id)) {
        ProjetService.save().then(function () {
          $state.go('suivi-projet');
        });
      }
    };

    /**
     * Met à jour le projet
     */
    vm.update = function () {
      vm.ctx.project.$update().then(function () {
        //$window.location.href = "#/suivi-projet";
        $state.go('suivi-projet');
      });
    };

    /**
     * Back to Suivi Projet
     */
    vm.backSuiviProjet = function(){
      ProjetService.setProject(vm.ctx.project);
      $state.go('suivi-projet', {'id': vm.ctx.project._id.$oid});
    };

    /**
     * If User allowedto update Project
     * @returns {boolean}
     */
    vm.allowedUpdate = function () {
      if (CurrentUser.hasRole('agence') || CurrentUser.hasRole('imprimeur') || CurrentUser.hasRole('installateur'))
        return false;
      if(CurrentUser.getRoles()[1] == 'dc' && vm.ctx.project.statut != 'Brouillon')
        return false;
      return true;
    };
  }

  /** @ngInject */
  function signatureModalInstance($uibModalInstance, $scope) {
    var vm = this;
    vm.done = function () {
      var signature = $scope.accept();
      if (angular.isUndefined(signature.dataUrl)) {
        $uibModalInstance.dismiss('empty');
      } else {
        $uibModalInstance.close(signature.dataUrl);
      }
    };
  }
})();
(function(){
  'use strict';

  angular
    .module('app')
    .controller('SmLivraisonController', SmLivraisonController);

  /** @ngInject */
  function SmLivraisonController($log, $document, $scope, ProjetService, Alert){
    var vm = this;
    vm.submitted = false;

    $document.scrollTop(0);

    /**
     * Récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      
    }

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.validate = function(form){
      vm.submitted = true;
      if(form.$invalid) {
        Alert.show("Formulaire invalide. Veuillez vérifier les données entourées en jaune.");
        return;
      }
      $scope.$emit('CallnextState', {});
    };

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.save = function(form){
      vm.submitted = true;      
      if(form.$invalid) {
        Alert.show("Formulaire invalide. Veuillez vérifier les données entourées en jaune.");
        return;
      }
      $scope.$emit('UpdateProject', {});
    };
  }

})();
(function(){
  'use strict';

  angular
    .module('app')
    .controller('SmAutresInfosController', SmAutresInfosController);

  /** @ngInject */
  function SmAutresInfosController($log, $document, $scope, 
    ProjetService, Alert, CurrentUser){
    var vm = this;
    vm.submitted = false;
    vm.isPose = false;

    // List Open days
    vm.arrayDays = ['Lundi','Mardi','Mercredi','Jeudi','Vendredi'];

    $document.scrollTop(0);

    /**
     * Récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      if(angular.isUndefined(vm.ctx.project.autresInfos)) {
        vm.ctx.project.autresInfos = {};
      }
      if(angular.isUndefined(vm.ctx.project.pose)) {
        vm.ctx.project.pose = {};
      }
      if(angular.isUndefined(vm.ctx.project.pose.contact)) {
        vm.ctx.project.pose.contact = {
          nom: CurrentUser.getDataNameUser(),
          email: CurrentUser.getUserMail(),
          telephone: CurrentUser.getUserPhone()
        };
      }
      fixEmptyArrayFromMongo();
      vm.isPose = vm.ctx.project.pose.pose === 'oui';
    }
    
    vm.changePose = function() {
      if(vm.ctx.project.pose.pose === 'oui') {
        vm.isPose = true;
      } else {
        vm.ctx.project.pose = { // Reset pose data execpt contact
          'pose': 'non',
          'contact': vm.ctx.project.pose.contact
        };
        vm.isPose = false;        
      }
    };
    
    /**
     * On change delete uncheck Days
     * @param item
     * @param index
     */
    vm.choseDay = function(item, index){
      if(item[index] === false) {
        delete vm.ctx.project.pose.jours[index];
      }
    };
    
    vm.onImpressionChange = function() {
      if(vm.ctx.project.autresInfos.impression === 'non') {
        // Remove quantité and livraison
        angular.forEach(vm.ctx.project.supports, function(support) {
          delete support.nombreExemplaire;          
        });
        delete vm.ctx.project.pdv.adresseIdemCommande;
        delete vm.ctx.project.pdv.adresseLivraison;
      }
    };
    
    /**
     * Mongo driver replaces empty object with empty array.     
     * Fix that.
     */
    function fixEmptyArrayFromMongo() {
      if(angular.isArray(vm.ctx.project.autresInfos) && 
        vm.ctx.project.autresInfos.length === 0) {
        vm.ctx.project.autresInfos = {};
      }
      if(angular.isArray(vm.ctx.project.pose) && 
        vm.ctx.project.pose.length === 0) {
        vm.ctx.project.pose = {};
      }
    }
    
    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.validate = function(form){
      vm.submitted = true;
      if(form.$invalid) {
        Alert.show("Formulaire invalide. Veuillez vérifier les données entourées en jaune.");
        return;
      } 
      $scope.$emit('CallnextState', {});
    };

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.save = function(form){
      vm.submitted = true;
      if(form.$invalid) {
        Alert.show("Formulaire invalide. Veuillez vérifier les données entourées en jaune.");
        return;
      }
      $scope.$emit('UpdateProject', {});
    };
  }

})();
(function(){
  'use strict';

  angular
    .module('app')
    .controller('SmContenuController', SmContenuController);

  /** @ngInject */
  function SmContenuController($log, $document, $scope, ProjetService){
    var vm = this;
    vm.submitted = false;

    $document.scrollTop(0);

    /**
     * Récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      
    }

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.validate = function(){
      vm.submitted = true;
      $scope.$emit('CallnextState', {});
    };

    /**
     * Check rules form and redirect to next state
     * @param form
     */
    vm.save = function(){
      vm.submitted = true;
      $scope.$emit('UpdateProject', {});
    };
  }

})();
(function () {
  'use strict';

  angular
      .module('app')
      .controller('SmInfoPdvController', SmInfoPdvController);

  /** @ngInject */
  function SmInfoPdvController($log, $document, $scope, ProjetService) {
    var vm = this;
    vm.submitted = false;

    vm.updateProject = false;

    $document.scrollTop(0);

    /**
     * récupère le current projet en cours de création
     * ou celui à modifier
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      // If project to update or not
      vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);

      if (angular.isUndefined(vm.ctx.project.pdv) || vm.ctx.project.pdv.length == 0) {
        vm.ctx.project.pdv = {};
      }
    }    

    /**
     * Enregistre les données du projet et redirige le user
     * @param form
     */
    vm.validate = function () {
      $scope.$emit('CallnextState', {});
    };

    /**
     * Update project and redirect to
     */
    vm.save = function(){
      $scope.$emit('UpdateProject', {});
    };
  }
})();

(function() {
  /*global angular */
  'use strict';

  /**
   * @ngdoc overview
   * @name mwaCore
   * @description
   * # mwaCore
   *
   * Core module of the application.
   */
  angular.module('mwaCore', []);  
})();
(function () {
  'use strict';

/**
 * Directive to bind file input to model. Replace ng-model in <input type="file" />
 * Correct use : <input type="file" sn-model-file="vm.fileToUpload" />
 */

  angular
    .module('mwaCore')
    .directive('snModelFile', SnModelFileDirective);

  /** @ngInject */
  function SnModelFileDirective() {
    return {
      scope: {
        snModelFile: "="
      },
      link: function (scope, element) {
        element.bind("change", function (changeEvent) {
          scope.$apply(function () {
            scope.snModelFile = changeEvent.target.files[0];
          });
        });
      }
    };
  }
})();
(function() {
  /*global angular */
  'use strict';

  /**
   * @ngdoc service
   * @name mwaApp.ActionService
   * @description
   * # ActionService
   * Provider in the mwaApp.
   */
  angular.module('mwaCore')
    .provider('ActionService', function() {

      // Private variables
      var actionByName = {};
      var actionByCategory = {};

      // Private constructor
      function ActionService() {
        var init = function() {
          var actionName, action, actionArray, category;

          // Group actions by category
          for (actionName in actionByName) {
            action = actionByName[actionName];
            actionArray = actionByCategory[action.category];
            if (!actionArray) {
              actionArray = [];
              actionByCategory[action.category] = actionArray;
            }
            actionArray.push(action);
          }

          // Reorders action depending on priority.
          for (category in actionByCategory) {
            actionByCategory[category].sort(sortAction);
          }
        };
        init();

        /**
         * @param {String} aCategory
         * @returns Array of action that belong to aCategory
         */
        this.getActions = function(aCategory) {
          return actionByCategory[aCategory];
        };

        this.getAction = function(anActionName) {
          return actionByName[anActionName];
        };
      }

      // Public API for configuration
      this.addActions = function(actionArray) {
        assert(actionArray !== null,
          'ActionServiceProvider.addActions(actionArray) : actionArray should not be null');
        assert(actionArray.constructor === Array,
          'ActionServiceProvider.addActions(actionArray) : actionArray should be an Array');

        actionArray.forEach(function(actionToRegister) {
          var action = actionByName[actionToRegister.name];
          if(action) {
            angular.merge(action, actionToRegister);
          } else {
            actionByName[actionToRegister.name] = actionToRegister;
          }
        });

        return this;
      };

      // Method for instantiating
      this.$get = function() {
        return new ActionService();
      };

      var assert = function(test, message) {
        if (!test) {
          throw message ? message : "assert failed";
        }
      };

      var sortAction = function(action1, action2) {
        if (!action1.priority && !action2.priority) {
          // no priority defined
          return 0;
        }
        if (!action1.priority) {
          // no priority for action1
          return -1;
        }
        if (!action2.priority) {
          // no priority for action2
          return +1;
        }
        if (action1.priority < action2.priority) {
          return -1;
        }
        if (action1.priority > action2.priority) {
          return +1;
        }
        return 0;  // same priority              
      };
    });
})();
(function () {
  'use strict';

  angular
    .module('app')
    .component('accueilSiege', AccueilSiege());

  /** @ngInject */
  function AccueilSiege() {

    return {
      templateUrl: 'app/main/accueil-siege/accueil-siege.html',
      controller: AccueilSiegeController,
      controllerAs: 'vm'
    };
  }

  /** @ngInject */
  function AccueilSiegeController($log, $state) {
    var vm = this;

    vm.go = function (stateName, status) {
      $state.go(stateName, {'q_statut': status});
    };
  }

})();
(function () {
    'use strict';
  
    angular
      .module('app')
      .component('accueilImprimeur', AccueilImprimeur());
  
    /** @ngInject */
    function AccueilImprimeur() {
  
      return {
        templateUrl: 'app/main/accueil-imprimeur/accueil-imprimeur.html',
        controller: AccueilImprimeurController,
        controllerAs: 'vm',
        bindings: {
          // Projet sur lequel effectuer l'action
          role: '<',
          searchFormat: '=?searchFormat',
          searchSupport: '=?searchSupport'
        }
      };
    }
  
    /** @ngInject */
    function AccueilImprimeurController($log, $state, countProjectByStatus) {
      var vm = this;
  
      vm.count = countProjectByStatus.get().$promise.then(function (data) {
  
        vm.countByStatus = {};
  
        angular.forEach(data,function(value){
          vm.countByStatus[value._id] = value.count;
        });
  
      });
  
  
      vm.go = function (stateName, status) {
        $state.go(stateName, {'q_statut': status});
      };
  
  
      vm.singular = function(data){
        if(data === 0 || data === 1){
          return 'projet';
        }
        return 'projets';
      }
  
    }
  
  
  })();
(function () {
  'use strict';

  angular
    .module('app')
    .component('accueilAgence', AccueilAgence());

  /** @ngInject */
  function AccueilAgence() {

    return {
      templateUrl: 'app/main/accueil-agence/accueil-agence.html',
      controller: AccueilAgenceController,
      controllerAs: 'vm',
      bindings: {
        // Projet sur lequel effectuer l'action
        role: '<',
        searchFormat: '=?searchFormat',
        searchSupport: '=?searchSupport'
      }
    };
  }

  /** @ngInject */
  function AccueilAgenceController($log, $state, countProjectByStatus) {
    var vm = this;

    vm.count = countProjectByStatus.get().$promise.then(function (data) {

      vm.countByStatus = {};

      angular.forEach(data,function(value){
        vm.countByStatus[value._id] = value.count;
      });

    });


    vm.go = function (stateName, status) {
      $state.go(stateName, {'q_statut': status});
    };


    vm.singular = function(data){
      if(data === 0 || data === 1){
        return 'projet';
      }
      return 'projets';
    }

  }


})();
(function() {
  /*global angular */
  'use strict';

  /**
   * @ngdoc overview
   * @name mwaCore
   * @description
   * # mwaCore
   *
   * Core module of the application.
   */
  angular.module('drupalHelper', []); 
  
  
})();
(function () {
  /*global angular */
  'use strict';

  angular.module('drupalHelper')
    .factory('CurrentUser', CurrentUser);

  /** @ngInject */
  function CurrentUser($resource, $q, $log, $window) {
    var currentUser = null;
    var currentConnect = null;
		var dataUser = null;

    var getCurrentUser = function () {
      return currentUser;
    };

    var userNull = function () {
      currentUser = null;
      currentConnect = null;
    };

    var connect = function () {
      var deferred = $q.defer();
      currentConnect = $resource('/jdrupal/connect?_format=json').get();
      var p1 = currentConnect.$promise;
      p1 = p1.then(
        function (data) {  // p1 success
          if(!data.roles) {
            $log.error("Password expired");
            $window.location.pathname = '/cms';
            return;
          }
          if (data.roles[0] === "anonymous") {
            // Anonymous user
            currentUser = null;
            deferred.resolve(currentUser);
          } else {
            // Identified user
            currentUser = $resource('/user/:id?_format=json').get({'id': data.uid});
            var p2 = currentConnect.$promise;
            p2.then(// p2 success
              function () {
								currentUser.$promise.then(function(data){
									dataUser = data;
									deferred.resolve(currentUser);
								});
              },
              function (error) {   // p2 error
                currentUser = null;
                currentConnect = null;
                deferred.reject(error);
              }
            );
          }
        },
        function (error) { // p1 error
          currentUser = null;
          currentConnect = null;
          deferred.reject(error);
        }
      );
      return deferred.promise;
    };

    /**
     * Return a promise 
     * 
     * @param {type} name
     * @param {type} password
     * @returns {unresolved}
     */
    var login = function (username, password) {
      var promise = $resource('/user/login?_format=json',
        {},
        {
          'userLogin': {
            'method': 'POST'
          }
        }
      ).userLogin({
        'name': username,
        'pass': password
      }).$promise;
      promise = promise.then(
        function () {
          return connect();
        },
        function (error) {
          $log.warn("ERROR in login()", error);
          userNull();
          return $q.reject(error);
        }
      );

      return promise;
    };

    var logout = function (afterLogoutCallback) {
      userNull();
      var promise = $resource('/user/logout').get().$promise;
      promise.then(
        function () {},
        afterLogoutCallback   // binded to error callback since userLogout() send a redirect.
        );
      return promise;
    };

    var getSmhfDc = function(idSmhf){
      var deferred = $q.defer();
      var promise = $resource('rest/myplv/data/user/:id').get({id:idSmhf});
      promise.$promise.then(function(result){
        deferred.resolve(result);
      });
      return deferred.promise;
    };

    var getRoles = function () {
      return currentConnect && currentConnect.roles ? currentConnect.roles : [];
    };

    var getUsername = function () {
      return currentConnect ? currentConnect.name : null;
    };

    var hasRole = function (aRole) {
      var roles = getRoles();
      return roles.indexOf(aRole) !== -1;
    };

		var getDataNameUser = function(){
			return dataUser && (dataUser.field_nom.length != 0) ? dataUser.field_nom[0].value : "";
		};

		var getDataFirstnameUser = function(){
			return dataUser && (dataUser.field_prenom.length != 0) ? dataUser.field_prenom[0].value : "";
		};

		var getUserMail = function(){
			return dataUser && (dataUser.mail.length != 0) ? dataUser.mail[0].value : "";
		};

		var getUserPhone = function(){
			return dataUser && (dataUser.field_user_telephone.length != 0) ? dataUser.field_user_telephone[0].value : "";
		};

    var getUserSmhf = function(){
      return dataUser && (dataUser.field_smhf_user.length != 0) ? dataUser.field_smhf_user[0].target_id : null;
    };

    var getUserMdv = function(){
      return dataUser && (dataUser.field_mdv_user.length != 0) ? dataUser.field_mdvf_user[0].target_id : null;
    };

    // Return public API
    return {
      // Retourne une promesse qui garantie que getCurrentUser()
      // retourne un resultat valide.
      connect: connect,
      // Retourne l'utilisateur identifié ou null si l'utilisateur 
      // n'est pas identifié
      // Doit être appelé après connect() sinon retourne null.
      getCurrentUser: getCurrentUser,
      // Retourne le SMHF du Dc connecté
      getSmhfDc: getSmhfDc,
      // Retourne les roles Drupal de l'utilisateur connecté
      getRoles: getRoles,
      // Retourne le nom d'utilisateur de l'utilisateur identifié, ou null sinon.
      getUsername: getUsername,
			// Retourne le nom de l'utilisateur identifié
			getDataNameUser: getDataNameUser,
			// Retourne le prénom de l'utilisateur identifié
			getDataFirstnameUser: getDataFirstnameUser,
			// Retourne l'email de l'utlisateur identifié
			getUserMail: getUserMail,
			// Retourne le téléphone de l'utilisateur
			getUserPhone: getUserPhone,
      // Retourne l'uid du smhf de l'utilisateur
      getUserSmhf: getUserSmhf,
      // Retourne l'uid du mdv de l'utilisateur
      getUserMdv: getUserMdv,
      // Retourne true si l'utilisateur a le role indique en parametre
      hasRole: hasRole,
      // Authentifie l'utilisateur et ouvre une connection.
      login: login,
      // Déconnecte l'utilisateur.
      logout: logout
    };
  }
})();

(function () {
    'use strict';
  
    angular
      .module('app')
      .controller('DaRecapitulatifController', DaRecapitulatifController);
  
    /** @ngInject */
    function DaRecapitulatifController($log, $scope, $state, $document, $window, 
                                        $uibModal, ProjetService, CurrentUser, canUpdateProject) {
      var vm = this;
      $document.scrollTop(0);
  
      /**
       * récupère le current projet en cours de création
       */
      vm.ctx = ProjetService.getProjectContext();
      vm.ctx.$promise.then(init);

    /**
     * If user Can Update Project
     * @type {boolean}
     */
    vm.canProjetUpdate = false;    
      function init() {
        canUpdateProject.get({id: vm.ctx.project._id.$oid}).$promise.then(function(result){
          vm.canProjetUpdate = result[0];
        });
      }
        
    }
})();
(function () {
    'use strict';
  
    angular
        .module('app')
        .controller('DaLivraisonController', DaLivraisonController);

    /** @ngInject */
    function DaLivraisonController($log, $state, $scope, $uibModal,
                                    $document, ProjetService, ChangeStatutService, CurrentUser, Alert) {
        var vm = this;
        vm.submitted = false;
        $document.scrollTop(0);
                  
        /**
         * récupère le current projet en cours de création
         */
        vm.ctx = ProjetService.getProjectContext();
        vm.ctx.$promise.then(init);

        function init() {
            if (CurrentUser.hasRole('dc')) {
              $state.go('da.dc.gamme', {}, {reload: true});
            }
            if (angular.isUndefined(vm.ctx.project.pdv.adresseLivraison)) {
                vm.ctx.project.pdv.adresseLivraison = {
                    nomPDV: vm.ctx.project.pdv.nomPDV,
                    adresse: vm.ctx.project.pdv.adresse,
                    codePostale: parseInt(vm.ctx.project.pdv.codePostal),
                    ville: vm.ctx.project.pdv.ville,
                    gerant: vm.ctx.project.pdv.nomClient,
                    telephone: vm.ctx.project.pdv.telephone
                }
            }
        }

        /**
         * Enregistre les données du projet et redirige le user
         * @param form
         */
        vm.validate = function (form) {
            vm.submitted = true;
            if (form.$invalid) {
                var errorValidation = angular.element('#errorValidation');
                $document.scrollTo(errorValidation, 30, 500);
                return;
            }
            vm.blockUI = true;
            if (angular.isUndefined(vm.ctx.project.signatureClient)) {
              var modalSignatureClient = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-bottom',
                ariaDescribedBy: 'modal-body-bottom',
                templateUrl: 'signatureClient.html',
                windowTopClass: 'signature-client-modal',
                controller: ['$uibModalInstance', '$scope', signatureModalInstance],
                controllerAs: 'vm'
              });
              
              modalSignatureClient.result.then(function (result) {
                vm.ctx.project.signatureClient = result;
                vm.changeStatut();
              }).catch(function(reason){
                if(reason == 'empty'){
                  Alert.show("La signature du Client est obligatoire pour finaliser le projet.");
                  return;
                }
              });
            } else if (angular.isDefined(vm.ctx.project._id)) {
              ProjetService.save().then(function () {
                $state.go('suivi-projet');
              });
            }
        };

        vm.changeStatut = function () {
            var text = "Votre projet a été passé à l'agence"
            ChangeStatutService.update(vm.ctx.project, "Agence", null)
              .then(function() {
                var modalStatut = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-bottom',
                  ariaDescribedBy: 'modal-body-bottom',
                  templateUrl: 'sendMsg.html',
                  controller: ['$uibModalInstance', 'projet', 'text', statutModal],
                  controllerAs: 'vm',
                  resolve:{
                    projet: function(){
                      return vm.ctx.project;
                    },
                    text: function(){
                      return text;
                    }
                  }
                });
                
                modalStatut.result.then(function(){
                  $state.go('suivi-projet');
                });
            });    
        }
    
        /**
         * Update project and redirect to
         */
        vm.save = function (form) {
            vm.submitted = true;
            if (form.$invalid) {
                var errorValidation = angular.element('#errorValidation');
                $document.scrollTo(errorValidation, 30, 500);
                return;
            }
            $scope.$emit('UpdateProject', {});
        };
    }

    /** @ngInject */
    function statutModal($uibModalInstance, projet, text){
        var vm = this;
        vm.text = text;
        vm.project = projet;
    }

  /** @ngInject */
  function signatureModalInstance($uibModalInstance, $scope) {
    var vm = this;
    vm.done = function () {
      var signature = $scope.accept();
      if (angular.isUndefined(signature.dataUrl)) {
        $uibModalInstance.dismiss('empty');
      } else {
        $uibModalInstance.close(signature.dataUrl);
      }
    };
  }
})();
(function () {
    'use strict';
  
    angular
        .module('app')
        .controller('DaContenuController', DaContenuController);

    /** @ngInject */
    function DaContenuController($log, $scope, $state, $document,  $uibModal, $location,
        ProjetService, IllustrationsService, FilesProjecttService, $window, CurrentUser, Alert) {
        var vm = this;
        vm.submitted = false;
        $document.scrollTop(0);
    
        /**
         * récupère le current projet en cours de création
         * ou le projet à modifier
         */
        vm.ctx = ProjetService.getProjectContext();
        vm.ctx.$promise.then(init);
        vm.submitted = false;

        vm.file_type = 'photo_carte';
        vm.uploader = vm.ctx.getUploader(vm.file_type);
                                    
        function init() {
            if (CurrentUser.hasRole('dc')) {
                $state.go('da.dc.gamme', {}, {reload: true});
            }
            // If project to update or not
            vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);
      
            /**
             * Init object contenu to add multiform
             */
            if (angular.isUndefined(vm.ctx.project.contenu) || vm.ctx.project.contenu.length == 0) {
              vm.ctx.project.contenu = {};
            }
      
            // If project has photo carte
            vm.hasPhoto = Object.keys(vm.ctx.project.contenu).length > 0 ? true : false;
      
            // Get files Project
            if (Object.keys(vm.ctx.project.contenu).length > 0) {
              FilesProjecttService.get({
                  id: vm.ctx.project._id.$oid
                })
                .$promise.then(function (result) {
                  vm.filesProject = result;
                });
            }
      
            /**
             * Load List Illustration
             */
            IllustrationsService.viewsLoad().$promise.then(function(result){
                vm.illustrations = result;
                vm.loading = false;
            });

            vm.nbIllust = 0; // Nbr Illust choisit

            if (angular.isDefined(vm.ctx.project.infocarte)) {
                if (angular.isDefined(vm.ctx.project.infocarte.illustrations)) {
                  if (angular.isDefined(vm.ctx.project.infocarte.illustrations.name))
                    vm.nbIllust = 1;
                  else {
                    vm.nbIllust = Object.keys(vm.ctx.project.infocarte.illustrations).length;
                  }
                }
            }
        }

        /**
         * Remove element unchecked
         * @param ele
         */
        vm.removeIllustrat = function (ele, img, index) {
            if (angular.isUndefined(ele)) {
                //$document.scrollTo(anchorSubmitIllustration, 30, 1000);
                vm.ctx.project.infocarte.illustrations.name = 'Aucune Illustration';
                vm.nbIllust = 0;
            } else if (ele == 'Aucune Illustration') {
                // uncheck other checkbox
                angular.forEach(vm.ctx.project.infocarte.illustrations, function (key, value) {
                    delete vm.ctx.project.infocarte.illustrations[value];
                });
                //$document.scrollTo(anchorSubmitIllustration, 30, 1000);
                vm.ctx.project.infocarte.illustrations.name = 'Aucune Illustration';
                vm.nbIllust = 0;
            } else if (angular.isDefined(ele.name)) {
                if (vm.nbIllust == -1)
                    vm.nbIllust = 0;
                vm.nbIllust++;
                ele.image = img;
                if (angular.isDefined(vm.ctx.project.infocarte.illustrations.name))
                    delete vm.ctx.project.infocarte.illustrations.name;// uncheck aucunIllustrations checkbox
            } else if (angular.isUndefined(ele.name)) {
                delete vm.ctx.project.infocarte.illustrations[index];
                vm.nbIllust = Object.keys(vm.ctx.project.infocarte.illustrations).length;
                if (vm.nbIllust == 0) {
                    vm.ctx.project.infocarte.illustrations.name = 'Aucune Illustration';
                    //$document.scrollTo(anchorSubmitIllustration, 30, 1000);
                }
            }
        };
        
        /**
         * Modifier Modification carte existante
         * @param photo
         */
        vm.modifCarte = function (photo) {
            var modalModifPhoto = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: 'modifPhoto.html',
            controller: ['$uibModalInstance', 'photo', modifPhoto],
            controllerAs: 'vm',
            resolve: {
                photo: function () {
                    return photo;
                }
            }
            });
    
            // Si on valide, on remplace les anciennes modification par les nouvelles
            modalModifPhoto.result.then(function (result) {
            photo.modificationCarte = result;
            });
        };
    
        /**
         * Remove photo from contenu property of project
         * @param index
         */
        vm.deletePhoto = function (index, item) {
            var modalDelePhoto = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: 'confirmDelePhoto.html'
            });
    
            modalDelePhoto.result.then(function () {
            item.remove(); // Remove from Uploader
            //vm.ctx.project.contenu.splice(item.file.name, 1);
            delete vm.ctx.project.contenu[item.file.firtsName]; // remove in data brief
            });
        };
    
        /**
         * Enregistre les données du projet et redirige le user
         * @param form
         */
        vm.validate = function () {
            vm.submitted = true;
            /*if (form.$invalid) {
                return;
            }*/
            if(angular.toJson(vm.ctx.project.contenu) === '{}') {
                Alert.show('Veuillez joindre au moins un fichier');
                return;
            }
            if (vm.nbIllust <= 0) {
                var errorIllustrations = angular.element('#errorIllustrations');
                $document.scrollTo(errorIllustrations, 30, 500);
                return;
            }
            $scope.$emit('CallnextState', {});
        };
    
        /**
         * Update project and redirect to
         */
        vm.save = function () {
            vm.submitted = true;
            /*if (form.$invalid) {
                return;
            }*/
            if(angular.toJson(vm.ctx.project.contenu) === '{}') {
                Alert.show('Veuillez joindre au moins un fichier');
                return;
            }
            if (vm.nbIllust <= 0) {
                var errorIllustrations = angular.element('#errorIllustrations');
                $document.scrollTo(errorIllustrations, 30, 500);
                return;
            }
            $scope.$emit('UpdateProject', {});
        }; 
    }

    /** @ngInject */
    function modifPhoto($uibModalInstance, photo) {
        var vm = this;

        // On récupère les modifs dans une variable
        vm.photoModif = photo.modificationCarte;

        // Lors de la validation, on récupère les modifications
        // Pour quelles remplace les anciennes
        vm.validate = function () {
        $uibModalInstance.close(vm.photoModif);
        };
    }
})();
(function () {
    'use strict';
  
    angular
        .module('app')
        .controller('DaBriefController', DaBriefController);

    /** @ngInject */
    function DaBriefController($log, $scope, $state,
                                $document, ProjetService, FilesProjectService, CurrentUser, Alert) {
        var vm = this;
        vm.submitted = false;
        $document.scrollTop(0);
        
        /**
         * récupère le current projet en cours de création
         */
        vm.ctx = ProjetService.getProjectContext();
        vm.ctx.$promise.then(init);
        vm.uploader = vm.ctx.getUploaderV2();

        function init() {
            if (CurrentUser.hasRole('dc')) {
                $state.go('da.dc.gamme', {}, {reload: true});
            }
            if (angular.isUndefined(vm.ctx.project.briefPDA)) {
                vm.ctx.project.briefPDA = "";
            }
            if (angular.isUndefined(vm.ctx.project.charte)) {
                vm.ctx.project.charte = {};
            }
            fixEmptyArrayFromMongo();
            FilesProjectService.get({id: vm.ctx.project._id.$oid})
                .$promise.then(function (result) {
                vm.filesProject = result;
            });
        }

        /**
         * Mongo driver replaces empty object with empty array.
         * Fix that.
         */
        function fixEmptyArrayFromMongo() {
            if (angular.isUndefined(vm.ctx.project.charte) || angular.isArray(vm.ctx.project.charte) &&
                vm.ctx.project.charte.length === 0) {
                vm.ctx.project.charte = {};
            }
            if (angular.isUndefined(vm.ctx.project.charte.photo_charte) || angular.isArray(vm.ctx.project.charte.photo_charte) &&
                vm.ctx.project.charte.photo_charte.length === 0) {
                vm.ctx.project.charte.photo_charte = {};
            }
            if (angular.isUndefined(vm.ctx.project.charte.photo_typo) || angular.isArray(vm.ctx.project.charte.photo_typo) &&
                vm.ctx.project.charte.photo_typo.length === 0) {
                vm.ctx.project.charte.photo_typo = {};
            }
            if (angular.isUndefined(vm.ctx.project.charte.photo_logo) || angular.isArray(vm.ctx.project.charte.photo_logo) &&
                vm.ctx.project.charte.photo_logo.length === 0) {
                vm.ctx.project.charte.photo_logo = {};
            }
        }

        /**
         * Validate and go to next page
         * @param form
         */
        vm.validate = function (form) {
            vm.submitted = true;
            if (vm.ctx.project.charte.charteClient == 'oui' && (!vm.ctx.project.charte.photo_charte || angular.toJson(vm.ctx.project.charte.photo_charte) === '{}')) {
                form.charteClient.$invalid = true;
                form.$invalid = true;
            }
            if (vm.ctx.project.charte.logoClient == 'oui' && (!vm.ctx.project.charte.photo_logo || angular.toJson(vm.ctx.project.charte.photo_logo)== '{}')) {
                form.logoClient.$invalid = true;
                form.$invalid = true;
            }
            if (vm.ctx.project.charte.typoClient == 'oui' && (!vm.ctx.project.charte.photo_typo || angular.toJson(vm.ctx.project.charte.photo_typo) === '{}')) {
                form.typoClient.$invalid = true;
                form.$invalid = true;
            }

            if (form.$invalid) {
                Alert.show("Formulaire invalide. Veuillez vérifier les données entourées en jaune.");
                return;
            }
            vm.ctx.project.briefPDA = $document[0].querySelector('#briefPDA').value;
            $scope.$emit('CallnextState', {});
        };
    
        /**
         * Save project
         * @param form
         */
        vm.save = function (form) {
            vm.submitted = true;

            if (vm.ctx.project.charte.charteClient == 'oui' && (!vm.ctx.project.charte.photo_charte || angular.toJson(vm.ctx.project.charte.photo_charte) === '{}')) {
                form.charteClient.$invalid = true;
                form.$invalid = true;
            }
            if (vm.ctx.project.charte.logoClient == 'oui' && (!vm.ctx.project.charte.photo_logo || angular.toJson(vm.ctx.project.charte.photo_logo)== '{}')) {
                form.logoClient.$invalid = true;
                form.$invalid = true;
            }
            if (vm.ctx.project.charte.typoClient == 'oui' && (!vm.ctx.project.charte.photo_typo || angular.toJson(vm.ctx.project.charte.photo_typo) === '{}')) {
                form.typoClient.$invalid = true;
                form.$invalid = true;
            }
            
            if (form.$invalid) {
                Alert.show("Formulaire incorrect. Veuillez vérifier les données.");
                return;
            }
            vm.ctx.project.briefPDA = $document[0].querySelector('#briefPDA').value;
            $scope.$emit('UpdateProject', {});
        };
    }
})();
(function () {
    'use strict';
  
    angular
        .module('app')
        .controller('DaFormatController', DaFormatController);

    /** @ngInject */
    function DaFormatController($log, $state, $scope, $uibModal, 
                                $document, ProjetService, 
                                FormatService, CurrentUser, TaxonomyService) {
        var vm = this;
        vm.submitted = false;
        $document.scrollTop(0);

        // Get all format
        vm.formats = FormatService.viewsLoadPDA();
        vm.materials = TaxonomyService.getMaterials();
        
        /**
         * récupère le current projet en cours de création
         */
        vm.ctx = ProjetService.getProjectContext();
        vm.ctx.$promise.then(init);

        function init() {
            if (CurrentUser.hasRole('dc')) {
                $state.go('da.dc.gamme', {}, {reload: true});
            }
            // If project to update or not
            vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);
        }
      
        /**
         * Ajoute l'url de image sélectionner
         * @param theme
         */
        var anchorSubmitFormat = angular.element('#submit-format');
        vm.formatChange = function (format) {
            vm.ctx.project.infocarte.format.image = format.field_media_image_3;
            vm.ctx.project.infocarte.format.media_format = format.field_media_format;
            vm.ctx.project.infocarte.format.field_1_volet = format.field_1_volet;
            vm.ctx.project.infocarte.format.field_2_volets = format.field_2_volets;
            $document.scrollTo(anchorSubmitFormat, 30, 1000);
        };

        /**
         * Valide le Format et passe à la page boissons
         * @param form
         */
        vm.validateFormat = function (form) {
            vm.submitted = true;
            if (form.$invalid) {
                var errorFormat = angular.element('#errorFormat');
                $document.scrollTo(errorFormat, 30, 500);
                return;
            }
            $scope.$emit('CallnextState', {});
        };
    
        /**
         * Update project and redirect to
         */
        vm.save = function (form) {
            vm.submitted = true;
            if (form.$invalid) {
                var errorFormat = angular.element('#errorFormat');
                $document.scrollTo(errorFormat, 30, 500);
                return;
            }
            $scope.$emit('UpdateProject', {});
        };

    }
})();
(function () {
    'use strict';
  
    angular
        .module('app')
        .controller('DaSupportController', DaSupportController);

    /** @ngInject */
    function DaSupportController($log, $state, $scope, $uibModal, 
                                $document, ProjetService, 
                                ModelesQrCodeService, ModelesQrCodeStickersService, ChangeStatutService, CurrentUser) {
        var vm = this;
        vm.submitted = false;
        
        $document.scrollTop(0);
    
        vm.nbrCarte = [30, 40, 50, 60, 70, 80, 90, 100];
        vm.nbrCarteQrCode = [
            "24 vignettes", "48 vignettes", "72 vignettes", "96 vignettes", "120 vignettes"
        ];

        /**
         * récupère le current projet en cours de création
         */
        vm.ctx = ProjetService.getProjectContext();
        vm.ctx.$promise.then(init);

        function init() {
            if (CurrentUser.hasRole('dc')) {
                $state.go('da.dc.gamme', {}, {reload: true});
            }

            ModelesQrCodeService.viewsLoad().$promise.then(function(result){
                vm.modelesqrcode = result;
                vm.loading = false;
            });

            ModelesQrCodeStickersService.viewsLoad().$promise.then(function(result){
                vm.modelesqrcodestickers = result;
                vm.loading = false;
            });

            // QrCode forcé à OUI. Demande du 21/06.
            if (angular.isUndefined(vm.ctx.project.infocarte) 
                || angular.isUndefined(vm.ctx.project.infocarte.qrcode)) {
                vm.ctx.project.infocarte = {
                    qrcode: 'oui',
                    impression: "carte_qrcode"
                }
            }

            //Si nombreExemplaireQrCode non compris dans la variable nbrCarteQrCode alors on initie sans valeur
            if (!vm.nbrCarteQrCode.includes(vm.ctx.project.infocarte.nombreExemplaireQrCode)) {
                vm.ctx.project.infocarte.nombreExemplaireQrCode = "";
            }
        }

        vm.changeQrCode = function (ouiOuNon) {
            switch(ouiOuNon) {
                case 'non':
                    vm.ctx.project.infocarte.impression = "carte";
                    break;
                case 'oui':
                    vm.ctx.project.infocarte.impression = "carte_qrcode";
                    break;
            }  
        }

        vm.changeModeleQrCode = function (modeleQrCode) {
            vm.ctx.project.infocarte.modeleQrCode.name = modeleQrCode.name;
            vm.ctx.project.infocarte.modeleQrCode.image = modeleQrCode.field_modele_qrcode_image;
        };
      
        vm.changeModeleQrCodeSticker = function (modeleQrCodeSticker) {
            vm.ctx.project.infocarte.modeleQrCodeSticker.name = modeleQrCodeSticker.name;
            vm.ctx.project.infocarte.modeleQrCodeSticker.image = modeleQrCodeSticker.field_modele_qrcode_image;
        };

        /**
         * Reset le nb d'exemplaire en fonction du mode d'impression choisie
         */
        vm.resetNbExemplaire = function() {
            if (vm.ctx.project.infocarte.qrcode === 'non') {
                vm.ctx.project.infocarte.nombreExemplaireQrCode = null;
                vm.ctx.project.infocarte.modeleQrCodeSticker = null;
            }
        }

        /**
         * Enregistre les données du projet et redirige le user
         * @param form
         */
        vm.validate = function (form) {
            vm.submitted = true;
            if (form.$invalid) {
                var errorValidation = angular.element('#errorValidation');
                $document.scrollTo(errorValidation, 30, 500);
                return;
            }
            vm.resetNbExemplaire();
            if (vm.ctx.project.statut == "Brouillon") {
                ChangeStatutService.update(vm.ctx.project, "Client", null).then(function(){
                    vm.ctx.project.statut = 'Client';
                    vm.ctx.project.pdv.comment = 'Changement de statut: Client';
                    $scope.$emit('CallnextState', {});
                });
            } else {
                $scope.$emit('CallnextState', {});
            }
        };
  
        /**
         * Update project and redirect to
         */
        vm.save = function (form) {
            vm.submitted = true;
            if (form.$invalid) {
                var errorValidation = angular.element('#errorValidation');
                $document.scrollTo(errorValidation, 30, 500);
                return;
            }
            vm.resetNbExemplaire();
            $scope.$emit('UpdateProject', {});
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .component('adminChangeStatutAction', adminChangeStatutAction());

  /** @ngInject */
  function adminChangeStatutAction() {

    return {
      templateUrl: 'app/components/suivi-projet-actions/admin-change-statut-action.html',
      controller: adminChangeStatutActionController,
      controllerAs: 'action',
      bindings: {
        // Projet sur lequel effectuer l'action
        projet: '<'
      }
    };

    /** @ngInject */
    function adminChangeStatutActionController($log, $state, $stateParams, $window,
      CurrentUser, ProjetService, AllowedStatutService) {
      var vm = this;

      /**
       * Get Current Project
       */
      vm.ctx = ProjetService.getProjectContext();
      vm.ctx.$promise.then(init);

      function init() {
        vm.statutProjet = AllowedStatutService.getProjetStatuts({id: vm.ctx.project._id.$oid});
      }

      /**
       * Control is the action is available (button displayed or not)
       * @returns {Boolean}
       */
      vm.isAvailable = function () {
        return CurrentUser.hasRole('siege') || CurrentUser.hasRole('administrator');
      };

      /**
       * Effectue l'action sur le projet (vm.projet)
       */
      vm.exec = function () {
        if (vm.selectedStatut
          && $window.confirm("Merci de confirmer.")) {
          vm.ctx.project.statut = vm.selectedStatut;
          ProjetService.save().then(goToSuivi, goToSuivi);
        }
      };

      function goToSuivi() {
        $state.transitionTo($state.current, $stateParams, {
          reload: true,
          inherit: false,
          notify: true
        });
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .component('statutProjetNavBar', {
      templateUrl: 'app/components/statut-projet-navbar/statut-projet-navbar.html',
      controller: function ($state, $log, $scope, ProjetService, AllowedStatutService) {
        var vm = this;

        /**
         * Get Current Project
         */
        vm.ctx = ProjetService.getProjectContext();
        vm.ctx.$promise.then(init);

        function init() {
          /**
           * Array d'enchainement des pages MyPlv
           * @type {string[]}
           */
          //vm.statutProjet = ['Brouillon','Agence','Validation DC','Validation Client','Exécution','Impression'];
          vm.statutProjet = AllowedStatutService.getProjetStatuts({id: vm.ctx.project._id.$oid});
        }
      },
      controllerAs: 'vm'
    });

})();

(function () {
  'use strict';

  angular
    .module('app')
    .component('suiviProjetAction', suiviProjetAction());

  /** @ngInject */
  function suiviProjetAction() {

    return {
      templateUrl: 'app/components/projet-actions/projet-action.html',
      controller: suiviProjetActionController,
      controllerAs: 'action',
      bindings: {
        // Projet sur lequel effectuer l'action
        projet: '<'
      }
    };

    /** @ngInject */
    function suiviProjetActionController($state, ProjetService, CurrentUser) {
      var vm = this;

      /**
       * Control is the action is available (button displayed or not)
       * @returns {Boolean}
       */
      vm.isAvailable = function() {
        return true;
      };

			/**
			 * If disabled, button is available but cannot be used.
			 */
			vm.isDisabled = function() {
        if (vm.projet.type === 'Direct Agence') {
          if (vm.projet.statut == 'Brouillon' && (CurrentUser.hasRole('dc') || CurrentUser.hasRole('client'))) {
            return true;
          }
          if (vm.projet.statut == 'Client' && CurrentUser.hasRole('client') && !vm.projet.signatureClient) {
            return true;
          }
          return false;
        }
				return CurrentUser.hasRole('siege') ? false : (!vm.projet.signatureClient && !vm.projet.signatureDC);
			};
      
      /**
       * Effectue l'action sur le projet (vm.projet)
       */
      vm.exec = function() {
        ProjetService.setProject(vm.projet);
        $state.go('suivi-projet', {'id': vm.projet._id.$oid});
      };
      
      // Classes bootstrap a appliquer au lien.
      vm.class = "btn btn-view"+(vm.isDisabled() ? " disabled" : "");

      // Title du lien
      vm.title = "Consulter";
      
      // Icon du bouton.
      vm.glyphiconClass = "glyphicon glyphicon-eye-open";
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .component('editProjetAction', editProjetAction());

  /** @ngInject */
  function editProjetAction() {

    return {
      templateUrl: 'app/components/projet-actions/projet-action.html',
      controller: editProjetActionController,
      controllerAs: 'action',
      bindings: {
        // Projet sur lequel effectuer l'action
        projet: '<'
      }
    };

    /** @ngInject */
    function editProjetActionController($log, $state, ProjetService, CurrentUser) {
      var vm = this;

      /**
       * Control is the action is available (button displayed or not)
       * @returns {Boolean}
       */
      vm.isAvailable = function() {
        if(CurrentUser.hasRole('siege') || CurrentUser.hasRole('administrator')){
          return true;
        }
        if(CurrentUser.hasRole('dc') && vm.projet.statut == 'Brouillon'){
          return true;
        }
        if(CurrentUser.hasRole('client') && (vm.projet.statut == 'Client' || vm.projet.statut == 'Brouillon')){
          return true;
        }
        return false;
      };
      
      /**
       * Effectue l'action sur le projet (vm.projet)
       */
      vm.exec = function() {
        var typeProj = "unknown_project_type";
        if (ProjetService.isCHR(vm.projet)) {
          typeProj = 'chr';
        } else if (ProjetService.isVAE(vm.projet)) {
          typeProj = 'vae';
        } else if (ProjetService.isPSM(vm.projet)) {
          typeProj = 'sm';
        } else if (ProjetService.isPDA(vm.projet)) {
          typeProj = 'da';
        } else {
          $log.error("UnSupported project type", vm.projet);
        }
        var state = vm.projet.nextState ? vm.projet.nextState : typeProj+'.info-pdv';
        ProjetService.setProject(vm.projet);
        $state.go(state, {'id': vm.projet._id.$oid});
      };
      
      // Classes bootstrap a appliquer au lien.
      vm.class = "btn btn-edit";

      // Title du lien
      vm.title = "Editer";
      
      // Icon du bouton.
      vm.glyphiconClass = "glyphicon glyphicon glyphicon-pencil";
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .component('downloadProjetAction', downloadProjetAction());

  /** @ngInject */
  function downloadProjetAction() {

    return {
      templateUrl: 'app/components/projet-actions/projet-action.html',
      controller: downloadProjetActionController,
      controllerAs: 'action',
      bindings: {
        // Projet sur lequel effectuer l'action
        projet: '<'
      }
    };

    /** @ngInject */
    function downloadProjetActionController($log) {
      var vm = this;
      
      /**
       * Control is the action is available (button displayed or not)
       * @returns {Boolean}
       */
      vm.isAvailable = function() {
        return vm.projet.statut != 'Brouillon' && vm.projet.statut != 'Agence';
      };
      
      /**
       * Effectue l'action sur le projet (vm.projet)
       */
      vm.exec = function() {
        $log.debug("DOWNLOAD");
      };
      
      // Classes bootstrap a appliquer au lien.
      vm.class = "btn btn-load";

      // Title du lien
      //vm.title = "Télécharger";
      
      // Icon du bouton.
      vm.glyphiconClass = "glyphicon glyphicon-download-alt";
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .component('deleteProjetAction', deleteProjetAction());

  /** @ngInject */
  function deleteProjetAction() {

    return {
      templateUrl: 'app/components/projet-actions/projet-action.html',
      controller: deleteProjetActionController,
      controllerAs: 'action',
      bindings: {
        // Projet sur lequel effectuer l'action
        projet: '<'
      }
    };

    /** @ngInject */
    function deleteProjetActionController($log, $uibModal, $state, CurrentUser) {
      var vm = this;

      /**
       * Control is the action is available (button displayed or not)
       * @returns {Boolean}
       */
      vm.isAvailable = function () {
        if (CurrentUser.hasRole('dc') && vm.projet.type === 'Direct Agence' && vm.projet.statut == 'Brouillon') {
          return true;
        }
        if(CurrentUser.hasRole('siege') && angular.isUndefined(vm.projet.eligibleQuota)){
          return true;
        }
        if((vm.projet.statut == 'Brouillon')
          && (CurrentUser.hasRole('dc') || CurrentUser.hasRole('mdv')) && angular.isUndefined(vm.projet.eligibleQuota)){
          return true;
        }
        return false;
      };

      /**
       * Effectue l'action sur le projet (vm.projet)
       */
      vm.exec = function () {
        $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title-bottom',
          ariaDescribedBy: 'modal-body-bottom',
          templateUrl: 'app/components/projet-actions/confirm-delete.html',
          controller: ['$uibModalInstance', '$state', 'project', deleteModalCtrl],
          controllerAs: 'vm',
          resolve: {
            project: function () {
              return vm.projet;
            }
          }
        });
      };

      // Classes bootstrap a appliquer au lien.
      vm.class = "btn btn-delete";

      // Title du lien
      vm.title = "Supprimer";

      // Icon du bouton.
      vm.glyphiconClass = "glyphicon glyphicon-trash";
    }
  }  
        
  /** @ngInject */
	function deleteModalCtrl($uibModalInstance, $state, project) {
		var vm = this;

		vm.project = project;

		/**
		 * Supprime un project
		 * et change le statut en fonction du statut de départ
		 */
		vm.deleteProject = function deleteProject() {
			/*if (project.statut == 'Validation DC' || project.statut == 'Creation') {
				ChangeStatutService.update({id: project._id, new_statut: 'Archive'}, project)
						.$promise.then(function () {
							projectLists.splice(projectLists.indexOf(project), 1);
							$uibModalInstance.close();
						});
			}
			else {*/
				project.$delete().then(function () {
          $state.reload();
					$uibModalInstance.close();
				});
			//}
		}
	}

})();

(function () {
  'use strict';

  angular
    .module('app')
    .component('cancelProjetAction', cancelProjetAction());

  /** @ngInject */
  function cancelProjetAction() {

    return {
      templateUrl: 'app/components/projet-actions/projet-action.html',
      controller: cancelProjetActionController,
      controllerAs: 'action',
      bindings: {
        // Projet sur lequel effectuer l'action
        projet: '<',
        ctx: '<'
      }
    };

    /** @ngInject */
    function cancelProjetActionController($log, $state, $uibModal, $document, $timeout, ProjetService, CurrentUser) {
      var vm = this;

      /**
       * Control is the action is available (button displayed or not)
       * @returns {Boolean}
       */
      vm.isAvailable = function() {
        if(CurrentUser.hasRole('siege') || CurrentUser.hasRole('administrator')){
          return true;
        }
        if((CurrentUser.hasRole('dc') || CurrentUser.hasRole('mdv')) && (vm.projet.statut == 'Agence' || vm.projet.statut == 'Validation DC')){
          return true;
        }
        return false;
      };

      /**
       * Effectue l'action sur le projet (vm.projet)
       */
      vm.exec = function() {
        ProjetService.setProject(vm.projet);
        $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title-bottom',
          ariaDescribedBy: 'modal-body-bottom',
          templateUrl: 'app/components/projet-actions/confirm-cancel.html',
          controller: ['$uibModalInstance', '$state', 'project',
            'ProjetService', cancelModalCtrl],
          controllerAs: 'vm',
          resolve: {
            project: function () {
              return vm.projet;
            }
          }
        }).result.then(function(){
            vm.ctx.class = [];
            vm.ctx.class[vm.projet.idprojet.nameProjet] = 'cancel-fade';
            vm.ctx.alert = {
              type: 'success',
              msg: 'Le projet '+vm.projet.idprojet.nameProjet+' à bien été Annulé !'
            };
            $document.scrollTop(0);
            $timeout(function(){
              vm.ctx.class = [];
            }, 0);
        });
      };

      // Classes bootstrap a appliquer au lien.
      vm.class = "btn btn-load-project";

      // Title du lien
      vm.title = "Annuler";

      // Icon du bouton.
      vm.glyphiconClass = "glyphicon glyphicon glyphicon-remove-circle";
    }
  }

  /** @ngInject */
  function cancelModalCtrl($uibModalInstance, $state, project, ProjetService) {
    var vm = this;

    vm.project = project;

    /**
     * Supprime un project
     * et change le statut en fonction du statut de départ
     */
    vm.cancelProject = function cancelProject() {
      vm.project.statut = 'Annulé';
      ProjetService.save().then(function () {
        $uibModalInstance.close();
      });
    }
  }

})();

(function () {
  'use strict';

  angular
      .module('app')
      .component('progressBarUpload', progressBarUpload());

  /** @ngInject */
  function progressBarUpload() {

    return {
      templateUrl: 'app/components/progress-bar-upload/progress-bar-upload.html',
      controller: progressBarUploadController,
      controllerAs: 'pbu',
      bindings: {
        // Projet sur lequel effectuer l'action
        uploader: '<'
      }
    };

    /** @nginject */
    function progressBarUploadController(){}

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .component('photoUpload', {
      templateUrl: 'app/components/photo-upload/photo-upload.html',
      controller: PhotoUploadController,
      controllerAs: 'vm',
      bindings: {
        photosObj: '<',
        uploader: '<',
        fileType: '<',
        annotationEnabled:'<'
      }
    });

  /** @ngInject */
  function PhotoUploadController($log, $scope, $window, $uibModal, 
    AnnotationPopin) {
      
    var vm = this;    
    
    /**
     * Component initialisation
     */
    vm.$onInit = function() {
      // Annotations are enabled by default.
      if(angular.isUndefined(vm.annotationEnabled)) {        
        vm.annotationEnabled = true;
      }
    };

    /**
     * Remove photo from contenu property of project
     * @param index
     */
    vm.deletePhoto = function (index, item) {
      var modalDelePhoto = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'app/components/photo-upload/photo-delete-confirm.html'
      });

      modalDelePhoto.result.then(function () {
        item.remove(); // Remove from Uploader
        delete vm.photosObj[item.file.firtsName]; // remove in data brief
      });
    };
    
    /**
     * Open annotation popin on photo in list.
     */
    vm.annotatePhoto = function(index, item) {      
      var fileSrc = ($window.URL || $window.webkitURL).createObjectURL(item._file);
      var photo = vm.photosObj[item.file.firtsName];
      var annotations = photo.anno;
      AnnotationPopin.open(
        fileSrc, 
        function(updatedAnnotations) {
          photo.anno = updatedAnnotations;
        }, 
        annotations
      );
    };
    
    /**
     * Open annnotation popin after photo selection
     */
    $scope.$watch('vm.file', function () {
      if (vm.file && vm.annotationEnabled) {
        var fileSrc = ($window.URL || $window.webkitURL).createObjectURL(vm.file);
        AnnotationPopin.open(fileSrc, onAnnotationPopinClosed);
      }
    });
    
    function onAnnotationPopinClosed(updatedAnnotations) {
      var fileName = vm.uploader.queue[vm.uploader.queue.length - 1].file.firtsName;
      // A la fermeture de la popin, on ajoute les annotations au projet      
      vm.photosObj[fileName].anno = updatedAnnotations;
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .component('photoListProjet', {
      templateUrl: 'app/components/photo-list-projet/photo-list-projet.html',
      controller: PhotoListProjetController,
      controllerAs: 'vm',
      bindings: {
        project: '<',      // project in mongo
        filesProject: '<',    // List of file related to this project on server
        canProjetUpdate: '<'
      }
    });

  /** @ngInject */
  function PhotoListProjetController($log, $uibModal, AnnotationPopin, PhotoFinder, Alert, ProjetService, CurrentUser, FilesProjecttService) {
    var vm = this;
    
    vm.user = CurrentUser;
    
    vm.files = null; // Files to be displayed
        
    vm.$onChanges = function(changeObj) {
      if(changeObj.filesProject && changeObj.filesProject.currentValue && vm.project) {
        // vm.filesProject is changed
        initFiles();
      }
    };
    
    /**
     * Init vm.files from vm.filesProject.
     * @returns {undefined}
     */
    function initFiles() {
      vm.files = [];
      angular.forEach(vm.filesProject, function(file) {
        var photoObj = PhotoFinder.findPhoto(file.filename, vm.project);
        file.photo = photoObj;
        vm.files.push(file);
      });
    }
    
    vm.isAnnotable = function(file) {
      var ext = file.filename.split('.').pop(); // get Extension file
      ext = ext.toLowerCase();
      var isExtOk = (['jpg','jpeg','png'].indexOf(ext) !== -1);
      return file.photo && isExtOk;
    };
    
    vm.annotate = function(file) {
      var annotations = null;
      if(vm.isAnnotable(file)) {
        annotations = file.photo.anno ? angular.copy(file.photo.anno) : [];   // Clone annotations
        AnnotationPopin.open(file.url, onAnnotationPopinClosed(file), annotations, vm.canProjetUpdate);
      } else {
        Alert.show("Fichier non annotable");
      }
    };
        
    function onAnnotationPopinClosed(file) {
      if(vm.canProjetUpdate) {
        return function(updatedAnnotations) {
          file.photo.anno = updatedAnnotations;   // Update annotations
          ProjetService.save().then(function () {
            Alert.show('Votre photo a bien été sauvegardée avec ses Post-its!', 'success');
            vm.project = ProjetService.getProjectContext().project;  // Refresh projects
            initFiles();         // Refresh files
          });
        };
      } else {
        return angular.noop;
      }
    }

    vm.openAddFilePopin = function() {
      var popin = $uibModal.open({
        //component: "addFileInviteModal",   // Need angular-ui-bootstrap 2.5.x to work
        controller: "AddFileInviteModalController",
        controllerAs: 'vm',
        templateUrl: "app/components/add-file-invite-modal/add-file-invite-modal.html",
        resolve: {
          projet: function() {
            return vm.project;
          }
        }
      });
      popin.result.then(function(){
        Alert.show("Invitation envoyée.", "success");
      });
    };
    
    vm.isAddFileEnabled = function() {
      var allowedStatus = ['Brouillon', 'Agence', 'Validation DC', 'Validation Client'];
      return  allowedStatus.indexOf(vm.project.statut) !== -1;
    };

    vm.delete = function(file) {
      vm.fileToDelete = file.filename;

      var modalStatut = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'confirmDelete.html',
        controller: ['$uibModalInstance', 'file', statutModal],
        controllerAs: 'vm',
        resolve:{
          file: function(){
            return file;
          }
        }
      });

      modalStatut.result.then(function(){
        FilesProjecttService.deleteFile(file.filename, ProjetService.getProjectContext().project._id.$oid).$promise.then(function (result) {
          if(result) {
            location.reload();
          } else {
            Alert.show("Echec de la suppression du fichier");
          }
        })
      });
    }
  }

  /** @ngInject */
  function statutModal($uibModalInstance, file){
    var vm = this;
    vm.fileToDelete = file.filename;
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .component('photoList', {
      templateUrl: 'app/components/photo-list/photo-list.html',
      controller: PhotoListController,
      controllerAs: 'vm',
      bindings: {
        photosObj: '<',      // JS obj that holds photo data. From mongo.
        filesProject: '<'    // List of file related to this project on server
      }
    });

  /** @ngInject */
  function PhotoListController($log, $uibModal, AnnotationPopin) {

    var vm = this;

    // Diplay list.
    vm.hasPhoto = false;
    
    // photoObj to be displayed. 
    vm.photosObjFiltered = null;

    /**
     * Initialize component.
     */
    vm.$onInit = function () {
      // If project has photo carte
      vm.hasPhoto = Object.keys(vm.photosObj).length > 0 ? true : false;
    };
    
    vm.$onChanges = function(changeObj) {
      if(changeObj.filesProject && changeObj.filesProject.currentValue) {
        vm.photosObjFiltered = [];
        for(var photoName in vm.photosObj) {
          if(getFileSrc(vm.photosObj[photoName])) {
            vm.photosObjFiltered.push(vm.photosObj[photoName]);
          }
        }
      } else {
        vm.photosObjFiltered = null;
      }
      vm.hasPhoto = vm.photosObjFiltered && vm.photosObjFiltered.length > 0;
    };

    /**
     * Modifier Modification carte existante
     * @param photo
     */
    vm.modifPhoto = function (photo) {
      var modalModifPhoto = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'app/components/photo-list/photo-modif-popin.html',
        controller: modifPhotoController,
        controllerAs: 'vm',
        resolve: {
          photo: function () {
            return photo;
          }
        }
      });

      // Si on valide, on remplace les anciennes modification par les nouvelles
      modalModifPhoto.result.then(function (result) {
        photo.comment = result;
      });
    };

    /** @ngInject */
    function modifPhotoController($uibModalInstance, photo) {
      var vm = this;

      // On récupère les modifs dans une variable
      vm.photoModif = photo.comment;

      // Lors de la validation, on récupère les modifications
      // Pour quelles remplace les anciennes
      vm.validate = function () {
        $uibModalInstance.close(vm.photoModif);
      };
    }
    
    /**
     * Open popin to annotate Image
     * @param file: file from service files project
     */
    vm.annotate = function(file){
      var annotations = file.anno,
        fileSrc = getFileSrc(file);
      
      AnnotationPopin.open(fileSrc, onAnnotationPopinClosed(file), annotations);
      
    };
    
    function onAnnotationPopinClosed(file) {
      return function(updatedAnnotations) {
        //$log.debug('onAnnotationPopinClosed()', updatedAnnotations);      
        file.anno = updatedAnnotations;
      };
    }
    
    function getFileSrc(file) {
      var i=0;
      for(i=0; i<vm.filesProject.length; ++i){
        if(vm.filesProject[i].filename.endsWith(file.photo)) {
          return vm.filesProject[i].url;
        }
      }
      $log.warn("No file found for ", file);
      return null;
    }
  }
})();
(function () {
	'use strict';

	angular
			.module('app')
			.component('navBarIcon', {

				templateUrl: 'app/components/navbar-icon/navbar-icon.html',
				controller: function($state){
					var vm = this;

					/**
					 * Récupère le menu courant
					 */
					vm.menu = $state.current.name;

					/**
					 * Array d'enchainement des pages MyPlv
					 * @type {string[]}
					 */
					vm.pageMenu = ['info-pdv','id-projet','carte','contenu','autres-informations','validation'];

					/**
					 * Empêche la navigation vers l'avant
					 * @param nav
					 * @returns {boolean}
					 */
					vm.navClick = function(nav){
						if(vm.pageMenu.indexOf(nav) > vm.pageMenu.indexOf(vm.menu)){
							return false
						} else {
							$state.go(nav);
						}
					};

					/**
					 * Ajout class active si menu actif
					 * @param menu
					 * @returns {boolean}
					 */
					vm.isSet = function(menu){
						return vm.menu == menu;
					};
				},
				controllerAs: 'vm'
			});

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('navbar', mwaNavbar);

  /** @ngInject */
  function mwaNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',      
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($location, ActionService) {
      var vm = this;
      vm.actions = ActionService.getActions('MAIN_MENU');
      vm.secondaryActions = ActionService.getActions('SECONDARY_MENU');
      
      /**
       * Displays action's label
       * @param {type} action
       * @returns String
       */
      vm.label = function(action) {
        return action.label ? action.label : action.name ;
      };
      
      /**
       * Executes action
       * @param {type} action
       * @returns void
       */
      vm.exec = function(action) {
        if(action.action) {
          action.action(action);
        
        } else if(action.url) {
          $location.url(action.url);
        }
      };
      
      /**
       * Returns true if action has children actions.
       * @param {type} action
       * @returns {undefined}
       */
      vm.hasSubMenu = function(action) {
        return action.subCategory != null;
      };
      
      /**
       * Returns subActions of action
       * @param {type} action
       * @returns {undefined}
       */
      vm.subActions = function(action) {
        var subActions = [];
        if(action.subCategory) {
          subActions = ActionService.getActions(action.subCategory);
        }
        return subActions;
      };
    }
  }

})();

(function(){
  'use strict';

  angular.module('app')
    .component('loadingScreen', loadingScreen());

  /** @ngInject */
  function loadingScreen(){

    return {
      templateUrl: 'app/components/loading-screen/loading-screen.html',
      controller: loadingScreenController,
      controllerAs: 'ls',
      bindings: {
        loading: '<'
      }
    };

    /** @ngInject */
    function loadingScreenController(){}
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .component('headerNav', {
      templateUrl: 'app/components/header/header-nav.html',
      controller: function ($window, $state, CurrentUser) {
        var vm = this;

        vm.home = function () {
          if (CurrentUser.getUsername() == 'imprimeurvae' || CurrentUser.getUsername() == 'imprimeur') {
            vm.url = "dashboard-imprimeur";
          } else {
            vm.url = "home";
          }
          $state.go(vm.url);
        };

        vm.logout = function () {
          CurrentUser.logout(
            function () {
              $window.location.href = "/";  // Force browser reload.
            }
          );
        };
      },
      controllerAs: 'hCtrl'
    });
})();

(function () {
  'use strict';

  angular
    .module('app')
    .component('gammeSelector', gammeSelector());

  /** @ngInject */
  function gammeSelector() {
    return {
      templateUrl: 'app/components/gamme-selector/gamme-selector.html',
      controller: GammeSelectorController,
      controllerAs: 'vm',
      bindings: {
        boissonsObj: '<',
        onBoissonAdded: '&', // callback function(addedBoisson, boissonModel, boissonType, addedIndex)
        onBoissonRemoved: '&'  // callback function(boissonModel, boissonType, removedIndex)
      }
    };

    /** @ngInject */
    function GammeSelectorController($log, $filter, GammeService, ProjetService, CurrentUser) {
      var vm = this;
      var projet = ProjetService.getProjectContext();
      vm.user = CurrentUser;

      /**
       * Boissons to be displayed
       */
      GammeService.viewsLoad().$promise.then(function(data) {
        vm.gammes = data.filter(function(itm){
          if (!itm.field_disponibilite.split(", ")) {
            return false;
          }
          return itm.field_disponibilite.split(", ").includes(projet.project.typeProjet);
        });
      });

      /**
       * if uncheck, remove boissons from array boissons
       * @param ele
       * @param parent
       * @param index
       */
      vm.onChangeBoissons = function (ele, parent, item, index) {
        if (vm.user.hasRole('client')) {
          return;
        }
        //$log.debug("onChangeBoissons()", ele, parent, item, index);
        if (ele[index].name !== false) {
          ele[index].name = ele[index].name.trim();
          // Added boisson => Trigger parent callback
          vm.onBoissonAdded({
            'addedBoisson': ele[index],
            'boissonModel': item,
            'boissonType': parent,
            'addedIndex': index
          });

        } else if (ele[index].name == false) {
          // Removed boissons => Delete item from Object array
          delete vm.boissonsObj[parent][index];
          if (Object.keys(vm.boissonsObj[parent]).length == 0) {
            delete vm.boissonsObj[parent];
          }

          // Trigger parent callback
          vm.onBoissonRemoved({
            'boissonModel': item,
            'boissonType': parent,
            'removedIndex': index
          });
        }
      };

      vm.selectAll = function (parent) {
        if (vm.user.hasRole('client')) {
          return;
        }
        var gamme = vm.gammes.filter(function(e) {
          return e.name.toLowerCase() === parent.toLowerCase();
        });
        gamme = $filter('orderBy')(gamme, 'weight_children');
        if(angular.isDefined(vm.boissonsObj) && angular.isDefined(vm.boissonsObj[parent]) && 
          Object.keys(vm.boissonsObj[parent]).length === gamme.length) {
          delete vm.boissonsObj[parent];
          return;
        }
        var obj = {}
        for(var i = 0; i < gamme.length; i++) {
          obj[i] = {'name' : gamme[i].fullName.trim()};
          vm.onBoissonAdded({
            'addedBoisson':  {'name': gamme[i].fullName.trim()},
            'boissonModel': gamme[i],
            'boissonType': parent,
            'addedIndex': i
          });
        }
        vm.boissonsObj[parent] = obj;
      };
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .component('gammeDisplay', gammeDisplay());

  /** @ngInject */
  function gammeDisplay() {
    return {
      templateUrl: 'app/components/gamme-display/gamme-display.html',
      controller: GammeDisplayController,
      controllerAs: 'vm',
      bindings: {
        boissonsObj: '<',
        onClick: '&'
      }
    };

    /** @ngInject */
    function GammeDisplayController($log, GammeService) {
      var vm = this;

      vm.$onInit = function() {
        vm.gammes = {};
        /**
         * Boissons to be displayed
         */
        GammeService.viewsLoad().$promise.then(function(data) {
          angular.forEach(data, function(boisson) {
            if(angular.isUndefined(vm.gammes[boisson.name])) {
              vm.gammes[boisson.name] = {
                'image': boisson.field_gamme_image_boissons_1
              };              
            }            
            vm.gammes[boisson.name][boisson.fullName] = {
              'image':  boisson.field_gamme_image_boissons
            };
          });
        }); 
      };
      
      vm.click = function() {
        vm.onClick();
      };
    }
  }
})();
(function(){
  'use strict';

  angular
      .module('app')
      .component('infoPdv', infoPdv());

  /** @ngInject */
  function infoPdv(){
    return {
      templateUrl: 'app/components/form-info-pdv/info-pdv.html',
      controller: infoPdvController,
      controllerAs: 'inf',
      bindings:{
        project: '<',
        updateProject: '<',
        validate: '&',
        save: '&'
      }
    };

    /** @ngInject */
    function infoPdvController(PdvInfoService, $uibModal, $state){
      var inf = this;

      inf.submitted = false;

      // If project to update or not
      inf.update = inf.updateProject;

      var allowedPDV = ['gold', 'platinum'];

      /**
       * Recupere les infos du point de vente.
       */
      inf.getPdvInfo = function () {
        var pdvInfo = PdvInfoService.get({'outlet': inf.project.pdv.nOutlet});
        pdvInfo.$promise.then(function (data) {
          if (data) {
            inf.project.pdv.medaillePDV = data.Segmentation__c;
            inf.project.pdv.nomPDV = data.Outlet_Name;
            inf.project.pdv.adresse = (data.House_Number__c ? data.House_Number__c+" " : "") +
            (data.Street__c ? data.Street__c : "") +
            (data.Street2__c ? "\n" + data.Street2__c : "") +
            (data.Street3__c ? "\n" + data.Street3__c : "");
            inf.project.pdv.codePostal = data.Postal_Code__c;
            inf.project.pdv.ville = data.City__c;
            inf.project.pdv.telephone = formatTel(data.Telephone__c);
            //inf.project.pdv.fax = data.Fax;
            inf.project.pdv.nSiret = data.SIRET__c;
            //inf.project.pdv.rcs = data.TO_BE_DEFINED;
            inf.project.pdv.nomClient = data.Owner_Name;
            inf.project.pdv.telephoneCLient = formatTel(data.Phone);
            inf.project.pdv.emailCLient = data.Email;
            inf.project.pdv.rcs = '';
          }

          var alertTemplate = 'alertUnknownPDV.html';
          if(data.Segmentation__c) {
            alertTemplate = 'alertNotSilverPDV.html';
          }

          var medaillePDV = '';
          if(inf.project.pdv.medaillePDV) {
            medaillePDV = inf.project.pdv.medaillePDV.trim().toLowerCase();
          }

          if( !allowedPDV.includes(medaillePDV) ) {
            // Alert PDV not eligible.
            var modal = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-bottom',
                ariaDescribedBy: 'modal-body-bottom',
                templateUrl: alertTemplate
            });

            modal.result.then(function () {
              $state.go('home');
            });
          }
        });
      };

      /**
       * Format Tel FR
       * @param tel
       * @returns {*}
       */
      var formatTel = function(tel) {
        if(tel) {
          tel = tel.replace("+33", "0");
        }
        return tel;
      };

      /**
       * Text type project
       * @returns {*}
       */
      inf.textTypeProj = function(){
        var textProj;
        switch (inf.project.type){
          case 'Carte Brasserie':
            textProj = 'La carte sera envoyéé';
            break;
          case 'Caissons Lumineux':
          case 'Boards PVC':
            textProj = 'Le board sera envoyé';
            break;
        }

        return textProj;
      };

      /**
       * Validate Form and call Validate() parent fonction
       * @param form
       */
      inf.validateForm = function (form){
        inf.submitted = true;
        if (form.$invalid){
          return;
        }

        var medaillePDV = '';
        if(inf.project.pdv.medaillePDV) {
          medaillePDV = inf.project.pdv.medaillePDV.trim().toLowerCase();
        }

        if( allowedPDV.includes(medaillePDV) ) {
          inf.validate();
        } else {
          // Alert PDV not eligible.
          var modal = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-bottom',
              ariaDescribedBy: 'modal-body-bottom',
              templateUrl: 'alertNotSilverPDV.html'
          });

          modal.result.then(function () {
            $state.go('home');
          });
        }
      };

      /**
       * Validate Form and call Save() parent fonction
       * @param form
       */
      inf.saveForm = function(form){
        inf.submitted = true;
        if (form.$invalid){
          return;
        }
        inf.save();
      };
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('app')
    .component('idProjet', idProjet());

  /** @ngInject */
  function idProjet(){
    return {
      templateUrl: 'app/components/form-id-projet/id-projet.html',
      controller: idProjetController,
      controllerAs: 'idp',
      bindings:{
        project: '<',
        updateProject: '<',
        previous: '&',
        validate: '&',
        save: '&'
      }
    };

    /** @ngInject */
    function idProjetController(UsersService, CurrentUser, $document){
      var idp = this;
      
      idp.submitted = false;
      idp.user = CurrentUser;
      //idp.planList = ['', 'Projet hors plan', 'Plan summer', 'Plan winter'];    // Version originale
      //idp.planList = ['', 'Plan summer', 'Plan winter'];                          // A supprimer le 1er aout 2026.
      idp.planList = ['', 'Plan winter'];                                       // A partir du 1er aout 2026.

      if(idp.project.$promise) {
        idp.project.$promise.then(init);
      } else {
        init();
      }

      function init() {
        // If project to update or not
        idp.updateProject = angular.isDefined(idp.project.signatureClient) || angular.isDefined(idp.project.signatureDC);

        idp.agenceMail = "";
        if (idp.project.agence) {
          UsersService.getAgenceMail({"agence": idp.project.agence}).$promise.then(function(result){
            idp.agenceMail = result.mail? result.mail : idp.agenceMail;
          });
        }
        /**
         * On créer les propiétés qui si elles ne sont pas définit. Si elle le sont
         * ça veut dire qu'elles contiennent des données et elle seront chargées dans le formulaire
         */
        if (angular.isUndefined(idp.project.idprojet)) {
          idp.project.idprojet = {
            nameProjet: idp.project.pdv.nomPDV,
            codeProjet: '',
            numProjet: ''
          };
        } else {
          var oldCodeProjet = idp.project.idprojet.codeProjet;
          idp.project.idprojet.nameProjet = idp.project.pdv.nomPDV;
        }
        if(idp.project.typeProjet == 'PSM' && angular.isUndefined(idp.project.briefPSM)) {
          idp.project.briefPSM = "";
        }
      }

      /**
       * Format code Projet with date : YYYY_MM_DD
       * @type {Date}
       */
      var codeOutlet = new Date();
      var month = codeOutlet.getUTCMonth() < 10 ? '0'+(codeOutlet.getUTCMonth()+1) : codeOutlet.getUTCMonth()+1;
      var day = codeOutlet.getUTCDate() < 10 ? '0'+codeOutlet.getUTCDate() : codeOutlet.getUTCDate();

      /**
       * Valid le nom Projet et passe à l'onglet Theme graphique
       * @param form
       */
      idp.validateNomProjet = function(form){
        if(idp.project.idprojet.codeProjet === '' || angular.isUndefined(idp.project.idprojet.codeProjet))
          idp.project.idprojet.codeProjet = codeOutlet.getFullYear()+'_'+month+'_'+day;

        idp.project.idprojet.numProjet = idp.project.pdv.nOutlet+'_'+idp.project.idprojet.codeProjet;

        idp.validMail = false;
        UsersService.checkMail({"mail": idp.agenceMail}).$promise.then(function(result){
          if (result.status == "OK" && result.agence) {
            idp.validMail = true;
          }
          form.$invalid =  (idp.validMail)? form.$invalid : true;
          idp.submitted = true;
          if (form.$invalid) {
            return;
          }
          idp.project.agence = result.agence;
          if (idp.project.typeProjet === 'PSM') {
            idp.project.briefPSM = $document[0].querySelector('#briefPSM').value;
          }
          idp.validate();
        });
      };

      /**
       * Update project and redirect to
       */
      idp.saveNomProjet = function(form){
        if(idp.project.idprojet.codeProjet == '')
          idp.project.idprojet.codeProjet = oldCodeProjet;
        //idp.project.idprojet.codeProjet = codeOutlet.getFullYear()+'_'+month+'_'+day;

        idp.project.idprojet.numProjet = idp.project.pdv.nOutlet+'_'+idp.project.idprojet.codeProjet;

        idp.validMail = false;
        UsersService.checkMail({"mail": idp.agenceMail}).$promise.then(function(result){
          if (result.status == "OK" && result.agence) {
            idp.validMail = true;
          }
          form.$invalid =  (idp.validMail)? form.$invalid : true;
          idp.submitted = true;
          if (form.$invalid) {
            return;
          }
          idp.project.agence = result.agence;
          if (idp.project.typeProjet == 'PSM') {
            idp.project.briefPSM = $document[0].querySelector('#briefPSM').value;
          }
          idp.save();
        });
      };
    }
  }
})();

(function(){
	'use strict';

	angular
			.module('app')
			.component('footerNav', {

				templateUrl: 'app/components/footer/footer-nav.html'
			});
})();

(function () {
  'use strict';

  angular
      .module('app')
      .component('filtreDashboard', filtreDashboard());

  /** @ngInject */
  function filtreDashboard() {

    return {
      templateUrl: 'app/components/filtre-dashboard/filtre-dashboard.html',
      controller: filtreDashboardController,
      controllerAs: 'db',
      bindings: {
        // Projet sur lequel effectuer l'action
        role: '<',
        searchFormat: '=?searchFormat',
        searchSupport: '=?searchSupport'
      }
    };

    /** @ngInject */
    function filtreDashboardController($log, CurrentUser, FormatService) {
      var vm = this;

      if(vm.role == 'dc'){
        vm.dc = true;
        vm.filtres = ['Carte Brasserie', 'VAE'];
        vm.textFiltre = 'Tous les supports';
      } else {
        vm.dc = false;
        FormatService.viewsLoad().$promise.then(function(result){
          vm.filtres = [];
          angular.forEach(result, function(key){
            vm.filtres.push(key.name);
          });
        });
        vm.textFiltre = 'Tous les formats';
      }
    }

  }

})();
(function () {
  'use strict';
  /*global moment */

  angular
    .module('app')
    .component('datePicker', datePicker())
    .run(initI18N);

  /** @ngInject */
  function datePicker() {

    return {
      templateUrl: 'app/components/date-picker/date-picker.html',
      controller: datePickerController,
      controllerAs: 'datePicker',
      bindings: {
        // Projet sur lequel effectuer l'action
        value: '<',
        onValueChange: '&'
      }
    };

    /** @ngInject */
    function datePickerController() {
      var vm = this;

      vm.opened = false;
      vm.dateOptions = {
        formatYear: 'yy',
        maxDate: new Date(2050, 1, 1),
        minDate: new Date(),
        startingDay: 1
      };

      vm.open = function () {
        vm.opened = true;
        //$log.debug("datePicker.open() : ", vm.opened);
      };

      vm.onChange = function () {
        if (vm.onValueChange) {
          //$log.debug('vm.value', vm.value.getTime());
          vm.onValueChange({selectedValue: vm.value.getTime()});
        }
      };

      vm.$onChanges = function (changesObj) {
        //$log.debug("datePickerController.$onChanges()", changesObj, vm.value);
        if (changesObj.value) {
          //$log.debug("datePickerController.$onChanges()", changesObj.value);
        }
      };
    }
  }

  /** @ngInject */
  function initI18N() {
    moment.locale('fr', {
      months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
      monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
      monthsParseExact: true,
      weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
      weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
      weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
      },
      calendar: {
        sameDay: '[Aujourd’hui à] LT',
        nextDay: '[Demain à] LT',
        nextWeek: 'dddd [à] LT',
        lastDay: '[Hier à] LT',
        lastWeek: 'dddd [dernier à] LT',
        sameElse: 'L'
      },
      relativeTime: {
        future: 'dans %s',
        past: 'il y a %s',
        s: 'quelques secondes',
        m: 'une minute',
        mm: '%d minutes',
        h: 'une heure',
        hh: '%d heures',
        d: 'un jour',
        dd: '%d jours',
        M: 'un mois',
        MM: '%d mois',
        y: 'un an',
        yy: '%d ans'
      },
      dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
      ordinal: function (number) {
        return number + (number === 1 ? 'er' : 'e');
      },
      meridiemParse: /PD|MD/,
      isPM: function (input) {
        return input.charAt(0) === 'M';
      },
      // In case the meridiem units are not separated around 12, then implement
      // this function (look at locale/id.js for an example).
      // meridiemHour : function (hour, meridiem) {
      //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
      // },
      meridiem: function (hours) {
        return hours < 12 ? 'PD' : 'MD';
      },
      week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
      }
    });
  }
})();

/**
 * Created by jjumarie on 16/06/2017.
 */
(function(){
  'use strict';

  angular
    .module('app')
    .component('brief',brief());

  /** @ngInject */
  function brief(){

    return {
      templateUrl: 'app/components/brief/brief.html',
      controller: briefController,
      controllerAs: 'brief',
      bindings: {
        // Projet sur lequel effectuer l'action
        projet: '<',
        board: '<'
      }
    };

    /** @ngInject */
    function briefController(){
      var vm = this;

      vm.state2items = ['menu-simple-pet-2-items','menu-can-2-items-coke','menu-can-2-items-mm','menu-autres-2-items-capri'];
      vm.state3items = ['menu-simple-pet-3-items','menu-can-3-items-coke','menu-can-3-items-mm', 'menu-simple-3-items-sans-option'];
      vm.state2x2items = ['menu-double-pet-2-items-coke','menu-double-pet-2-items-mm','menu-double-can-2-items-coke','menu-double-can-2-items-mm','menu-double-2-items-mm-sans-option'];
      vm.state2x3items = ['menu-double-pet-3-items-coke','menu-double-can-3-items-coke'];
      vm.stateStandard2018 = ['menu-standard-2018'];

      vm.labelPrixAutreFormule = '';

      /**
       * Show libelé autre formule
       * according to the menu
       */
      switch (vm.board.state){
        case 'menu-simple-pet-2-items':
          vm.labelPrixAutreFormule = 'Prix avec CAN 33cl';
          break;
        case 'menu-can-2-items-coke':
          vm.labelPrixAutreFormule = 'Prix avec PET 50cl';
          break;
        case 'menu-can-2-items-mm':
          vm.labelPrixAutreFormule = 'Prix avec PET 33cl';
          break;
        case 'menu-simple-pet-3-items':
          vm.labelPrixAutreFormule = 'Prix avec CAN 33cl';
          break;
        case 'menu-can-3-items-coke':
          vm.labelPrixAutreFormule = 'Prix avec PET 50cl';
          break;
        case 'menu-can-3-items-mm':
          vm.labelPrixAutreFormule = 'Prix avec PET 33cl';
          break;
        case 'menu-double-pet-2-items-coke':
          vm.labelPrixAutreFormule = 'Prix avec CAN 33cl';
          break;
        case 'menu-double-can-2-items-coke':
          vm.labelPrixAutreFormule = 'Prix avec PET 50cl';
          break;
        case 'menu-double-pet-2-items-mm':
          vm.labelPrixAutreFormule = 'Prix avec CAN 33cl';
          break;
        case 'menu-double-can-2-items-mm':
          vm.labelPrixAutreFormule = 'Prix avec PET 33cl';
          break;
        case 'menu-double-pet-3-items-coke':
          vm.labelPrixAutreFormule = 'Prix de la formule avec CAN 33cl';
          break;
        case 'menu-double-can-3-items-coke':
          vm.labelPrixAutreFormule = 'Prix de la formule avec PET 50cl';
          break;
      }

      // If gamme,
      vm.arrayBoissons = {};
      if(vm.board.state == 'gamme-prix'){
        var texte = '';
        angular.forEach(vm.board.brief, function(key){
          texte = '';
          vm.arrayBoissons[key.prix];
          angular.forEach(key.boissons, function(k,value){
            angular.forEach(k, function(boissons){
              texte += value+' '+boissons.name+', ';
            });
          });
          vm.arrayBoissons[key.prix] = texte;
        });
      }

      /**
       * Get Picture visuel Solide for menu 3,2x2,2x3 items
       * @param solide
       * @param rang
       * @returns {string}
       */
      vm.getSolidePicture = function(solide, rang){
        var pictureName = '';
        angular.forEach(solide, function(value){
          angular.forEach(value, function(visuel){
            if(visuel.numSolide == rang)
              pictureName = visuel.name;
          });
        });
        return pictureName;
      };
    }

  }
})();

(function(){
  'use strict';

  angular
    .module('app')
    .component('alertMessage',alertMessage());

  function alertMessage(){
    return {
      templateUrl: 'app/components/alert-message/alert-message.html',
      controller: AlertMessageController,
      controllerAs: 'vm'      
    };

    /** @ngInject */
    function AlertMessageController($log, $document, Alert){
      var vm = this;
      
      vm.type = "danger";
      
      /**
       * Component initialization
       */
      vm.$onInit = function() {
        //$log.debug("Alert.onInit()", Alert);
        Alert.addListener(this);
      };
      
      /**
       * Component release
       */
      vm.$onDestroy = function() {
        //$log.debug("Alert.$onDestroy()", Alert);
        Alert.removeListener(this);
      };
      
      /**
       * Alert callback.
       */
      vm.onAlert = function(alert, type) {
        vm.msg = alert;
        vm.type = type ? type : "danger";
        var alertDiv = angular.element('#alert-message');
        $document.scrollTo(alertDiv, 30, 500);
      };
      
      vm.closeAlert = function() {
        vm.msg = null;
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('app')
    .component('adresseLivraison',adresseLivraison());

  /** @ngInject */
  function adresseLivraison(){
    return {
      templateUrl: 'app/components/adresse-livraison/adresse-livraison.html',
      controller: AdresseLivraisonController,
      controllerAs: 'adr',
      bindings:{
        project: '<',
        submitted: '<',
        form: '<'
      }
    };

    /** @ngInject */
    function AdresseLivraisonController(){}
  }
})();
/**
 * Send an invitation to upload a file.
 */
(function () {
  'use strict';

  angular
    .module('app')
    .controller('AddFileInviteModalController', AddFileInviteModalController)
    //.component('addFileInviteModal', addFileInviteModal());
  
  /** @ngInject */
  /*
  function addFileInviteModal() {

    return {
      restrict: 'E',
      templateUrl: 'app/components/add-file-invite-modal/add-file-invite-modal.html',
      controller: "AddFileInviteModalController",
      controllerAs: 'vm',
      bindings: {
        // Projet sur lequel effectuer l'action
        projet: '<',
        board: '<'
      }
    };
  }
  */

  /** @ngInject */
  function AddFileInviteModalController($log, $uibModalInstance, 
    sendUploadFileInvite, projet) {

    var vm = this;
    
    // Project to attach the file to
    vm.projet = projet;

    // Form submitted flag
    vm.submitted = false;

    // Last error
    vm.lastError = null;

    // Form data
    vm.data = {
      projectId: vm.projet._id.$oid,
      destEmail: vm.projet.pdv.emailCLient,
      textEmail: "Bonjour, \n\n" +
        "Dans le cadre de votre projet de menu avec votre commercial Coca-Cola " +
        "merci d’ouvrir l’URL ci-dessous afin d’y déposer un fichier.\n\n"      
    }

    vm.submit = function(form) {
      vm.lastError = null;
      vm.submitted = true;
      if(form.$invalid) {
        return;
      }
      sendUploadFileInvite.send(vm.data).$promise.then(
        success,
        error
      );      
    }

    function success(data) {
      $uibModalInstance.close(data);
    }

    function error(err) {
      $log.error("Cannot sendUploadFileInvite", err);
      vm.lastError = err;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('ChrRecapitulatifController', ChrRecapitulatifController);

  /** @ngInject */
  function ChrRecapitulatifController($log, $scope, $state, $document, $window, $uibModal, ProjetService, FilesProjecttService, CurrentUser, canUpdateProject) {
    var vm = this;
    $document.scrollTop(0);

    /**
     * récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    /**
     * If user Can Update Project
     * @type {boolean}
     */
    vm.canProjetUpdate = false;

    vm.files = [];    

    function init() {
      canUpdateProject.get({id: vm.ctx.project._id.$oid}).$promise.then(function(result){
        vm.canProjetUpdate = result[0];
      });

      FilesProjecttService.get({id: vm.ctx.project._id.$oid}).$promise.then(function (result) {
        vm.files = result;
      })
    }

    /**
     * Si retour pas vide, il s'agit d'une mise à jour
     * Sinon, c'est un nouveau projet
     * @returns {*}
     */
    vm.isUpdate = function () {
      if (angular.isDefined(vm.ctx.project))
        return vm.ctx.project._id;
      return false;
    };

    /**
     * Close arte message
     */
    vm.closeAlert = function() {
      vm.alert = {};
    };

    /**
     * Enregistre le projet en bdd Mongo et redirige vers le suivi du projet
     */
    vm.validate = function () {
      if (angular.isUndefined(vm.ctx.project.signatureClient) || angular.isUndefined(vm.ctx.project.signatureDC)) {
        var modalSignatureClient = $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title-bottom',
          ariaDescribedBy: 'modal-body-bottom',
          templateUrl: 'signatureClient.html',
          windowTopClass: 'signature-client-modal',
          controller: ['$uibModalInstance', '$scope', signatureModalInstance],
          controllerAs: 'vm'
        });

        modalSignatureClient.result.then(function (result) {
          vm.ctx.project.signatureClient = result;

          var modalSignatureDC = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: 'signatureDC.html',
            windowTopClass: 'signature-dc-modal',
            controller: ['$uibModalInstance', '$scope', signatureModalInstance],
            controllerAs: 'vm'
          });

          modalSignatureDC.result.then(function (result) {
            vm.ctx.project.signatureDC = result;
            vm.ctx.project.nextState = null;
            vm.ctx.project.create = true;
            ProjetService.save().then(function () {
              vm.ctx.project.popin = true;
              $state.go('suivi-projet');
            });
          }).catch(function(reason){
            if(reason == 'empty'){
              vm.alert = {
                type: 'danger',
                msg: 'La signature du DC est obligatoire pour finaliser le projet.'
              };
              $document.scrollTo(alert, 30, 500);
            }
          });
        }).catch(function(reason){
          if(reason == 'empty'){
            vm.alert = {
              type: 'danger',
              msg: 'La signature du Client est obligatoire pour finaliser le projet.'
            };
            $document.scrollTo(alert, 30, 500);
          }
        });
      } else if (angular.isDefined(vm.ctx.project._id)) {
        ProjetService.save().then(function () {
          $state.go('suivi-projet');
        });
      }
    };

    vm.goQrCode = function (projet) {
      var pid = projet.originalId ? projet.originalId : projet._id.$oid;
      $state.go('qrcodes', {'id': pid, 'backId': projet._id.$oid});
    };

    /**
     * Met à jour le projet
     */
    vm.update = function () {
      vm.ctx.project.$update().then(function () {
        //$window.location.href = "#/suivi-projet";
        $state.go('suivi-projet');
      });
    };

    /**
     * If User allowedto update Project
     * @returns {boolean}
     */
    vm.allowedUpdate = function () {
      if (CurrentUser.getRoles()[1] == 'agence' || CurrentUser.getRoles()[1] == 'imprimeur')
        return false;
      if(CurrentUser.getRoles()[1] == 'dc' && vm.ctx.project.statut != 'Brouillon')
        return false;
      return true;
    };

    var CARTE   = "carte";
    var QRCODE  = "qrcode";
    var CARTE_ET_QRCODE  = "carte_qrcode";
    var CARTE_ET_MENU = "carte_menu";
    var CARTE_ET_QRCODE_ET_MENU = "carte_qrcode_menu";
    var AUCUN  = "aucun";
    
    vm.isImpressionCarte = function () {
      return vm.ctx.project.infocarte && (
          vm.ctx.project.infocarte.impression === CARTE || 
          vm.ctx.project.infocarte.impression === CARTE_ET_QRCODE ||
          vm.ctx.project.infocarte.impression === CARTE_ET_MENU ||
          vm.ctx.project.infocarte.impression === CARTE_ET_QRCODE_ET_MENU
      );
    };

    vm.isImpressionQrCode = function () {
      return vm.ctx.project.infocarte && (
        vm.ctx.project.infocarte.impression === QRCODE || 
        vm.ctx.project.infocarte.impression === CARTE_ET_QRCODE ||
        vm.ctx.project.infocarte.impression === CARTE_ET_QRCODE_ET_MENU
      );
    };

    vm.isImpressionMenu = function () {
      return vm.ctx.project.infocarte && (
        vm.ctx.project.infocarte.impression === CARTE_ET_MENU || 
        vm.ctx.project.infocarte.impression === CARTE_ET_QRCODE_ET_MENU
      );
    };
    
    vm.isImpressionAucun = function () {
      return vm.ctx.project.infocarte && (
          vm.ctx.project.infocarte.impression === AUCUN
      );
    };

    vm.isQrCodeEnabled = function () {
      return vm.ctx.project.infocarte && vm.ctx.project.infocarte.qrcode === 'oui';
    };
  }

  /** @ngInject */
  function signatureModalInstance($uibModalInstance, $scope) {
    var vm = this;
    vm.done = function () {
      var signature = $scope.accept();
      if (angular.isUndefined(signature.dataUrl)) {
        $uibModalInstance.dismiss('empty');
      } else {
        $uibModalInstance.close(signature.dataUrl);
      }
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('ChrLivraisonController', ChrLivraisonController);

  /** @ngInject */
  function ChrLivraisonController($log, $scope, $document, ModelesQrCodeService, ModelesQrCodeStickersService, ProjetService) {
    var vm = this;
    vm.submitted = false;
    $document.scrollTop(0);

    /**
     * Nombre de carte à choisir de 10 en 10, de 30 à 120
     * @type {number[]}
     */
    vm.nbrCarte = [30, 40, 50, 60, 70, 80, 90, 100];
    vm.nbrCarteQrCode = [
      "24 vignettes", "48 vignettes", "72 vignettes", "96 vignettes", "120 vignettes"
    ];
    vm.nbrCarteMenu = [
      "1xA3", "2xA3"
    ];

    /**
     * récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      // If project to update or not
      vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);

      ModelesQrCodeService.viewsLoad().$promise.then(function(result){
        vm.modelesqrcode = result;
        vm.loading = false;
      });

      ModelesQrCodeStickersService.viewsLoad().$promise.then(function(result){
        vm.modelesqrcodestickers = result;
        vm.loading = false;
      });

      // QrCode forcé à OUI. Demande du 21/06.
      vm.ctx.project.infocarte.qrcode = 'oui';

      //Si nombreExemplaireQrCode non compris dans la variable nbrCarteQrCode alors on initie sans valeur
      if (!vm.nbrCarteQrCode.includes(vm.ctx.project.infocarte.nombreExemplaireQrCode)) {
        vm.ctx.project.infocarte.nombreExemplaireQrCode = "";
      }

      //Si nombreExemplaireMenu non compris dans la variable nbrCarteMenu alors on initie sans valeur
      if (!vm.nbrCarteMenu.includes(vm.ctx.project.infocarte.nombreExemplaireMenu)) {
        vm.ctx.project.infocarte.nombreExemplaireMenu = "";
      }
    }

    var CARTE   = "carte";
    var QRCODE  = "qrcode";
    var CARTE_ET_QRCODE  = "carte_qrcode";
    var CARTE_ET_MENU = "carte_menu";
    var CARTE_ET_QRCODE_ET_MENU = "carte_qrcode_menu";
    var AUCUN  = "aucun";

    /**
     * Options d'impression
     */
    vm.impressionList = [{
      label: "Carte seulement", value: CARTE
    }, {
      label: "QrCode seulement", value: QRCODE
    }, {
      label: "Carte et QrCode", value: CARTE_ET_QRCODE
    }, {
      label: "Carte et menu extérieur", value: CARTE_ET_MENU
    }, {
      label: "Carte, QrCode et menu extérieur", value: CARTE_ET_QRCODE_ET_MENU
    }, {
      label: "Aucune impression", value: AUCUN
    }];

    /**
     * Options d'impression
     */
    vm.impressionListNoQrCode = [{
      label: "Carte seulement", value: CARTE
    }, {
      label: "Carte et menu extérieur", value: CARTE_ET_MENU
    }, {
      label: "Aucune impression", value: AUCUN
    }];


    /**
     * Add livraison adresse
     */
    vm.addLivraison = function () {
      vm.ctx.project.pdv.adresseLivraison = {}
    };

    /**
     * qrCode ?
     */
    vm.qrCodeEnabled = function () {
      return vm.ctx.project.infocarte && vm.ctx.project.infocarte.qrcode === 'oui';
    };

    vm.changeQrCode = function (ouiOuNon) {
      if(ouiOuNon === 'non') {
        vm.ctx.project.infocarte.impression = CARTE;
      }
    }

    vm.changeModeleQrCode = function (modeleQrCode) {
      vm.ctx.project.infocarte.modeleQrCode.name = modeleQrCode.name;
      vm.ctx.project.infocarte.modeleQrCode.image = modeleQrCode.field_modele_qrcode_image;
    };

    vm.changeModeleQrCodeSticker = function (modeleQrCodeSticker) {
      vm.ctx.project.infocarte.modeleQrCodeSticker.name = modeleQrCodeSticker.name;
      vm.ctx.project.infocarte.modeleQrCodeSticker.image = modeleQrCodeSticker.field_modele_qrcode_image;
    };


    vm.isImpressionCarte = function () {
      return vm.ctx.project.infocarte && (
          vm.ctx.project.infocarte.impression === CARTE || 
          vm.ctx.project.infocarte.impression === CARTE_ET_QRCODE ||
          vm.ctx.project.infocarte.impression === CARTE_ET_MENU ||
          vm.ctx.project.infocarte.impression === CARTE_ET_QRCODE_ET_MENU
      );
    };

    vm.isImpressionQrCode = function () {
      return vm.ctx.project.infocarte && (
        vm.ctx.project.infocarte.impression === QRCODE || 
        vm.ctx.project.infocarte.impression === CARTE_ET_QRCODE ||
        vm.ctx.project.infocarte.impression === CARTE_ET_QRCODE_ET_MENU
      );
    };

    vm.isImpressionMenu = function () {
      return vm.ctx.project.infocarte && (
        vm.ctx.project.infocarte.impression === CARTE_ET_MENU || 
        vm.ctx.project.infocarte.impression === CARTE_ET_QRCODE_ET_MENU
      );
    };

    /**
     * Reset le nb d'exemplaire en fonction du mode d'impression choisie
     */
    vm.resetNbExemplaire = function() {
      if(!vm.isImpressionCarte()) {
        vm.ctx.project.infocarte.nombreExemplaire = null;
      }
      if(!vm.isImpressionQrCode()) {
        vm.ctx.project.infocarte.nombreExemplaireQrCode = null;
        vm.ctx.project.infocarte.modeleQrCodeSticker = null;
      }
      if(!vm.isImpressionMenu()) {
        vm.ctx.project.infocarte.nombreExemplaireMenu = null;
      }
    }

    /**
     * Remove livraison adresse
     */
    vm.removeLivraison = function () {
      delete vm.ctx.project.pdv.adresseLivraison;
    };

    /**
     * Enregistre les données du projet et redirige le user
     * @param form
     */
    vm.validate = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        var errorValidation = angular.element('#errorValidation');
        $document.scrollTo(errorValidation, 30, 500);
        return;
      }
      vm.resetNbExemplaire();
      $scope.$emit('CallnextState', {});
    };

    /**
     * Update project and redirect to
     */
    vm.save = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        var errorValidation = angular.element('#errorValidation');
        $document.scrollTo(errorValidation, 30, 500);
        return;
      }
      vm.resetNbExemplaire();
      $scope.$emit('UpdateProject', {});
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('ChrAutresInfosController', ChrAutresInfosController);

  /** @ngInject **/
  function ChrAutresInfosController($log, $scope, $document, ProjetService, CurrentUser, sendUploadFileInvite, Alert) {
    var vm = this;
    vm.submitted = false;
    $document.scrollTop(0);

    /**
     * récupère le current projet en cours de création
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);
    vm.user = CurrentUser;

    function init() {
      // If project to update or not
      vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);

      ///**
      // * Get Mentions Légales
      // */
      //vm.mentions = MentionsService.viewsLoad();
      if (angular.isDefined(vm.ctx.project.autresInfos)) {
        if (angular.isDefined(vm.ctx.project.autresInfos.heureouverture))
          vm.ctx.project.autresInfos.heureouverture = new Date(vm.ctx.project.autresInfos.heureouverture);
        if (angular.isDefined(vm.ctx.project.autresInfos.heurefermeture))
          vm.ctx.project.autresInfos.heurefermeture = new Date(vm.ctx.project.autresInfos.heurefermeture);
        if (angular.isUndefined(vm.ctx.project.autresInfos.telephoneDC) || (angular.isDefined(vm.ctx.project.autresInfos.telephoneDC) && !vm.ctx.project.autresInfos.telephoneDC)) {
          vm.ctx.project.autresInfos.telephoneDC = vm.user.getUserPhone();
        }
      } else {
        vm.ctx.project.autresInfos = {
          telephoneDC :  vm.user.getUserPhone()
        };
      }
    }

    /**
     * Enregistre les données du projet et redirige le user
     * @param form
     */
    vm.validate = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        var errorAutresInfos = angular.element('#errorAutresInfos');
        $document.scrollTo(errorAutresInfos, 30, 500);
        return;
      }
      $scope.$emit('CallnextState', {});
    };

    /**
     * Update project and redirect to
     */
    vm.save = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        var errorAutresInfos = angular.element('#errorAutresInfos');
        $document.scrollTo(errorAutresInfos, 30, 500);
        return;
      }
      $scope.$emit('UpdateProject', {});
    };
  
    vm.sendEmail = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        return;
      }
  
      vm.data = {
        projectId: vm.ctx.project._id.$oid,
        destEmail: vm.ctx.project.pdv.emailCLient,
        textEmail: "Bonjour, \n\n" +
          "Dans le cadre de votre projet de menu avec votre commercial Coca-Cola " +
          "merci de déposer le logo à intégrer dans la carte.\n\n"
      }
  
      sendUploadFileInvite.send(vm.data).$promise.then(
        success,
        error
      );
    }

    function success() {
      Alert.show("L'Email a bien été envoyé", "success");
    }

    function error(err) {
      $log.error("Cannot sendUploadFileInvite", err);
      Alert.show("Une erreur s'est produite, l'email n'a pas pu être envoyé");
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('ChrPhotoController', ChrPhotoController);

  /** @ngInject */
  function ChrPhotoController($log, $scope, $document, $uibModal, $location,
    ProjetService, AnnotationPopin, FilesProjecttService, $window, sendUploadFileInvite, Alert) {
    var vm = this;

    
    $document.scrollTop(0);

    /**
     * récupère le current projet en cours de création
     * ou le projet à modifier
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);
    var fileNameAnnotate = ''; // Filename to annotate
    var arraySrcFile = {};
    vm.submitted = false;

    vm.file_type = 'photo_carte';
    vm.uploader = vm.ctx.getUploader(vm.file_type);

    function init() {
      // If project to update or not
      vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);

      /**
       * Init object contenu to add multiform
       */
      if (angular.isUndefined(vm.ctx.project.contenu) || vm.ctx.project.contenu.length == 0) {
        vm.ctx.project.contenu = {};
      }

      // If project has photo carte
      vm.hasPhoto = Object.keys(vm.ctx.project.contenu).length > 0 ? true : false;

      // Get files Project
      if (Object.keys(vm.ctx.project.contenu).length > 0) {
        FilesProjecttService.get({
            id: vm.ctx.project._id.$oid
          })
          .$promise.then(function (result) {
            vm.filesProject = result;
          });
      }

      /**
       * Ajout de propiétés : "contenu_fichier_texte" au projet, si elles ne sont pas définies.
       * Si elles le sont déjà, leurs données seront chargées dans le formulaire
       */
      if (angular.isUndefined(vm.ctx.project.contenu_fichier_texte)) {
        vm.ctx.project.contenu_fichier_texte = {
          hasFichierTexte: '',
          emailCLient: vm.ctx.project.pdv.emailCLient
        };
      }

      /**
       * Annotation Photo
       * @type {Array}
       */
      vm.file = null;
      vm.fileSrc = null;
    }

    $scope.$watch('main.file', function () {
      if (vm.file) {
        vm.fileSrc = ($window.URL || $window.webkitURL).createObjectURL(vm.file);
        AnnotationPopin.open(vm.fileSrc, onAnnotationPopinClosed);
      } else {
        vm.fileSrc = null;
      }
    });

    var onAnnotationPopinClosed = function (updatedAnnotations) {
      //$log.debug('onAnnotationPopinClosed()', updatedAnnotations);
      var fileName;
      // A la fermeture de la popin, on ajoute les annotations au projet
      if (fileNameAnnotate != '') {
        fileName = fileNameAnnotate;
        fileNameAnnotate = '';
      } else {
        fileName = vm.uploader.queue[vm.uploader.queue.length - 1].file.firtsName;
        arraySrcFile[fileName] = {
          fileSrc: vm.fileSrc
        };
      }

      vm.ctx.project.contenu[fileName].anno = updatedAnnotations;
    };

    /**
     * Open popin to annotate Image
     * @param file: file from service files project
     */
    vm.annotate = function (file, k) {
      var keep = true;
      var annotations = getAnnotations(file);
      if (angular.isDefined(arraySrcFile[k]) && arraySrcFile[k].fileSrc != '') {
        AnnotationPopin.open(vm.fileSrc, onAnnotationPopinClosed, annotations);
      } else {
        angular.forEach(vm.filesProject, function (photo) {
          if (keep) {
            var test = photo.filename.replace('photo_carte_', '');
            if (test == file.photo) {
              fileNameAnnotate = k;
              if (photo.url != null) {
                AnnotationPopin.open(photo.url, onAnnotationPopinClosed, annotations);
              }
              keep = false;
            }
          }
        });
      }
    };

    /**
     * Return list anno photo
     * @param photo
     * @returns {Array}
     */
    var getAnnotations = function (photo) {
      var arrayAnno = [];
      angular.forEach(photo.anno, function (annot) {
        arrayAnno.push(annot);
      });
      return arrayAnno;
    };

    /**
     * Modifier Modification carte existante
     * @param photo
     */
    vm.modifCarte = function (photo) {
      var modalModifPhoto = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'modifPhoto.html',
        controller: ['$uibModalInstance', 'photo', modifPhoto],
        controllerAs: 'vm',
        resolve: {
          photo: function () {
            return photo;
          }
        }
      });

      // Si on valide, on remplace les anciennes modification par les nouvelles
      modalModifPhoto.result.then(function (result) {
        photo.modificationCarte = result;
      });
    };

    /**
     * Remove photo from contenu property of project
     * @param index
     */
    vm.deletePhoto = function (index, item) {
      var modalDelePhoto = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'confirmDelePhoto.html'
      });

      modalDelePhoto.result.then(function () {
        item.remove(); // Remove from Uploader
        //vm.ctx.project.contenu.splice(item.file.name, 1);
        delete vm.ctx.project.contenu[item.file.firtsName]; // remove in data brief
      });
    };

    /**
     * Enregistre les données du projet et redirige le user
     * @param form
     */
    vm.validate = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        return;
      }
      $scope.$emit('CallnextState', {});
    };

    /**
     * Update project and redirect to
     */
    vm.save = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        return;
      }

      $scope.$emit('UpdateProject', {});
    };

    vm.sendEmail = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        return;
      }

      vm.data = {
        projectId: vm.ctx.project._id.$oid,
        destEmail: vm.ctx.project.contenu_fichier_texte.emailCLient,
        textEmail: "Bonjour, \n\n" +
          "Dans le cadre de votre projet de menu avec votre commercial Coca-Cola " +
          "merci de déposer le fichier texte contenant les tarifs à mettre dans la carte.\n\n"
      }

      sendUploadFileInvite.send(vm.data).$promise.then(
        success,
        error
      );
    }

    function success() {
      Alert.show("L'Email a bien été envoyé", "success");
    }

    function error(err) {
      $log.error("Cannot sendUploadFileInvite", err);
      Alert.show("Une erreur s'est produite, l'email n'a pas pu être envoyé");
    }
  }

  /** @ngInject */
  function modifPhoto($uibModalInstance, photo) {
    var vm = this;

    // On récupère les modifs dans une variable
    vm.photoModif = photo.modificationCarte;

    // Lors de la validation, on récupère les modifications
    // Pour quelles remplace les anciennes
    vm.validate = function () {
      $uibModalInstance.close(vm.photoModif);
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('ChrInfoPdvController', ChrInfoPdvController);

  /** @ngInject */
  function ChrInfoPdvController($log, $state, $document, $scope, ProjetService, PdvInfoService) {
    var vm = this;
    vm.submitted = false;

    vm.updateProject = false;

    $document.scrollTop(0);

    /**
     * récupère le current projet en cours de création
     * ou celui à modifier
     */
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);

    function init() {
      // If project to update or not
      vm.updateProject = angular.isDefined(vm.ctx.project.signatureClient) || angular.isDefined(vm.ctx.project.signatureDC);
      vm.name = $state.current.name;

      if (angular.isUndefined(vm.ctx.project.pdv) || vm.ctx.project.pdv.length == 0) {
        vm.ctx.project.pdv = {};
      }
    }

    /**
     * Enregistre les données du projet et redirige le user
     * @param form
     */
    vm.validate = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        return;
      }
      $scope.$emit('CallnextState', {});
    };

    /**
     * Update project and redirect to
     */
    vm.save = function (form) {
      vm.submitted = true;
      if (form.$invalid) {
        return;
      }
      if (angular.isDefined(vm.ctx.project.idprojet)) {
        vm.ctx.project.idprojet.nameProjet = vm.ctx.project.pdv.nomPDV;
      }
      $scope.$emit('UpdateProject', {});
    };

    /**
     * Recupere les infos du point de vente.
     */
    vm.getPdvInfo = function () {
      var pdvInfo = PdvInfoService.get({'outlet': vm.ctx.project.pdv.nOutlet});
      pdvInfo.$promise.then(function (data) {
        if (data) {
          vm.ctx.project.pdv.medaillePDV = data.Segmentation__c;
          vm.ctx.project.pdv.nomPDV = data.Outlet_Name;
          vm.ctx.project.pdv.adresse = (data.House_Number__c ? data.House_Number__c + " " : "") +
            (data.Street__c ? data.Street__c : "") +
            (data.Street2__c ? "\n" + data.Street2__c : "") +
            (data.Street3__c ? "\n" + data.Street3__c : "");
          vm.ctx.project.pdv.codePostal = data.Postal_Code__c;
          vm.ctx.project.pdv.ville = data.City__c;
          vm.ctx.project.pdv.telephone = formatTel(data.Telephone__c);
          //vm.ctx.project.pdv.fax = data.Fax;
          vm.ctx.project.pdv.nSiret = data.SIRET__c;
          //vm.ctx.project.pdv.rcs = data.TO_BE_DEFINED;
          vm.ctx.project.pdv.nomClient = data.Owner_Name;
          vm.ctx.project.pdv.telephoneCLient = formatTel(data.Phone);
          vm.ctx.project.pdv.emailCLient = data.Email;
          vm.ctx.project.pdv.rcs = '';
        }
      });

    };

    var formatTel = function (tel) {
      if (tel) {
        tel = tel.replace("+33", "0");
      }
      return tel;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider

    /**
     * Root State
     */
      .state('vae', {
        url: '/vae',
        templateUrl: 'app/vae/vae-layout.html',
        controller: 'VaeController',
        controllerAs: 'vae'
      })

      .state('vae.info-pdv', {
        url: '/info-pdv',
        templateUrl: 'app/vae/vae-01-info-pdv/vae-01-info-pdv.html',
        controller: 'VaeInfoPdvController',
        controllerAs: 'main',
        params: {
          nextState: 'vae.creation.id-projet'
        }
      })

      .state('vae.creation', {
        url: '/creation',
        templateUrl: 'app/vae/vae-02-creation/vae-02-creation-layout.html'
      })
      .state('vae.creation.id-projet', {
        url: '/id-projet',
        templateUrl: 'app/vae/vae-02-creation/vae-21-id-projet/vae-21-id-projet.html',
        controller: 'VaeIdProjetController',
        controllerAs: 'main',
        params: {
          previousState: 'vae.info-pdv',
          nextState: 'vae.creation.choix-boards'
        }
      })
      .state('vae.creation.choix-boards', {
        url: '/choix-boards',
        templateUrl: 'app/vae/vae-02-creation/vae-22-choix-boards/vae-22-choix-boards.html',
        controller: 'VaeChoixBoardsController',
        controllerAs: 'main',
        params: {
          previousState: 'vae.creation.id-projet',
          nextState: 'vae.creation.format'
        }
      })
      .state('vae.creation.format', {
        url: '/format',
        templateUrl: 'app/vae/vae-02-creation/vae-23-format/vae-23-format.html',
        controller: 'VaeFormatController',
        controllerAs: 'main',
        params: {
          previousState: 'vae.creation.choix-boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu', {
        url: '/contenu',
        controller: function($state) { $state.go('vae.contenu.boards') },
        controllerAs: 'dummy',
        templateUrl: 'app/vae/vae-03-contenu/vae-03-contenu-layout.html'
      })
      .state('vae.contenu.boards', {
        url: '/contenu/boards',
        templateUrl: 'app/vae/vae-03-contenu/vae-03-contenu.html',
        controller: 'VaeContenuController',
        controllerAs: 'main',
        params: {
          previousState: 'vae.creation.format',
          nextState: 'vae.pose'
        }
      })
      .state('vae.contenu.gamme-prix', {
        url: '/contenu/gamme-prix',
        templateUrl: 'app/vae/vae-03-contenu/vae-31-contenu_gamme/vae-31-contenu_gamme-prix.html',
        controller: 'VaeContenuGammePrixController',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          editState: 'vae.contenu.gamme-boissons',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.gamme-boissons', {
        url: '/contenu/gamme-boissons',
        templateUrl: 'app/vae/vae-03-contenu/vae-31-contenu_gamme/vae-31-contenu_gamme-boissons.html',
        controller: 'VaeContenuGammeBoissonsController',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.gamme-prix',
          nextState: 'vae.contenu.gamme-prix'
        }
      })
      .state('vae.contenu.pricelist', {
        url: '/contenu/pricelist',
        templateUrl: 'app/vae/vae-03-contenu/vae-32-contenu_pricelist/vae-32-contenu_pricelist.html',
        controller: 'VaeContenuPricelistController',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-simple-pet-2-items', {
        url: '/menu-simple-pet-2-items',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-pet-2-items/vae-33-contenu_menu-simple-pet-2-items.html',
        controller: 'VaeContenuSimplePet2Controller',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-simple-pet-3-items', {
        url: '/menu-simple-pet-3-items',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-3-items/vae-33-contenu_menu-simple-3-items.html',
        controller: 'VaeContenuSimple3Controller',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-simple-3-items-sans-option', {
        url: '/mmenu-simple-3-items-sans-option',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-3-items/vae-33-contenu_menu-simple-3-items.html',
        controller: 'VaeContenuSimple3Controller',
        controllerAs: 'main',
        params: {
          sansOption: true,
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-can-2-items-coke', {
        url: '/menu-can-2-items-coke',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-pet-2-items/vae-33-contenu_menu-simple-pet-2-items.html',
        controller: 'VaeContenuSimplePet2Controller',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-can-3-items-coke', {
        url: '/menu-can-3-items-coke',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-3-items/vae-33-contenu_menu-simple-3-items.html',
        controller: 'VaeContenuSimple3Controller',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-can-2-items-mm', {
        url: '/menu-can-2-items-mm',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-pet-2-items/vae-33-contenu_menu-simple-pet-2-items.html',
        controller: 'VaeContenuSimplePet2Controller',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-can-3-items-mm', {
        url: '/menu-can-3-items-mm',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-3-items/vae-33-contenu_menu-simple-3-items.html',
        controller: 'VaeContenuSimple3Controller',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-double-pet-2-items-coke', {
        url: '/menu-double-pet-2-items-coke',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x2-items/vae-33-contenu_menu-double-2x2-items.html',
        controller: 'VaeContenuDoublePet2Controller',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-double-pet-3-items-coke', {
        url: '/menu-double-pet-3-items-coke',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x3-items/vae-33-contenu_menu-double-2x3-items.html',
        controller: 'VaeContenuDoublePet3Controller',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-double-pet-2-items-mm', {
        url: '/menu-double-pet-2-items-mm',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x2-items/vae-33-contenu_menu-double-2x2-items.html',
        controller: 'VaeContenuDoublePet2Controller',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-double-2-items-mm-sans-option', {
        url: '/menu-double-2-items-mm-sans-option',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x2-items/vae-33-contenu_menu-double-2x2-items.html',
        controller: 'VaeContenuDoublePet2Controller',
        controllerAs: 'main',
        params: {
          sansOption: true,
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-double-can-2-items-coke', {
        url: '/menu-double-can-2-items-coke',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x2-items/vae-33-contenu_menu-double-2x2-items.html',
        controller: 'VaeContenuDoublePet2Controller',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-double-can-3-items-coke', {
        url: '/menu-double-can-3-items-coke',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x3-items/vae-33-contenu_menu-double-2x3-items.html',
        controller: 'VaeContenuDoublePet3Controller',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-double-can-2-items-mm', {
        url: '/menu-double-can-2-items-mm',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x2-items/vae-33-contenu_menu-double-2x2-items.html',
        controller: 'VaeContenuDoublePet2Controller',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-autres-2-items-capri', {
        url: '/menu-autres-2-items-capri',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-pet-2-items/vae-33-contenu_menu-simple-pet-2-items.html',
        controller: 'VaeContenuSimplePet2Controller',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.contenu.menu-standard-2018', {
        url: '/menu-standard-2018',
        templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-standard-2018/vae-33-contenu_menu-standard-2018.html',
        controller: 'VaeContenuMenuStandard2018Controller',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu.boards',
          nextState: 'vae.contenu.boards'
        }
      })
      .state('vae.pose', {
        url: '/pose',
        templateUrl: 'app/vae/vae-04-pose/vae-04-pose.html',
        controller: 'VaePoseController',
        controllerAs: 'main',
        params: {
          previousState: 'vae.contenu',
          nextState: 'vae.livraison'
        }
      })
      .state('vae.livraison', {
        url: '/livraison',
        templateUrl: 'app/vae/vae-05-livraison/vae-05-livraison.html',
        controller: 'VaeLivraisonController',
        controllerAs: 'main',
        params: {
          previousState: 'vae.pose',
          nextState: 'vae.recapitulatif'
        }
      })
      .state('vae.recapitulatif', {
        url: '/recapitulatif',
        templateUrl: 'app/vae/vae-06-recapitulatif/vae-06-recapitulatif.html',
        controller: 'VaeRecapitulatifController',
        controllerAs: 'main',
        params: {
          previousState: 'vae.pose',
          nextState: 'suivi-projet'
        }
      });
  }
})();
(function(){
  'use strict';

  angular
      .module('app')
      .controller('VaeController', VaeController);

  /** @ngInject */
  function VaeController($state, $log, $scope, $q, ProjetService, CurrentUser) {
    var vm = this;

    /**
     * Controle accès user création vae
     */
    vm.user = CurrentUser;

    if (vm.user.getUsername() == 'imprimeurvae' || vm.user.getUsername() == 'imprimeur') {
      $state.go('dashboard-imprimeur');
    }

    vm.statePrefix = $state.$current.name.substring(0, $state.$current.name.indexOf('.'));
    $log.debug("$state:", vm.statePrefix);

    /** ********************************** **/

    var itemOrder = [vm.statePrefix+'.info-pdv', vm.statePrefix+'.creation',
      vm.statePrefix+'.contenu', vm.statePrefix+'.pose', vm.statePrefix+'.livraison',
      vm.statePrefix+'.recapitulatif'];

    // Titre principal
    vm.ctx = ProjetService.getProjectContext();
    vm.title = vm.ctx.project.type;

    // Expose $state dans les vues.
    vm.$state = $state;

    /**
     * Si retour pas vide, il s'agit d'une mise à jour
     * Sinon, c'est un nouveau projet
     * @returns {*}
     */
    vm.isUpdate = function() {
      var ctx = ProjetService.getProjectContext();
      return ctx.project.signatureClient && ctx.project.signatureDC;
    };

    // Binde a ng-class du breadcrumb
    vm.classForItem = function(stateName) {
      var isAfter = itemOrder.indexOf(mainStateName(stateName))
        >= itemOrder.indexOf(mainStateName($state.current.name));
      return {
        active: $state.includes(stateName),
        disabled: isAfter
      };
    };

    //
    vm.classPicto = function(title){
      if (title == 'Caissons Lumineux')
        return 'caisons-lumineux-picto';
      if (title == 'Boards PVC')
        return 'boards-pvc-picto'
      if (title == 'Digital')
        return 'caisons-lumineux-picto'
    };

    vm.go = function (stateName) {
      var ctx = ProjetService.getProjectContext();
      var isBefore = itemOrder.indexOf(mainStateName(stateName))
        < itemOrder.indexOf(mainStateName($state.current.name));
      if (isBefore) {
        $state.go(stateName, {id: ctx.project._id.$oid} );
      }
    };

    // Navigue vers l'etat precedent
    vm.previousState = function() {
      if(vm.hasPreviousState()) {
        $state.go($state.params.previousState);
      } else {
        $log.warn("vm.hasPreviousState() : No previous step defined");
      }
    };

    /**
     * Permet au controller enfant et composant d'appeller
     * la fonction vm.previousState();
     */
    $scope.$on('CallpreviousSate', function(){
      vm.previousState();
    });

    /**
     * Permet au controller enfant d'appeler la fonction
     * vm.nextState();
     */
    $scope.$on('CallnextState', function(){
      vm.nextState();
    });

    /**
     * Update existing Project and redirect to dashboard
     */
    $scope.$on('UpdateProject', function(){
      ProjetService.save().then(function(){
        $state.go(vm.statePrefix+'.recapitulatif',{},{reload: true});
      });
    });

    // Navigue vers l'état suivant
    vm.nextState = function() {
      if(vm.hasNextState()) {
        saveProject().then(function(){
          $state.go($state.params.nextState);
        });
      } else {
        $log.warn("vm.nextState() : No next step defined");
      }
    };

    // Retourne true si l'etat courant défini un etat suivant.
    vm.hasNextState = function() {
      return angular.isDefined($state.params) && angular.isDefined($state.params.nextState);
    };

    // Retourne true si l'etat courant défini un etat precedent.
    vm.hasPreviousState = function() {
      return angular.isDefined($state.params) && angular.isDefined($state.params.previousState);
    };

    // Return parent stateName or stateName if 2nd level.
    // toto.tata => toto.tata
    // toto.tata.tutu => toto.tata
    function mainStateName(stateName) {
      var mainStateName = stateName;
      var nbDot = (stateName.match(/\./g) || []).length;
      if(nbDot > 1) {
        // Cas stateName est un 3ieme niveau
        mainStateName = stateName.substring(0, stateName.lastIndexOf('.'));
      }
      return mainStateName;
    }

    /**
     * Sauvegarde etape par etape
     * @returns {undefined}
     */
    function saveProject() {
      var deferred = $q.defer();
      var ctx = ProjetService.getProjectContext();
      // Si le BDC n'a pas encore ete signe, alors on retient l'etape
      //$log.debug("saveProject()", $state.params.nextState, ctx.project);
      if(!vm.isUpdate()) {
        ctx.project.nextState = $state.params.nextState;
      }
      ProjetService.save().then(function(){
        deferred.resolve('Project save'); // Attente de la promesse en cas d'upload de doc
      });
      return deferred.promise;
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider

        /**
         * Root State
         */
            .state('vae-digital', {
                url: '/vae-digital',
                templateUrl: 'app/vae/vae-layout.html',
                controller: 'VaeController',
                controllerAs: 'vae'
            })

            .state('vae-digital.info-pdv', {
                url: '/info-pdv',
                templateUrl: 'app/vae/vae-01-info-pdv/vae-01-info-pdv.html',
                controller: 'VaeInfoPdvController',
                controllerAs: 'main',
                params: {
                    nextState: 'vae-digital.creation.id-projet'
                }
            })

            .state('vae-digital.creation', {
                url: '/creation',
                templateUrl: 'app/vae/vae-02-creation/vae-02-creation-layout.html'
            })
            .state('vae-digital.creation.id-projet', {
                url: '/id-projet',
                templateUrl: 'app/vae/vae-02-creation/vae-21-id-projet/vae-21-id-projet.html',
                controller: 'VaeIdProjetController',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.info-pdv',
                    nextState: 'vae-digital.creation.choix-boards'
                }
            })
            .state('vae-digital.creation.choix-boards', {
                url: '/choix-boards',
                templateUrl: 'app/vae/vae-02-creation/vae-22-choix-boards/vae-22-choix-boards.html',
                controller: 'VaeChoixBoardsController',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.creation.id-projet',
                    nextState: 'vae-digital.creation.format'
                }
            })
            .state('vae-digital.creation.format', {
                url: '/format',
                templateUrl: 'app/vae/vae-02-creation/vae-23-format/vae-23-format.html',
                controller: 'VaeFormatController',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.creation.choix-boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu', {
                url: '/contenu',
                controller: function($state) { $state.go('vae-digital.contenu.boards') },
                controllerAs: 'dummy',
                templateUrl: 'app/vae/vae-03-contenu/vae-03-contenu-layout.html'
            })
            .state('vae-digital.contenu.boards', {
                url: '/contenu/boards',
                templateUrl: 'app/vae/vae-03-contenu/vae-03-contenu.html',
                controller: 'VaeContenuController',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.creation.format',
                    nextState: 'vae-digital.pose'
                }
            })
            .state('vae-digital.contenu.gamme-prix', {
                url: '/contenu/gamme-prix',
                templateUrl: 'app/vae/vae-03-contenu/vae-31-contenu_gamme/vae-31-contenu_gamme-prix.html',
                controller: 'VaeContenuGammePrixController',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    editState: 'vae-digital.contenu.gamme-boissons',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.gamme-boissons', {
                url: '/contenu/gamme-boissons',
                templateUrl: 'app/vae/vae-03-contenu/vae-31-contenu_gamme/vae-31-contenu_gamme-boissons.html',
                controller: 'VaeContenuGammeBoissonsController',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.gamme-prix',
                    nextState: 'vae-digital.contenu.gamme-prix'
                }
            })
            .state('vae-digital.contenu.pricelist', {
                url: '/contenu/pricelist',
                templateUrl: 'app/vae/vae-03-contenu/vae-32-contenu_pricelist/vae-32-contenu_pricelist.html',
                controller: 'VaeContenuPricelistController',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-simple-pet-2-items', {
                url: '/menu-simple-pet-2-items',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-pet-2-items/vae-33-contenu_menu-simple-pet-2-items.html',
                controller: 'VaeContenuSimplePet2Controller',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-simple-pet-3-items', {
                url: '/menu-simple-pet-3-items',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-3-items/vae-33-contenu_menu-simple-3-items.html',
                controller: 'VaeContenuSimple3Controller',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-simple-3-items-sans-option', {
                url: '/mmenu-simple-3-items-sans-option',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-3-items/vae-33-contenu_menu-simple-3-items.html',
                controller: 'VaeContenuSimple3Controller',
                controllerAs: 'main',
                params: {
                    sansOption: true,
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-can-2-items-coke', {
                url: '/menu-can-2-items-coke',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-pet-2-items/vae-33-contenu_menu-simple-pet-2-items.html',
                controller: 'VaeContenuSimplePet2Controller',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-can-3-items-coke', {
                url: '/menu-can-3-items-coke',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-3-items/vae-33-contenu_menu-simple-3-items.html',
                controller: 'VaeContenuSimple3Controller',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-can-2-items-mm', {
                url: '/menu-can-2-items-mm',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-pet-2-items/vae-33-contenu_menu-simple-pet-2-items.html',
                controller: 'VaeContenuSimplePet2Controller',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-can-3-items-mm', {
                url: '/menu-can-3-items-mm',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-3-items/vae-33-contenu_menu-simple-3-items.html',
                controller: 'VaeContenuSimple3Controller',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-double-pet-2-items-coke', {
                url: '/menu-double-pet-2-items-coke',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x2-items/vae-33-contenu_menu-double-2x2-items.html',
                controller: 'VaeContenuDoublePet2Controller',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-double-pet-3-items-coke', {
                url: '/menu-double-pet-3-items-coke',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x3-items/vae-33-contenu_menu-double-2x3-items.html',
                controller: 'VaeContenuDoublePet3Controller',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-double-pet-2-items-mm', {
                url: '/menu-double-pet-2-items-mm',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x2-items/vae-33-contenu_menu-double-2x2-items.html',
                controller: 'VaeContenuDoublePet2Controller',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-double-2-items-mm-sans-option', {
                url: '/menu-double-2-items-mm-sans-option',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x2-items/vae-33-contenu_menu-double-2x2-items.html',
                controller: 'VaeContenuDoublePet2Controller',
                controllerAs: 'main',
                params: {
                    sansOption: true,
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-double-can-2-items-coke', {
                url: '/menu-double-can-2-items-coke',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x2-items/vae-33-contenu_menu-double-2x2-items.html',
                controller: 'VaeContenuDoublePet2Controller',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-double-can-3-items-coke', {
                url: '/menu-double-can-3-items-coke',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x3-items/vae-33-contenu_menu-double-2x3-items.html',
                controller: 'VaeContenuDoublePet3Controller',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-double-can-2-items-mm', {
                url: '/menu-double-can-2-items-mm',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x2-items/vae-33-contenu_menu-double-2x2-items.html',
                controller: 'VaeContenuDoublePet2Controller',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-autres-2-items-capri', {
                url: '/menu-autres-2-items-capri',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-simple-pet-2-items/vae-33-contenu_menu-simple-pet-2-items.html',
                controller: 'VaeContenuSimplePet2Controller',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.contenu.menu-standard-2018', {
                url: '/menu-standard-2018',
                templateUrl: 'app/vae/vae-03-contenu/vae-33-contenu_menu-standard-2018/vae-33-contenu_menu-standard-2018.html',
                controller: 'VaeContenuMenuStandard2018Controller',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu.boards',
                    nextState: 'vae-digital.contenu.boards'
                }
            })
            .state('vae-digital.pose', {
                url: '/pose',
                templateUrl: 'app/vae/vae-04-pose/vae-04-pose.html',
                controller: 'VaePoseController',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.contenu',
                    nextState: 'vae-digital.livraison'
                }
            })
            .state('vae-digital.livraison', {
                url: '/video',
                templateUrl: 'app/vae/vae-05-2-video/vae-05-2-video.html',
                controller: 'VaeVideoController',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.pose',
                    nextState: 'vae-digital.recapitulatif'
                }
            })
            .state('vae-digital.recapitulatif', {
                url: '/recapitulatif',
                templateUrl: 'app/vae/vae-06-recapitulatif/vae-06-recapitulatif.html',
                controller: 'VaeRecapitulatifController',
                controllerAs: 'main',
                params: {
                    previousState: 'vae-digital.pose',
                    nextState: 'suivi-projet'
                }
            });
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .controller('SuiviProjetController', SuiviProjetController);

  /** @ngInject */
  function SuiviProjetController($log, $state, $window, $document, $uibModal, $stateParams, $timeout,
    ProjetService, AllowedStatutService, ChangeStatutService,
    FilesProjecttService, CurrentUser, DownloadProjecttService, DCData, 
    EtatQuotasSmhfService, canUpdateProject, CloneProjetService, UsersService) {
    var vm = this;

    $document.scrollTop(0);
    vm.user = CurrentUser;
    vm.roleUser = vm.user.getRoles()[1]; // Get User Rôle
    vm.loading = false;
    vm.blockUI = false;

    /**
     * récupère le projet sélectionner dans le dashboard
     */
    if ($stateParams.id) {
      ProjetService.setProject(null);
    }

    var agences = UsersService.viewsLoadAgence();
    var imprimeurs = UsersService.viewsLoadImprimeur();
    vm.ctx = ProjetService.getProjectContext();
    vm.ctx.$promise.then(init);
    

    function init() {
      /**
       * Init object docSuiviProjet to add multiform
       * Object contain doc upload on suivi project page
       */
      if (angular.isUndefined(vm.ctx.project.docSuiviProjet) || vm.ctx.project.docSuiviProjet.length == 0) {
        vm.ctx.project.docSuiviProjet = {};
      }

      /**
       * Get Data's DC of project
       */
      DCData.get({dc_username: vm.ctx.project.dc}).$promise.then(function (response) {
        vm.dcProject = response[0];
        if (vm.dcProject) {
          vm.dataDC = vm.dcProject.nom != null ? vm.dcProject.nom + ' ' : '';
          vm.dataDC += vm.dcProject.prenom != null ? vm.dcProject.prenom + ' ' : '';
          vm.dataDC += vm.dcProject.mail != null ? vm.dcProject.mail + ' ' : '';
          vm.dataDC += vm.dcProject.telephone != null ? vm.dcProject.telephone : '';
        }
      });

      /**
       * Get EtatQuota for smhf DC
       */
      if(vm.user.hasRole('dc') || vm.user.hasRole('administrator')){
        vm.user.getSmhfDc(vm.user.getUserSmhf()).then(function(result){
          vm.smhf = result;
          EtatQuotasSmhfService.getEtatQuotasSmhf(vm.smhf.username).then(function(data){
            vm.etatQuota = data[0];
            vm.disabled = false;
            if(vm.isCHR(vm.ctx.project) && angular.isUndefined(vm.ctx.project.eligibleQuota))
              vm.disabled = vm.etatQuota.statutQuotaCHR == 'DEPASSE' ? true : false;
            if(vm.isVAE(vm.ctx.project) && angular.isUndefined(vm.ctx.project.eligibleQuota))
              vm.disabled = vm.etatQuota.statutQuotaVAE == 'DEPASSE' ? true : false;
            if(vm.isPDA(vm.ctx.project) && angular.isUndefined(vm.ctx.project.eligibleQuota))
              vm.disabled = vm.etatQuota.statutQuotaPDA == 'DEPASSE' ? true : false;
          });
        });
      }

      var eleBtnDashboard = angular.element('#btn-back-dashboard');
      if (angular.isDefined(vm.ctx.project.create)) {
        if (vm.ctx.project.popin == true) {
          eleBtnDashboard.hide();
          $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: 'newProject.html',
            controllerAs: 'vm'
          });
        }
        vm.ctx.project.popin = false;
      }

      // File type of upload file
      vm.fileType = vm.ctx.project.statut.replace(/\s+/g, '_').toLowerCase();
      vm.fileType += '_'+vm.ctx.project.nb_ar_agence;

      // On récupère l'uploader
      vm.uploader = vm.ctx.getUploader(vm.fileType);

      /**
       * Action quand tout est uploader, refresh list doc files
       */
      vm.uploader.onCompleteAll = function () {
        vm.filesProject = {};
        FilesProjecttService.get({id: vm.ctx.project._id.$oid})
          .$promise.then(function (result) {
            vm.filesProject = result;
          })
      };

      vm.uploader.onErrorItem = function (item, response, status, headers) {
        $log.error("UPLOAD FAILED", item, response, status, headers);
        alert("ECHEC UPLOAD. La page va se refraîchir.");
        location.reload();
      }

      // Récupération des statut autorisé pour le projet courant
      if (vm.ctx.project._id !== null) {
        AllowedStatutService.get({id: vm.ctx.project._id.$oid}).$promise.then(function (result) {
          vm.allowedStatuts = result;
          vm.showStatutChange = vm.allowedStatuts.length == 0 ? false : true;
          if (vm.user.hasRole('siege') && vm.ctx.project.statut == 'Agence') {
            vm.showStatutChange = true;
          }
        });

        FilesProjecttService.get({id: vm.ctx.project._id.$oid})
          .$promise.then(function (result) {
            vm.filesProject = result;
          });
      }

      /**
       * Action avant l'upload des fichiers sur le server
       * Préfixage du fichier par le statut courant du projet
       * @param item
       */
      vm.uploader.onBeforeUploadItem = function (item) {
        item.formData.push({
          'projet_id': vm.ctx.project._id.$oid,
          'file_type': item.myplv_file_type
        });
      };

      vm.canProjetUpdate = false;
      canUpdateProject.get({id: vm.ctx.project._id.$oid}).$promise.then(function(result){
        vm.canProjetUpdate = result[0];
      });
    }

    vm.backHistory = function(){
      history.back();
    };

    /**
     * Callback bouton de changement d'agence.
     * @param projet
     */
    vm.changeAgence = function(projet) {
      var modalChangeAgence = $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title-bottom',
          ariaDescribedBy: 'modal-body-bottom',
          templateUrl: 'changeAgence.html',
          controller: ['$uibModalInstance', 'projet', 'agences', 'ChangeAgenceService', agenceModal],
          controllerAs: 'vm',
          resolve:{
            projet: function(){
              return projet;
            },
            agences: function(){
              return agences;
            }
          }
      });
      modalChangeAgence.result.then(function(){
        $state.reload();
      });
    }

    /**
     * Url Download Zip Project
     */
    vm.downloadZipProject = function () {
      vm.loading = true;
      DownloadProjecttService.get({id: vm.ctx.project._id.$oid}).$promise.then(function (result) {
        vm.loading = false;
        // On récupère le lien de téléchargement
        vm.downloadUrlProject = result[0];

        // Créer un lien avec l'url du zip
        // Et simule le click sur ce lien pour télécharger le zip
        var a = angular.element('<a>');
        a.attr('href', vm.downloadUrlProject.replace('http://','https://'));
        //a.attr('download', getNameDownload());
        a.attr('target', '_blank');
        if(angular.element('body').hasClass('browser-firefox')){
          angular.element('body').append(a);
        }
        a[0].click();
        if(angular.element('body').hasClass('browser-firefox')){
          a.remove();
        }
      });
    };

    // Change statut du projet, avec des commentaires
    vm.changeStatut = function(projet, new_statut){
      var text = 'Vous avez bien envoyé le BDC ';
      switch (new_statut){
        case 'Brouillon':
        case 'Validation DC':
          text = 'Vous avez bien envoyé le BDC au DC';
          break;
        case 'Agence':
          text = 'Vous avez bien envoyé le bon de commande à l’Agence. Vous recevrez un premier retour sous 5 jours ouvrés.';
          break;
        case 'Validation Client':
          text = 'Vous avez bien envoyé le BDC au Client pour confirmation';
          break;
        case 'Impression':
          text = 'Vous avez bien envoyé le BDC en Impression';
          break;
        case 'Imprimé':
          text = 'Vous avez bien envoyé le BDC en Imprimé';
          break;
        case 'refusPose':
          text = 'Vous avez bien refusé le projet';
          break;
        case 'Prévisite':
          text = 'Vous avez bien envoyé le bon de commande à l’installateur. Notre prestataire va prendre contact avec le client sous 48h.';
          break;
      }

      if(projet.statut !== 'Brouillon' && new_statut === 'Agence') {
        text = 'Vous avez bien retourné le projet à l\'Agence';
      }
      if(projet.statut == 'Prévisite' && new_statut === 'sousConditionPose') {
        text = 'Vous avez bien validé sous condition le projet';
      }
      if(projet.type === 'Digital'){
        if(projet.statut == 'Exécution' && new_statut === 'Livré'){
          text = 'Vous avez bien envoyé le projet en livraison';
        }
      }

      if (vm.isPSM(projet)) {
        if(new_statut === 'Brouillon' || new_statut === 'Terminé') {
          text = 'Opération réalisée';
        }
      }
      if(vm.isCHR(projet)){
        if(projet.statut == 'Exécution' && new_statut === 'Terminé'){
          text = "Un mail contenant les fichiers d'éxécution a été envoyé au client.";
        }
        if(projet.statut == 'Impression' && new_statut === 'Exécution'){
          text = "Vous avez bien retourné le projet en éxécution.";
        }
      }

      vm.blockUI = true;

      ChangeStatutService.update(projet, new_statut, vm.uploader)
        .then(function() {
          vm.blockUI = false;
          var modalStatut = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: 'sendMsg.html',
            controller: ['$uibModalInstance', 'projet', 'text', statutModal],
            controllerAs: 'vm',
            resolve:{
              projet: function(){
                return projet;
              },
              text: function(){
                return text;
              }
            }
          });

          modalStatut.result.then(function(){
            $state.go('dashboard');
          });
        });
    };

    /**
     * Callback bouton de clonage.
     * @param projet
     */
    vm.clonage = function(projet){
      var text = 'Vous avez bien cloné le projet.';
      var modalStatut = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'confirmationClonage.html',
        controller: ['$uibModalInstance', 'projet', 'text', statutModal],
        controllerAs: 'vm',
        resolve:{
          projet: function(){
            return projet;
          },
          text: function(){
            return text;
          }
        }
      });
      modalStatut.result.then(function(){
        var clone = CloneProjetService.clone(projet);
        clone.$promise.then(function() {
          if(clone['error']) {
            // Cas quota depasse
            alert(clone['error']);
            return;
          }
          var typeProj = "unknown_project_type";
          if (ProjetService.isCHR(clone)) {
            typeProj = 'chr';
          } else if (ProjetService.isVAE(clone)) {
            typeProj = 'vae';
          } else if (ProjetService.isPSM(clone)) {
            typeProj = 'sm';
          } else if (ProjetService.isPDA(vm.projet)) {
            typeProj = 'da';
          } else {
            $log.error("UnSupported project type", clone);
          }
          var state = clone.nextState ? clone.nextState : typeProj+'.info-pdv';
          ProjetService.loadProject( clone._id.$oid );
          $state.go(state, {'id': clone._id.$oid});
        });
      });
    }

    /**
     * Select le projet en cours et redirige vers le récap
     * @param projet
     */
    vm.selectProjet = function (projet) {
      var typeProj = "unknown_project_type";
      if(vm.isCHR(projet)) {
        typeProj = 'chr';
      } else if(vm.isVAE(projet)) {
        typeProj = projet.type === 'Digital' ? 'vae-digital' : 'vae';
      } else if(vm.isPSM(projet)) {
        typeProj = 'sm';
      } else if (ProjetService.isPDA(vm.projet)) {
        typeProj = 'da';
      } else {
        $log.error("UnSupported project type", projet);
      }
      ProjetService.setProject(projet);
      $state.go(typeProj+'.recapitulatif', {'id': projet._id.$oid});
    };

    vm.isCHR = ProjetService.isCHR;
    vm.isVAE = ProjetService.isVAE;
    vm.isPSM = ProjetService.isPSM;
    vm.isPDA = ProjetService.isPDA;
    vm.isAvecPose = ProjetService.isAvecPose;
    vm.nbBoards = ProjetService.nbBoards;

    vm.setDatePrevisite = function(selectedDate) {
      vm.ctx.project.pose.t_previsite = selectedDate;
      ProjetService.save().then(goToSuivi, goToSuivi);
    };

    vm.setDatePose = function(selectedDate) {
      vm.ctx.project.pose.t_pose = selectedDate;
      ProjetService.save().then(goToSuivi, goToSuivi);
    };

    vm.canChangeDatePrevisite = function() {
      return vm.user.hasRole('installateur') ||
        vm.user.hasRole('siege') ||
        vm.user.hasRole('administrator');
    };

    vm.canChangeDatePose = function() {
      return vm.user.hasRole('installateur') ||
        vm.user.hasRole('siege') ||
        vm.user.hasRole('administrator');
    };


    vm.selectPrinter = function(projet) {
      var modalSelectPrinter = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'selectPrinter.html',
        controller: ['$uibModalInstance', 'projet', 'imprimeurs', printerModal],
        controllerAs: 'vm',
        resolve:{
          projet: function(){
            return projet;
          },
          imprimeurs: function(){
            return imprimeurs;
          }
        }
      });
      modalSelectPrinter.result.then(function(params){
        projet.imprimeur = params.$value;
        vm.changeStatut(projet, "Impression")
      });
    }

    // Force le rafrichissement complet de la page en cours.
    function goToSuivi() {
      $state.transitionTo($state.current, $stateParams, {
        reload: true,
        inherit: false,
        notify: true
      });
    }

    vm.alertPrixFinal = null;
    vm.savePrixFinal = function(form) {
      ProjetService.save().then(
        function() {   // Success
          form.$setPristine();
          vm.alertPrixFinal = {
            type: 'success',
            msg: 'Sauvegarde effectuée'
          }
          $timeout(vm.closePrixFinalAlert, 3000);
        });
    }
    vm.closePrixFinalAlert = function() {
      vm.alertPrixFinal = null;
    }
    vm.shouldDisplayFinalPrix = function() {
      var allowedStatus = ['imprimé', 'terminé', 'rejeté', 'annulé'];
      var allowedRole = ['agence', 'imprimeur', 'siege', 'administrator'];
      var userRoles = vm.user.getRoles();

      return 'PSM' == vm.ctx.project.typeProjet
        && allowedStatus.includes(vm.ctx.project.statut.toLowerCase())
        && vm.intersect(allowedRole, userRoles);
    }
    vm.intersect = function(array1, array2) {
      var filteredArray = array1.filter(function(n) {
        return array2.indexOf(n) !== -1;
      });
      return filteredArray && filteredArray.length > 0;
    }
  }

  /** @ngInject */
  function statutModal($uibModalInstance, projet, text){
    var vm = this;
    vm.text = text;
    vm.projet = projet;
  }

  /** @ngInject */
  function agenceModal($uibModalInstance, projet, agences, ChangeAgenceService){
    var vm = this;
    vm.projet = projet;
    vm.agences = agences;
    vm.newAgence = null;
    
    vm.validate = function () {
      ChangeAgenceService.update(projet, vm.newAgence).then(function(result){
        $uibModalInstance.close(result);
      });
    };
  }

    /** @ngInject */
    function printerModal($uibModalInstance, projet, imprimeurs){
      var vm = this;
      vm.imprimeurs = imprimeurs;
      vm.project = projet

      if (angular.isDefined(vm.project.imprimeur) && vm.project.imprimeur == vm.project.agence) {
        vm.agenceIsPrinter = "oui";
      } else if (angular.isDefined(vm.project.imprimeur) && vm.project.imprimeur != "") {
        vm.agenceIsPrinter = "non";
      } else {
        vm.agenceIsPrinter = "oui";
      }

      vm.validate = function() {
        $uibModalInstance.close({$value: (vm.agenceIsPrinter == "oui")? vm.project.agence : vm.project.imprimeur});
      }
    }
})();

(function (){
  'use strict';

  angular
    .module('app')
    .controller('SuiviQuotasController', SuiviQuotasController);

  /** @ngInject */
  function SuiviQuotasController($log, CurrentUser, SuiviQuotasService){
    var vm = this;

    vm.user = CurrentUser;

    vm.loading = true;

    vm.hasRole = CurrentUser.hasRole;

    /**
     * Variables d'initialisation de tri
     * @type {boolean}
     */
    vm.reverse = true;
    vm.propertyName = 'smhf.data.prenom';

    SuiviQuotasService.getSuiviQuotas(vm.user).then(function(result){
      vm.dataSuiviQuotas = result;
      vm.loading = false;
    });

    /**
     * Fonction de tri des données
     * @param propertyName
     */
    vm.sortBy = function (propertyName) {
      vm.reverse = (vm.propertyName === propertyName) ? !vm.reverse : false;
      vm.propertyName = propertyName;
    };

    /**
     * Return type of progress bar
     * @param pourcent
     * @returns {string}
     */
    vm.typeProgressBar = function(pourcent){
      var type = '';
      if (pourcent < 25) {
        type = 'success';
      } else if (pourcent < 50) {
        type = 'info';
      } else if (pourcent < 75) {
        type = 'warning';
      } else {
        type = 'danger';
      }

      return type;
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);
  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider

      //
      // Root state.
      //
      .state('sm', {
        url: '/sm',
        //abstract: true,
        templateUrl: 'app/sm/sm-layout.html',
        controller: 'SurMesureController',
        controllerAs: 'sm'
      })

      //
      // Step 01 : Information client
      //
      .state('sm.info-pdv', {
        url: '/info-pdv/:id',
        templateUrl: 'app/sm/sm-01-info-pdv/sm-01-info-pdv.html',
        controller: 'SmInfoPdvController',
        controllerAs: 'main',
        params: {
          nextState: 'sm.creation.id_projet'
        }
      })

      //
      // Step 02 : Creation de la carte
      //  
      .state('sm.creation', {
        url: '/creation',
        templateUrl: 'app/sm/sm-02-creation/sm-02-creation-layout.html'
      })
      .state('sm.creation.id_projet', {
        url: '/id-projet/:id',
        templateUrl: 'app/sm/sm-02-creation/sm-21-id-projet/sm-21-id-projet.html',
        controller: 'SmIdProjetController',
        controllerAs: 'main',
        params: {
          previousState: 'sm.info-pdv',
          nextState: 'sm.creation.support'
        }
      })
      .state('sm.creation.support', {
        url: '/support/:id',
        templateUrl: 'app/sm/sm-02-creation/sm-22-choix-support/sm-22-choix-support.html',
        controller: 'SmChoixSupportController',
        controllerAs: 'main',
        params: {
          previousState: 'sm.creation.id_projet',
          nextState: 'sm.creation.charte'
        }
      })
      .state('sm.creation.charte', {
        url: '/charte/:id',
        templateUrl: 'app/sm/sm-02-creation/sm-23-charte/sm-23-charte.html',
        controller: 'SmCharteController',
        controllerAs: 'main',
        params: {
          previousState: 'sm.creation.support',
          nextState: 'sm.contenu.gamme'
        }
      })

      //
      // Step 03 : Contenu de la carte
      //
      .state('sm.contenu', {
        url: '/contenu/:id',
        abstract: true,
        templateUrl: 'app/sm/sm-03-contenu/sm-03-contenu-layout.html'
      })
      .state('sm.contenu.gamme', {
        url: '/gamme',
        templateUrl: 'app/sm/sm-03-contenu/sm-31-gamme/sm-31-gamme.html',
        controller: 'SmGammeController',
        controllerAs: 'main',
        params: {
          previousState: 'sm.creation.charte',
          nextState: 'sm.contenu.edition'
        }
      })
      .state('sm.contenu.gamme-select', {
        url: '/gamme/:index',
        templateUrl: 'app/sm/sm-03-contenu/sm-31-gamme-select/sm-31-gamme-select.html',
        controller: 'SmGammeSelectController',
        controllerAs: 'main',
        params: {
          previousState: 'sm.contenu.gamme',
          nextState: 'sm.contenu.gamme'
        }
      })
      .state('sm.contenu.edition', {
        url: '/edition',
        templateUrl: 'app/sm/sm-03-contenu/sm-32-edition/sm-32-edition.html',
        controller: 'SmEditionController',
        controllerAs: 'main',
        params: {
          previousState: 'sm.contenu.gamme',
          nextState: 'sm.autres-infos'
        }
      })
      .state('sm.contenu.edition-update', {
        url: '/edition/:index',
        templateUrl: 'app/sm/sm-03-contenu/sm-32-edition-update/sm-32-edition-update.html',
        controller: 'SmEditionUpdateController',
        controllerAs: 'main',
        params: {
          previousState: 'sm.contenu.edition',
          nextState: 'sm.contenu.edition'
        }
      })
      //
      // Step 04 : Autres infos
      //
      .state('sm.autres-infos', {
        url: '/autres-infos/:id',
        templateUrl: 'app/sm/sm-04-autres-infos/sm-04-autres-infos.html',
        controller: 'SmAutresInfosController',
        controllerAs: 'main',
        params: {
          previousState: 'sm.contenu.gamme',
          nextState: 'sm.livraison'
        }
      })

      //
      // Step 05: Livraison
      //
      .state('sm.livraison', {
        url: '/livraison/:id',
        templateUrl: 'app/sm/sm-05-livraison/sm-05-livraison.html',
        controller: 'SmLivraisonController',
        controllerAs: 'main',
        params: {
          previousState: 'sm.autres-infos',
          nextState: 'sm.recapitulatif'
        }
      })
      .state('sm.recapitulatif', {
        url: '/recapitulatif/:id',
        templateUrl: 'app/sm/sm-06-recapitulatif/sm-06-recapitulatif.html',
        controller: 'SmRecapitulatifController',
        controllerAs: 'main',
        params: {
          previousState: 'sm.livraison',
          nextState: 'suivi-projet'
        }
      });

  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('SurMesureController', SurMesureController);

  /** @ngInject */
  function SurMesureController($state, $log, $scope, $q, $uibModal, ProjetService, CurrentUser) {
    var vm = this;

    /**
     * Controle accès user création sur-mesure
     */
    vm.user = CurrentUser;

    if (vm.user.getUsername() == 'imprimeurvae' || vm.user.getUsername() == 'imprimeur') {
      $state.go('dashboard-imprimeur');
    }

    /** ********************************** **/

    var itemOrder = ['sm.info-pdv', 'sm.creation', 'sm.contenu', 'sm.photo',
      'sm.autres-infos', 'sm.livraison'];

    // Titre principal
    vm.title = "Sur mesure";

    vm.hideNavBar = false;

    // Expose $state dans les vues.
    vm.$state = $state;

    /**
     * Si retour pas vide, il s'agit d'une mise à jour
     * Sinon, c'est un nouveau projet
     * @returns {*}
     */
    vm.isUpdate = function () {
      var ctx = ProjetService.getProjectContext();
      return ctx.project && ctx.project.signatureClient && ctx.project.signatureDC;
    };

    // Binde a ng-class du breadcrumb
    vm.classForItem = function (stateName) {
      var isAfter = itemOrder.indexOf(mainStateName(stateName))
        >= itemOrder.indexOf(mainStateName($state.current.name));
      return {
        active: $state.includes(stateName),
        disabled: isAfter
      };
    };

    vm.go = function (stateName) {
      var ctx = ProjetService.getProjectContext();
      var isBefore = itemOrder.indexOf(mainStateName(stateName))
        < itemOrder.indexOf(mainStateName($state.current.name));
      if (isBefore) {
        $state.go(stateName, {id: ctx.project._id.$oid} );
      }
    };

    // Navigue vers l'etat precedent
    vm.previousState = function () {
      if (vm.hasPreviousState()) {
        var extraParams = $state.params.id ? {id: $state.params.id} : undefined;
        $state.go($state.params.previousState, extraParams);
      } else {
        $log.warn("vm.hasPreviousState() : No previous step defined");
      }
    };

    // Navigue vers l'etat parent.
    vm.up = function () {
      $state.go('^');
    };

    /**
     * Permet au controller enfant et composant d'appeller
     * la fonction vm.previousState();
     */
    $scope.$on('CallpreviousSate', function(){
      vm.previousState();
    });
    
    /**
     * Permet au controller enfant d'appeler la fonction
     * vm.nextState();
     */
    $scope.$on('CallnextState', function () {
      vm.nextState();
    });

    /**
     * Update existing Project and redirect to dashboard
     */
    $scope.$on('UpdateProject', function () {
      var extraParams = $state.params.id ? {id: $state.params.id} : undefined;
      ProjetService.save().then(function () {
        $state.go('sm.recapitulatif', extraParams, {reload: true});
      });
    });

    // Navigue vers l'état suivant
    vm.nextState = function () {
      if (vm.hasNextState()) {
        saveProject().then(function(){
          var extraParams = $state.params.id ? {id: $state.params.id} : undefined;
          $state.go($state.params.nextState, extraParams);
        });
      } else {
        $log.warn("vm.nextState() : No next step defined");
      }
    };

    // Retourne true si l'etat courant défini un etat suivant.
    vm.hasNextState = function () {
      return angular.isDefined($state.params) && angular.isDefined($state.params.nextState);
    };

    // Retourne true si l'etat courant défini un etat precedent.
    vm.hasPreviousState = function () {
      return angular.isDefined($state.params) && angular.isDefined($state.params.previousState);
    };

    // Return parent stateName or stateName if 2nd level.
    // toto.tata => toto.tata
    // toto.tata.tutu => toto.tata
    function mainStateName(stateName) {
      var mainStateName = stateName;
      var nbDot = (stateName.match(/\./g) || []).length;
      if (nbDot > 1) {
        // Cas stateName est un 3ieme niveau
        mainStateName = stateName.substring(0, stateName.lastIndexOf('.'));
      }
      return mainStateName;
    }

    /**
     * Sauvegarde etape par etape
     * @returns {undefined}
     */
    function saveProject() {
      var deferred = $q.defer();
      var ctx = ProjetService.getProjectContext();
      // Si le BDC n'a pas encore ete signe, alors on retient l'etape
      //$log.debug("saveProject()", $state.params.nextState, ctx.project);
      if (!vm.isUpdate()) {
        ctx.project.nextState = $state.params.nextState;
      }
      ProjetService.save().then(function(){
        deferred.resolve('Project save'); // Attente de la promesse en cas d'upload de doc
      });
      return deferred.promise;
    }
    
    /**
     * Delete support
     * @param index
     */
    vm.deleteSupport = function (index) {
      var ctx = ProjetService.getProjectContext();
      var modalDelete = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'app/sm/sm-delete-support.html'
      });

      modalDelete.result.then(function(){
        ctx.project.supports.splice(index, 1);
        // If no more price, delete brief
        if(ctx.project.supports.length == 0)
          delete ctx.project.supports;
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .factory('VisuelSolide',VisuelSolide);

  /** @ngInject */
  function VisuelSolide($resource){
    var path = 'rest/visuel-solide/data';
    var viewResource = $resource(path,
        { '_format': 'json' },
        {
          'get': {
            method: 'GET',
            isArray: true
          }
        });

    // Return public API
    return {
      getPath: function () {
        return path;
      },
      viewsLoad: function () {
        return viewResource.get();
      }
    }
  }
})();
(function(){
  'use strict';

  angular
    .module('app')
    .factory('BoardsService', BoardsService);

  /** @ngINject */
  function BoardsService($resource){
    var path = 'rest/boards/data';
    var viewResource = $resource(path,
      { '_format': 'json' },
      {
        'get': {
          method: 'GET',
          isArray: true
        }
      });

    // Return public API
    return {
      getPath: function () {
        return path;
      },
      viewsLoad: function () {
        return viewResource.get();
      }
    };
  }
})();
(function () {
	'use strict';

	angular.module('app')
			.factory('UsersService', UsersService);

	function UsersService($resource) {
		var path_prefix = 'rest/user/';
        var path_suffix = '/data';

		var imprimeur = $resource(path_prefix+'imprimeur'+path_suffix,
				{ '_format': 'json' },
				{
					'get': {
						method: 'GET',
						isArray: true
					}
				});

        var agence = $resource(path_prefix+'agence'+path_suffix,
				{ '_format': 'json' },
				{
					'get': {
						method: 'GET',
						isArray: true
					}
				});

		var checkAgence = $resource('rest/myplv/agence/checkMail',
				{ '_format': 'json' },
				{
					'post': {
						method: 'POST',
						isArray: false
					}
				});

		var getAgenceMail = $resource('rest/myplv/agence/get_mail',
				{ '_format': 'json' },
				{
					'post': {
						method: 'POST',
						isArray: false
					}
				});

		// Return public API
		return {
			viewsLoadAgence: function () {
				return agence.get();
			},
            viewsLoadImprimeur: function () {
				return imprimeur.get();
			},
			checkMail: checkAgence.post,
			getAgenceMail: getAgenceMail.post
		};
	}
})();

(function(){
  'use strict';

  angular.module('app')
    .factory('UserList', UserList);

  /** @ngInject */
  function UserList($resource, $q){

    /**
     * Return list of All Users by role
     */
    var itemRessource = $resource('rest/myplv/all/users/:role',
      {},
      {
        'get': {
          method: 'GET',
          isArray: true,
          cache: true
        }
      }
    );

    /**
     * Get user list by role
     * @param role
     * @returns {*}
     */
    var getUsersByRole = function(role){
      var deferred = $q.defer();
      var ressource = itemRessource.get({role: role});
      ressource.$promise.then(function(result){
        deferred.resolve(result);
      });
      return deferred.promise;
    };

    // Return Public API
    return {
      getUsersByRole: getUsersByRole
    };
  }
})();
(function () {
	'use strict';

	angular.module('app')
			.factory('TaxonomyService', TaxonomyService);

	function TaxonomyService($resource) {
		var viewResource = $resource('rest/:taxonomy/data',
				{ '_format': 'json' },
				{
					'getSupportsSurMesure': {
						method: 'GET',
						isArray: true,
            cache:true,
            params: {
              taxonomy: "supportssurmesure"
            }
					},
          'getChartesCCE': {
						method: 'GET',
						isArray: true,
				cache:true,
				params: {
					taxonomy: "chartescce"
				}
			},
			'getMaterials': {
				method: 'GET',
				isArray: true,
				cache:true,
				params: {
					taxonomy: "matieres"
				}
			},
			'getCHRMaterials': {
				method: 'GET',
				isArray: true,
				cache:true,
				params: {
					taxonomy: "matieres_chr"
				}
			}
		}          
    );

		// Return public API
		return {
			getSupportsSurMesure: viewResource.getSupportsSurMesure,
			getChartesCCE: viewResource.getChartesCCE,
			getMaterials: viewResource.getMaterials,
			getCHRMaterials: viewResource.getCHRMaterials
		};
	}
})();

(function () {
	'use strict';

	angular.module('app')
			.factory('ThemeService', ThemeService);

	function ThemeService($resource) {
		var path = 'rest/support/data';
		var viewResource = $resource(path,
				{ '_format': 'json' },
				{
					'get': {
						method: 'GET',
						isArray: true
					}
				});

		// Return public API
		return {
			getPath: function () {
				return path;
			},
			viewsLoad: function () {
				return viewResource.get();
			}
		};
	}
})();

(function(){
  'use strict';

  angular.module('app').factory('sendUploadFileInvite', sendUploadFileInvite);

  /** @ngInject */
  function sendUploadFileInvite($resource){
    var sendInviteRes = $resource('rest/myplv/externalupload/sendinvite',
      {},
      {
        'send': {
          method: 'POST'
        }
      }
    );

    // Return Public API
    return {
      send: sendInviteRes.send
    };
  }
})();
(function(){
  'use strict';

  angular.module('app')
    .factory('SuiviQuotasService', SuiviQuotasService);

  /** @ngInject */
  function SuiviQuotasService($log, $q, $resource){

    var itemSuiviQuotas = $resource('rest/myplv/quotas/suivi/:username',
      {},
      {
        'get': {
          method: 'GET',
          isArray: true
        }
      });

    /**
     * Return username
     * @param user
     * @returns {*}
     */
    var getUserNameForSuivi = function(user){
      var deferred = $q.defer();

      // If MDV, get SMHF's MDV
      if(user.hasRole('mdv')){
        user.getSmhfDc(user.getUserSmhf()).then(function(data){
          deferred.resolve(data.username);
        });
      }else if(user.hasRole('smhf')){ // Return username if smhf user
        deferred.resolve(user.getUsername());
      } else { // Else is user siege (or administartor)
        deferred.resolve('');
      }

      return deferred.promise;
    };

    /**
     * Get Suiv Quota By Username (or not)
     * @param usermane
     * @returns {*}
     */
    var getSuiviQuotas = function(user){
      var deferred = $q.defer();

      /**
       * First get Username SMHF of current user
       */
      getUserNameForSuivi(user).then(function(data){
        var ressource = itemSuiviQuotas.get({username: data});
        ressource.$promise.then(function(result){
          deferred.resolve(result);
        });
      });

      return deferred.promise;
    };

    // Return public API
    return {
      getSuiviQuotas: getSuiviQuotas
    };
  }
})();
(function(){
  'use strict';

  angular.module('app')
    .factory('EtatQuotasSmhfService', EtatQuotasSmhfService);

  /** @ngInject */
  function EtatQuotasSmhfService($log, $resource, $q){

    var itemEtatQuotas = $resource('rest/myplv/quotas/etat/:smhf',
      {},
      {
        'get': {
          method: 'GET',
          isArray: true
        }
      });

    /**
     * Return Etat Quotas Smhf
     * @param smhf
     * @returns {*}
     */
    var getEtatQuotasSmhf = function(smhf){
      var deferred = $q.defer();
      var ressource = itemEtatQuotas.get({smhf: smhf});
      ressource.$promise.then(function(result){
        deferred.resolve(result);
      });
      return deferred.promise;
    };

    // Return public API
    return {
      getEtatQuotasSmhf: getEtatQuotasSmhf
    };
  }
})();
(function () {
  'use strict';

  angular.module('app')
    .factory('QrCodeService', QrCodeService);

  /** @ngInject */
  function QrCodeService($log, $resource) {
    var qrcodeResource = $resource('/rest/myplv/qrcodes/:id',
      { id: '@_id.$oid' },
      {
        'get': {
          method: 'GET',
          isArray: false
        },
        'create': {
          method: 'POST',
          isArray: false
        },
        'update': {
          method: 'PUT',
          isArray: false
        }
      });

    function create(qrcodeId) {
      return qrcodeResource.create({ "_id": { "$oid":  qrcodeId} });
    }

    var bannerRessource = $resource('/rest/myplv/qrcodes/:id/banner',
      { id: '@_id.$oid' },
      {
        'delete': {
          method: 'DELETE',
          isArray: false
        }
    }); 

    // Return public API
    return {
      get: qrcodeResource.get,
      create: create,
      update: qrcodeResource.update,
      resetBanner: bannerRessource.delete
    };
  }
})();

(function () {
    'use strict';

    angular.module('app')
        .factory('ProjetService', ProjetService);

    /** @ngInject */
    function ProjetService($log, $resource, $q, $state, FileUploader, CleanStringService) {
        var ctx = {
            'project': null,
            'uploader': null,
            'getUploader': getUploader,
            'getUploaderV2': getUploaderV2,
            '$promise': null
        };

        var itemListResource = $resource('/rest/myplv/projets/:id',
            {id: '@_id.$oid'},
            {
                'get': {
                    method: 'GET',
                    isArray: true
                },
                'getProjet': {
                    method: 'GET',
                    isArray: false
                },
                query: {
                    method: 'GET'
                },
                'update': {
                    method: 'PUT'
                }
            });

        var setProject = function (project) {
            ctx.uploader = new FileUploader({
                url: '/rest/myplv/projets/upload'
            });
            ctx.project = project;
        };

        var save = function () {
            var deferred = $q.defer();
            ctx.uploader.onBeforeUploadItem = function (item) {
                item.formData.push({
                    'projet_id': ctx.project._id.$oid,
                    'file_type': item.myplv_file_type
                });
            };

            var resource = null;

            delete ctx.project.isSelected;   // Bugfix: prevent gestion-projet screen checkboxes to be be pre-checked

            if (angular.isDefined(ctx.project._id)) {
                //$log.debug('Update');
                resource = ctx.project.$update();

                resource.then(function (result) {
                    if (ctx.uploader.queue.length > 0) {
                        ctx.uploader.onCompleteAll = function () {
                            ctx.uploader.clearQueue();
                            deferred.resolve('on CompleteAll');
                        };
                        ctx.project = result;
                        ctx.uploader.uploadAll();
                    } else {
                        ctx.project = result;
                        deferred.resolve('no Doc Upload');
                    }
                });

            } else {
                resource = itemListResource.save(ctx.project);

                resource.$promise.then(function (result) {
                    if (ctx.uploader.queue.length > 0) {
                        ctx.uploader.onCompleteAll = function () {
                            deferred.resolve('on CompleteAll');
                        };
                        ctx.project = result;
                        ctx.uploader.uploadAll();
                    } else {
                        ctx.project = result;
                        deferred.resolve('no Doc Upload');
                    }
                });
            }
            //$log.debug(deferred.promise);
            return deferred.promise;
        };

        var createProject = function () {
            ctx.uploader = new FileUploader({
                url: '/rest/myplv/projets/upload'
            });
            ctx.project = {
                pdv: {}
            };
        };

        var loadProject = function(projetId) {
            setProject(itemListResource.getProjet({id: projetId}));
            ctx.$promise = ctx.project.$promise;
        }

        var getProjectContext = function () {
            if (!ctx.project && $state.params.id) {
                // Init project from url parameter
                setProject(itemListResource.getProjet({id: $state.params.id}));
                ctx.$promise = ctx.project.$promise;
            } else if (ctx.project && ctx.project.$promise) {
                ctx.$promise = ctx.project.$promise;
            } else {
                ctx.$promise = qResolve(ctx.project);
            }
            return ctx;
        };

        /**
         * @deprecated kept for backward compatibility. Use getUploaderV2() instead.
         */
        function getUploader(file_type) {
            ctx.uploader.onAfterAddingFile = function (item) {
                item.myplv_file_type = file_type;
                var filename = item.file.name.split('.').shift();
                var fileExtension = '.' + item.file.name.split('.').pop();
                item.file.name = CleanStringService.cleanText(filename + '_' + new Date().getTime()) + fileExtension;
                item.file.firtsName = CleanStringService.cleanText(filename + '_' + new Date().getTime());
                item.myplv_file_type_name = file_type + '_' + item.file.name;
            };
            return ctx.uploader;
        }

        /**
         * Return application Uploader.
         * Refactoring of previous upload mecanism :
         *  - use file_type coming from item.file_type
         *  - used by photo-upload component.
         */
        function getUploaderV2() {
            ctx.uploader.onAfterAddingFile = function (item) {
                var file_type = item.file_type;

                item.myplv_file_type = file_type;   // Really useful ?
                var filename = item.file.name.split('.').shift();
                var fileExtension = '.' + item.file.name.split('.').pop();
                item.file.name = CleanStringService.cleanText(filename + '_' + new Date().getTime()) + fileExtension;
                item.file.firtsName = CleanStringService.cleanText(filename + '_' + new Date().getTime());   // Really useful ?
                item.myplv_file_type_name = file_type + '_' + item.file.name;
            };
            return ctx.uploader;
        }

        function qResolve(projet) {
            return $q(function (resolve) {
                resolve(projet);
            });
        }

        /**
         * Return if CHR Project
         * @param aProject
         * @returns {boolean}
         */
        function isCHR(aProject) {
            aProject = aProject ? aProject : ctx.project;
            return aProject.type === "Carte Brasserie";
        }

        /**
         * Return if VAE Project
         * @param aProject
         * @returns {boolean}
         */
        function isVAE(aProject) {
            aProject = aProject ? aProject : ctx.project;
            return aProject.type === "Caissons Lumineux" ||
                aProject.type === "Boards PVC" || aProject.type === "Digital";
        }

        /** Return true if aProject type is Projet Sur Mesure
         * @param aProject
         * @returns {boolean}
         */
        function isPSM(aProject) {
            aProject = aProject ? aProject : ctx.project;
            return aProject.type === "Sur Mesure";
        }

        /** Return true if aProject type is Projet Sur Mesure
         * @param aProject
         * @returns {boolean}
         */
        function isPDA(aProject) {
            aProject = aProject ? aProject : ctx.project;
            return aProject.type === "Direct Agence";
        }

        /**
         * Return if Project with Pose
         * @param aProject
         * @returns {Document.pose|Document.pose.pose|VaePoseController.ctx.project.pose|*|boolean}
         */
        function isAvecPose(aProject) {
            aProject = aProject ? aProject : ctx.project;
            return aProject.pose && aProject.pose.pose === 'oui';
        }

        /**
         * Return nbr total of boards to Print
         * @param aProject
         * @returns {number}
         */
        function nbBoards(aProject) {
            var count = 0;
            aProject = aProject ? aProject : ctx.project;
            angular.forEach(aProject.boards, function (board) {
                count += parseInt(board.nombreExemplaire);
            });
            return count;
        }

        /**
         * Return nbr type Boards selected
         * @param aProject
         * @returns {*}
         */
        function nbBoardsCreated(aProject) {
            if (angular.isDefined(aProject.boards))
                return aProject.boards.length;
            return null;
        }

        function isPoseDisabled(aProject) {
            aProject = aProject ? aProject : ctx.project;
            return aProject.type === "Digital" || aProject.type === 'Caissons Lumineux';
        }

        // Return public API
        return {
            get: itemListResource.get,
            query: itemListResource.query,
            save: save,
            getProjectContext: getProjectContext,
            setProject: setProject,
            createProject: createProject,
            isCHR: isCHR,
            isVAE: isVAE,
            isPSM: isPSM,
            isPDA: isPDA,
            isAvecPose: isAvecPose,
            nbBoards: nbBoards,
            nbBoardsCreated: nbBoardsCreated,
            isPoseDisabled: isPoseDisabled,
            loadProject: loadProject
        };
    }
})();

(function(){
  'use strict';

  angular
    .module('app')
    .factory('PrixGammeBoissons', PrixGammeBoissons);

  /** @ngInject */
  function PrixGammeBoissons(){
    var prixGamme = null;

    /**
     * Set prix to associate drinks
     * @param index
     * @param prix
     */
    var setPrixGammeBoissoons = function(index, prix){
      prixGamme = {};
      prixGamme = {
        index: index,
        prix: prix
      }
    };

    /**
     * Init data prixGammeBoissons
     */
    var cleanPrixGammeBoissons = function(){
      prixGamme = null;
    };

    /**
     * Get PrixGamme
     * @returns {*}
     */
    var getPrixGammeBoissons = function(){
      return prixGamme;
    };

    /**
     * Return API
     */
    return {
      cleanPrixGammeBoissons: cleanPrixGammeBoissons,
      setPrixGammeBoissoons: setPrixGammeBoissoons,
      getPrixGammeBoissons: getPrixGammeBoissons
    };
  }
})();
(function () {
  'use strict';

  /**
   * Service to find photo object in project.
   */
  angular.module('app')
    .factory('PhotoFinder', PhotoFinder);

  /** @ngInject */
  function PhotoFinder() {
    var PHOTO_CONF = {
      'photo_carte': {'finder': findPhotoCarte},
      'photo_pricelist': {'finder': findPhotoPriceList},
      'agence': {'finder': findPhotoSuiviProjet},
      'photo_crea': {'finder': findPhotoCrea},
      'photo_charte': {'finder': findPhotoCharte},
      'photo_typo': {'finder': findPhotoTypo}
    };

    /**
     * Find suitable confr from PHOTO_CONF.
     */
    function getConf(filename) {
      for (var type in PHOTO_CONF) {
        if (filename.startsWith(type)) {
          return PHOTO_CONF[type];
        }
      }
      return null;
    }

    // Find photo_carte prefixed photo
    function findPhotoCarte(filename, project) {
      return findIn(filename, project.contenu);
    }

    // Find photo_pricelist prefixed photo
    function findPhotoPriceList(filename, project) {
      var boards = project.boards ? project.boards : [];
      var result = null;
      for (var i = 0; i < boards.length; ++i) {
        if (boards[i].brief) {
          result = findIn(filename, boards[i].brief.photo);
          if (result) {
            return result; // Return first result.
          }
        }
      }
      return result;
    }

    // Find photo_crea prefixed photo
    function findPhotoCrea(filename, project) {
      var boards = project.supports ? project.supports : [];
      var result = null;
      for (var i = 0; i < boards.length; ++i) {
        result = findIn(filename, boards[i].creation);
        if (result) {
          return result; // Return first result.
        }
      }
      return result;
    }

    // Find photo_charte prefixed photo
    function findPhotoCharte(filename, project) {
      if (project.charte) {
        return findIn(filename, project.charte.photo_charte);
      }
      return null;
    }

    // Find photo_type prefixed photo
    function findPhotoTypo(filename, project) {
      if (project.charte) {
        return findIn(filename, project.charte.photo_typo);
      }
      return null;
    }

    function findPhotoSuiviProjet(filename, project) {
      return findIn(filename, project.docSuiviProjet);
    }

    function findIn(filename, photosArray) {
      if (!photosArray) {
        return null;
      }
      for (var i in photosArray) {
        if (photosArray[i] &&
          (filename.endsWith(photosArray[i].photo) ||
            filename.endsWith(photosArray[i].name))
          ) {
          return photosArray[i];
        }
      }
      return null;
    }

    /**
     * Find photo object in project that represents filename.
     * @param {type} filename
     * @param {type} project
     * @returns photoObj from project
     */
    function findPhoto(filename, project) {
      var conf = getConf(filename);
      if (conf && conf.finder) {
        return conf.finder(filename, project);
      } else {
        return null;
      }
    }

    // Return public API
    return {
      findPhoto: findPhoto
    };
  }
})();

(function () {
  'use strict';

  angular.module('app')
    .factory('PdvInfoService', PdvInfoService);

  /** @ngInject */
  function PdvInfoService($resource) {
    var pdvResource = $resource('rest/myplv/sf/pdv/:outlet',
      {},
      {
        'get': {
          method: 'GET'
        }
      });

    // Return Public API
    return {
      get: pdvResource.get
    };
  }
})();

(function () {
	'use strict';

	angular.module('app')
			.factory('ModelesQrCodeStickersService', ModelesQrCodeStickersService);

	function ModelesQrCodeStickersService($resource) {
		var path = 'rest/modeleqrcodesstickers/data';
		var viewResource = $resource(path,
				{ '_format': 'json' },
				{ 
					'get': {
						method: 'GET',
						isArray: true
					}
				});

		// Return public API
		return {
			getPath: function () {
				return path;
			},
			viewsLoad: function () {
				return viewResource.get();
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('app')
			.factory('ModelesQrCodeService', ModelesQrCodeService);

	function ModelesQrCodeService($resource) {
		var path = 'rest/modeleqrcodes/data';
		var viewResource = $resource(path,
				{ '_format': 'json' },
				{
					'get': {
						method: 'GET',
						isArray: true
					}
				});

		// Return public API
		return {
			getPath: function () {
				return path;
			},
			viewsLoad: function () {
				return viewResource.get();
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('app')
			.factory('MentionsService', MentionsService);

	function MentionsService($resource) {
		var path = 'rest/mentions/data';
		var viewResource = $resource(path,
				{ '_format': 'json' },
				{
					'get': {
						method: 'GET',
						isArray: true
					}
				});

		// Return public API
		return {
			getPath: function () {
				return path;
			},
			viewsLoad: function () {
				return viewResource.get();
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('app')
			.factory('IllustrationsService', IllustrationsService);

	function IllustrationsService($resource) {
		var path = 'rest/illustrations/data';
		var viewResource = $resource(path,
				{ '_format': 'json' },
				{
					'get': {
						method: 'GET',
						isArray: true
					}
				});

		// Return public API
		return {
			getPath: function () {
				return path;
			},
			viewsLoad: function () {
				return viewResource.get();
			}
		};
	}
})();

(function () {
  'use strict';

  angular.module('app')
    .factory('GammeService', GammeService);

  /** @ngInject */
  function GammeService($resource) {
    var path = 'rest/boissons/data';
    var viewResource = $resource(path,
      { '_format': 'json' },
      {
        'get': {
          method: 'GET',
          isArray: true,
          cache: true,
          transformResponse: function (responseData) {
            responseData = angular.fromJson(responseData);
            angular.forEach(responseData, function (boisson) {
              if (boisson.name_1 && boisson.name_1 !== '') {
                boisson.fullName = boisson.name_1 + ' ' + boisson.field_gamme_format_boissons;
              } else {
                boisson.fullName =  boisson.field_gamme_format_boissons;
              }
            });
            return responseData;
          }
        }
      });

    // Return public API
    return {
      getPath: function () {
        return path;
      },
      viewsLoad: function () {
        return viewResource.get();
      }
    };
  }
})();

(function () {
	'use strict';

	angular.module('app')
			.factory('FormatService', FormatService);

	function FormatService($resource) {
		var path = 'rest/format/data';
		var viewResource = $resource(path,
				{ '_format': 'json' },
				{
					'get': {
						method: 'GET',
						isArray: true
					}
				});

		var pathPDA = 'rest/formatPDA/data';
		var viewResourcePDA = $resource(pathPDA,
				{ '_format': 'json' },
				{
					'get': {
						method: 'GET',
						isArray: true
					}
				});

		// Return public API
		return {
			getPath: function () {
				return path;
			},
			getPathPDA: function () {
				return pathPDA;
			},
			viewsLoad: function () {
				return viewResource.get();
			},
			viewsLoadPDA: function () {
				return viewResourcePDA.get();
			}
		};
	}
})();

(function(){
	'use strict';

	angular.module('app')
			.factory('FilesProjecttService', FilesProjecttService)   // Backward compat
      .factory('FilesProjectService', FilesProjecttService);

	/** @ngInject */
	function FilesProjecttService($resource){
		var itemListResource = $resource('rest/myplv/projets/download/:id',
				{id: '@_id.$oid'},
				{
					'get': {
						method: 'GET',
						isArray: true
					}
				});

		var deleteFileResource = $resource('/rest/myplv/projets/deleteFile/:id',
				{ id: '@_id.$oid'},
				{
					'delete': {
						method: 'GET',
						isArray: false
					}
				}); 

		function deleteFile(filename, projectId) {
			return deleteFileResource.delete( {"filename": filename, "id": projectId} );
		}


		// Return Public API
		return {
			get: itemListResource.get,
			deleteFile: deleteFile
		}
	}
})();

(function () {
  'use strict';

  angular.module('app')
      .factory('ExportTableService', ExportTableService);

  /** @ngInject */
  function ExportTableService($log, $window, $q){

    var uri = 'data:application/vnd.ms-excel;base64,';
    var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta http-equiv="content-type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    var base64 = function(s){
      return $window.btoa(unescape(encodeURIComponent(s)));
    };
    var format = function(s,c){
      return s.replace(/{(\w+)}/g,function(m,p){return c[p];})
    };

    return {
      tableToExcel:function(tableId,worksheetName){
        var deferred = $q.defer();
        var table=$(tableId);
        var ctx={worksheet:worksheetName,table:table.html()};
        var href=uri+base64(format(template,ctx));
        deferred.resolve(href);
        //return href;
        return deferred.promise;
      }
    }
  }

})();
(function(){
	'use strict';

	angular
			.module('app')
			.factory('EditeBoard', EditeBoard);

	/** @ngInject */
	function EditeBoard(){
		var board = {};

		/**
		 * Set Board To Edit
		 * @param data
		 */
		var setEditBoard = function(index, data){
      board = {};
			board = {
        index: index,
        data: data
      };
		};

		/**
		 * Get Board to Edit
		 * @returns {*}
		 */
		var getEditBoard = function(){
			return board;
		};

		/**
		 * Return API
		 */
		return {
			setEditBoard: setEditBoard,
			getEditBoard: getEditBoard
		};
	}
})();
(function(){
	'use strict';

	angular.module('app')
			.factory('DownloadProjecttService', DownloadProjecttService);

	/** @ngInject */
	function DownloadProjecttService($resource){
		var itemListResource = $resource('rest/myplv/download/projets/:id',
				{id: '@_id.$oid'},
				{
					'get': {
						method: 'GET',
						isArray: true
					}
				});

		// Return Public API
		return {
			get: itemListResource.get
		}
	}
})();

(function(){
  'use strict';

  angular.module('app')
      .factory('DlProjectImprimeurService', DlProjectImprimeurService);

  /** @ngInject */
  function DlProjectImprimeurService($resource){
    var itemListResource = $resource('rest/myplv/projets/imprimeur/download/:id',
        {id: '@_id.$oid'},
        {
          'get': {
            method: 'GET',
            isArray: true
          }
        });

    // Return Public API
    return {
      get: itemListResource.get
    }
  }
})();

(function () {
	'use strict';

	angular.module('app')
			.factory('DCData', DCData);

	/** @ngInject */
	function DCData($resource) {
		var viewResource = $resource('rest/myplv/dc/:dc_username',
				{},
				{
					'get': {
						method: 'GET',
						isArray: true,
            cache: true
					}
				});

		// Return Public API
		return {
			get: viewResource.get
		}
	}
})();

(function(){
  'use strict';

  angular.module('app').factory('countProjectByStatus', countProjectByStatus);

  /** @ngInject */
  function countProjectByStatus($resource){
    var countProjectByStatus = $resource('rest/myplv/data/accueil/agence',
      {},
      {
        'get': {
          method: 'GET',
          isArray: true
        }
      }
    );

    // Return Public API
    return {
      get: countProjectByStatus.get
    };
  }
})();
(function () {
	'use strict';

	angular.module('app')
			.factory('CocktailsService', CocktailsService);

	function CocktailsService($resource) {
		var path = 'rest/cocktails/data';
		var viewResource = $resource(path,
				{ '_format': 'json' },
				{
					'get': {
						method: 'GET',
						isArray: true
					}
				});

		// Return public API
		return {
			getPath: function () {
				return path;
			},
			viewsLoad: function () {
				return viewResource.get();
			}
		};
	}
})();

(function () {
	'use strict';

	angular.module('app')
			.factory('CloneProjetService', CloneProjetService);

	/** @ngInject */
	function CloneProjetService($resource) {
		var viewResource = $resource('rest/myplv/clone/projet/:id',
				{id: '@_id.$oid'},
				{
					'clone': {
						method: 'POST',
						isArray: false,
						cache: false
					}
				});

		// Return Public API
		return {
			clone: viewResource.clone
		}
	}
})();

(function(){
  'use strict';

  angular
    .module('app')
    .factory('CleanStringService', CleanStringService);

  /** @ngInject */
  function CleanStringService(){

    /**
     * List of 'letters' to replace by 'base'
     * @type {{base: string, letters: RegExp}[]}
     */
    var defaultDiacriticsRemovalMap = [
      {'base':'A', 'letters':/[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g},
      {'base':'AA','letters':/[\uA732]/g},
      {'base':'AE','letters':/[\u00C6\u01FC\u01E2]/g},
      {'base':'AO','letters':/[\uA734]/g},
      {'base':'AU','letters':/[\uA736]/g},
      {'base':'AV','letters':/[\uA738\uA73A]/g},
      {'base':'AY','letters':/[\uA73C]/g},
      {'base':'B', 'letters':/[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g},
      {'base':'C', 'letters':/[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g},
      {'base':'D', 'letters':/[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g},
      {'base':'DZ','letters':/[\u01F1\u01C4]/g},
      {'base':'Dz','letters':/[\u01F2\u01C5]/g},
      {'base':'E', 'letters':/[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g},
      {'base':'F', 'letters':/[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g},
      {'base':'G', 'letters':/[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g},
      {'base':'H', 'letters':/[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g},
      {'base':'I', 'letters':/[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g},
      {'base':'J', 'letters':/[\u004A\u24BF\uFF2A\u0134\u0248]/g},
      {'base':'K', 'letters':/[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g},
      {'base':'L', 'letters':/[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g},
      {'base':'LJ','letters':/[\u01C7]/g},
      {'base':'Lj','letters':/[\u01C8]/g},
      {'base':'M', 'letters':/[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g},
      {'base':'N', 'letters':/[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g},
      {'base':'NJ','letters':/[\u01CA]/g},
      {'base':'Nj','letters':/[\u01CB]/g},
      {'base':'O', 'letters':/[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g},
      {'base':'OI','letters':/[\u01A2]/g},
      {'base':'OO','letters':/[\uA74E]/g},
      {'base':'OU','letters':/[\u0222]/g},
      {'base':'P', 'letters':/[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g},
      {'base':'Q', 'letters':/[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g},
      {'base':'R', 'letters':/[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g},
      {'base':'S', 'letters':/[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g},
      {'base':'T', 'letters':/[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g},
      {'base':'TZ','letters':/[\uA728]/g},
      {'base':'U', 'letters':/[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g},
      {'base':'V', 'letters':/[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g},
      {'base':'VY','letters':/[\uA760]/g},
      {'base':'W', 'letters':/[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g},
      {'base':'X', 'letters':/[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g},
      {'base':'Y', 'letters':/[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g},
      {'base':'Z', 'letters':/[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g},
      {'base':'a', 'letters':/[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g},
      {'base':'aa','letters':/[\uA733]/g},
      {'base':'ae','letters':/[\u00E6\u01FD\u01E3]/g},
      {'base':'ao','letters':/[\uA735]/g},
      {'base':'au','letters':/[\uA737]/g},
      {'base':'av','letters':/[\uA739\uA73B]/g},
      {'base':'ay','letters':/[\uA73D]/g},
      {'base':'b', 'letters':/[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g},
      {'base':'c', 'letters':/[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g},
      {'base':'d', 'letters':/[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g},
      {'base':'dz','letters':/[\u01F3\u01C6]/g},
      {'base':'e', 'letters':/[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g},
      {'base':'f', 'letters':/[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g},
      {'base':'g', 'letters':/[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g},
      {'base':'h', 'letters':/[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g},
      {'base':'hv','letters':/[\u0195]/g},
      {'base':'i', 'letters':/[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g},
      {'base':'j', 'letters':/[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g},
      {'base':'k', 'letters':/[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g},
      {'base':'l', 'letters':/[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g},
      {'base':'lj','letters':/[\u01C9]/g},
      {'base':'m', 'letters':/[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g},
      {'base':'n', 'letters':/[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g},
      {'base':'nj','letters':/[\u01CC]/g},
      {'base':'o', 'letters':/[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g},
      {'base':'oi','letters':/[\u01A3]/g},
      {'base':'ou','letters':/[\u0223]/g},
      {'base':'oo','letters':/[\uA74F]/g},
      {'base':'p','letters':/[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g},
      {'base':'q','letters':/[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g},
      {'base':'r','letters':/[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g},
      {'base':'s','letters':/[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g},
      {'base':'t','letters':/[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g},
      {'base':'tz','letters':/[\uA729]/g},
      {'base':'u','letters':/[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g},
      {'base':'v','letters':/[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g},
      {'base':'vy','letters':/[\uA761]/g},
      {'base':'w','letters':/[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g},
      {'base':'x','letters':/[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g},
      {'base':'y','letters':/[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g},
      {'base':'z','letters':/[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g},
      {'base':'','letters':/[\u0040\u0301\u0300\u0302\u0303\u0304\u0306\u0307\u0308\u0309\u030A\u030B\u030C\u002E\u003A\u003B]/g},
      {'base':'_','letters':/[\u0020\u002F\u005C]/g}
    ];

    /**
     * Function replace character
     * @param str
     * @returns {*}
     */
    var cleanText = function (str) {
      for(var i=0; i<defaultDiacriticsRemovalMap.length; i++) {
        str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
      }
      return str;
    };

    // Return API
    return {
      cleanText: cleanText
    };
  }
})();
(function () {
	'use strict';

	angular.module('app')
			.factory('ChangeStatutService', ChangeStatutService);

	// Change le statut du projet
	/** @ngInject */
	function ChangeStatutService($log, $resource, $q){

		// Return public API
		var itemChangeStatut = $resource('rest/myplv/projets/:id/statut/:new_statut',
				{id: '@_id.$oid'},
				{
					'update': {
						method: 'PUT'
					}
				});

		// Update Statut with upload file
		var update = function(project, new_statut, uploader){
			var deferred = $q.defer();

      if(uploader && uploader.queue.length > 0) {
        // Upload files first, then change status
        uploader.onCompleteAll = function(){
          deferred.resolve('on CompleteAll');
        };
        uploader.uploadAll();
      } else {
        deferred.resolve('no doc to upload');
      }

			var deferred2 = $q.defer();
      deferred.promise.then(
        function() {
          itemChangeStatut.update(
						{id: project._id.$oid, new_statut: new_statut}, 
						project
					).$promise.then(
						function(data) {
							deferred2.resolve(data);
						},
						function(error) {
							$log.error("Cannot change status.", error);
							deferred2.reject("Cannot change status.", error);
						}
					);
        },
        function(error) {
          $log.error("Cannot change status.", error);
        }
			);
			return deferred2.promise;
		};

		// Return public API
		return {
			update:  update
		};
	}
})();
(function () {
  'use strict';

  angular.module('app')
    .factory('ChangeDCService', ChangeDCService);

  // Change le dc du projet
  /** @ngInject */
  function ChangeDCService($resource, $q){

    var itemChangeDC = $resource('rest/myplv/projets/changedc/:new_dc',
      {},
      {
        'update': {
          method: 'PUT',
          isArray: true
        }
      });

    // Update DC for Project
    var update = function(projects, new_dc){
      var deferred = $q.defer();

      var resource = itemChangeDC.update({new_dc: new_dc}, projects);
      resource.$promise.then(function(){
        deferred.resolve('Change DC OK.');
      });

      return deferred.promise;
    };

    // Return public API
    return {
      update:  update
    };
  }
})();
(function () {
	'use strict';

	angular.module('app')
			.factory('ChangeAgenceService', ChangeAgenceService);

	/** @ngInject */
	function ChangeAgenceService($resource, $q) {
		var itemChangeAgence = $resource('rest/myplv/projets/:id/agence/:new_agence',
			{},
			{
				'update': {
					method: 'PUT'				
                }
			});
        
        // Update Agence for Project
        var update = function(project, new_agence){
            var deferred = $q.defer();
            var resource = itemChangeAgence.update({id: project._id.$oid, new_agence: new_agence}, project);
            resource.$promise.then(function(){
                deferred.resolve('Change Agence OK.');
            });
  
        return deferred.promise;
      };

		// Return Public API
		return {
			update: update
		}
	}
})();

(function(){
  'use strict';

  angular.module('app').factory('canUpdateProject', canUpdateProject);

  /** @ngInject */
  function canUpdateProject($resource){
    var canUpdateProject = $resource('rest/myplv/can/update/projet/:id',
      {id: '@_id.$oid'},
      {
        'get': {
          method: 'GET',
          isArray: true
        }
      }
    );

    // Return Public API
    return {
      get: canUpdateProject.get
    };
  }
})();
(function () {
  /*global angular */
  'use strict';

  angular.module('app')
    .factory('AuthInterceptor', AuthInterceptor)
    .config(registerInterceptor);

  /** @ngInject */
  function AuthInterceptor($q, $window, $log) {
    var responseError = function (rejection) {
      $log.warn('AuthInterceptor ERROR', rejection);
      if (rejection.status === 401 ||
          rejection.status === 403) {
        $window.location.href = "/";  // Force browser reload.
      }
      return $q.reject(rejection);
    };

    // Return public API
    return {
      'responseError': responseError
    };
  }
  
  /** @ngInject */
  function registerInterceptor($httpProvider) {
    $httpProvider.interceptors.push('AuthInterceptor');
  }    
  
})();

(function () {
  'use strict';

  angular.module('app')
    .factory('ArticleService', ArticleService);

  function ArticleService($resource) {
    var path = 'rest/articles/data';
    var viewResource = $resource(path,
      { '_format': 'json' },
      {
        'get': {
          method: 'GET',
          isArray: true
        }
      });

    // Return public API
    return {
      getPath: function () {
        return path;
      },
      viewsLoad: function () {
        return viewResource.get();
      }
    };
  }
})();
(function () {
  'use strict';

  angular.module('app')
    .factory('AllowedStatutService', AllowedStatutService);

  /** @ngInject */
  function AllowedStatutService($resource) {
    var itemListResource = $resource('rest/myplv/projets/allowedstatut/:id',
      {id: '@_id.$oid'},
      {
        'get': {
          method: 'GET',
          isArray: true
        }
      });
    var userStatutListResource = $resource('/rest/myplv/userstatut',
      {},
      {
        'get': {
          method: 'GET',
          isArray: true
        }
      });
    var projetStatutListResource = $resource('/rest/myplv/projets/allstatut/:id',
      {id: '@_id.$oid'},
      {
        'get': {
          method: 'GET',
          isArray: true
        }
      });

    // Return Public API
    return {
      get: itemListResource.get,
      getUserStatuts: userStatutListResource.get,
      getProjetStatuts: projetStatutListResource.get
    }
  }
})();

(function () {
	'use strict';

/**
 * Service to share alerts from controller to alert-message.
 */
	angular.module('app')
			.factory('Alert', AlertService);

  /** @ngInject */
	function AlertService() {
    var listeners = [];
    
    /**
     * Add listener to be nofified when an alert is to be shown.
     * listener object must implement function onAlert( alertToBeShown )
     */
    function addListener(listener) {
      listeners.push(listener);
      //$log.debug("addListener() : ", listeners);
    }
    
    /**
     * Removes listener from the list of listener to be notified.
     */
    function removeListener(listener) {
      var i = listeners.indexOf(listener);
      if(i > -1) {
        listeners.splice(i, 1);
      }
      //$log.debug("removeListener() : ", listeners);
    }
    
    /**
     * Notifie listeners that alert have to be displayed.
     */
    function show(alert, type) {
      angular.forEach(listeners, function(listener){
        listener.onAlert(alert, type);
      });
    }
    
		// Return public API
		return {
			show: show,
      addListener: addListener,
      removeListener: removeListener
		};
	}
})();

(function (){
  'use strict';

  angular
    .module('app')
    .controller('QrCodesController', QrCodesController);

  /** @ngInject */
  function QrCodesController($log, $scope, CurrentUser, QrCodeService, $stateParams, FileUploader, $window){
    var vm = this;
    vm.user = CurrentUser;
    vm.loading = false;
    vm.qrcode = null;
    vm.uploader = null;
    vm.bannerUploader = null;
    vm.fileToUpload = null;
    vm.bannerToUpload = null;
    vm.bannerInfo = null;
    vm.id = $stateParams.id;
    vm.backId = $stateParams.backId ? $stateParams.backId : $stateParams.id;
    vm.isNew = true;
    vm.ERROR_CLASS = "text-danger";
     
    function init() {
      block();
      vm.uploader = new FileUploader({
        url: '/rest/myplv/qrcodes/'+vm.id+'/upload'
      });
      if(!vm.bannerUploader) {
        vm.bannerUploader = new FileUploader({
          url: '/rest/myplv/qrcodes/'+vm.id+'/banner-upload'
        });
      }
      vm.fileToUpload = null;
      vm.bannerToUpload = null;
      vm.bannerInfo = null;
      vm.qrcode = QrCodeService.get({ id: vm.id })
      vm.qrcode.$promise.then(function () {
        if (vm.qrcode.type) {
          vm.isNew = false;
        }
        unblock();
        $scope.$apply();
      });
      $scope.$watch('main.bannerToUpload', function () {
        vm.onBannerImageChange();
      });
    }
    init();

    /**
     * Mise a jour de l'url
     */
    vm.updateUrl = function() {
      block();
      vm.qrcode = QrCodeService.update(vm.qrcode);
      vm.qrcode.$promise.then(init);
    }
    /**
     * Uplod du fichier
     */
    vm.uploadFile = function() {
      // After uploadAll(), refresh qrcode.
      vm.uploader.onCompleteAll = init;
      block();      
      vm.uploader.uploadAll(); 
    }
    vm.uploadBannerFile = function() {
      // After uploadAll(), refresh qrcode.
      vm.bannerUploader.onCompleteAll = init;
      block();
      if (vm.bannerToUpload != null) {
        vm.bannerUploader.uploadAll(); 
      } else {
        vm.qrcode = QrCodeService.update(vm.qrcode);
        vm.qrcode.$promise.then(init);
      }     
    }
    vm.bannerUploader.onBeforeUploadItem = function (item) {
      item.formData.push({
          'banner_timer': vm.qrcode.bannerTimer
      });
    }

    vm.onBannerImageChange = function() {
      var _URL = $window.URL || $window.webkitURL;
      if (!(vm.bannerToUpload)) {
        return false;
      }
      if(angular.isUndefined(vm.qrcode.bannerTimer) ||
        vm.qrcode.bannerTimer === null || 
        vm.qrcode.bannerTimer === '') 
      {
        vm.qrcode.bannerTimer = 5;
      }
      vm.bannerInfo = {'size':null, 'type':null, 'width':null, 'height':null, 'typeClass': null};

      var objectUrl = _URL.createObjectURL(vm.bannerToUpload);
      var img = new Image();
      img.onload = function () {
        vm.bannerInfo.height = img.height;
        vm.bannerInfo.width = img.width
        vm.validateBannerInfo();  
        $scope.$apply();
        _URL.revokeObjectURL(objectUrl);
      };
      img.src = objectUrl;
      vm.bannerInfo.type = vm.bannerToUpload.type;
      vm.bannerInfo.size = vm.bannerToUpload.size;
      vm.validateBannerInfo();  
    }

    vm.validateBannerInfo = function () {
      var allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
      if (allowedTypes.indexOf(vm.bannerToUpload.type) == -1) {
        vm.bannerInfo.typeClass = vm.ERROR_CLASS;
      }
      if (vm.bannerInfo.width && (vm.bannerInfo.width < 320 || vm.bannerInfo.width > 750) ) {
        vm.bannerInfo.widthClass = vm.ERROR_CLASS;
      }
      if (vm.bannerInfo.height && (vm.bannerInfo.height < 480 || vm.bannerInfo.height > 1334) ) {
        vm.bannerInfo.heightClass = vm.ERROR_CLASS;
      }
      if (vm.bannerInfo.size > 153600 ) {
        vm.bannerInfo.sizeClass = vm.ERROR_CLASS;
      }
    }

    vm.isModeFichier = function() {
      return vm.qrcode.type === "fichier" ;
    }
    vm.isModeUrl = function() {
      return vm.qrcode.type === "url" ;
    }
    vm.isBannerFormValid = function() {
      if (vm.bannerToUpload != null && vm.qrcode.bannerTimer != null) {
        return true
      }
      if (vm.qrcode.bannerName && vm.qrcode.bannerName != null && vm.qrcode.bannerTimer != null) {
        return true;
      }
      return false;
    }
    vm.isQrCodeGenerated = function() {
      return vm.qrcode && vm.qrcode.extra && vm.qrcode.extra.qrcodeUrl
    }
    vm.generateQrCode = function() {
      block();
      vm.qrcode = QrCodeService.create(vm.id);
      vm.qrcode.$promise.then(unblock);
    }
    vm.resetBanner = function() {
      block();
      QrCodeService.resetBanner({ id: vm.id }).$promise.then(init);
    }
    function block() {
      vm.loading = true;
    }
    function unblock() {
      vm.loading = false;
    }
  }

})();
(function (){
	'use strict';

	angular
			.module('app')
			.controller('OpenProjetController', OpenProjetController);

	/** @ngInject */
	function OpenProjetController($state, $stateParams, ProjetService){
		ProjetService.query({id: $stateParams.id}).$promise.then(function(result){
			ProjetService.setProject(result);
			$state.go('suivi-projet');
		});
	}

})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($log, $window, $state, $uibModal, CurrentUser, ProjetService, ArticleService, EtatQuotasSmhfService) {
        var vm = this;

        vm.user = CurrentUser;
        vm.actualites = ArticleService.viewsLoad(); // Récupération des actualités

        // Redirect if not DC, Siege or Admin
        // @TODO: put this in a service that return the homepage of a role
        if ( vm.user.hasRole('installateur') || vm.user.hasRole('client')) {
            $state.go('dashboard');
        }
        if (vm.user.getUsername() == 'imprimeurvae' || vm.user.getUsername() == 'imprimeur') {
            $state.go('dashboard-imprimeur');
        }

        /**
         * Close arte messagecd
         */
        vm.closeAlert = function () {
            vm.alert = {};
        };

        vm.alert = {
            type: 'danger',
            msg: " Information importante : nos budgets sur mesure sont désormais consommés à 100 %. Les briefs Sur Mesure créés à partir du 7 juillet et les briefs SUMMER créés à partir du 1er août ne pourront donc pas être pris en charge ni traités. Les projets WINTER restent maintenus. Merci de votre compréhension."
        };

        /**
         * Get EtatQuota for smhf DC
         */
        if (vm.user.hasRole('dc') || vm.user.hasRole('administrator')) {
            vm.user.getSmhfDc(vm.user.getUserSmhf()).then(function (result) {
                vm.smhf = result;

                EtatQuotasSmhfService.getEtatQuotasSmhf(vm.smhf.username).then(function (data) {
                    vm.etatQuota = data[0];
                    vm.etatQuotaCHR = vm.etatQuota.statutQuotaCHR;
                    vm.etatQuotaVAE = vm.etatQuota.statutQuotaVAE;
                    vm.etatQuotaPDA = vm.etatQuota.statutQuotaPDA;

                    if (vm.etatQuotaCHR == 'DEPASSE') {
                        vm.alertChr = 'Attention : quota dépassé. La création d’un projet est impossible.';
                    }
                    if (vm.etatQuotaVAE == 'DEPASSE') {
                        vm.alertVae = 'Attention : quota dépassé. La création d’un projet est impossible.';
                    }
                    if (vm.etatQuotaPDA == 'DEPASSE') {
                        vm.alertPda = 'Attention : quota dépassé. La création d’un projet Direct Agence est impossible.';
                    }
                });
            });
        }

        /**
         * Return if display btn dashboard access
         * @returns {boolean}
         */
        vm.hasDashbord = function () {
            if (vm.user.hasRole('dc') || vm.user.hasRole('administrator')) {
                return true;
            }
            return false;
        };

        /**
         * Création Projet CHR
         */
        vm.createNewProject = function () {
            // Alert if no SMHF for this DC
            if (!vm.checkUserSmhf()) {
                return;
            }
            // Alert if quotas < 10
            if (vm.etatQuotaCHR <= 10 || vm.etatQuotaCHR == 'ALERTE') {
                var modal = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title-bottom',
                    ariaDescribedBy: 'modal-body-bottom',
                    templateUrl: 'alertQuota.html',
                    controller: ['quota', alertQuotaModal],
                    controllerAs: 'vm',
                    resolve: {
                        quota: function () {
                            return vm.etatQuota.quotasAnnuelCHR - vm.etatQuota.quotasConsoCHR;
                        }
                    }
                });

                modal.result.then(function () {
                    ProjetService.createProject();
                    vm.ctx = ProjetService.getProjectContext();
                    vm.ctx.project.type = 'Carte Brasserie';
                    vm.ctx.project.typeProjet = 'CHR';
                    $state.go("chr.info-pdv");
                });
            }

            if (vm.etatQuotaCHR == 'OK') {
                ProjetService.createProject();
                vm.ctx = ProjetService.getProjectContext();
                vm.ctx.project.type = 'Carte Brasserie';
                vm.ctx.project.typeProjet = 'CHR';
                $state.go("chr.info-pdv");
            }
        };

        vm.createVaeProject = function () {
            vm.alert = {
                type: 'danger',
                msg: "La création de projets VAE est suspendue pour le moment"
            };
            return;
        }

        /**
         * Création Projet Sur Mesure
         */
        vm.createSurMesureProject = function () {
            // Alert if no SMHF for this DC
            if (!vm.checkUserSmhf()) {
                return;
            }
            ProjetService.createProject();
            vm.ctx = ProjetService.getProjectContext();
            vm.ctx.project.type = 'Sur Mesure';
            vm.ctx.project.typeProjet = 'PSM';
            $state.go("sm.info-pdv");
        };

        /**
         * Création Projet Direct Agence
         */
        vm.createDirectAgenceProject = function () {
            //DEACTIVATED
            return;
            if (!vm.checkUserSmhf()) {
                return;
            }

            // Alert if quotas < 10
            if (vm.etatQuotaPDA <= 10 || vm.etatQuotaPDA == 'ALERTE') {
                var modal = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title-bottom',
                    ariaDescribedBy: 'modal-body-bottom',
                    templateUrl: 'alertQuota.html',
                    controller: ['quota', alertQuotaModal],
                    controllerAs: 'vm',
                    resolve: {
                        quota: function () {
                            return vm.etatQuota.quotasAnnuelPDA - vm.etatQuota.quotasConsoPDA;
                        }
                    }
                });
            
                modal.result.then(function () {
                    ProjetService.createProject();
                    vm.ctx = ProjetService.getProjectContext();
                    vm.ctx.project.type = 'Direct Agence';
                    vm.ctx.project.typeProjet = 'PDA';
                    $state.go("da.dc.info_client");
                });
            }
            
            if (vm.etatQuotaPDA == 'OK') {
                ProjetService.createProject();
                vm.ctx = ProjetService.getProjectContext();
                vm.ctx.project.type = 'Direct Agence';
                vm.ctx.project.typeProjet = 'PDA';
                $state.go("da.dc.info_client");
            }
        };

        /**
         * Déconnexion User
         */
        vm.logout = function () {
            CurrentUser.logout(
                function () {
                    $window.location.href = "/";  // Force browser reload.
                }
            );
        };

        vm.checkUserSmhf = function () {
            // Alert if no SMHF for this DC
            if (vm.user.getUserSmhf() == null) {
                vm.alert = {
                    type: 'danger',
                    msg: "Vous n'êtes pas associé à un SMHF. La création du projet est impossible"
                };
                return false;
            }
            return true;
        };
    }


    /** @ngInject */
    function alertQuotaModal(quota) {
        var vm = this;

        vm.quota = quota;
    }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController(CurrentUser, $scope, $log, $location, $stateParams) {
    var vm = this;

		/**
		 * @returns trueif user is connected, false is not
		 */
		vm.connected = function() {
			return CurrentUser.getCurrentUser() !== null;
		};

		if(vm.connected()){
			$location.url($stateParams.targetUrl);
		}
    
    vm.loginForm = {
      username: "",
      password: "",
      error: null
    };

		vm.inputType = 'password';
		vm.password = true;

		/**
		 * Hide/Show password
		 */
		vm.hideShowPassword = function(){
			if (vm.inputType == 'password'){
				vm.inputType = 'text';
				vm.password = false;
			}
			else{
				vm.inputType = 'password';
				vm.password = true;
			}
		};

		/**
		 * remove text email login
		 */
		vm.removeText = function(){
			vm.loginForm.username = "";
		};

		/**
		 * Connect user and redirect
		 */
    vm.login = function() {
      vm.loginForm.error = null;      
      CurrentUser.login(
        vm.loginForm.username, 
        vm.loginForm.password
      ).then(
        function() {
			$log.log($stateParams.targetUrl);
					if(CurrentUser.hasRole('installateur') || CurrentUser.hasRole('client')){
						$location.url('/dashboard');
					} else if (CurrentUser.getUsername() == 'imprimeurvae' || CurrentUser.getUsername() == 'imprimeur') {
						$location.url('/dashboard-imprimeur');
					} else if ($stateParams.targetUrl !== null) {
						// Navigate to desired page
						$location.url($stateParams.targetUrl);
						//$scope.$apply();  // Force location refresh
					}
        },
        function() {
					vm.loginForm.error = 'Nom d\'utilisateur ou mot de passe non reconnu';
					if(vm.loginForm.username == '' || vm.loginForm.password == ''){
						vm.loginForm.error = 'Tous les champs sont obligatoires';
					}
          //vm.loginForm.error = 'Accès interdit';
          $scope.$apply();  // Nedded to update the view
        });
    };
  }
})();

(function () {
  'use strict';

  angular.module('app')
      .controller('HelpController', HelpController);

  /** @ngInject */
  function HelpController() {

  }
})();

(function (){
  'use strict';

  angular
    .module('app')
    .controller('GestionProjetsSmhfMdvController', GestionProjetsSmhfMdvController);

  /** @ngInject */
  function GestionProjetsSmhfMdvController($log, $state, $document, $uibModal, $timeout, ProjetService, CurrentUser, UserList,
                                    FormatService, AllowedStatutService, ChangeDCService, ExportTableService){
    var vm = this;

    vm.loading = true;

    vm.user = CurrentUser;

    vm.hasRole = CurrentUser.hasRole;

    vm.ctx = ProjetService.getProjectContext();

    /**
     * Variables d'initialisation de tri
     * @type {boolean}
     */
    vm.reverse = true;
    vm.propertyName = 't_update';

    vm.searchStatutArray = AllowedStatutService.getUserStatuts();
    vm.searchSupportArray = ['Carte Brasserie', 'Caissons Lumineux', 'Boards PVC', 'Sur Mesure'];

    /**
     * Initialisation data filter
     */
    vm.searchFormat = null;
    vm.searchSupport = vm.searchTypeSupport =  '';
    vm.searchStatut = '';
    vm.searchFilter = '';

    // Array project Selected
    vm.selectedProjet = [];

    /**
     * List of items to be displayed.
     */
    ProjetService.get().$promise.then(function (result) {
      vm.projectLists = result;

      // Get list of Users DC
      UserList.getUsersByRole('dc').then(function(data){
        vm.DCUsers = data;

        // Array with data DC (nom, prenom)
        vm.arrayDCData = {};
        angular.forEach(vm.DCUsers, function(user){
          vm.arrayDCData[user.username] = {
            data: user.prenom+' '+user.nom,
            smhf: user.smhf,
            mdv: user.mdv
          };
        });
      });

      // Get list of Users MDV
      UserList.getUsersByRole('mdv').then(function(data){
        vm.UsersMDV = data;

        vm.arrayMDVData = {};
        angular.forEach(vm.UsersMDV, function(user){
          vm.arrayMDVData[user.username] = user.prenom+' '+user.nom;
        });
      });

      // Get list of Users SMHF
      UserList.getUsersByRole('smhf').then(function(data){
        vm.UsersSMHF = data;

        vm.arraySMHFData = {};
        angular.forEach(vm.UsersSMHF, function(user){
          vm.arraySMHFData[user.username] = user.prenom+' '+user.nom;
        });
        vm.loading = false;
      });
    });

    /**
     * Multi Check Projet
     * @param project
     */
    vm.changeCheck = function(project){
      if (project.isSelected === true) {
        vm.selectedProjet.push(project._id.$oid);
      } else {
        var index = vm.selectedProjet.indexOf(project._id.$oid);
        vm.selectedProjet.splice(index, 1);
      }
      vm.selectedProjet.length > 1 ? vm.activeDownload = true : vm.activeDownload = false;
    };

    /**
     * Fonction de tri des données
     * @param propertyName
     */
    vm.sortBy = function (propertyName) {
      vm.reverse = (vm.propertyName === propertyName) ? !vm.reverse : false;
      vm.propertyName = propertyName;
    };

    /**
     * Export data table to Excel File
     * @param tableId
     */
    vm.exportToExcel = function(tableId){ // ex: '#my-table'
      ExportTableService.tableToExcel(tableId,'listprojets').then(function(result){
        var a = angular.element('<a>');
        a.attr('href', result);
        a.attr('download', 'ProjetsExport.xls');
        if(angular.element('body').hasClass('browser-firefox')){
          angular.element('body').append(a);
        }
        $timeout(function(){a[0].click();},100); // trigger download
        if(angular.element('body').hasClass('browser-firefox')){
          a.remove();
        }
      });
    };

    /**
     * Close arte message
     */
    vm.closeAlert = function() {
      if(angular.isDefined(vm.ctx.alert))
        delete vm.ctx.alert;
      vm.alert = {};
    };

    /**
     * Open popin to reaffect projet to dc
     */
    vm.reafffectProjet = function(){
      var alert = angular.element('#alert-message');
      if(vm.selectedProjet.length < 1){
        vm.alert = {
          type: 'danger',
          msg: 'Veuillez sélectionner au moins 1 projet à réaffecter !'
        };
        $document.scrollTo(alert, 30, 500);
      } else {
        var reaffectModal = $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title-bottom',
          ariaDescribedBy: 'modal-body-bottom',
          templateUrl: 'reaffectation.html',
          windowTopClass: 'reaffectation-modal',
          controller: ['$uibModalInstance', 'dcUsers', 'ChangeDCService', 'projets', reaffectModalInstance],
          controllerAs: 'vm',
          resolve: {
            dcUsers: function () {
              return vm.DCUsers;
            },
            projets: function(){
              return vm.selectedProjet;
            }
          }
        });

        // Refresh state à la fin du changment de DC
        reaffectModal.result.then(function(){
          $state.reload();
        });
      }
    };
  }

  /** @ngInject */
  function reaffectModalInstance($uibModalInstance, dcUsers, ChangeDCService, projets){
    var vm = this;

    // List Users DC
    vm.dcUsers = dcUsers;

    // Array selected Projects
    vm.projets = projets;

    // User DC Selected
    vm.dcSelected = null;

    /**
     * Close arte message
     */
    vm.closeAlert = function() {
      vm.alert = {};
    };

    /**
     * Confirmer changement de DC
     */
    vm.done = function (){
      if(vm.dcSelected == '' || vm.dcSelected == null){
        vm.alert = {
          type: 'danger',
          msg: 'Veuillez sélectionner 1 DC !'
        };
      } else {
        vm.loading = true;
        ChangeDCService.update(vm.projets, vm.dcSelected).then(function(result){
          vm.loading = false;
          $uibModalInstance.close(result);
        });
      }
    };
  }
})();
(function (){
  'use strict';

  angular
    .module('app')
    .controller('GestionProjetsController', GestionProjetsController);

  /** @ngInject */
  function GestionProjetsController($log, $state, $stateParams,
    $document, $uibModal, $timeout,
    ProjetService, CurrentUser, UserList,
    AllowedStatutService, ExportTableService,
    ProjetsConfig
    ){
    var vm = this;

    vm.loading = true;

    vm.user = CurrentUser;

    vm.hasRole = CurrentUser.hasRole;

    vm.ctx = ProjetService.getProjectContext();

    /**
     * Variables d'initialisation de tri
     * @type {boolean}
     */
    vm.reverse = true;
    vm.propertyName = 't_update';

    vm.searchStatutArray = AllowedStatutService.getUserStatuts();

    /**
     * Initialisation data filter
     */
    vm.searchFormat = null;
    vm.searchMedaille =  null;
    vm.searchStatut = $stateParams.q_statut;
    vm.searchFilter = '';
    vm.typeProjet = $stateParams.q_typeProjet;
    vm.projetConfig = ProjetsConfig[vm.typeProjet];
    vm.searchMedailleArray = vm.projetConfig.medailles;

    // Array project Selected
    vm.selectedProjet = [];
    vm.displayedProjects = [];

    /**
     * List of items to be displayed.
     */
    var query = {
      'q_typeProjet': vm.typeProjet,
      'q_statut': vm.searchStatut
    };
    ProjetService.get(query).$promise.then(function (result) {
      vm.projectLists = result;
      //vm.loadMoreProjects();

      // Get list of Users DC
      UserList.getUsersByRole('dc').then(function(data){
        vm.DCUsers = data;

        // Array with data DC (nom, prenom)
        vm.arrayDCData = {};
        angular.forEach(vm.DCUsers, function(user){
          vm.arrayDCData[user.username] = {
            data: user.prenom+' '+user.nom,
            smhf: user.smhf,
            mdv: user.mdv
          };
        });
      });

      // Get list of Users MDV
      UserList.getUsersByRole('mdv').then(function(data){
        vm.UsersMDV = data;

        vm.arrayMDVData = {};
        angular.forEach(vm.UsersMDV, function(user){
          vm.arrayMDVData[user.username] = user.prenom+' '+user.nom;
        });
      });

      // Get list of Users SMHF
      UserList.getUsersByRole('smhf').then(function(data){
        vm.UsersSMHF = data;

        vm.arraySMHFData = {};
        angular.forEach(vm.UsersSMHF, function(user){
          vm.arraySMHFData[user.username] = user.prenom+' '+user.nom;
        });
        vm.loading = false;
      });
    });

    vm.loadMoreProjects = function() {
      if(!vm.projectLists) {
        return;
      }
      var index = vm.displayedProjects.length;
      for(var i = 0; i <= 8; i++) {
        vm.displayedProjects.push(vm.projectLists[index + i]);
      }
    }

    /**
     * Statut filter change callback
     */
    vm.onStatutChanged = function() {
      $state.go('gestion-projets', {
        'q_typeProjet': vm.typeProjet,
        'q_statut': vm.searchStatut
      });
    };

    /**
     * Returns date of first transition to agence.
     * @param {type} projet
     * @returns {undefined}
     */
    vm.getDateAgence1 = function(projet) {
      var i = 0;
      if(!projet.historique) {
        return null;
      }
      for(i=0; i<projet.historique.length; ++i) {
        if(projet.historique[i].statut_dep === 'Brouillon' &&
          projet.historique[i].statut_arr === 'Agence') {
          return projet.historique[i].t_creation;
        }
      }
      return null;
    };

    /**
     * Multi Check Projet
     * @param project
     */
    vm.changeCheck = function(project){
      if (project.isSelected === true) {
        vm.selectedProjet.push(project._id.$oid);
      } else {
        var index = vm.selectedProjet.indexOf(project._id.$oid);
        vm.selectedProjet.splice(index, 1);
      }
      vm.selectedProjet.length > 1 ? vm.activeDownload = true : vm.activeDownload = false;
    };

    function sortFct(a, b) {
      var aV = getProperty(a, vm.propertyName.split('.'));
      var bV = getProperty(b, vm.propertyName.split('.'));

      var res = 0;
      if(aV && bV) {
        switch (vm.propertyName) {
          case 't_update':
          case 't_creation':
          case 'nb_ar_agence':
            res = aV - bV; break;
          default:
            res = aV.localeCompare(bV);
        }
      } else if(aV) {
        res = 1;
      } else if(bV) {
        res = -1;
      } else {
        res = 0;
      }
      return vm.reverse ? -res : res;
    }

    function getProperty(obj, propArray) {
      var i = 0;
      while (i < propArray.length) {
        if(!obj) {
          break;
        }
        obj = obj[propArray[i]];
        i++;
      }
      return obj;
    }

    /**
     * Fonction de tri des données
     * @param propertyName
     */
    vm.sortBy = function (propertyName) {
      vm.reverse = (vm.propertyName === propertyName) ? !vm.reverse : false;
      vm.propertyName = propertyName;

      vm.projectLists.sort(sortFct);
      vm.displayedProjects = [];
      //vm.loadMoreProjects();
    };

    /**
     * Close arte message
     */
    vm.closeAlert = function() {
      if(angular.isDefined(vm.ctx.alert))
        delete vm.ctx.alert;
      vm.alert = {};
    };

    /**
     * Open popin to reaffect projet to dc
     */
    vm.reafffectProjet = function(){
      var alert = angular.element('#alert-message');
      if(vm.selectedProjet.length < 1){
        vm.alert = {
          type: 'danger',
          msg: 'Veuillez sélectionner au moins 1 projet à réaffecter !'
        };
        $document.scrollTo(alert, 30, 500);
      } else {
        var reaffectModal = $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title-bottom',
          ariaDescribedBy: 'modal-body-bottom',
          templateUrl: 'reaffectation.html',
          windowTopClass: 'reaffectation-modal',
          controller: ['$uibModalInstance', 'dcUsers', 'ChangeDCService', 'projets', reaffectModalInstance],
          controllerAs: 'vm',
          resolve: {
            dcUsers: function () {
              return vm.DCUsers;
            },
            projets: function(){
              return vm.selectedProjet;
            }
          }
        });

        // Refresh state à la fin du changment de DC
        reaffectModal.result.then(function(){
          $state.reload();
        });
      }
    };
  }

  /** @ngInject */
  function reaffectModalInstance($uibModalInstance, dcUsers, ChangeDCService, projets){
    var vm = this;

    // List Users DC
    vm.dcUsers = dcUsers;

    // Array selected Projects
    vm.projets = projets;

    // User DC Selected
    vm.dcSelected = null;

    /**
     * Close arte message
     */
    vm.closeAlert = function() {
      vm.alert = {};
    };

    /**
     * Confirmer changement de DC
     */
    vm.done = function (){
      if(vm.dcSelected == '' || vm.dcSelected == null){
        vm.alert = {
          type: 'danger',
          msg: 'Veuillez sélectionner 1 DC !'
        };
      } else {
        vm.loading = true;
        ChangeDCService.update(vm.projets, vm.dcSelected).then(function(result){
          vm.loading = false;
          $uibModalInstance.close(result);
        });
      }
    };
  }
})();
(function () {
	'use strict';

	angular.module('app')
			.controller('DashboardImprimeurController', DashboardImprimeurController);

	/** @ngInject */
	function DashboardImprimeurController($log, $q, $timeout, $state, DlProjectImprimeurService, ProjetService, CurrentUser, FormatService, ExportTableService, ChangeStatutService) {
		var vm = this;
		vm.project = null;

    vm.user = CurrentUser;
    // User Rôle
    vm.userRole = vm.user.getRoles()[1];

    // List project Selected
    vm.selectedProjet = [];
    vm.activeDownload = vm.allCheckbox = false;

    vm.isCHR = ProjetService.isCHR;
    vm.isVAE = ProjetService.isVAE;
    vm.isAvecPose = ProjetService.isAvecPose;
    vm.nbBoards = ProjetService.nbBoards;

    /**
     * List des statuts popur le filtre
     */
    vm.searchStatutArray = ['Impression', 'Imprimé'];
    vm.searchFormatArray = FormatService.viewsLoad();

    vm.searchFormat = null;
    vm.searchStatut = 'Impression';

    vm.searchFilter = '';

    /**
     * List of items to be displayed.
     */
    vm.projectLists = ProjetService.get();

    /**
     * Variables d'initialisation de tri
     * @type {boolean}
     */
    vm.reverse = true;
    vm.propertyName = 't_update';

    /**
     * Multi Check Projet
     * @param project
     */
    vm.changeCheck = function(project){
      if (project.isSelected === true) {
        vm.selectedProjet.push(project);
      } else {
        var index = vm.selectedProjet.indexOf(project);
        vm.selectedProjet.splice(index, 1);
      }
      vm.selectedProjet.length > 1 ? vm.activeDownload = true : vm.activeDownload = false;

      // Uncheck Checkbox all
      if(vm.selectedProjet.length == 0){
        vm.allCheckbox = false;
      }
    };

    /**
     * Check/Uncheck All Project
     */
    vm.checkAllProject = function(){
      if(vm.allCheckbox == false)
        vm.selectedProjet = [];
      angular.forEach(vm.projectLists, function(key){
        if(key.statut == vm.searchStatut){
          key.isSelected = vm.allCheckbox;
          if(vm.allCheckbox == true)
            vm.selectedProjet.push(key);
        } else if(vm.searchStatut == '') {
          key.isSelected = vm.allCheckbox;
          if(vm.allCheckbox == true)
            vm.selectedProjet.push(key);
        }
      });
      vm.selectedProjet.length > 1 ? vm.activeDownload = true : vm.activeDownload = false;
    };

    /**
     * Multi Download Project
     */
    vm.allDownload = function(){
      angular.forEach(vm.selectedProjet, function(key){
        vm.downloadZipImprimeur(key);
      });
    };

    /**
     * Url Download Zip Project
     */
    vm.downloadZipImprimeur = function(project){
      DlProjectImprimeurService.get({id: project._id.$oid}).$promise.then(function(result){
        // Change de Statut si Staut dep = Impression
        if(project.statut == 'Impression' && project.statut ){
          ChangeStatutService.update(project, 'Imprimé', null).then(function(){
            project.statut = 'Imprimé';
          });
        }

        // On récupère le lien de téléchargement
        vm.downloadUrlProject = result[0];

        // Créer un lien avec l'url du zip
        // Et simule le click sur ce lien pour télécharger le zip
        var a = angular.element('<a>');
        a.attr('href', vm.downloadUrlProject);
        //a.attr('download', getNameDownload(project));
        a.attr('target', '_blank');
        if(angular.element('body').hasClass('browser-firefox')){
          angular.element('body').append(a);
        }
        a[0].click();
        if(angular.element('body').hasClass('browser-firefox')){
          a.remove();
        }
      });
    };

    /**
     * Statut Livré Change Projects
     */
    vm.statutProjectsLivre = function(){
      if(vm.selectedProjet.length == 0){
        vm.alert = {
          type: 'danger',
          msg: 'Aucun projets sélectionnés.'
        };
        return;
      }

      var promises = [];
      angular.forEach(vm.selectedProjet, function(key){
        var statut = 'Terminé';    // sans pose
        delete key.isSelected;
        if(vm.isAvecPose(key)) {
          statut = 'Livré';   // avec pose
        }
        var p = ChangeStatutService.update(key, statut, null).then(function(){
          vm.selectedProjet.splice(vm.selectedProjet.indexOf(key), 1);
        });
        promises.push(p);
      });
      $q.all(promises).then(function(){
        vm.alert = {
          type: 'success',
          msg: 'Les projets sont passés en statut "Livré" et "Terminé".'
        };
        vm.selectedProjet.length > 1 ? vm.activeDownload = true : vm.activeDownload = false;
        vm.projectLists = ProjetService.get(); // Refresh project list
      });
    };

    /**
     * Close arte message
     */
    vm.closeAlert = function() {
      vm.alert = {};
    };

		/**
		 * Fonction de tri des données
		 * @param propertyName
		 */
		vm.sortBy = function (propertyName) {
			vm.reverse = (vm.propertyName === propertyName) ? !vm.reverse : false;
			vm.propertyName = propertyName;
		};
	}
})();

(function () {
	'use strict';

	angular.module('app')
			.controller('DashboardClientController', DashboardClientController);

	/** @ngInject */
	function DashboardClientController($log, $q, $timeout, $state, DlProjectImprimeurService, ProjetService, CurrentUser, FormatService) {
		var vm = this;
		vm.project = null;

        vm.user = CurrentUser;
        // User Rôle
        vm.userRole = vm.user.getRoles()[1];

        // List project Selected
        vm.selectedProjet = [];
        vm.activeDownload = vm.allCheckbox = false;

        /**
         * List of items to be displayed.
         */
        vm.projectLists = ProjetService.get();
    }
})();
(function () {
  'use strict';

  angular.module('app')
    .controller('DashboardController', DashboardController);

  /** @ngInject */
  function DashboardController($log, $state, ProjetService, CurrentUser,
                               FormatService, AllowedStatutService, DCData, UserList) {

    var vm = this;
    vm.project = null;
    vm.loading = true;
    vm.displayedProjects = [];

    vm.user = CurrentUser;

    vm.hasRole = CurrentUser.hasRole;

    // If Imprimeur, redirect to dashboard imprimeur
    if (vm.user.getUsername() == 'imprimeurvae' || vm.user.getUsername() == 'imprimeur') {
      $state.go('dashboard-imprimeur');
    }

    if(vm.hasRole('agence') && $state.params.q_statut === null){
      $state.go('dashboard', {'q_statut': 'Agence'});
      vm.searchStatut = 'Agence';
    }

    if (vm.user.hasRole('client')) {
      $state.go('dashboard');
      vm.searchStatut = 'Client';
    }

    vm.nbBoards = ProjetService.nbBoards;

    /**
     * List des statuts popur le filtre
     */
    vm.searchStatutArray = AllowedStatutService.getUserStatuts();
    vm.searchFormatArray = FormatService.viewsLoad();
    vm.searchSupportArray = ['Carte Brasserie', 'Caissons Lumineux', 'Boards PVC', 'Sur Mesure', 'Digital', 'Direct Agence'];
    vm.searchTypeSupportArray = ['CHR', 'VAE', 'PSM', 'PDA'];

    /**
     * Initialisation data filter
     */
    vm.searchFormat = null;
    vm.searchSupport = vm.searchTypeSupport = '';
    vm.searchStatut = '';
    vm.searchFilter = '';

    /**
     * Variables d'initialisation de tri
     * @type {boolean}
     */
    vm.reverse = true;
    vm.propertyName = 't_update';

    var queryParams = null;

    if ($state.params.q_statut !== null) {
      queryParams = {'q_statut': $state.params.q_statut};
    }
    if($state.params.q_statut === '_none'){
      queryParams = null;
    }

    ProjetService.get(queryParams).$promise.then(function (result) {
      vm.projectLists = result;
      //vm.loadMoreProjects();
      if (vm.hasRole('agence')) {
        // Get list of Users DC
        UserList.getUsersByRole('dc').then(function (data) {
          vm.DCUsers = data;

          // Array with data DC (nom, prenom)
          vm.arrayDC = [];
          angular.forEach(vm.DCUsers, function (user) {
            vm.arrayDC[user.username] = user.prenom + ' ' + user.nom;
          });
        });
        // Get list of Users MDV
        UserList.getUsersByRole('mdv').then(function(data){
          vm.UsersMDV = data;

          vm.arrayMDVData = {};
          angular.forEach(vm.UsersMDV, function(user){
            vm.arrayMDVData[user.username] = user.prenom+' '+user.nom;
          });
        });
        // Get list of Users SMHF
        UserList.getUsersByRole('smhf').then(function(data){
          vm.UsersSMHF = data;

          vm.arraySMHFData = {};
          angular.forEach(vm.UsersSMHF, function(user){
            vm.arraySMHFData[user.username] = user.prenom+' '+user.nom;
          });
          vm.loading = false;
        });
      }
      vm.loading = false;

      vm.searchStatut = $state.params.q_statut;

    });

    vm.loadMoreProjects = function() {
      if(!vm.projectLists) {
        return;
      }
      var index = vm.displayedProjects.length;
      for(var i = 0; i <= 8; i++) {
        vm.displayedProjects.push(vm.projectLists[index + i]);
      }
    }

    function sortFct(a, b) {
      var aV = getProperty(a, vm.propertyName.split('.'));
      var bV = getProperty(b, vm.propertyName.split('.'));

      var res = 0;
      if(aV && bV) {
        switch (vm.propertyName) {
          case 't_update':
          case 't_creation':
          case 'nb_ar_agence':
            res = aV - bV; break;
          default:
            res = aV.localeCompare(bV);
        }
      } else if(aV) {
        res = 1;
      } else if(bV) {
        res = -1;
      } else {
        res = 0;
      }
      return vm.reverse ? -res : res;
    }

    function getProperty(obj, propArray) {
      var i = 0;
      while (i < propArray.length) {
        if(!obj) {
          break;
        }
        obj = obj[propArray[i]];
        i++;
      }
      return obj;
    }

    /**
     * Fonction de tri des données
     * @param propertyName
     */
    vm.sortBy = function (propertyName) {
      vm.reverse = (vm.propertyName === propertyName) ? !vm.reverse : false;
      vm.propertyName = propertyName;

      vm.projectLists.sort(sortFct);
      vm.displayedProjects = [];
      //vm.loadMoreProjects();
    };

    vm.getStatut = function () {
      $state.go('dashboard', {'q_statut': vm.searchStatut});
    };
    /**
     * retourne la date de la dernière mise à jour
     * @param projet
     * @returns {*}
     */
    vm.getNbrBoards = ProjetService.nbBoardsCreated;
  }
})();

(function () {
    'use strict';
  
    angular
      .module('app')
      .config(routerConfig);
    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider

        //
        // Root state.
        //
        .state('da', {
            url: '/da',
            //abstract: true,
            templateUrl: 'app/da/da-layout.html',
            controller: 'DirectAgenceController',
            controllerAs: 'da'
        })

        //
        // Step 0 : Delegue commercial
        //
        .state('da.dc', {
            url: '/dc',
            templateUrl: 'app/da/da-00-dc/da-00-dc-layout.html'
          })
        .state('da.dc.info_client', {
            url: '/info-client/:id',
            templateUrl: 'app/da/da-00-dc/da-01-dc-info-client/da-01-dc-info-client.html',
            controller: 'DaDcInfoClientController',
            controllerAs: 'main',
            params: {
                nextState: 'da.dc.info_projet'
            }
        })
        .state('da.dc.info_projet', {
            url: '/info-projet/:id',
            templateUrl: 'app/da/da-00-dc/da-02-dc-info-projet/da-02-dc-info-projet.html',
            controller: 'DaDcInfoProjetController',
            controllerAs: 'main',
            params: {
                previousState: 'da.dc.info_client',
                nextState: 'da.dc.gamme'
            }
        })
        .state('da.dc.gamme', {
            url: '/gamme/:id',
            templateUrl: 'app/da/da-00-dc/da-03-dc-gamme/da-03-dc-gamme.html',
            controller: 'DaDcGammeController',
            controllerAs: 'main',
            params: {
                previousState: 'da.dc.info_projet',
                nextState: 'da.support'
            }
        })
        .state('da.support', {
            url: '/support/:id',
            templateUrl: 'app/da/da-01-support/da-01-support.html',
            controller: 'DaSupportController',
            controllerAs: 'main',
            params: {
                previousState: 'da.dc.gamme',
                nextState: 'da.format'
            }
        })
        .state('da.format', {
            url: '/format/:id',
            templateUrl: 'app/da/da-02-format/da-02-format.html',
            controller: 'DaFormatController',
            controllerAs: 'main',
            params: {
                previousState: 'da.support',
                nextState: 'da.brief'
            }
        })
        .state('da.brief', {
            url: '/brief/:id',
            templateUrl: 'app/da/da-03-brief/da-03-brief.html',
            controller: 'DaBriefController',
            controllerAs: 'main',
            params: {
                previousState: 'da.format',
                nextState: 'da.contenu'
            }
        })
        .state('da.contenu', {
            url: '/contenu/:id',
            templateUrl: 'app/da/da-04-contenu/da-04-contenu.html',
            controller: 'DaContenuController',
            controllerAs: 'main',
            params: {
                previousState: 'da.brief',
                nextState: 'da.livraison'
            }
        })
        .state('da.livraison', {
            url: '/livraison/:id',
            templateUrl: 'app/da/da-05-livraison/da-05-livraison.html',
            controller: 'DaLivraisonController',
            controllerAs: 'main',
            params: {
                previousState: 'da.contenu'
            }
        })
        .state('da.recapitulatif', {
            url: '/recapitulatif/:id',
            //abstract: true,
            templateUrl: 'app/da/da-recapitulatif/da-recapitulatif.html',
            controller: 'DaRecapitulatifController',
            controllerAs: 'main'
        })
    }
})();

(function () {
    'use strict';
  
    angular
      .module('app')
      .controller('DirectAgenceController', DirectAgenceController);
  
    /** @ngInject */
    function DirectAgenceController($state, $log, $scope, $q, ProjetService, CurrentUser, EtatQuotasSmhfService) {
        var vm = this;
  
        /**
         * Controle accès user création chr
         */
        vm.user = CurrentUser;

        var itemOrder = ['da.dc'];

        // Titre principal
        vm.title = "Direct agence";

        vm.hideNavBar = false;

        // Expose $state dans les vues.
        vm.$state = $state;

        /**
        * Get EtatQuota for smhf DC
        */
        vm.etatQuota = {};
        if (vm.user.hasRole('dc') || vm.user.hasRole('administrator')) {
          vm.user.getSmhfDc(vm.user.getUserSmhf()).then(function (result) {
              vm.smhf = result;

              EtatQuotasSmhfService.getEtatQuotasSmhf(vm.smhf.username).then(function (data) {
                vm.etatQuota = data[0];
              });
          });
        }

        if (vm.user.hasRole('client') && vm.$state.current.name == 'da.dc.gamme') {
          var ctx = ProjetService.getProjectContext();
          if (ctx.project.statut == "Brouillon") {
            $state.go($state.params.nextState);
          }
        }

        /**
         * Si retour pas vide, il s'agit d'une mise à jour
         * Sinon, c'est un nouveau projet
         * @returns {*}
         */
        vm.isUpdate = function () {
          var ctx = ProjetService.getProjectContext();
          return ctx.project.signatureClient;
        };

        // Binde a ng-class du breadcrumb
        vm.classForItem = function (stateName) {
          var isAfter = itemOrder.indexOf(mainStateName(stateName))
            >= itemOrder.indexOf(mainStateName($state.current.name));
          return {
            active: $state.includes(stateName),
            disabled: isAfter
          };
        };

        vm.go = function (stateName) {
          var ctx = ProjetService.getProjectContext();
          var isBefore = itemOrder.indexOf(mainStateName(stateName))
            < itemOrder.indexOf(mainStateName($state.current.name));
          if (isBefore) {
            $state.go(stateName, {id: ctx.project._id.$oid} );
          }
        };
    
        // Navigue vers l'etat precedent
        vm.previousState = function () {
          if (vm.hasPreviousState()) {
            var extraParams = $state.params.id ? {id: $state.params.id} : undefined;
            $state.go($state.params.previousState, extraParams);
          } else {
            $log.warn("vm.hasPreviousState() : No previous step defined");
          }
        };
    
        // Navigue vers l'etat parent.
        vm.up = function () {
          $state.go('^');
        };
    
        /**
         * Permet au controller enfant et composant d'appeller
         * la fonction vm.previousState();
         */
        $scope.$on('CallpreviousSate', function(){
          vm.previousState();
        });
        
        /**
         * Permet au controller enfant d'appeler la fonction
         * vm.nextState();
         */
        $scope.$on('CallnextState', function () {
          vm.nextState();
        });
    
        /**
         * Update existing Project and redirect to dashboard
         */
        $scope.$on('UpdateProject', function () {
          var extraParams = $state.params.id ? {id: $state.params.id} : undefined;
          ProjetService.save().then(function () {
            $state.go('da.recapitulatif', extraParams, {reload: true});
          });
        });
    
        // Navigue vers l'état suivant
        vm.nextState = function () {
          if (vm.hasNextState()) {
            saveProject().then(function(){
              var extraParams = $state.params.id ? {id: $state.params.id} : undefined;
              $state.go($state.params.nextState, extraParams);
            });
          } else {
            $log.warn("vm.nextState() : No next step defined");
          }
        };
    
        // Retourne true si l'etat courant défini un etat suivant.
        vm.hasNextState = function () {
          return angular.isDefined($state.params) && angular.isDefined($state.params.nextState);
        };
    
        // Retourne true si l'etat courant défini un etat precedent.
        vm.hasPreviousState = function () {
          return angular.isDefined($state.params) && angular.isDefined($state.params.previousState);
        };
    
        // Return parent stateName or stateName if 2nd level.
        // toto.tata => toto.tata
        // toto.tata.tutu => toto.tata
        function mainStateName(stateName) {
          var mainStateName = stateName;
          var nbDot = (stateName.match(/\./g) || []).length;
          if (nbDot > 1) {
            // Cas stateName est un 3ieme niveau
            mainStateName = stateName.substring(0, stateName.lastIndexOf('.'));
          }
          return mainStateName;
        }
    
        /**
         * Sauvegarde etape par etape
         * @returns {undefined}
         */
        function saveProject() {
          var deferred = $q.defer();
          var ctx = ProjetService.getProjectContext();
          // Si le BDC n'a pas encore ete signe, alors on retient l'etape
          //$log.debug("saveProject()", $state.params.nextState, ctx.project);
          if (!vm.isUpdate()) {
            ctx.project.nextState = $state.params.nextState;
          }
          ProjetService.save().then(function(){
            deferred.resolve('Project save'); // Attente de la promesse en cas d'upload de doc
          });
          return deferred.promise;
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);
  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider

      //
      // Root state.
      //
      .state('chr', {
        url: '/chr',
        //abstract: true,
        templateUrl: 'app/chr/chr-layout.html',
        controller: 'ChrController',
        controllerAs: 'chr'
      })

      //
      // Step 01 : Information client
      //
      .state('chr.info-pdv', {
        url: '/info-pdv/:id',
        templateUrl: 'app/chr/chr-01-info-pdv/chr-01-info-pdv.html',
        controller: 'ChrInfoPdvController',
        controllerAs: 'main',
        params: {
          nextState: 'chr.creation.id_projet'
        }
      })

      //
      // Step 02 : Creation de la carte
      //  
      .state('chr.creation', {
        url: '/creation',
        templateUrl: 'app/chr/chr-02-creation/chr-02-creation-layout.html'
      })
      .state('chr.creation.id_projet', {
        url: '/id-projet/:id',
        templateUrl: 'app/chr/chr-02-creation/chr-21-id-projet/chr-21-id-projet.html',
        controller: 'ChrIdController',
        controllerAs: 'main',
        params: {
          previousState: 'chr.info-pdv',
          nextState: 'chr.creation.theme'
        }
      })
      .state('chr.creation.theme', {
        url: '/theme/:id',
        templateUrl: 'app/chr/chr-02-creation/chr-22-theme/chr-22-theme.html',
        controller: 'ChrThemeController',
        controllerAs: 'main',
        params: {
          previousState: 'chr.creation.id_projet',
          nextState: 'chr.creation.format'
        }
      })
      .state('chr.creation.format', {
        url: '/format/:id',
        templateUrl: 'app/chr/chr-02-creation/chr-23-format/chr-23-format.html',
        controller: 'ChrFormatController',
        controllerAs: 'main',
        params: {
          previousState: 'chr.creation.theme',
          nextState: 'chr.contenu.gamme'
        }
      })

      //
      // Step 03 : Contenu de la carte
      //
      .state('chr.contenu', {
        url: '/contenu',
        templateUrl: 'app/chr/chr-03-contenu/chr-03-contenu-layout.html'
      })
      .state('chr.contenu.gamme', {
        url: '/gamme/:id',
        templateUrl: 'app/chr/chr-03-contenu/chr-31-gamme/chr-31-gamme.html',
        controller: 'ChrGammeController',
        controllerAs: 'main',
        params: {
          previousState: 'chr.creation.format',
          nextState: 'chr.contenu.formules'
        }
      })
      .state('chr.contenu.formules', {
        url: '/formules/:id',
        templateUrl: 'app/chr/chr-03-contenu/chr-34-formules/chr-34-formules.html',
        controller: 'ChrFormulesController',
        controllerAs: 'main',
        params: {
          previousState: 'chr.contenu.gamme',
          nextState: 'chr.contenu.cocktails'
        }
      })
      .state('chr.contenu.cocktails', {
        url: '/cocktails/:id',
        templateUrl: 'app/chr/chr-03-contenu/chr-32-cocktails/chr-32-cocktails.html',
        controller: 'ChrCocktailsController',
        controllerAs: 'main',
        params: {
          previousState: 'chr.contenu.formules',
          nextState: 'chr.contenu.illustrations'
        }
      })
      .state('chr.contenu.illustrations', {
        url: '/illustrations/:id',
        templateUrl: 'app/chr/chr-03-contenu/chr-33-illustrations/chr-33-illustrations.html',
        controller: 'ChrIllustrationsController',
        controllerAs: 'main',
        params: {
          previousState: 'chr.contenu.cocktails',
          nextState: 'chr.photo'
        }
      })

      //
      // Step 04 : Photo de la carte
      //
      .state('chr.photo', {
        url: '/photo/:id',
        templateUrl: 'app/chr/chr-04-photo/chr-04-photo.html',
        controller: 'ChrPhotoController',
        controllerAs: 'main',
        params: {
          previousState: 'chr.contenu.formules',
          nextState: 'chr.autres-infos'
        }
      })

      //
      // Step 05: Photo de la carte
      //
      .state('chr.autres-infos', {
        url: '/autres-infos/:id',
        templateUrl: 'app/chr/chr-05-autres-infos/chr-05-autres-infos.html',
        controller: 'ChrAutresInfosController',
        controllerAs: 'main',
        params: {
          previousState: 'chr.photo',
          nextState: 'chr.livraison'
        }
      })

      //
      // Step 05: Validation
      //
      .state('chr.livraison', {
        url: '/livraison/:id',
        templateUrl: 'app/chr/chr-06-livraison/chr-06-livraison.html',
        controller: 'ChrLivraisonController',
        controllerAs: 'main',
        params: {
          previousState: 'chr.autres-infos',
          nextState: 'chr.recapitulatif'
        }
      })
      .state('chr.recapitulatif', {
        url: '/recapitulatif/:id',
        templateUrl: 'app/chr/chr-07-recapitulatif/chr-07-recapitulatif.html',
        controller: 'ChrRecapitulatifController',
        controllerAs: 'main',
        params: {
          previousState: 'chr.livraison',
          nextState: 'suivi-projet'
        }
      });

  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('ChrController', ChrController);

  /** @ngInject */
  function ChrController($state, $log, $scope, $q, ProjetService, CurrentUser, EtatQuotasSmhfService) {
    var vm = this;

    /**
     * Controle accès user création chr
     */
    vm.user = CurrentUser;
    if (vm.user.getUsername() == 'imprimeurvae' || vm.user.getUsername() == 'imprimeur') {
      $state.go('dashboard-imprimeur');
    }

    /** ********************************** **/

    var itemOrder = ['chr.info-pdv', 'chr.creation', 'chr.contenu', 'chr.photo',
      'chr.autres-infos', 'chr.livraison'];

    // Titre principal
    vm.title = "Carte Brasserie";

    vm.hideNavBar = false;

    // Expose $state dans les vues.
    vm.$state = $state;

    /**
      * Get EtatQuota for smhf DC
      */
    vm.etatQuota = {};
    if (vm.user.hasRole('dc') || vm.user.hasRole('administrator')) {
      vm.user.getSmhfDc(vm.user.getUserSmhf()).then(function (result) {
          vm.smhf = result;

          EtatQuotasSmhfService.getEtatQuotasSmhf(vm.smhf.username).then(function (data) {
              vm.etatQuota = data[0];
          });
      });
    }

    /**
     * Si retour pas vide, il s'agit d'une mise à jour
     * Sinon, c'est un nouveau projet
     * @returns {*}
     */
    vm.isUpdate = function () {
      var ctx = ProjetService.getProjectContext();
      return ctx.project.signatureClient && ctx.project.signatureDC;
    };

    // Binde a ng-class du breadcrumb
    vm.classForItem = function (stateName) {
      var isAfter = itemOrder.indexOf(stateName) >= itemOrder.indexOf($state.current.name);
      return {
        active: $state.includes(stateName),
        disabled: isAfter
      };
    };

    vm.go = function (stateName) {
      var isBefore = itemOrder.indexOf(mainStateName(stateName))
        < itemOrder.indexOf(mainStateName($state.current.name));
      if (isBefore) {
        $state.go(stateName);
      }
    };

    // Navigue vers l'etat precedent
    vm.previousState = function () {
      if (vm.hasPreviousState()) {
        var extraParams = $state.params.id ? {id: $state.params.id} : undefined;
        $state.go($state.params.previousState, extraParams);
      } else {
        $log.warn("vm.hasPreviousState() : No previous step defined");
      }
    };

    // Navigue vers l'etat parent.
    vm.up = function () {
      $state.go('^');
    };

    /**
     * Permet au controller enfant d'appeler la fonction
     * vm.nextState();
     */
    $scope.$on('CallnextState', function () {
      vm.nextState();
    });

    /**
     * Update existing Project and redirect to dashboard
     */
    $scope.$on('UpdateProject', function () {
      ProjetService.save().then(function () {
        $state.go('chr.recapitulatif', {}, {reload: true});
      });
    });

    // Navigue vers l'état suivant
    vm.nextState = function () {
      if (vm.hasNextState()) {
        saveProject().then(function(){
          var extraParams = $state.params.id ? {id: $state.params.id} : undefined;
          $state.go($state.params.nextState, extraParams);
        });
      } else {
        $log.warn("vm.nextState() : No next step defined");
      }
    };

    // Retourne true si l'etat courant défini un etat suivant.
    vm.hasNextState = function () {
      return angular.isDefined($state.params) && angular.isDefined($state.params.nextState);
    };

    // Retourne true si l'etat courant défini un etat precedent.
    vm.hasPreviousState = function () {
      return angular.isDefined($state.params) && angular.isDefined($state.params.previousState);
    };

    // Return parent stateName or stateName if 2nd level.
    // toto.tata => toto.tata
    // toto.tata.tutu => toto.tata
    function mainStateName(stateName) {
      var mainStateName = stateName;
      var nbDot = (stateName.match(/\./g) || []).length;
      if (nbDot > 1) {
        // Cas stateName est un 3ieme niveau
        mainStateName = stateName.substring(0, stateName.lastIndexOf('.'));
      }
      return mainStateName;
    }

    /**
     * Sauvegarde etape par etape
     * @returns {undefined}
     */
    function saveProject() {
      var deferred = $q.defer();
      var ctx = ProjetService.getProjectContext();
      // Si le BDC n'a pas encore ete signe, alors on retient l'etape
      //$log.debug("saveProject()", $state.params.nextState, ctx.project);
      if (!vm.isUpdate()) {
        ctx.project.nextState = $state.params.nextState;
      }
      ProjetService.save().then(function(){
        deferred.resolve('Project save'); // Attente de la promesse en cas d'upload de doc
      });
      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';
  /* globals anno */

  angular.module('app')
    .factory('AnnotationPopin', AnnotationPopinService)
    .directive('annotoriousInit', AnnotoriousInitDirective);

  /** @ngInject */
  function AnnotationPopinService($uibModal) {

    var open = function (imgSrc, onClosedCallback, listannotations, canUpdateProjet) {

      var popin = $uibModal.open({
        animation: true,
        backdrop: 'static',
        backdropClass: 'annotation-modal-backdrop',
        windowTopClass: 'modal-annotation-popin',
        ariaLabelledBy: 'modal-title-bottom',
        ariaDescribedBy: 'modal-body-bottom',
        templateUrl: 'app/annotation-popin/annotation-popin.html',
        controller: AnnotationPopinController,
        controllerAs: 'vm',
        resolve: {
          imgSrc: function () {
            return imgSrc;
          },
          listannotations: function () {
            return listannotations;
          },
          canUpdateProjet: function(){
            return canUpdateProjet
          }
        }
      });

      popin.result.then(function (updatedAnnotations) {
        onClosedCallback(updatedAnnotations);
      });

    };

    // Return Public API
    return {
      open: open
    };
  }

  /** @ngInject */
  function AnnotationPopinController($uibModalInstance,
    imgSrc, listannotations, canUpdateProjet, $document, $timeout) {
    var vm = this;
    vm.imgSrc = imgSrc;

    // Change text Anno BTN to French
    $timeout(function(){
      var textCancel = angular.element($document[0].querySelector('.annotorious-editor-button-cancel'));
      var textSave = angular.element($document[0].querySelector('.annotorious-editor-button-save'));
      textCancel.text('Annuler');
      textSave.text('Enregistrer');
    }, 1500);

    // If User can't Update Project, Make Annotarius Img Read Only
    if(angular.isDefined(canUpdateProjet) && !canUpdateProjet){
      $timeout(function(){
        anno.hideSelectionWidget(vm.imgSrc);
      }, 500);
    }

    // Close AnnotationPopin and invoke caller's callback with updated annotations
    vm.close = function () {
      var updatedAnnotations = anno.getAnnotations(vm.imgSrc);
      $uibModalInstance.close(updatedAnnotations);
    };

    // Callback when image is loaded to add pre-existing annotations
    vm.onImgLoaded = function () {
      angular.forEach(listannotations, function (annotation) {
        annotation.src = vm.imgSrc;
        // If User can't Update Project, Make Annotation Read Only
        if(angular.isDefined(canUpdateProjet) && !canUpdateProjet){
          annotation.editable = false;
        }
        anno.addAnnotation(annotation);
      });
    };
  }

  /** @ngInject */
  function AnnotoriousInitDirective() {
    return {
      link: function (scope, element) {

        var img = element.context;
        // Makes sure img is loaded before initialize annotorious
        img.onload = function () {
          anno.reset();
          anno.makeAnnotatable(img);
          scope.vm.onImgLoaded();
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .run(runBlock)
    .run(preload);

  /** @ngInject */
  function runBlock($log) {
    $log.debug('runBlock end');
  }

  /**
   * Handle application initialisation : preloading critical resources and
   * get Drupal connected user.
   * 
   * @returns {undefined}
   */
  /** @ngInject */
  function preload($q, $location, $state,
    CurrentUser) {

    var promises = [],
      location = $location.url();
    
    location = location !== null && location !== "" ? location : '/';
    $location.url('/init');
    promises.push(CurrentUser.connect());
    // Add all the promises to be loaded before app starts.
    // promises.push( ... );

    $q.all(promises).then(function () {
      if (CurrentUser.getCurrentUser() === null) {
        // user not loggued
        $state.go('login', { targetUrl: location });
        return;
      }
      // Go to original page.
      $location.url(location);
      
    });
  }

})();

(function () {
	'use strict';

	angular
			.module('app')
			.config(routerConfig);
	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('login', {
        url: '/login',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'main',
        params: {
          targetUrl: '/'
        }
      })
      .state('dashboard', {
        url: '/dashboard?:q_statut',
        templateUrl: 'app/dashboard/dashboard.html',
        controller: 'DashboardController',
        controllerAs: 'main',
        params:{
          q_statut:null
        }
      })
      .state('gestion-projets', {
        url: '/gestion-projets/:q_typeProjet?:q_statut',
        templateUrl: 'app/gestion-projets/gestion-projets.html',
        controller: 'GestionProjetsController',
        controllerAs: 'main'
      })
      .state('gestion-projets-smhf', {
        url: '/gestion-projets-smhf',
        templateUrl: 'app/gestion-projets-smhfmdv/gestion-projets.html',
        controller: 'GestionProjetsSmhfMdvController',
        controllerAs: 'main'
      })
      .state('gestion-projets-mdv', {
        url: '/gestion-projets-mdv',
        templateUrl: 'app/gestion-projets-smhfmdv/gestion-projets.html',
        controller: 'GestionProjetsSmhfMdvController',
        controllerAs: 'main'
      })
      .state('suivi-quotas', {
        url: '/suivi-quotas',
        templateUrl: 'app/suivi-quotas/suivi-quotas.html',
        controller: 'SuiviQuotasController',
        controllerAs: 'main'
      })
      .state('dashboard-imprimeur', {
        url: '/dashboard-imprimeur',
        templateUrl: 'app/dashboard-imprimeur/dashboard.html',
        controller: 'DashboardImprimeurController',
        controllerAs: 'main'
      })
      .state('dashboard-client', {
        url: '/dashboard-client',
        templateUrl: 'app/dashboard-client/dashboard.html',
        controller: 'DashboardClientController',
        controllerAs: 'main'
      })
      .state('suivi-projet', {
        url: '/suivi-projet/:id',
        templateUrl: 'app/suivi_projet/suivi_projet.html',
        controller: 'SuiviProjetController',
        controllerAs: 'main'
      })
      .state('help', {
        url: '/help',
        templateUrl: 'app/help/help.html',
        controller: 'HelpController',
        controllerAs: 'main'
      })
      .state('open-projet', {
        url: '/open-projet/:id',
        controller: 'OpenProjetController',
        controllerAs: 'main',
        params: {
          id: id
        }
      })
      .state('init', {
        url: '/init',
        templateUrl: 'app/init/init.html'
      })
      .state('qrcodes', {
        url: '/qrcodes/:id',
        templateUrl: 'app/qrcodes/qrcodes.html',
        controller: 'QrCodesController',
        controllerAs: 'main',
        params: {
          backId: ''
        }
      });

		$urlRouterProvider.otherwise('/');
	}

})();

(function() {
  'use strict';

  angular
    .module('app')
    .constant('ProjetsConfig', {
      'CHR': {
        label: "CHR",
        supports: ['Carte Brasserie'],
        medailles: ['Platinum', 'Gold', 'Silver']
      },
      'VAE': {
        label: "VAE",
        supports: ['Caissons Lumineux', 'Boards PVC', 'Digital']
      },
      'PSM': {
        label: "SUR-MESURE",
        supports: ['Sur Mesure'],
        medailles: ['Platinum', 'Gold']
      },
      'PDA': {
        label: 'DIRECT-AGENCE',
        support: ['Direct Agence'],
        medailles: ['Platinum', 'Gold', 'Silver']
      }
    });

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config);

  /** @ngInject */
  function config($logProvider, ActionServiceProvider) {
    ActionServiceProvider
        .addActions([{
          'name': 'HOME',
          'category': 'MAIN_MENU',
          'label': 'Home',
          'priority': 10,
          'url':'/'
        }]);
  }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/annotation-popin/annotation-popin.html","<div class=\"modal-body annotation-popin\" id=\"modal-body-annotation-popin\"><div class=\"help-anno\">Annotez la photo si besoin en glissant votre doigt sur la zone que vous souhaitez commenter</div><span class=\"glyphicon glyphicon-remove\" ng-click=\"vm.close()\" aria-hidden=\"true\"></span> <img id=\"annotorious_popin_img\" ng-src=\"{{vm.imgSrc}}\" class=\"annotatable annotations\" annotorious-init=\"\"> <button class=\"btn btn-default btn-anno\" ng-click=\"vm.close()\">Valider</button></div>");
$templateCache.put("app/chr/chr-layout.html","<header-nav></header-nav><div class=\"container-fluid id-projet\"><div class=\"msg-to-dc container h3\" ng-if=\"chr.etatQuota && chr.etatQuota.statutQuotaCHR == \'ALERTE\'\"><p><strong>ALERTE QUOTA</strong></p><p>Il y a plus de projets en brouillon ({{chr.etatQuota.quotasAVenirCHR}}) que de quota restant disponible ({{chr.etatQuota.quotasAnnuelCHR - chr.etatQuota.quotasConsoCHR}}). Certains de ces projets pourraient ne pas être pris en charge.</p></div><div class=\"text-uppercase title-picto\" ng-if=\"!chr.$state.includes(\'chr.recapitulatif\')\"><div class=\"container\"><h1><span class=\"picto-carte\"></span><span class=\"denom\">{{chr.title}}</span></h1></div></div><div class=\"nav-bar-icon\" ng-if=\"!chr.$state.includes(\'chr.recapitulatif\')\"><div class=\"container\"><ul class=\"nav nav-tabs nav-bar-icon text-center\"><li ng-class=\"chr.classForItem(\'chr.info-pdv\')\"><a href=\"\" ng-click=\"chr.go(\'chr.info-pdv\')\"><span class=\"number\">1.</span><span>INFORMATION CLIENT</span></a></li><li ng-class=\"chr.classForItem(\'chr.creation\')\"><a href=\"\" ng-click=\"chr.go(\'chr.creation.id_projet\')\"><span class=\"number\">2.</span><span>CREATION DE LA CARTE</span></a></li><li ng-class=\"chr.classForItem(\'chr.contenu\')\"><a href=\"\" ng-click=\"chr.go(\'chr.contenu\')\"><span class=\"number\">3.</span><span>CONTENU DE LA CARTE</span></a></li><li ng-class=\"chr.classForItem(\'chr.photo\')\"><a href=\"\" ng-click=\"chr.go(\'chr.photo\')\"><span class=\"number\">4.</span><span>PHOTO DE LA CARTE</span></a></li><li ng-class=\"chr.classForItem(\'chr.autres-infos\')\"><a href=\"\" ng-click=\"chr.go(\'chr.autres-infos\')\"><span class=\"number\">5.</span><span>AUTRES INFORMATIONS</span></a></li><li ng-class=\"chr.classForItem(\'chr.livraison\')\"><a href=\"\" ng-click=\"chr.go(\'chr.livraison\')\"><span class=\"number\">6.</span><span>LIVRAISON</span></a></li></ul></div></div><div ui-view=\"\" autoscroll=\"false\"></div></div>");
$templateCache.put("app/da/da-layout.html","<header-nav></header-nav><div class=\"container-fluid id-projet\"><div class=\"msg-to-dc container h3\" ng-if=\"pda.etatQuota && pda.etatQuota.statutQuotaPDA == \'ALERTE\'\"><p><strong>ALERTE QUOTA</strong></p><p>Il y a plus de projets en brouillon ({{chr.etatQuota.quotasAVenirPDA}}) que de quota restant disponible ({{pda.etatQuota.quotasAnnuelPDA - pda.etatQuota.quotasConsoPDA}}). Certains de ces projets pourraient ne pas être pris en charge.</p></div><div class=\"text-uppercase title-picto\" ng-if=\"!da.$state.includes(\'da.recapitulatif\')\"><div class=\"container\"><h1><span class=\"picto-carte sm-picto\"></span><span class=\"denom\">{{da.title}}</span></h1></div></div><div class=\"nav-bar-icon\" ng-if=\"!da.$state.includes(\'da.recapitulatif\')\"><div class=\"container\"><ul class=\"nav nav-tabs nav-bar-icon text-center\"><li ng-class=\"da.classForItem(\'da.dc\')\"><a href=\"\" ng-click=\"da.go(\'da.dc\')\"><span class=\"number\">0.</span><span>Delegue Commercial</span></a></li><li ng-class=\"da.classForItem(\'da.support\')\"><a href=\"\" ng-click=\"da.go(\'da.support\')\"><span class=\"number\">1.</span><span>Support</span></a></li><li ng-class=\"da.classForItem(\'da.format\')\"><a href=\"\" ng-click=\"da.go(\'da.format\')\"><span class=\"number\">2.</span><span>Format</span></a></li><li ng-class=\"da.classForItem(\'da.brief\')\"><a href=\"\" ng-click=\"da.go(\'da.brief\')\"><span class=\"number\">3.</span><span>Brief</span></a></li><li ng-class=\"da.classForItem(\'da.contenu\')\"><a href=\"\" ng-click=\"da.go(\'da.contenu\')\"><span class=\"number\">4.</span><span>Contenu</span></a></li><li ng-class=\"da.classForItem(\'da.livraison\')\"><a href=\"\" ng-click=\"da.go(\'da.livraison\')\"><span class=\"number\">5.</span><span>Livraison</span></a></li></ul></div></div><div ui-view=\"\" autoscroll=\"false\"></div></div>");
$templateCache.put("app/dashboard/dashboard.html","<loading-screen loading=\"main.loading\"></loading-screen><header-nav></header-nav><div class=\"container-fluid dashboard\"><div class=\"page-header\"><div class=\"container\"><h1><span>Tableau de bord</span></h1></div></div><div class=\"container data-dashboard data-project\"><div class=\"\"><table class=\"table table-bordered table-hover table-striped\" infinite-scroll=\"main.loadMoreProjects()\" infinite-scroll-disabled=\"true\" infinite-scroll-distance=\"3\"><caption class=\"text-uppercase\">Suivi de mes projets</caption><caption class=\"search-filter text-center\"><label>Filtres:</label><select name=\"searchFilter\" ng-model=\"main.searchStatut\" ng-change=\"main.getStatut()\"><option value=\"_none\">Tous les statuts</option><option ng-repeat=\"option in main.searchStatutArray\" value=\"{{option}}\">{{option}}</option></select><span class=\"glyphicon glyphicon-triangle-bottom\"></span><select ng-if=\"!main.hasRole(\'agence\') && !main.hasRole(\'siege\') && !main.hasRole(\'client\')\" name=\"searchFilter\" ng-options=\"option for option in main.searchSupportArray\" ng-model=\"main.searchSupport\"><option value=\"\">Tous les supports</option></select><select ng-if=\"main.hasRole(\'siege\') && !main.hasRole(\'client\')\" name=\"searchFilter\" ng-options=\"option for option in main.searchTypeSupportArray\" ng-model=\"main.searchTypeSupport\"><option value=\"\">Tous les supports</option></select><span ng-if=\"!main.hasRole(\'agence\') && !main.hasRole(\'client\')\" class=\"glyphicon glyphicon-triangle-bottom\"></span></caption><tr class=\"text-center legend-dash text-uppercase\"><th ng-if=\"!main.hasRole(\'agence\')\" ng-click=\"main.sortBy(\'pdv.nomClient\')\">Nom du Client <span ng-if=\"!main.reverse && main.propertyName == \'pdv.nomClient\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'pdv.nomClient\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'pdv.nomClient\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'pdv.nomClient\'}\"></span></th><th ng-if=\"main.hasRole(\'agence\')\">SMHF</th><th ng-if=\"main.hasRole(\'agence\')\">MDV</th><th ng-if=\"main.hasRole(\'agence\')\">Nom du DC</th><th ng-click=\"main.sortBy(\'idprojet.nameProjet\')\">Nom du Projet <span ng-if=\"!main.reverse && main.propertyName == \'idprojet.nameProjet\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'idprojet.nameProjet\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'idprojet.nameProjet\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'idprojet.nameProjet\'}\"></span></th><th ng-click=\"main.sortBy(\'idprojet.numProjet\')\">Numéro Projet <span ng-if=\"!main.reverse && main.propertyName == \'idprojet.numProjet\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'idprojet.numProjet\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'idprojet.codeProjet\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'idprojet.numProjet\'}\"></span></th><th ng-click=\"main.sortBy(\'pdv.medaillePDV\')\">Médaille <span ng-if=\"!main.reverse && main.propertyName == \'pdv.medaillePDV\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'pdv.medaillePDV\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'pdv.medaillePDV\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'pdv.medaillePDV\'}\"></span></th><th ng-click=\"\" ng-if=\"main.hasRole(\'agence\')\">Nombre de boards à créer</th><th ng-click=\"\" ng-if=\"main.hasRole(\'installateur\')\">Nombre de boards à créer</th><th ng-click=\"\" ng-if=\"main.hasRole(\'installateur\')\">Date de pré-visite</th><th ng-click=\"\" ng-if=\"main.hasRole(\'installateur\')\">Date de pose</th><th ng-click=\"main.sortBy(\'t_creation\')\">Date Création <span ng-if=\"!main.reverse && main.propertyName == \'t_creation\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'t_creation\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'t_creation\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'t_creation\'}\"></span></th><th ng-click=\"main.sortBy(\'t_update\')\">Date Modification <span ng-if=\"!main.reverse && main.propertyName == \'t_update\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'t_update\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'t_update\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'t_update\'}\"></span></th><th ng-click=\"main.sortBy(\'statut\')\">Statut <span ng-if=\"!main.reverse && main.propertyName == \'statut\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'statut\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'statut\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'statut\'}\"></span></th><th ng-click=\"main.sortBy(\'nb_ar_agence\')\">Nombre AR Agence <span ng-if=\"!main.reverse && main.propertyName == \'nb_ar_agence\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'nb_ar_agence\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'nb_ar_agence\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'nb_ar_agence\'}\"></span></th><th><span class=\"glyphicon glyphicon-cog\" aria-hidden=\"true\"></span></th></tr><tr ng-repeat=\"project in main.projectLists | filterBy:[\'type\']: main.searchSupport\" class=\"text-center\"><td ng-if=\"main.hasRole(\'agence\')\">{{ main.arraySMHFData[project.smhf] }}</td><td ng-if=\"main.hasRole(\'agence\')\">{{ main.arrayMDVData[project.mdv] }}</td><td ng-if=\"main.hasRole(\'agence\')\">{{ main.arrayDC[project.dc] }}</td><td ng-if=\"!main.hasRole(\'agence\')\">{{ project.pdv.nomClient }}</td><td>{{project.idprojet.nameProjet}}</td><td>{{project.idprojet.numProjet}}</td><td>{{project.pdv.medaillePDV}}</td><td ng-if=\"main.hasRole(\'agence\')\">{{ main.getNbrBoards(project) }}</td><td ng-if=\"main.hasRole(\'installateur\')\">{{ main.nbBoards(project) }}</td><td ng-if=\"main.hasRole(\'installateur\')\">{{ project.pose.t_previsite | date:\'yyyy-MM-dd HH:mm\' }}</td><td ng-if=\"main.hasRole(\'installateur\')\">{{ project.pose.t_pose | date:\'yyyy-MM-dd HH:mm\' }}</td><td>{{project.t_creation | date:\'yyyy-MM-dd\'}}</td><td>{{project.t_update | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{project.statut}}</td><td>{{project.nb_ar_agence}}</td><td><div class=\"btn-group-vertical col-sm-12\"><suivi-projet-action projet=\"project\"></suivi-projet-action><edit-projet-action projet=\"project\"></edit-projet-action><delete-projet-action projet=\"project\"></delete-projet-action><cancel-projet-action projet=\"project\"></cancel-projet-action></div></td></tr></table></div></div></div>");
$templateCache.put("app/dashboard-client/dashboard.html","<h1>DASHBOARD CLIENT</h1>");
$templateCache.put("app/dashboard-imprimeur/dashboard.html","<header-nav></header-nav><div class=\"container-fluid dashboard dashboard-imprimeur\"><div class=\"page-header\"><div class=\"container\"><h1><span>Tableau de bord</span></h1></div></div><div class=\"container data-dashboard data-project data-imprimeur\"><div id=\"alert-message\"><div uib-alert=\"\" class=\"alert alert-fade\" type=\"{{main.alert.type}}\" close=\"main.closeAlert()\" ng-if=\"main.alert.msg != undefined\">{{main.alert.msg}}</div></div><div class=\"table-responsive\"><table class=\"table table-bordered table-hover table-striped\"><caption class=\"text-uppercase\">Suivi de mes projets <a class=\"btn btn-load btn-export\" href=\"/rest/myplv/projets?excelType=excel_imprimeur&q_statut={{main.searchStatut}}&q_infocarteDOTformatDOTname={{main.searchFormat.name}}\" target=\"_blank\"><span class=\"glyphicon glyphicon-export\"></span> Exporter les données</a></caption><caption class=\"search-filter\"><label>Filtres:</label><select name=\"searchFilter\" ng-model=\"main.searchStatut\"><option value=\"\">Tous les statuts</option><option ng-repeat=\"option in main.searchStatutArray\" value=\"{{option}}\">{{option}}</option></select><span class=\"glyphicon glyphicon-triangle-bottom\"></span><select ng-if=\"main.userRole != \'dc\'\" name=\"searchFilter\" ng-options=\"option.name for option in main.searchFormatArray\" ng-model=\"main.searchFormat\"><option value=\"\">Tous les formats</option></select><select ng-if=\"main.userRole == \'dc\'\" name=\"searchFilter\" ng-options=\"option for option in main.searchSupportArray\" ng-model=\"main.searchSupport\"><option value=\"\">Tous les supports</option></select><span class=\"glyphicon glyphicon-triangle-bottom\"></span></caption><caption class=\"action-projets\"><button class=\"btn btn-load btn-all-download\" ng-click=\"main.allDownload()\" ng-class=\"{disabled: !main.activeDownload}\"><span class=\"glyphicon glyphicon-download-alt\"></span> Télécharger Projets</button> <button ng-click=\"main.statutProjectsLivre()\" ng-if=\"main.searchStatut == \'Imprimé\'\" class=\"btn btn-change-state\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Passer en livré</button></caption><tbody id=\"tableToExport\"><tr class=\"text-center legend-dash text-uppercase\"><th class=\"th-checkbox\"><input id=\"imprimeur\" type=\"checkbox\" class=\"all-checkbox\" ng-model=\"main.allCheckbox\" ng-change=\"main.checkAllProject()\"><label for=\"imprimeur\"></label></th><th ng-click=\"main.sortBy(\'idprojet.nameProjet\')\">Nom du Projet <span ng-if=\"!main.reverse && main.propertyName == \'idprojet.nameProjet\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'idprojet.nameProjet\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'idprojet.nameProjet\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'idprojet.nameProjet\'}\"></span></th><th ng-click=\"main.sortBy(\'infocarte.format.name\')\">Format <span ng-if=\"!main.reverse && main.propertyName == \'infocarte.format.name\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'infocarte.format.name\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'infocarte.format.name\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'infocarte.format.name\'}\"></span></th><th ng-click=\"main.sortBy(\'infocarte.nombreExemplaire\')\">Qté carte <span ng-if=\"!main.reverse && main.propertyName == \'infocarte.nombreExemplaire\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'infocarte.nombreExemplaire\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'infocarte.nombreExemplaire\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'infocarte.nombreExemplaire\'}\"></span></th><th>Qté QrCode</th><th ng-click=\"main.sortBy(\'statut\')\">Statut <span ng-if=\"!main.reverse && main.propertyName == \'statut\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'statut\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'statut\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'statut\'}\"></span></th><th><span class=\"glyphicon glyphicon-cog\" aria-hidden=\"true\"></span></th></tr><tr ng-repeat=\"project in main.projectLists | filterBy: [\'infocarte.format.name\']: main.searchFormat.name | filterBy:[\'type\']: main.searchSupport | filter:{statut: main.searchStatut} | orderBy:main.propertyName:main.reverse\" class=\"text-center\" ng-class=\"{selected: project.isSelected}\"><td class=\"cs-select\"><input id=\"imprimeur{{$index}}\" type=\"checkbox\" class=\"checkbox-select\" ng-model=\"project.isSelected\" ng-value=\"true\" ng-change=\"main.changeCheck(project)\"><label for=\"imprimeur{{$index}}\"></label></td><td>{{project.idprojet.nameProjet}}</td><td>{{project.infocarte.format.name}}</td><td>{{project.infocarte.nombreExemplaire}}</td><td>{{project.infocarte.nombreExemplaireQrCode}}</td><td>{{project.statut}}</td><td><div class=\"btn-group-vertical col-sm-12\"><a href=\"\" ng-click=\"main.downloadZipImprimeur(project)\" class=\"ng-scope btn btn-load\"><span aria-hidden=\"true\" class=\"glyphicon glyphicon-download-alt\"></span></a></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/gestion-projets/gestion-projets.html","<loading-screen loading=\"main.loading\"></loading-screen><header-nav></header-nav><div class=\"container-fluid dashboard gestion-projets dashboard-imprimeur\"><div class=\"page-header\"><div class=\"container\"><div id=\"alert-message\"><div uib-alert=\"\" class=\"alert alert-fade\" type=\"{{main.alert.type}}\" close=\"main.closeAlert()\" ng-if=\"main.alert.msg != undefined\">{{main.alert.msg}}</div><div uib-alert=\"\" class=\"alert alert-fade alert-cancel\" type=\"{{main.ctx.alert.type}}\" close=\"main.closeAlert()\" ng-if=\"main.ctx.alert.msg != undefined\">{{main.ctx.alert.msg}}</div></div><h1><span>Gestion des projets&nbsp;&nbsp;<br>{{main.projetConfig.label}}</span></h1></div></div><div class=\"container data-dashboard data-project data-imprimeur data-siege\"><div class=\"table-responsive\"><table class=\"table table-bordered table-hover table-striped\"><caption class=\"text-uppercase\">Tous les projets</caption><caption class=\"search-filter row\"><div class=\"reaffect col-sm-3\"><button class=\"btn btn-default col-sm-12 btn-reaffect\" ng-click=\"main.reafffectProjet()\">Réaffecter le projet</button></div><div class=\"filtres col-sm-9\"><label>Filtres:</label><select name=\"searchFilter\" ng-model=\"main.searchStatut\" ng-change=\"main.onStatutChanged()\"><option value=\"\">Tous les statuts</option><option ng-repeat=\"option in main.searchStatutArray\" value=\"{{option}}\">{{option}}</option></select><span class=\"glyphicon glyphicon-triangle-bottom\"></span><select name=\"searchFilter\" ng-options=\"option for option in main.searchMedailleArray\" ng-model=\"main.searchMedaille\"><option value=\"\">Toutes les médailles</option></select><span class=\"glyphicon glyphicon-triangle-bottom\"></span> <a class=\"btn btn-load btn-export\" href=\"/rest/myplv/projets?excelType=excel_boissons&q_typeProjet={{main.typeProjet}}&q_statut={{main.searchStatut}}\" target=\"_blank\">Export boissons</a> <a class=\"btn btn-load btn-export\" href=\"/rest/myplv/projets?excelType=excel_siege&q_typeProjet={{main.typeProjet}}&q_statut={{main.searchStatut}}\" target=\"_blank\">Export projets</a></div></caption><tbody ng-repeat=\"isExport in [false]\" ng-include=\"\'table.html\'\" infinite-scroll=\"main.loadMoreProjects()\" infinite-scroll-disabled=\"true\" infinite-scroll-distance=\"3\"></tbody><tbody ng-repeat=\"isExport in [true]\" ng-include=\"\'table.html\'\" id=\"tableToExport\" style=\"display:none\"></tbody></table></div></div></div><script type=\"text/ng-template\" id=\"table.html\"><tr class=\"text-center legend-dash text-uppercase\"> <th class=\"th-checkbox\" ng-if=\"!isExport\"></th> <th>SMHF</th> <th>MDV</th> <th>DC</th> <th ng-click=\"main.sortBy(\'idprojet.nameProjet\')\">Nom du Projet <span ng-if=\"!main.reverse && main.propertyName == \'idprojet.nameProjet\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'idprojet.nameProjet\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'idprojet.nameProjet\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'idprojet.nameProjet\'}\"></span> </th> <th ng-click=\"main.sortBy(\'idprojet.numProjet\')\">Numéro Projet <span ng-if=\"!main.reverse && main.propertyName == \'idprojet.numProjet\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'idprojet.numProjet\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'idprojet.numProjet\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'idprojet.numProjet\'}\"></span> </th> <th ng-click=\"main.sortBy(\'pdv.medaillePDV\')\">Médaille <span ng-if=\"!main.reverse && main.propertyName == \'pdv.medaillePDV\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'pdv.medaillePDV\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'pdv.medaillePDV\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'pdv.medaillePDV\'}\"></span> </th> <th ng-click=\"main.sortBy(\'nb_ar_agence\')\">AR Créa <span ng-if=\"!main.reverse && main.propertyName == \'nb_ar_agence\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'nb_ar_agence\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'nb_ar_agence\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'nb_ar_agence\'}\"></span> </th> <th ng-click=\"main.sortBy(\'statut\')\">Statut <span ng-if=\"!main.reverse && main.propertyName == \'statut\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'statut\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'statut\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'statut\'}\"></span> </th> <th ng-click=\"main.sortBy(\'t_creation\')\">Date Création <span ng-if=\"!main.reverse && main.propertyName == \'t_creation\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'t_creation\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'t_creation\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'t_creation\'}\"></span> </th> <th>Date agence 1</th> <th ng-click=\"main.sortBy(\'t_update\')\">Date Modification <span ng-if=\"!main.reverse && main.propertyName == \'t_update\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'t_update\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'t_update\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'t_update\'}\"></span> </th> <th>Agence</th> <th ng-if=\"!isExport\"><span class=\"glyphicon glyphicon-cog\" aria-hidden=\"true\"></span></th> </tr> <tr ng-repeat=\"project in main.projectLists | filterBy:[\'pdv.medaillePDV\']: main.searchMedaille\" class=\"text-center project-{{$index}} {{main.ctx.class[project.idprojet.nameProjet]}}\" ng-class=\"{selected: project.isSelected}\" class=\"text-center\"> <td class=\"cs-select\" ng-if=\"!isExport\"><input id=\"projet{{$index}}\" type=\"checkbox\" class=\"checkbox-select\" ng-model=\"project.isSelected\" ng-value=\"true\" ng-change=\"main.changeCheck(project)\"><label for=\"projet{{$index}}\"></label></td> <td>{{ main.arraySMHFData[project.smhf] }}</td> <td>{{ main.arrayMDVData[project.mdv] }}</td> <td>{{ main.arrayDCData[project.dc].data }}</td> <td>{{project.idprojet.nameProjet}}</td> <td>{{project.idprojet.numProjet}}</td> <td>{{project.pdv.medaillePDV}}</td> <td>{{project.nb_ar_agence}}</td> <td>{{project.statut}}</td> <td>{{project.t_creation | date:\'yyyy-MM-dd\'}}</td> <td>{{main.getDateAgence1(project) | date:\'yyyy-MM-dd\' }}</td> <td>{{project.t_update | date:\'yyyy-MM-dd HH:mm\'}}</td> <td>{{project.agence}}</td> <td ng-if=\"!isExport\"> <div class=\"btn-group-vertical col-sm-12\"> <suivi-projet-action projet=\"project\"></suivi-projet-action> <edit-projet-action projet=\"project\"></edit-projet-action> <delete-projet-action projet=\"project\"></delete-projet-action> <cancel-projet-action projet=\"project\" ctx=\"main.ctx\"></cancel-projet-action> </div> </td> </tr></script><script type=\"text/ng-template\" id=\"reaffectation.html\"><loading-screen loading=\"vm.loading\"></loading-screen> <div class=\"modal-body reaffectation\" id=\"modal-body-reaffectation\"> <div class=\"modal-header\" style=\"text-align: left;\"> <div id=\"alert-message-bis\"> <div uib-alert class=\"alert alert-fade\" type=\"{{vm.alert.type}}\" close=\"vm.closeAlert()\" ng-if=\"vm.alert.msg != undefined\">{{vm.alert.msg}} </div> </div> <h2>Réaffectation du projet</h2> </div> <div class=\"modal-body\"> <div class=\"group-text-search row\"> <div class=\"col-sm-6\"> Choisissez le DC à qui réaffecter le projet sélectionné </div> <div class=\"col-sm-6\"> <form class=\"form-inline\"> <div class=\"form-group\"> <span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span> <input type=\"text\" ng-model=\"searchKeyword\" placeholder=\"Rechercher\"/> </div> </form> </div> </div> </div> <div class=\"modal-body tableau\"> <table class=\"table table-bordered table-hover table-striped\"> <tr> <th></th> <th>Numéro du DC</th> <th>Nom du DC</th> </tr> <tr ng-repeat=\"dc in vm.dcUsers | filter: searchKeyword\" ng-class=\"vm.dcSelected == dc.username ? \'selected\' : \'\'\"> <td class=\"cs-select\"><input id=\"dc_{{$index}}\" type=\"radio\" name=\"dc_project\" ng-model=\"vm.dcSelected\" ng-value=\"\'{{dc.username}}\'\"><label for=\"dc_{{$index}}\"></label></td> <td>{{ dc.username }}</td> <td>{{ dc.prenom }} {{ dc.nom }}</td> </tr> </table> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.done()\"> Confirmer </button> </div> </div></script>");
$templateCache.put("app/gestion-projets-smhfmdv/gestion-projets.html","<loading-screen loading=\"main.loading\"></loading-screen><header-nav></header-nav><div class=\"container-fluid dashboard gestion-projets gestion-smhf-mdv dashboard-imprimeur\"><div class=\"page-header\"><div class=\"container\"><div id=\"alert-message\"><div uib-alert=\"\" class=\"alert alert-fade\" type=\"{{main.alert.type}}\" close=\"main.closeAlert()\" ng-if=\"main.alert.msg != undefined\">{{main.alert.msg}}</div><div uib-alert=\"\" class=\"alert alert-fade alert-cancel\" type=\"{{main.ctx.alert.type}}\" close=\"main.closeAlert()\" ng-if=\"main.ctx.alert.msg != undefined\">{{main.ctx.alert.msg}}</div></div><h1><span>Gestion des projets</span></h1></div></div><div class=\"container data-dashboard data-project data-imprimeur data-siege\"><div class=\"table-responsive\"><table class=\"table table-bordered table-hover table-striped\"><caption class=\"text-uppercase\">Tous les projets</caption><caption class=\"search-filter row\"><div class=\"filtres\"><label>Filtres:</label><select name=\"searchFilter\" ng-model=\"main.searchStatut\"><option value=\"\">Tous les statuts</option><option ng-repeat=\"option in main.searchStatutArray\" value=\"{{option}}\">{{option}}</option></select><span class=\"glyphicon glyphicon-triangle-bottom\"></span><select name=\"searchFilter\" ng-options=\"option for option in main.searchSupportArray\" ng-model=\"main.searchSupport\"><option value=\"\">Tous les supports</option></select><span class=\"glyphicon glyphicon-triangle-bottom\"></span> <button class=\"btn btn-load btn-export\" ng-if=\"main.user.hasRole(\'smhf\')\" ng-click=\"main.exportToExcel(\'#tableToExport\')\">Exporter les données</button></div></caption><tbody><tr class=\"text-center legend-dash text-uppercase\"><th ng-click=\"main.sortBy(\'\')\">SMHF</th><th ng-click=\"main.sortBy(\'\')\">MDV</th><th ng-click=\"main.sortBy(\'\')\">DC</th><th ng-click=\"main.sortBy(\'idprojet.nameProjet\')\">Nom du Projet <span ng-if=\"!main.reverse && main.propertyName == \'idprojet.nameProjet\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'idprojet.nameProjet\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'idprojet.nameProjet\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'idprojet.nameProjet\'}\"></span></th><th ng-click=\"main.sortBy(\'infocarte.format.name\')\">Support <span ng-if=\"!main.reverse && main.propertyName == \'infocarte.format.name\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'infocarte.format.name\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'infocarte.format.name\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'infocarte.format.name\'}\"></span></th><th ng-click=\"main.sortBy(\'nb_ar_agence\')\">AR Créa <span ng-if=\"!main.reverse && main.propertyName == \'nb_ar_agence\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'nb_ar_agence\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'nb_ar_agence\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'nb_ar_agence\'}\"></span></th><th ng-click=\"main.sortBy(\'statut\')\">Statut <span ng-if=\"!main.reverse && main.propertyName == \'statut\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'statut\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'statut\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'statut\'}\"></span></th><th ng-click=\"main.sortBy(\'t_creation\')\">Date Création <span ng-if=\"!main.reverse && main.propertyName == \'t_creation\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'t_creation\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'t_creation\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'t_creation\'}\"></span></th><th ng-click=\"main.sortBy(\'t_update\')\">Date Modification <span ng-if=\"!main.reverse && main.propertyName == \'t_update\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'t_update\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'t_update\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'t_update\'}\"></span></th><th><span class=\"glyphicon glyphicon-cog\" aria-hidden=\"true\"></span></th></tr><tr ng-repeat=\"project in main.projectLists | filterBy:[\'type\']: main.searchSupport | filter:{statut: main.searchStatut} | orderBy:main.propertyName:main.reverse\" class=\"text-center project-{{$index}} {{main.ctx.class[project.idprojet.nameProjet]}}\" ng-class=\"{selected: project.isSelected}\"><td>{{ main.arraySMHFData[project.smhf] }}</td><td>{{ main.arrayMDVData[project.mdv] }}</td><td>{{ main.arrayDCData[project.dc].data }}</td><td>{{project.idprojet.nameProjet}}</td><td>{{project.typeProjet}}</td><td>{{project.nb_ar_agence}}</td><td>{{project.statut}}</td><td>{{project.t_creation | date:\'yyyy-MM-dd\'}}</td><td>{{project.t_update | date:\'yyyy-MM-dd HH:mm\'}}</td><td><div class=\"btn-group-vertical col-sm-12\"><suivi-projet-action projet=\"project\"></suivi-projet-action><edit-projet-action projet=\"project\"></edit-projet-action><delete-projet-action projet=\"project\"></delete-projet-action><cancel-projet-action projet=\"project\" ctx=\"main.ctx\"></cancel-projet-action></div></td></tr></tbody><tbody id=\"tableToExport\" style=\"display: none;\"><tr class=\"text-center legend-dash text-uppercase\"><th ng-click=\"main.sortBy(\'\')\">SMHF</th><th ng-click=\"main.sortBy(\'\')\">MDV</th><th ng-click=\"main.sortBy(\'\')\">DC</th><th ng-click=\"main.sortBy(\'idprojet.nameProjet\')\">Nom du Projet <span ng-if=\"!main.reverse && main.propertyName == \'idprojet.nameProjet\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'idprojet.nameProjet\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'idprojet.nameProjet\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'idprojet.nameProjet\'}\"></span></th><th ng-click=\"main.sortBy(\'infocarte.format.name\')\">Support <span ng-if=\"!main.reverse && main.propertyName == \'infocarte.format.name\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'infocarte.format.name\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'infocarte.format.name\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'infocarte.format.name\'}\"></span></th><th ng-click=\"main.sortBy(\'nb_ar_agence\')\">AR Créa <span ng-if=\"!main.reverse && main.propertyName == \'nb_ar_agence\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'nb_ar_agence\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'nb_ar_agence\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'nb_ar_agence\'}\"></span></th><th ng-click=\"main.sortBy(\'statut\')\">Statut <span ng-if=\"!main.reverse && main.propertyName == \'statut\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'statut\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'statut\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'statut\'}\"></span></th><th ng-click=\"main.sortBy(\'t_creation\')\">Date Création <span ng-if=\"!main.reverse && main.propertyName == \'t_creation\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'t_creation\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'t_creation\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'t_creation\'}\"></span></th><th ng-click=\"main.sortBy(\'t_update\')\">Date Modification <span ng-if=\"!main.reverse && main.propertyName == \'t_update\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'t_update\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'t_update\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'t_update\'}\"></span></th></tr><tr ng-repeat=\"project in main.projectLists | filterBy:[\'type\']: main.searchSupport | filter:{statut: main.searchStatut} | orderBy:main.propertyName:main.reverse\" class=\"text-center\" ng-class=\"{selected: project.isSelected}\"><td>{{ main.arraySMHFData[project.smhf] }}</td><td>{{ main.arrayMDVData[project.mdv] }}</td><td>{{ main.arrayDCData[project.dc].data }}</td><td>{{project.idprojet.nameProjet}}</td><td>{{project.typeProjet}}</td><td>{{project.nb_ar_agence}}</td><td>{{project.statut}}</td><td>{{project.t_creation | date:\'yyyy-MM-dd\'}}</td><td>{{project.t_update | date:\'yyyy-MM-dd HH:mm\'}}</td></tr></tbody></table></div></div></div><script type=\"text/ng-template\" id=\"reaffectation.html\"><loading-screen loading=\"vm.loading\"></loading-screen> <div class=\"modal-body reaffectation\" id=\"modal-body-reaffectation\"> <div class=\"modal-header\" style=\"text-align: left;\"> <div id=\"alert-message-bis\"> <div uib-alert class=\"alert alert-fade\" type=\"{{vm.alert.type}}\" close=\"vm.closeAlert()\" ng-if=\"vm.alert.msg != undefined\">{{vm.alert.msg}} </div> </div> <h2>Réaffectation du projet</h2> </div> <div class=\"modal-body\"> <div class=\"group-text-search row\"> <div class=\"col-sm-6\"> Choisissez le DC à qui réaffecter le projet sélectionné </div> <div class=\"col-sm-6\"> <form class=\"form-inline\"> <div class=\"form-group\"> <span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span> <input type=\"text\" ng-model=\"searchKeyword\" placeholder=\"Rechercher\"/> </div> </form> </div> </div> </div> <div class=\"modal-body tableau\"> <table class=\"table table-bordered table-hover table-striped\"> <tr> <th></th> <th>Numéro du DC</th> <th>Nom du DC</th> </tr> <tr ng-repeat=\"dc in vm.dcUsers | filter: searchKeyword\" ng-class=\"vm.dcSelected == dc.username ? \'selected\' : \'\'\"> <td class=\"cs-select\"><input id=\"dc_{{$index}}\" type=\"radio\" name=\"dc_project\" ng-model=\"vm.dcSelected\" ng-value=\"\'{{dc.username}}\'\"><label for=\"dc_{{$index}}\"></label></td> <td>{{ dc.username }}</td> <td>{{ dc.prenom }} {{ dc.nom }}</td> </tr> </table> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.done()\"> Confirmer </button> </div> </div></script>");
$templateCache.put("app/help/help.html","<header-nav></header-nav><div class=\"container-fluid help\"><div class=\"page-header\"><div class=\"container\"><h1><span>BESOIN D\'AIDE ?</span></h1></div></div><div class=\"container\"><p>Si vous rencontrez un problème d’ordre technique, merci de contacter <a href=\"mailto:FRPERFORMANCESYSTEM@COKECCE.COM\">FRPERFORMANCESYSTEM@COKECCE.COM</a></p><p>Si vous contactez un problème de support, merci de contacter <a href=\"mailto:supportmyplv@cokecce.com\">supportmyplv@cokecce.com</a></p><p>Pour toute question concernant « les process » liés à la plateforme, nous vous invitons à vous rendre sur l’indispensable : Plans et Moyens Marketing – MyPLV – MyPLV CHR 2019 Guide d’utilisation et MyPLV VAE 2019 Guide d’utilisation</p></div></div>");
$templateCache.put("app/init/init.html","<div class=\"container\"><div class=\"jumbotron\"><p class=\"lead\">Veuillez patienter pendant le chargement...</p></div></div>");
$templateCache.put("app/login/login.html","<div class=\"login-page\"><div class=\"img-login\"><h1>Image du login</h1></div><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-6\"><form class=\"form-horizontal\" ng-if=\"!main.connected()\"><div class=\"form-group\"><div class=\"col-sm-offset-4 col-sm-5\"><span ng-bind=\"main.loginForm.error\" class=\"error-msg\"></span></div></div><div class=\"form-group\"><div class=\"col-sm-offset-4 col-sm-5\"><input ng-model=\"main.loginForm.username\" type=\"text\" class=\"form-control\" id=\"name\" placeholder=\"Identifiant\" required=\"\" tabindex=\"1\"></div><span ng-click=\"main.removeText()\" class=\"glyphicon glyphicon-remove-sign control-label\" aria-hidden=\"true\"></span></div><div class=\"form-group\"><div class=\"col-sm-offset-4 col-sm-5\"><input ng-model=\"main.loginForm.password\" type=\"{{ main.inputType }}\" class=\"form-control\" id=\"password\" placeholder=\"Password\" required=\"\" tabindex=\"2\"></div><span ng-if=\"main.password == true\" class=\"glyphicon glyphicon-eye-open control-label\" aria-hidden=\"true\" ng-click=\"main.hideShowPassword()\"></span> <span ng-if=\"main.password == false\" class=\"glyphicon glyphicon-eye-close control-label\" aria-hidden=\"true\" ng-click=\"main.hideShowPassword()\"></span></div><div class=\"form-group\"><div class=\"col-sm-offset-4 col-sm-5\"><button type=\"submit\" class=\"btn btn-default btn-lg col-sm-12 btn-login\" style=\"margin: 0;\" ng-click=\"main.login()\" tabindex=\"3\">Se connecter</button></div></div><div class=\"form-group\"><div class=\"col-sm-offset-4 col-sm-5 text-center\"><a class=\"btn btn-link\" href=\"/cms/user/password\" tabindex=\"4\">Mot de passe oublié ?</a></div></div></form></div><div class=\"col-sm-6 img-myplv-login\"><h2>Image MyPLV</h2><p>Créez en quelques clics les projets<br>sur-mesure de vos clients !</p></div></div></div></div>");
$templateCache.put("app/main/main.html","<nav class=\"navbar navbar-default header-nav header-home\"><div class=\"container\"><p class=\"navbar-text navbar-left\"><a class=\"navbar-link logo\" href=\"/\">Home</a></p><p class=\"navbar-text hello text-capitalize\" ng-if=\"main.user.getDataFirstnameUser()\">Bonjour {{ main.user.getDataFirstnameUser() }} !</p><p class=\"navbar-text hello text-capitalize\" ng-if=\"!main.user.getDataFirstnameUser() && main.user.getUsername()\">Bonjour {{ main.user.getUsername() }} !</p><p class=\"navbar-text navbar-right\"><a class=\"navbar-link\" href=\"\" ng-click=\"main.logout()\"><span class=\"glyphicon glyphicon-log-out\"></span><span class=\"fonction\">déconnexion</span></a></p><p class=\"navbar-text navbar-right\"><a class=\"navbar-link\" ui-sref=\"help\"><span class=\"glyphicon glyphicon-question-sign\"></span><span class=\"fonction\">aide</span></a></p><p></p></div></nav><div class=\"container-fluid home\"><div class=\"container\"><div id=\"alert-message\"><div uib-alert=\"\" class=\"alert alert-fade\" type=\"{{main.alert.type}}\" close=\"main.closeAlert()\" ng-if=\"main.alert.msg != undefined\">{{main.alert.msg}}</div></div><div class=\"create-project panel col-sm-8\" ng-if=\"main.user.hasRole(\'dc\') || main.user.hasRole(\'administrator\')\"><h3 class=\"col-sm-12 text-center\"><span>Créer un projet</span></h3><div class=\"panel panel-default col-sm-5\"><div class=\"panel-heading text-center\">CARTES BARECA</div><div class=\"panel-body\"><a type=\"submit\" class=\"btn btn-default btn-create create-chr\" href=\"\" ng-click=\"main.createNewProject()\" ng-class=\"main.etatQuotaCHR == \'DEPASSE\' ? \'disabled\' : \'\'\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> <span>Créer une carte avec un template CCEP <strong>- Brief DC</strong></span></a></div><div class=\"div-alert\"><div uib-alert=\"\" class=\"alert alert-danger alert-fade\" ng-if=\"main.alertChr != undefined\">{{main.alertChr}}</div></div></div><div class=\"panel panel-default col-sm-5\"><div class=\"panel-heading text-center\">PROJETS SUR MESURE</div><div class=\"panel-body\"><a type=\"submit\" class=\"btn btn-default btn-create create-sm\" href=\"\" ng-click=\"main.createSurMesureProject()\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> <span>Créer un projet sur-mesure</span></a></div></div></div><accueil-siege ng-if=\"main.user.hasRole(\'siege\')\"></accueil-siege><accueil-agence ng-if=\"main.user.hasRole(\'agence\')\"></accueil-agence><accueil-imprimeur ng-if=\"main.user.hasRole(\'imprimeur\')\"></accueil-imprimeur><div class=\"group-btn-smhf col-sm-7\" ng-if=\"main.user.hasRole(\'smhf\') || main.user.hasRole(\'mdv\')\"><h3 class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default\" ui-sref=\"gestion-projets-smhf()\" ng-if=\"main.user.hasRole(\'smhf\')\"><span class=\"glyphicon glyphicon-list\" aria-hidden=\"true\"></span> Tableau de bord</a> <a type=\"submit\" class=\"btn btn-default\" ui-sref=\"gestion-projets-mdv()\" ng-if=\"main.user.hasRole(\'mdv\')\"><span class=\"glyphicon glyphicon-list\" aria-hidden=\"true\"></span> Tableau de bord</a></h3><h3 class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default\" ui-sref=\"suivi-quotas()\"><span class=\"glyphicon glyphicon-stats\" aria-hidden=\"true\"></span> Suivi des quotas</a></h3></div><div class=\"info-user panel text-center col-sm-4\"><h3 class=\"col-sm-12 text-center\" ng-if=\"main.hasDashbord()\"><a type=\"submit\" class=\"btn btn-default\" href=\"#/dashboard\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Tableau de bord</a></h3><div class=\"panel panel-default well col-sm-12 block-actualites\"><div class=\"panel-heading text-center\">Actualités</div><div class=\"panel-body\"><div class=\"articles\" ng-repeat=\"actualite in main.actualites\"><h2>{{actualite.title}}</h2><div class=\"description\" ng-bind-html=\"actualite.body\"></div><div class=\"more-link\"><a href=\"{{actualite.path}}\" target=\"_blank\"><span class=\"glyphicon glyphicon-circle-arrow-right\" aria-hidden=\"true\"></span></a></div></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"alertQuota.html\"><div class=\"modal-body\" id=\"modal-body-msg\"> <div class=\"modal-header\"><h2>Attention, quota restant faible : {{vm.quota}}</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"$close()\">OK</button> </div> </div></script>");
$templateCache.put("app/qrcodes/qrcodes.html","<loading-screen loading=\"main.loading\"></loading-screen><header-nav></header-nav><div class=\"container-fluid dashboard qrcodes\"><div class=\"page-header\"><div class=\"container\"><h1><span>QrCodes</span></h1></div></div><div class=\"page-body\"><div id=\"qrcodes-picture\" class=\"col-sm-6\"><div ng-if=\"main.qrcode.extra.qrcodeUrl\">Cliquer sur le QrCode pour le télécharger.<br><a ng-href=\"{{main.qrcode.extra.qrcodeUrl}}\" download=\"\"><img ng-src=\"{{main.qrcode.extra.qrcodeUrl}}\"></a></div><div ng-if=\"!main.qrcode.extra.qrcodeUrl\"><button class=\"btn btn-default btn-url\" ng-click=\"main.generateQrCode()\">Générer le QrCode</button></div></div><div class=\"form-group radio-custom col-sm-6\" ng-if=\"main.qrcode.extra.qrcodeUrl\"><h2>Cible du QrCode</h2><div class=\"text-left\"><div class=\"radio\"><input type=\"radio\" name=\"mode\" value=\"fichier\" ng-model=\"main.qrcode.type\" required=\"\"> <label>Fichier</label></div><div class=\"radio\"><input type=\"radio\" name=\"mode\" value=\"url\" ng-model=\"main.qrcode.type\" required=\"\"> <label>Url ext.</label></div></div><div class=\"form-group row\"><hr></div><div id=\"qrcodes-fichier\" ng-if=\"main.isModeFichier()\" class=\"form-vertical\"><div class=\"form-group row\"><label class=\"control-label\">Fichier PDF basse définition à télécharger par l\'agence : {{main.qrcode.filename}}</label> <input type=\"file\" accept=\"application/pdf\" class=\"form-control\" nv-file-select=\"\" uploader=\"main.uploader\" sn-model-file=\"main.fileToUpload\"></div><div class=\"form-group row\"><button class=\"btn btn-default btn-url\" ng-disabled=\"!main.fileToUpload\" ng-click=\"main.uploadFile()\">Valider</button> <a class=\"btn btn-default btn-lg\" ui-sref=\"suivi-projet({id: main.backId})\">Retour au projet</a></div></div><div ng-form=\"urlForm\" id=\"qrcodes-url\" ng-if=\"main.isModeUrl()\" class=\"form-vertical\"><div class=\"form-group row\"><label for=\"emailDestinataire\" class=\"control-label\">Url externe :</label> <input type=\"text\" class=\"form-control\" id=\"url\" name=\"url\" required=\"\" ng-model=\"main.qrcode.url\" placeholder=\"URL du lien vers le site externe\"></div><div class=\"form-group row\"><button class=\"btn btn-default btn-url\" ng-disabled=\"urlForm.$invalid\" ng-click=\"main.updateUrl()\">Valider</button> <a class=\"btn btn-default btn-lg\" ui-sref=\"suivi-projet({id: main.backId})\">Retour au projet</a></div></div></div><div ng-if=\"main.isModeUrl() || main.isModeFichier()\" class=\"form-group col-sm-6\"><hr></div><div class=\"form-group col-sm-6\" ng-if=\"!main.isNew\"><h2>Bannière publicitaire</h2><div id=\"qrcodes-banner\" class=\"form-vertical\"><div class=\"form-group row\"><label class=\"control-label\">Bannière : {{main.qrcode.bannerName}}</label> <input type=\"file\" class=\"form-control\" nv-file-select=\"\" uploader=\"main.bannerUploader\" sn-model-file=\"main.bannerToUpload\"></div><div class=\"form-group row\" ng-if=\"main.bannerInfo\"><ul><li>Type: <span class=\"{{main.bannerInfo.typeClass}}\">{{main.bannerInfo.type}}</span> <span ng-if=\"main.bannerInfo.typeClass === main.ERROR_CLASS\" class=\"{{main.bannerInfo.typeClass}}\">- Formats acceptés : JPG, GIF, PNG</span></li><li>Taille: <span class=\"{{main.bannerInfo.sizeClass}}\">{{main.bannerInfo.size / 1024 | number:1}} Ko</span> <span ng-if=\"main.bannerInfo.sizeClass === main.ERROR_CLASS\" class=\"{{main.bannerInfo.sizeClass}}\">- Taille maximale 150Ko</span></li><li>Dimension: <span><span class=\"{{main.bannerInfo.widthClass}}\">{{main.bannerInfo.width}}</span> x <span class=\"{{main.bannerInfo.heightClass}}\">{{main.bannerInfo.height}}</span>px</span> <span ng-if=\"main.bannerInfo.widthClass === main.ERROR_CLASS || main.bannerInfo.heightClass === main.ERROR_CLASS\" class=\"{{main.bannerInfo.widthClass}}\">- Dimensions entre 320x480 et 750x1334px</span></li></ul></div><div class=\"form-group row\"><label class=\"control-label col-8\">Temporisation (en secondes) :</label> <input type=\"number\" class=\"form-control col-4\" string-to-number=\"\" ng-model=\"main.qrcode.bannerTimer\" min=\"0\"></div><div class=\"form-group row\"><button class=\"btn btn-default btn-url\" ng-disabled=\"!main.isBannerFormValid()\" ng-click=\"main.uploadBannerFile()\">Valider</button> <a class=\"btn btn-default btn-lg\" ng-disabled=\"!main.qrcode.bannerName\" ng-click=\"main.resetBanner()\">Supprimer la bannière</a></div></div></div></div></div>");
$templateCache.put("app/sm/sm-delete-support.html","<div class=\"modal-body alert-delete-gamme\" id=\"modal-body-alert-delete-gamme\"><div class=\"modal-header\"><h2 class=\"text-center\">Voulez-vous vraiment supprimer ce support ?</h2></div><div class=\"modal-footer\"><button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">ANNULER <span class=\"glyphicon glyphicon-remove-sign\" aria-hidden=\"true\"></span></button> <button class=\"btn btn-default\" ng-click=\"$close()\"><span class=\"glyphicon glyphicon-ok-sign\" aria-hidden=\"true\"></span> OUI</button></div></div>");
$templateCache.put("app/sm/sm-layout.html","<header-nav></header-nav><div class=\"container-fluid id-projet\"><div class=\"text-uppercase title-picto\" ng-if=\"!sm.$state.includes(\'sm.recapitulatif\')\"><div class=\"container\"><h1><span class=\"picto-carte sm-picto\"></span><span class=\"denom\">{{sm.title}}</span></h1></div></div><div class=\"nav-bar-icon\" ng-if=\"!sm.$state.includes(\'sm.recapitulatif\')\"><div class=\"container\"><ul class=\"nav nav-tabs nav-bar-icon text-center\"><li ng-class=\"sm.classForItem(\'sm.info-pdv\')\"><a href=\"\" ng-click=\"sm.go(\'sm.info-pdv\')\"><span class=\"number\">1.</span><span>INFORMATION CLIENT</span></a></li><li ng-class=\"sm.classForItem(\'sm.creation\')\"><a href=\"\" ng-click=\"sm.go(\'sm.creation.id_projet\')\"><span class=\"number\">2.</span><span>CREATION DES SUPPORTS</span></a></li><li ng-class=\"sm.classForItem(\'sm.contenu\')\"><a href=\"\" ng-click=\"sm.go(\'sm.contenu.gamme\')\"><span class=\"number\">3.</span><span>CONTENU DES SUPPORTS</span></a></li><li ng-class=\"sm.classForItem(\'sm.autres-infos\')\"><a href=\"\" ng-click=\"sm.go(\'sm.autres-infos\')\"><span class=\"number\">4.</span><span>AUTRES INFORMATIONS</span></a></li><li ng-class=\"sm.classForItem(\'sm.livraison\')\"><a href=\"\" ng-click=\"sm.go(\'sm.livraison\')\"><span class=\"number\">5.</span><span>LIVRAISON</span></a></li></ul></div></div><div ui-view=\"\" autoscroll=\"false\"></div></div>");
$templateCache.put("app/suivi-quotas/suivi-quotas.html","<loading-screen loading=\"main.loading\"></loading-screen><header-nav></header-nav><div class=\"container-fluid dashboard suivi-quotas dashboard-imprimeur\"><div class=\"page-header\"><div class=\"container\"><h1><span>Suivi des quotas</span></h1></div></div><div class=\"container data-dashboard data-project data-imprimeur data-siege\"><div class=\"table-responsive\"><table class=\"table table-bordered table-hover\"><caption class=\"text-uppercase\">Quotas Annuels et Restants <span class=\"help-block\">Les projets passés pour la seconde fois en statut \"brouillons\" sont considéré comme \"créations\"</span></caption><thead><tr><th ng-click=\"main.sortBy(\'smhf.data.prenom\')\" class=\"th-smhf\">SMHF <span ng-if=\"!main.reverse && main.propertyName == \'smhf.data.prenom\'\" class=\"glyphicon glyphicon-triangle-top\" ng-class=\"{active: main.propertyName == \'smhf.data.prenom\'}\"></span> <span ng-if=\"main.reverse && main.propertyName == \'smhf.data.prenom\'\" class=\"glyphicon glyphicon-triangle-bottom\" ng-class=\"{active: main.propertyName == \'smhf.data.prenom\'}\"></span></th><th>Supports</th><th>Quota annuel</th><th colspan=\"4\" class=\"quota-utilises\"><div class=\"col-sm-12\">Quota utlisés</div><div><span class=\"col-sm-3\">Créations</span> <span class=\"col-sm-3\">Impr.</span> <span class=\"col-sm-3\">Digit.</span> <span class=\"col-sm-3\">Annulés</span></div></th><th>Quota restant</th><th>à venir</th><th>Evolution de l\'utilisation des quotas</th></tr></thead><tbody ng-repeat=\"smhf in main.dataSuiviQuotas | orderBy:main.propertyName:main.reverse\"><tr ng-repeat=\"quota in smhf.dataQuota\" class=\"text-center\"><td rowspan=\"2\" ng-if=\"!($index%2)\">{{ smhf.data.prenom }} {{ smhf.data.nom }}</td><td><strong>{{quota.name}}</strong></td><td>{{quota.data.annuel}}</td><td>{{quota.data.creation}}</td><td>{{quota.data.imprime}}</td><td>{{quota.data.digital}}</td><td>{{quota.data.annule}}</td><td>{{quota.data.restant}}</td><td>{{quota.data.avenir}}</td><td class=\"td-progress-bar\"><uib-progressbar class=\"progress active\" value=\"quota.data.pourcentage\" type=\"{{main.typeProgressBar(quota.data.pourcentage)}}\">{{quota.data.pourcentage}} %</uib-progressbar></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/suivi_projet/suivi_projet.html","<loading-screen loading=\"main.blockUI\" class=\"projet-loading\"></loading-screen><header-nav></header-nav><div class=\"container-fluid suivi_projet\"><div class=\"page-header text-uppercase text-center\"><div class=\"container\"><h1><span>Suivi du Projet</span></h1><h3><span class=\"projet\">{{ main.ctx.project.idprojet.nameProjet }}</span></h3></div></div><div class=\"msg-to-dc container h3\" ng-if=\"main.ctx.project.statut == \'Brouillon\' && main.ctx.project.nb_ar_agence < 1 && main.ctx.project.typeProjet !== \'PDA\'\"><p>Pour transmettre le bon de commande, cliquez sur le bouton <span class=\"text-uppercase\"><strong>soumettre à l\'agence</strong></span>.</p><p><strong>Vous avez la possibilité de mettre un message ou de joindre un fichier.</strong></p></div><div class=\"msg-to-dc container h3\" ng-if=\"main.ctx.project.nb_ar_agence > 2\"><p>Attention, vous avez réalisé plus de deux aller-retours. Merci de veiller à limiter ce nombre.</p></div><div class=\"msg-to-dc container h3\" ng-if=\"main.etatQuota && main.etatQuota.statutQuotaCHR == \'ALERTE\' && main.ctx.project.typeProjet == \'CHR\'\"><p><strong>ALERTE QUOTA</strong></p><p>Il y a plus de projets en brouillon ({{main.etatQuota.quotasAVenirCHR}}) que de quota restant disponible ({{main.etatQuota.quotasAnnuelCHR - main.etatQuota.quotasConsoCHR}}). Certains de ces projets pourraient ne pas être pris en charge.</p></div><div class=\"msg-to-dc container h3\" ng-if=\"main.etatQuota && main.etatQuota.statutQuotaPDA == \'ALERTE\' && main.ctx.project.typeProjet == \'PDA\'\"><p><strong>ALERTE QUOTA</strong></p><p>Il y a plus de projets en brouillon ({{main.etatQuota.quotasAVenirPDA}}) que de quota restant disponible ({{main.etatQuota.quotasAnnuelPDA - main.etatQuota.quotasConsoPDA}}). Certains de ces projets pourraient ne pas être pris en charge.</p></div><div class=\"container\"><div class=\"panel panel-default row data-projet\"><div class=\"panel-heading\">PROJET</div><div class=\"panel-body text-center\"><div class=\"content\"><div class=\"col-sm-6\"><p>Nom du Projet : <span>{{ main.ctx.project.idprojet.nameProjet }}</span></p><p>N° Projet : <span>{{ main.ctx.project.pdv.nOutlet }}_{{ main.ctx.project.idprojet.codeProjet }}</span></p><p>Nom Client : <span>{{ main.ctx.project.pdv.nomClient }}</span></p><p>Type de support : <span>{{ main.ctx.project.type }}</span></p><p ng-if=\"main.isCHR()\">Thème graphique : <span>{{ main.ctx.project.infocarte.template.name }}</span></p><p ng-if=\"main.isCHR()\">Format de la carte : <span>{{ main.ctx.project.infocarte.format.name }}</span></p><p ng-if=\"main.user.getRoles()[1] == \'agence\'\">Nombre d\'exemplaire : <span>{{ main.ctx.project.infocarte.nombreExemplaire }}</span></p><p ng-if=\"main.isVAE() && main.ctx.project.type !== \'Digital\'\">Nombre de boards : <span>{{ main.nbBoards() }}</span></p><p ng-if=\"main.isPSM()\">Nombre de créations : <span>{{ main.ctx.project.supports.length }}</span></p><p>Date de création : <span>{{ main.ctx.project.t_creation | date: \"dd/MM/yyyy\"}}</span></p><p>Date de dernière modification : <span>{{ main.ctx.project.t_update | date:\'dd/MM/yyyy HH:mm\' }}</span></p><p>DC : <span>{{ main.dataDC }}</span></p><p class=\"suivi-statut\"><span style=\"text-decoration: underline;color: inherit;\">Statut</span> : <span><strong>{{ main.ctx.project.statut }}</strong></span></p></div><div class=\"col-sm-6\"><img ng-if=\"main.isCHR()\" ng-src=\"{{ main.ctx.project.infocarte.template.image }}\"><div class=\"projet-type-vae\" ng-if=\"main.isAvecPose() && main.isVAE()\"><div class=\"date-previsite\"><span class=\"title-date-pose\">Pré-visite</span><date-picker value=\"main.ctx.project.pose.t_previsite\" on-value-change=\"main.setDatePrevisite(selectedValue)\" ng-if=\"main.canChangeDatePrevisite()\"></date-picker><span ng-if=\"main.ctx.project.pose.t_previsite\" class=\"first-span\">{{main.ctx.project.pose.t_previsite | date: \"dd/MM/yyyy HH:mm\"}}</span> <span ng-if=\"!main.ctx.project.pose.t_previsite\" class=\"first-span\">Non renseignée</span></div><div class=\"date-pose\"><span class=\"title-date-pose\">Pose</span><date-picker value=\"main.ctx.project.pose.t_pose\" on-value-change=\"main.setDatePose(selectedValue)\" ng-if=\"main.canChangeDatePose()\"></date-picker><span ng-if=\"main.ctx.project.pose.t_pose\">{{main.ctx.project.pose.t_pose | date: \"dd/MM/yyyy HH:mm\"}}</span> <span ng-if=\"!main.ctx.project.pose.t_pose\">Non renseignée</span></div></div><button class=\"btn btn-default btn-view-bdc\" href=\"\" ng-click=\"main.selectProjet(main.ctx.project)\"><span class=\"glyphicon glyphicon-folder-open\" aria-hidden=\"true\"></span> BON DE COMMANDE</button></div></div><div class=\"row text-center\"><a class=\"well\" href=\"\" ng-click=\"main.downloadZipProject()\" ng-if=\"!main.user.hasRole(\'dc\')\"><span class=\"glyphicon\" aria-hidden=\"true\" ng-class=\"{\'loader\': main.loading, \'glyphicon-save\': !main.loading}\"></span> Télécharger le Projet</a></div></div></div><div class=\"contenant-flex\"><div class=\"panel panel-default statut-panel row data-projet\"><div class=\"panel-heading\">Statut du Projet</div><div class=\"panel-body text-center\"><statut-projet-nav-bar></statut-projet-nav-bar></div></div><div class=\"row change-statut\"><div class=\"panel panel-default\" ng-if=\"main.showStatutChange\"><div class=\"panel-heading\">ACTIONS ET MESSAGERIE</div><div class=\"panel-body text-center\"><div class=\"msg-file\"><label class=\"upload-file text-center text-uppercase\" for=\"documents\"><span class=\"glyphicon glyphicon-paperclip\" aria-hidden=\"true\"></span> <input type=\"file\" accept=\"application/pdf,image/*,video/*,.flv\" class=\"form-control\" id=\"documents\" name=\"documents\" nv-file-select=\"\" uploader=\"main.uploader\" options=\"{myplv_file_type:\'{{ main.fileType }}\'}\" style=\"display: none;\" multiple=\"\"></label> <textarea class=\"msg-change-statut\" name=\"comment\" style=\"width: 100%;\" rows=\"7\" placeholder=\"Message à envoyer...\" ng-model=\"main.ctx.project.pdv.comment\"></textarea></div><hr><div class=\"upload-file-queue\"><div ng-repeat=\"item in main.uploader.queue\" class=\"row item-file\"><div class=\"col-sm-8\"><span ng-bind=\"item.file.name\"></span> <span class=\"weight\" ng-show=\"main.uploader.isHTML5\" nowrap=\"\">{{ item.file.size / 1024 / 1024|number:2 }} MB</span> <input type=\"hidden\" ng-init=\"main.ctx.project.docSuiviProjet[item.file.firtsName].photo = item.myplv_file_type_name\" value=\"{{item.myplv_file_type_name}}\"> <input type=\"hidden\" ng-init=\"main.ctx.project.docSuiviProjet[item.file.firtsName].anno = []\"></div><div class=\"col-sm-4\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"item.remove()\"><span class=\"glyphicon glyphicon-trash\"></span> Supprimer</button></div></div><div ng-show=\"main.uploader.queue.length\" class=\"uploader-action-bar\"><div class=\"progess-bar-file\"><div class=\"progress\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': main.uploader.progress + \'%\' }\"></div></div></div></div></div><div class=\"button-wrapper\"><div ng-if=\"(main.user.hasRole(\'administrator\') || main.user.hasRole(\'siege\')) && main.ctx.project.statut == \'Agence\'\" class=\"status-btn\"><button type=\"submit\" class=\"btn btn-default btn-lg btn-block\" ng-click=\"main.changeAgence(main.ctx.project)\">RÉ-ATTRIBUER LE PROJET À UNE AGENCE</button></div><div ng-repeat=\"statut in main.allowedStatuts\" class=\"status-btn {{statut}}\"><button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" ng-class=\"{\'btn-agence\': main.ctx.project.statut == \'Brouillon\'}\" href=\"\" ng-disabled=\"main.disabled\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"(main.ctx.project.statut == \'Brouillon\' && statut == \'Agence\') || (main.ctx.project.statut == \'Client\' && statut == \'Agence\' && main.ctx.project.signatureClient)\"><span class=\"to-agence\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Soumettre à l\'Agence</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" ng-class=\"{\'btn-agence\': main.ctx.project.statut == \'Brouillon\'}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"main.ctx.project.statut == \'Agence\' && statut == \'Brouillon\'\"><span><span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span>Retour en brouillon</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" ng-class=\"{\'btn-agence\': main.ctx.project.statut == \'Brouillon\'}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"main.ctx.project.statut == \'Agence\' && statut == \'Client\'\"><span><span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span>Retour au client</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" ng-class=\"{\'btn-agence\': main.ctx.project.statut == \'Brouillon\'}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"(main.ctx.project.statut == \'Agence\' || main.ctx.project.statut == \'Exécution\') && statut == \'Validation DC\'\"><span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Validation DC</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" ng-class=\"{\'btn-agence\': main.ctx.project.statut == \'Brouillon\'}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"main.ctx.project.statut == \'Validation DC\' && statut == \'Agence\' || main.ctx.project.statut == \'Impression\' && statut == \'Agence\'\"><span><span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span>Retour à l\'Agence</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" ng-class=\"{\'btn-agence\': main.ctx.project.statut == \'Brouillon\'}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"(main.ctx.project.statut == \'Agence\' || main.ctx.project.statut == \'Validation DC\' || main.ctx.project.statut == \'Exécution\') && statut == \'Validation Client\' && main.ctx.project.type !== \'Direct Agence\'\"><span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Soumettre au client</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" ng-class=\"{\'btn-agence\': main.ctx.project.statut == \'Brouillon\'}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"(main.ctx.project.statut == \'Agence\' || main.ctx.project.statut == \'Validation CCEP\') && statut == \'Validation Client\' && main.ctx.project.type == \'Direct Agence\'\"><span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Demander validation au client</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" ng-class=\"{\'btn-agence\': main.ctx.project.statut == \'Brouillon\'}\" href=\"\" ng-click=\"main.selectPrinter(main.ctx.project)\" ng-if=\"(main.ctx.project.statut == \'Exécution\' && statut == \'Impression\' && main.ctx.project.type !== \'Digital\') || (main.ctx.project.statut == \'Agence\' && statut == \'Impression\' && main.ctx.project.type !== \'Digital\')\"><span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Envoyer à l\'Impression</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" ng-class=\"{\'btn-agence\': main.ctx.project.statut == \'Brouillon\'}\" href=\"\" ng-click=\"main.selectPrinter(main.ctx.project)\" ng-if=\"main.ctx.project.statut == \'Validation CCEP\' && statut == \'Impression\'\"><span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Envoyer à l\'Impression</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" ng-class=\"{\'btn-agence\': main.ctx.project.statut == \'Brouillon\'}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"main.ctx.project.statut == \'Impression\' && statut == \'Validation CCEP\'\"><span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Demander validation au CCEP</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" ng-class=\"{\'btn-agence\': main.ctx.project.statut == \'Brouillon\'}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"(main.ctx.project.statut == \'Impression\' && statut == \'Exécution\')\"><span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Retour en Exécution</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" ng-class=\"{\'btn-agence\': main.ctx.project.statut == \'Brouillon\'}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"(main.ctx.project.statut == \'Impression\' && statut == \'Imprimé\' && main.ctx.project.type !== \'Digital\')\"><span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Imprimé</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" ng-class=\"{\'btn-agence\': main.ctx.project.statut == \'Brouillon\'}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"(main.ctx.project.statut == \'Imprimé\' && statut == \'Agence\' && main.ctx.project.type !== \'Digital\')\"><span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Retour en agence</span></button> <button type=\"submit\" class=\"btn btn-default disabled btn-lg btn-block {{statut}}\" ng-class=\"{\'btn-agence\': main.ctx.project.statut == \'Brouillon\'}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-disabled=\"main.disabled\" ng-if=\"statut == \'Prévisite\'\"><span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Soumettre à l\'installateur</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"statut == \'Livré\'\"><span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Livré</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"statut == \'Terminé\'\"><span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Terminer projet</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"statut == \'refusPose\'\"><span><span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span>Refus</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"statut == \'sousConditionPose\'\"><span><span class=\"glyphicon\" aria-hidden=\"true\"></span>Validation sous condition</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" href=\"\" ng-click=\"main.changeStatut(main.ctx.project, statut)\" ng-if=\"statut == \'validationPose\'\"><span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Validation</span></button> <button type=\"submit\" class=\"btn btn-default btn-lg btn-block {{statut}}\" href=\"\" ng-click=\"main.clonage(main.ctx.project)\" ng-if=\"statut == \'clonage\'\"><span><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Cloner le projet</span></button></div><ng-include src=\"\'prixFormTemplate.html\'\"></ng-include></div></div></div><div class=\"panel panel-default no-allowed-statut\" ng-if=\"!main.showStatutChange\"><div class=\"panel-heading\">ACTIONS ET MESSAGERIE</div><div class=\"panel-body text-center\"><h2>Le statut du projet ne vous permet pas d\'en changer.</h2></div><ng-include src=\"\'prixFormTemplate.html\'\"></ng-include></div></div></div><admin-change-statut-action></admin-change-statut-action><div class=\"action-messages row\"><div class=\"panel panel-default col-sm-12 data-actions\"><div class=\"panel-heading\">Historique du projet</div><div class=\"panel-body\"><div ng-repeat=\"historique in main.ctx.project.historique | orderBy:historique.t_creation:true\" class=\"actions col-sm-12\"><div class=\"col-sm-6\"><span class=\"date-action\">Le {{ historique.t_creation | date:\'dd-MM-yyyy HH:mm\' }}</span> <span class=\"resp-action\">{{ historique.resp }}</span> <span class=\"statut-action\">STATUT {{ historique.statut_arr }}</span></div><div class=\"col-sm-6\">Message :<span style=\"white-space: pre-line;\">\"{{ historique.comment }}\"</span></div></div></div></div></div><photo-list-projet project=\"main.ctx.project\" files-project=\"main.filesProject\" can-projet-update=\"main.canProjetUpdate\"></photo-list-projet></div><h3 class=\"col-sm-12 dashboard-h3 text-left\" id=\"btn-back-dashboard\"><a type=\"submit\" class=\"btn btn-default btn-dashboard\" href=\"#/dashboard\" ng-if=\"main.user.hasRole(\'dc\') || main.user.hasRole(\'agence\')\"><span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span> Retour au Tableau de bord</a> <a type=\"submit\" class=\"btn btn-default btn-dashboard\" ui-sref=\"gestion-projets({q_typeProjet:main.ctx.project.typeProjet})\" ng-if=\"main.user.hasRole(\'siege\')\"><span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span> Retour à la gestion des projets</a> <a type=\"submit\" class=\"btn btn-default btn-dashboard\" ng-click=\"main.backHistory()\" ng-if=\"main.user.hasRole(\'smhf\') || main.user.hasRole(\'mdv\')\"><span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span> Retour au Tableau de bord</a></h3><script type=\"text/ng-template\" id=\"sendMsg.html\"><div class=\"modal-body\" id=\"modal-body-msg\"> <div class=\"modal-header\"><h2>{{ vm.text }}</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"$close()\">OK</button> </div> </div></script><script type=\"text/ng-template\" id=\"newProject.html\"><div class=\"modal-body-new-msg\" id=\"modal-body-new-msg\"> <div class=\"modal-header\"><h2 class=\"text-center\">Vous avez bien enregistré votre projet, veuillez procéder à l\'envoi à l\'agence</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"$close()\">OK</button> </div> </div></script><script type=\"text/ng-template\" id=\"alertAllRetourAgence.html\"><div class=\"modal-body-alert-agence modal-body\" id=\"modal-body-alert-agence\"> <div class=\"modal-header\"><h2 class=\"text-center\">Attention, vous avez réalisé plus de deux aller-retours. Merci de veiller à limiter ce nombre.</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"$close()\">OK</button> </div> </div></script><script type=\"text/ng-template\" id=\"confirmationClonage.html\"><div class=\"modal-body-alert-agence modal-body\" id=\"modal-body-alert-agence\"> <div class=\"modal-header\"><h2 class=\"text-center\">Vous êtes sur le point de cloner ce projet, en un nouveau projet au statut Brouillon et il sera décompté du Quota. </h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"$close()\">Confirmer</button> </div> </div></script><script type=\"text/ng-template\" id=\"changeAgence.html\"><div class=\"modal-body-change-agence modal-body\" id=\"modal-body-change-agence\"> <div class=\"modal-header\"><h2 class=\"text-center\">RÉ-ATTRIBUER LE PROJET À UNE AGENCE.</h2></div> <div class=\"modal-body col-sm-12\" style=\"display: flex; flex-direction:column;\"> <div class=\"col-sm-12\" style=\"margin-bottom:10px\"> <span class=\"col-sm-3\">De l\'agence :</span> <span class=\"col-sm-6\"><b>{{vm.projet.agence}}</b></span> </div> <div class=\"col-sm-12\"> <span class=\"col-sm-3\">Vers l\'agence:</span> <select id=\"agence\" name=\"agence\" ng-options=\"agence.name[0].value as agence.name[0].value for agence in vm.agences\" ng-model=\"vm.newAgence\" class=\"form-control col-sm-6\" style=\"width: 50%\"> </select> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.validate()\">Confirmer</button> </div> </div></script><script type=\"text/ng-template\" id=\"selectPrinter.html\"><div class=\"modal-body-select-printer modal-body\" id=\"modal-body-select-printer\"> <div class=\"modal-header\"><h2 class=\"text-center\">IMPRIMEUR</h2></div> <div class=\"modal-body\"> <div class=\"form-group radio-custom\" style=\"display: flex;\"> <div class=\"text-vertical col-sm-11\"> <div class=\"radio\"> <input type=\"radio\" name=\"agenceIsPrinter\" value=\"oui\" id=\"agenceIsPrinter\" ng-model=\"vm.agenceIsPrinter\" required> <label for=\"agenceIsPrinter\" class=\"radio-label\"> L’agence est également l’imprimeur </label> </div> <div class=\"radio\"> <input type=\"radio\" name=\"agenceIsPrinter\" id=\"agenceIsNotPrinter\" ng-model=\"vm.agenceIsPrinter\" value=\"non\" required> <label for=\"agenceIsNotPrinter\" class=\"radio-label\"> Imprimeur autre que l’agence </label> </div> </div> </div> <div class=\"form-group\" ng-if=\"vm.agenceIsPrinter == \'non\'\" style=\"display: flex;\"> <label for=\"agence\" class=\"col-sm-3 control-label\">Imprimeur : </label> <div class=\"col-sm-5 control-group\"> <select id=\"imprimeur\" name=\"imprimeur\" ng-model=\"vm.project.imprimeur\" ng-options=\"imprimeur.name[0].value as imprimeur.name[0].value for imprimeur in vm.imprimeurs\" required class=\"form-control\" > </select> <span class=\"glyphicon glyphicon-triangle-bottom\"></span> </div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.validate()\" ng-disabled=\"vm.agenceIsPrinter == \'non\' && !vm.project.imprimeur\">Confirmer</button> </div> </div></script><script type=\"text/ng-template\" id=\"prixFormTemplate.html\"><div class=\"panel-body text-center\" ng-if=\"main.shouldDisplayFinalPrix()\"> <form name=\"prixFinalForm\" class=\"form-horizontal prixFinalForm\" name=\"livraison\" > <div class=\"form-group row\"> <label for=\"prixFinal\">Prix final facturé&#8239;:</label> <div> <input type=\"number\" min=\"0\" step=\".01\" class=\"form-control prixFinal\" id=\"prixFinal\" name=\"prixFinal\" ng-model=\"main.ctx.project.prixFinal\" ng-class=\"{true: \'error\'}[prixFinalForm.prixFinal.$invalid]\" /> <span>&euro;</span> </div> <button type=\"button\" class=\"btn btn-default\" ng-click=\"main.savePrixFinal(prixFinalForm)\" ng-disabled=\"prixFinalForm.$pristine || prixFinalForm.$invalid\" > <span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Sauvegarde </button> </div> <div uib-alert class=\"alert alert-fade\" type=\"{{main.alertPrixFinal.type}}\" ng-if=\"main.alertPrixFinal != undefined\" close=\"main.closePrixFinalAlert()\" >{{main.alertPrixFinal.msg}}</div> </form> </div></script></div>");
$templateCache.put("app/vae/vae-layout.html","<header-nav></header-nav><div class=\"container-fluid id-projet vae\"><div class=\"text-uppercase title-picto\" ng-if=\"!vae.$state.includes(vae.statePrefix+\'.recapitulatif\')\"><div class=\"container\"><h1><span class=\"picto-carte\" ng-class=\"vae.classPicto(vae.title)\"></span> <span class=\"denom\">{{vae.title}}</span></h1></div></div><div class=\"nav-bar-icon\" ng-if=\"!vae.$state.includes(vae.statePrefix+\'.recapitulatif\')\"><div class=\"container\"><ul class=\"nav nav-tabs nav-bar-icon text-center nav-vae\"><li ng-class=\"vae.classForItem(vae.statePrefix+\'.info-pdv\')\"><a href=\"\" ng-click=\"vae.go(vae.statePrefix+\'.info-pdv\')\"><span class=\"number\">1.</span><span>INFORMATION<br>CLIENT</span></a></li><li ng-class=\"vae.classForItem(vae.statePrefix+\'.creation\')\"><a href=\"\" ng-click=\"vae.go(vae.statePrefix+\'.creation.id-projet\')\"><span class=\"number\">2.</span><span>CREATION<br>DES BOARDS</span></a></li><li ng-class=\"vae.classForItem(vae.statePrefix+\'.contenu\')\"><a href=\"\" ng-click=\"vae.go(vae.statePrefix+\'.contenu\')\"><span class=\"number\">3.</span><span>CONTENU DES<br>BOARDS</span></a></li><li ng-class=\"vae.classForItem(vae.statePrefix+\'.pose\')\"><a href=\"\" ng-click=\"vae.go(vae.statePrefix+\'.pose\')\"><span class=\"number\">4.</span><span>POSE</span></a></li><li ng-class=\"vae.classForItem(vae.statePrefix+\'.livraison\')\"><a href=\"\" ng-click=\"vae.go(vae.statePrefix+\'.livraison\')\"><span class=\"number\">5.</span><span>LIVRAISON</span></a></li></ul></div></div><div ui-view=\"\" autoscroll=\"false\"></div></div>");
$templateCache.put("app/chr/chr-01-info-pdv/chr-01-info-pdv.html","<div class=\"container text-center info-pdv\"><form class=\"form-horizontal\" name=\"infopdv\"><fieldset class=\"col-sm-offset-1\"><span class=\"col-sm-offset-3 col-sm-9 help-block\">*Champs obligatoires</span><div class=\"form-group row\"><label for=\"noutlet\" class=\"col-sm-3 control-label\">N° OUTLET&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"noutlet\" class=\"form-control\" id=\"noutlet\" ng-model=\"main.ctx.project.pdv.nOutlet\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.noutlet.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.noutlet.$invalid\" class=\"error-msg col-sm-4\">Numéro d\'OUTLET obligatoire</div></div><div class=\"form-group row\"><div class=\"col-sm-5 col-sm-offset-3\"><button type=\"button\" class=\"btn btn-default sails-force\" ng-click=\"main.getPdvInfo()\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Remplir</button></div></div><div class=\"form-group row\"><label for=\"medaillepdv\" style=\"padding-left: 0;\" class=\"col-sm-3 control-label\">Médaille du PDV :</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"medaillepdv\" name=\"medaillepdv\" ng-model=\"main.ctx.project.pdv.medaillePDV\" ng-disabled=\"1\"></div></div><div class=\"form-group row\"><label for=\"namepdv\" style=\"padding-left: 0;\" class=\"col-sm-3 control-label\">Nom du point de vente&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"namepdv\" name=\"namepdv\" ng-model=\"main.ctx.project.pdv.nomPDV\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.namepdv.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.namepdv.$invalid\" class=\"error-msg col-sm-4\">Nom du point de vente obligatoire</div></div><div class=\"form-group row\"><label for=\"adressepdv\" class=\"col-sm-3 control-label\">Adresse&#8239;*&#8239;:</label><div class=\"col-sm-5\"><textarea class=\"form-control\" rows=\"3\" ng-model=\"main.ctx.project.pdv.adresse\" name=\"adressepdv\" id=\"adressepdv\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.adressepdv.$invalid]\"></textarea></div><div ng-if=\"main.submitted && infopdv.adressepdv.$invalid\" class=\"error-msg col-sm-4\">Adresse du point de vente obligatoire</div></div><div class=\"form-group row\"><label for=\"codepostal\" class=\"col-sm-3 control-label\">CODE POSTAL&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"codepostal\" class=\"form-control\" id=\"codepostal\" ng-pattern=\"/^(\\d{5}-\\d{4}|\\d{5})$/\" max=\"99999\" ng-model=\"main.ctx.project.pdv.codePostal\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.codepostal.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.codepostal.$invalid && !infopdv.codepostal.$error.pattern\" class=\"error-msg col-sm-4\">Code postal obligatoire</div><div ng-if=\"main.submitted && infopdv.codepostal.$error.pattern\" class=\"error-msg col-sm-4\">Code postal incorrect</div></div><div class=\"form-group row\"><label for=\"ville\" class=\"col-sm-3 control-label\">VILLE&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" name=\"ville\" class=\"form-control\" id=\"ville\" ng-model=\"main.ctx.project.pdv.ville\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.ville.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.ville.$invalid\" class=\"error-msg col-sm-4\">Ville obligatoire</div></div><div class=\"form-group row\"><label for=\"telephone\" class=\"col-sm-3 control-label\">TéLéPHONE&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"telephone\" class=\"form-control\" id=\"telephone\" ng-pattern=\"/^0\\d(\\s|-)?(\\d{2}(\\s|-)?){4}$/\" ng-model=\"main.ctx.project.pdv.telephone\" required=\"\" placeholder=\"ex: 0652413698\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.telephone.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.telephone.$invalid && infopdv.telephone.$error.required\" class=\"error-msg col-sm-4\">Téléphone obligatoire</div><div ng-if=\"main.submitted && infopdv.telephone.$error.pattern\" class=\"error-msg col-sm-4\">Téléphone incorrect</div></div><div class=\"form-group row\"><label for=\"nsiret\" class=\"col-sm-3 control-label\">N° SIRET&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"nsiret\" class=\"form-control\" id=\"nsiret\" ng-pattern=\"/^[0-9]{14}$/\" ng-model=\"main.ctx.project.pdv.nSiret\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.nsiret.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.nsiret.$invalid && infopdv.nsiret.$error.required\" class=\"error-msg col-sm-4\">N°SIRET obligatoire</div><div ng-if=\"main.submitted && infopdv.nsiret.$error.pattern\" class=\"error-msg col-sm-4\">N°SIRET incorrect: 14 chiffres</div></div><div class=\"form-group row\"><label for=\"rcs\" class=\"col-sm-3 control-label\">RCS&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"rcs\" class=\"form-control\" id=\"rcs\" ng-model=\"main.ctx.project.pdv.rcs\"></div></div><div class=\"form-group row\"><label for=\"nomclient\" class=\"col-sm-3 control-label\">NOM DU CLIENT&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" name=\"nomclient\" class=\"form-control\" id=\"nomclient\" ng-model=\"main.ctx.project.pdv.nomClient\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.nomclient.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.nomclient.$invalid\" class=\"error-msg col-sm-4\">Nom du Client obligatoire</div></div><div class=\"form-group row\"><label for=\"telclient\" class=\"col-sm-3 control-label\">TéLéPHONE DU CLIENT&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"telclient\" class=\"form-control\" id=\"telclient\" ng-pattern=\"/^0\\d(\\s|-)?(\\d{2}(\\s|-)?){4}$/\" ng-model=\"main.ctx.project.pdv.telephoneCLient\" required=\"\" placeholder=\"ex: 0652413698\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.telclient.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.telclient.$invalid && infopdv.telclient.$error.required\" class=\"error-msg col-sm-4\">Téléphone Client obligatoire</div><div ng-if=\"main.submitted && infopdv.telclient.$error.pattern\" class=\"error-msg col-sm-4\">Téléphone incorrect</div></div><div class=\"form-group row\"><label for=\"emailclient\" class=\"col-sm-3 control-label\">EMAIL DU CLIENT&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"email\" name=\"emailclient\" class=\"form-control\" id=\"emailclient\" ng-model=\"main.ctx.project.pdv.emailCLient\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.emailclient.$invalid]\"> <span class=\"help-block\">Attention, vous devez fournir un email valide.<br>La carte sera envoyée à votre client sur cette adresse mail afin d\'obtenir sa validation.</span></div><div ng-if=\"main.submitted && infopdv.emailclient.$invalid && infopdv.emailclient.$error.required\" class=\"error-msg col-sm-4\">Email client obligatoire</div><div ng-if=\"main.submitted && infopdv.emailclient.$error.email\" class=\"error-msg col-sm-4\">Email invalid</div></div></fieldset><div><a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(infopdv)\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(infopdv)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form></div>");
$templateCache.put("app/chr/chr-02-creation/chr-02-creation-layout.html","<div class=\"container id-projet text-center wrapp\"><ul class=\"nav nav-tabs sub-menu text-center\"><li class=\"col-sm-4 disabled\" ng-class=\"{active: chr.$state.is(\'chr.creation.id_projet\')}\"><a disabled=\"\">NOM DU PROJET</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: chr.$state.is(\'chr.creation.theme\')}\"><a disabled=\"\">THEME GRAPHIQUE</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: chr.$state.is(\'chr.creation.format\')}\"><a disabled=\"\">FORMAT</a></li></ul><div ui-view=\"\" autoscroll=\"true\"></div></div>");
$templateCache.put("app/chr/chr-03-contenu/chr-03-contenu-layout.html","<div class=\"container wrapp\"><ul class=\"nav nav-tabs sub-menu text-center\"><li class=\"col-sm-4 disabled\" ng-class=\"{active: chr.$state.is(\'chr.contenu.gamme\')}\"><a disabled=\"\">GAMME CCEP</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: chr.$state.is(\'chr.contenu.formules\')}\"><a disabled=\"\">FORMULE</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: chr.$state.is(\'chr.contenu.cocktails\')}\"><a disabled=\"\">COCKTAILS</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: chr.$state.is(\'chr.contenu.illustrations\')}\"><a disabled=\"\">ILLUSTRATION</a></li></ul><div ui-view=\"\" autoscroll=\"true\"></div></div>");
$templateCache.put("app/chr/chr-04-photo/chr-04-photo.html","<alert-message></alert-message><div class=\"container text-center photo-carte\"><h2>Veuillez renseigner le contenu de la carte à saisir en annotant les modifications à apporter.</h2><form class=\"form-horizontal-photo row\" name=\"photocarte\" novalidate=\"\"><fieldset class=\"col-sm-12\"><div class=\"form-group\"><label for=\"fichiertexte\" class=\"col-sm-8 col-sm-offset-2 control-label label-fichier-texte\">Le client dispose-t-il d\'un fichier texte (Word, Powerpoint, Excel) contenant les tarifs ?</label><div class=\"radio-custom col-sm-4 col-sm-offset-4\"><div class=\"text-left\" ng-class=\"{true: \'error\'}[main.submitted && photocarte.fichiertexte.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"fichiertexte\" value=\"oui\" ng-model=\"main.ctx.project.contenu_fichier_texte.hasFichierTexte\" ng-class=\"{true: \'error\'}[main.submitted && photocarte.fichiertexte.$invalid]\" required=\"\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"fichiertexte\" ng-model=\"main.ctx.project.contenu_fichier_texte.hasFichierTexte\" value=\"non\" ng-class=\"{true: \'error\'}[main.submitted && photocarte.fichiertexte.$invalid]\" required=\"\"> <label>NON</label></div></div></div></div></fieldset><fieldset ng-if=\"main.ctx.project.contenu_fichier_texte.hasFichierTexte == \'oui\'\" class=\"col-sm-12\" ng-class=\"{true: \'error\'}[main.submitted && photocarte.fichiertexte.$invalid]\"><div class=\"col-sm-12\"><span class=\"col-sm-12 help-block\">Ce formulaire envoie par mail, au client, un lien à usage unique lui permettant d\'associer au projet un fichier contenant les tarifs de la carte.<br>Ce fichier doit être dans un format texte exploitable par l\'agence qui réalisera la carte : .doc, .ppt, .xls.</span><div class=\"form-horizontal row\"><label for=\"emailDestinataire\" class=\"col-sm-4 control-label\">Adressse email du destinataire :</label><div class=\"col-sm-5\"><input type=\"email\" class=\"form-control\" id=\"emailDestinataire\" name=\"emailDestinataire\" value=\"main.ctx.project.pdv.emailCLient\" ng-model=\"main.ctx.project.contenu_fichier_texte.emailCLient\" ng-class=\"{true: \'error\'}[main.submitted && photocarte.emailDestinataire.$invalid]\" required=\"\" placeholder=\"Email du destinataire\"></div><div ng-if=\"main.submitted && photocarte.emailDestinataire.$invalid && photocarte.emailDestinataire.$error.required\" class=\"error-msg align-middle\">Email destinataire obligatoire</div><div ng-if=\"main.submitted && photocarte.emailDestinataire.$error.email\" class=\"error-msg align-middle\">Email invalid</div></div></div><button class=\"btn btn-default btn-fichier-texte\" ng-click=\"main.sendEmail(photocarte)\">Envoyer</button></fieldset><fieldset class=\"col-sm-12 list-photo-added\" ng-if=\"main.ctx.project.contenu_fichier_texte.hasFichierTexte == \'non\'\"><h4>Liste des photos déjà prises:</h4><ul class=\"list-group\"><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"(key,photo) in main.ctx.project.contenu\"><uib-accordion-heading>{{photo.photo}}<i class=\"pull-right glyphicon glyphicon-chevron-down\"></i></uib-accordion-heading><table class=\"table\"><tr><td>Modifications: {{ photo.modificationCarte }}</td><td class=\"photo-picto-group\"><a class=\"photo-pencil\" ng-click=\"main.modifCarte(photo)\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></a> <a class=\"photo-comment\" ng-click=\"main.annotate(photo,key)\"><span class=\"glyphicon glyphicon-comment\" aria-hidden=\"true\"></span></a></td></tr><tr ng-if=\"photo.anno.length > 0\"><td><p>Post-It:</p><ol><li ng-repeat=\"(key,postit) in photo.anno\">{{ postit.text }}</li></ol></td><td></td></tr></table></div></uib-accordion></ul></fieldset><fieldset class=\"panel col-sm-12\" ng-repeat=\"(key,item) in main.uploader.queue | filter:{myplv_file_type: main.file_type}\"><div class=\"well index--{{$index}}\"><div class=\"text-right\"><span ng-click=\"main.deletePhoto($index, item)\" class=\"glyphicon glyphicon-trash\"></span></div><div class=\"form-group\"><label ng-bind=\"item.file.name\" class=\"col-sm-6\"></label><div class=\"col-sm-6\"><input type=\"hidden\" ng-init=\"main.ctx.project.contenu[item.file.firtsName].photo = item.file.name\" value=\"{{item.file.name}}\" readonly=\"\"></div><p ng-show=\"main.uploader.isHTML5\" nowrap=\"\" class=\"col-sm-3\">Taille : {{ item.file.size / 1024 / 1024|number:2 }} MB</p></div><div class=\"form-group\"><label for=\"modification\" class=\"col-sm-3 control-label\">Modification à apporter&#8239;:</label><div class=\"col-sm-9\"><textarea class=\"form-control\" id=\"modification\" name=\"modification\" ng-model=\"main.ctx.project.contenu[item.file.firtsName].modificationCarte\"></textarea></div></div></div></fieldset><fieldset class=\"panel col-sm-12\" ng-if=\"main.ctx.project.contenu_fichier_texte.hasFichierTexte == \'non\'\"><span class=\"help-block\">Merci de prendre une photo de bonne qualité et de vérifier la lisibilité du texte.</span><div class=\"photo-action\"><div class=\"form-group\"><label for=\"photo\" class=\"col-sm-3 control-label\">Ajouter une photo&#8239;:</label><div class=\"\"><input type=\"file\" accept=\"application/pdf,image/*\" class=\"form-control\" id=\"photo\" name=\"photo\" nv-file-select=\"\" uploader=\"main.uploader\" options=\"{file_type:\'photo_carte\'}\" sn-model-file=\"main.file\" multiple=\"\"></div></div></div></fieldset><progress-bar-upload ng-show=\"main.uploader.queue.length\" uploader=\"main.uploader\" class=\"col-sm-12\"></progress-bar-upload><div class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"chr.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(photocarte)\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(photocarte)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form></div><script type=\"text/ng-template\" id=\"confirmDelePhoto.html\"><div class=\"modal-body alert-delete-photo\" id=\"modal-body-alert-delete-photo\"> <div class=\"modal-header\"><h2 class=\"text-center\">Voulez vraiment supprimer ce fichier ?</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"$close()\">OUI</button> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">ANNULER</button> </div> </div></script><script type=\"text/ng-template\" id=\"modifPhoto.html\"><div class=\"modal-body alert-modif-photo\" id=\"modal-body-alert-modif-photo\"> <div class=\"modal-header\"><h2 class=\"text-center\">Modification de la carte</h2></div> <div class=\"modal-body\"> <textarea name=\"modifphoto\" id=\"\" cols=\"30\" rows=\"10\" ng-model=\"vm.photoModif\"></textarea> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">ANNULER</button> <button class=\"btn btn-default\" ng-click=\"vm.validate()\">VALIDER</button> </div> </div></script>");
$templateCache.put("app/chr/chr-05-autres-infos/chr-05-autres-infos.html","<alert-message></alert-message><div class=\"container contenu-info-plus-carte text-center\"><h2 class=\"text-left\">INFORMATIONS SUPPLÉMENTAIRES</h2><form class=\"form-horizontal row\" name=\"infopluscarte\" id=\"errorAutresInfos\"><fieldset class=\"col-sm-12\"><div class=\"form-group\"><label for=\"nompdv\" class=\"col-sm-3 col-sm-offset-1 control-label\">Nom du point de vente&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nompdv\" name=\"nompdv\" ng-model=\"main.ctx.project.autresInfos.nomPdv\" ng-class=\"{true: \'error\'}[main.submitted && infopluscarte.nompdv.$invalid]\" required=\"\" placeholder=\"Tel qu\'il doit apparaître sur le carte\"></div><div ng-if=\"main.submitted && infopluscarte.nompdv.$invalid\" class=\"error-msg text-left\">Nom du point de vente obligatoire</div></div><div class=\"form-group form-logo\"><label class=\"col-sm-3 col-sm-offset-1 control-label\">Logo à intégrer &#8239;:</label><div class=\"radio-custom col-sm-5\"><div class=\"text-left\" ng-class=\"{true: \'error\'}[main.submitted && infopluscarte.logoclient.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"logoclient\" value=\"oui\" ng-model=\"main.ctx.project.autresInfos.logoClient\" ng-class=\"{true: \'error\'}[main.submitted && infopluscarte.logoclient.$invalid]\" required=\"\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"logoclient\" ng-model=\"main.ctx.project.autresInfos.logoClient\" value=\"non\" ng-class=\"{true: \'error\'}[main.submitted && infopluscarte.logoclient.$invalid]\" required=\"\"> <label>NON</label></div></div></div><span class=\"help-block\">Un email sera envoyé à votre client via l\'adresse mail renseignée dans le bon de commande.<br>Le client devra envoyer son logo en format vectoriel (&#8239;.ai ou .eps&#8239;) ou en jpg en format 300 DPI.</span></div><button class=\"btn btn-default btn-fichier-texte\" ng-click=\"main.sendEmail(infopluscarte)\" ng-if=\"main.ctx.project.autresInfos.logoClient == \'oui\'\">Envoyer</button></fieldset><fieldset class=\"col-sm-12\"><div class=\"form-group\"><label for=\"telephoneDC\" class=\"col-sm-3 col-sm-offset-1 control-label\">Téléphone du DC&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"telephoneDC\" name=\"telephoneDC\" ng-model=\"main.ctx.project.autresInfos.telephoneDC\"></div></div><div class=\"form-group\"><label for=\"siteinternet\" class=\"col-sm-3 col-sm-offset-1 control-label\">Site Internet&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"siteinternet\" name=\"siteinternet\" ng-model=\"main.ctx.project.autresInfos.siteInternet\"></div></div><div class=\"form-group\"><label for=\"pagefacebook\" class=\"col-sm-3 col-sm-offset-1 control-label\">Page Facebook&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"pagefacebook\" name=\"pagefacebook\" ng-model=\"main.ctx.project.autresInfos.pageFacebook\"></div></div><div class=\"form-group horaires\"><label for=\"heureouverture\" class=\"col-sm-3 col-sm-offset-1 control-label\">Horaire d\'ouverture&#8239;:</label><div class=\"col-sm-5\"><input type=\"time\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" id=\"heureouverture\" name=\"heureouverture\" ng-model=\"main.ctx.project.autresInfos.heureouverture\" aria-invalid=\"false\"> <label for=\"heurefermeture\" class=\"control-label\">Fermeture :</label> <input type=\"time\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" id=\"heurefermeture\" name=\"heurefermeture\" ng-model=\"main.ctx.project.autresInfos.heurefermeture\" aria-invalid=\"false\"></div></div><div class=\"form-group\"><label for=\"mttmincb\" class=\"col-sm-3 col-sm-offset-1 control-label\">Montant minimum CB&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"mttmincb\" class=\"form-control\" id=\"mttmincb\" placeholder=\"En €\" ng-model=\"main.ctx.project.autresInfos.mttMinCB\"></div></div><div class=\"form-group\"><label for=\"autreinfo\" class=\"col-sm-3 col-sm-offset-1 control-label\">Autres informations&#8239;:</label><div class=\"col-sm-5\"><textarea class=\"form-control\" rows=\"3\" name=\"autreinfo\" id=\"autreinfo\" ng-model=\"main.ctx.project.autresInfos.autreInfo\"></textarea></div></div></fieldset><div class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"chr.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(infopluscarte)\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(infopluscarte)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form></div>");
$templateCache.put("app/chr/chr-06-livraison/chr-06-livraison.html","<div class=\"container text-center livraison\"><form class=\"form-horizontal\" name=\"validation\"><fieldset class=\"col-sm-12 group-qrcode\" id=\"errorValidation\"><h2>Version téléchargeable avec QR code</h2><div class=\"form-group radio-custom\"><label class=\"col-sm-3 control-label\"></label><div class=\"text-left col-sm-4 radio-qrcode\" ng-class=\"{true: \'error\'}[main.submitted && validation.qrcode.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"qrcode\" value=\"oui\" ng-model=\"main.ctx.project.infocarte.qrcode\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && validation.qrcode.$invalid]\" ng-change=\"main.changeQrCode(\'oui\')\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"qrcode\" ng-model=\"main.ctx.project.infocarte.qrcode\" value=\"non\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && validation.qrcode.$invalid]\" ng-change=\"main.changeQrCode(\'non\')\"> <label>NON</label></div></div><div ng-if=\"main.submitted && validation.qrcode.$invalid\" class=\"error-msg\">Veuillez choisir une option.</div></div></fieldset><div><hr><fieldset class=\"col-sm-12 group-qrcode\"><h2>Impression</h2><div class=\"form-group impression\"><div class=\"col-sm-12\" ng-if=\"main.qrCodeEnabled()\"><select name=\"impression\" class=\"form-control impression\" id=\"impression\" ng-model=\"main.ctx.project.infocarte.impression\" ng-class=\"{true: \'error\'}[main.submitted && validation.nbExemplaire.$invalid]\" required=\"\"><option value=\"\"></option><option ng-repeat=\"item in main.impressionList\" value=\"{{ item.value }}\">{{ item.label }}</option></select></div><div class=\"col-sm-12\" ng-if=\"!main.qrCodeEnabled()\"><select name=\"impression\" class=\"form-control impression\" id=\"impression\" ng-model=\"main.ctx.project.infocarte.impression\" ng-class=\"{true: \'error\'}[main.submitted && validation.nbExemplaire.$invalid]\" required=\"\"><option value=\"\"></option><option ng-repeat=\"item in main.impressionListNoQrCode\" value=\"{{ item.value }}\">{{ item.label }}</option></select></div><div ng-if=\"main.submitted && validation.impression.$invalid\" class=\"error-msg col-sm-4\">Choisir l\'impression</div></div></fieldset><div ng-if=\"main.isImpressionMenu()\">Le menu extérieur est un support créé après validation du BAT de la carte. Il n’y aura pas d’aller-retour de validation pour ce support car il s’agit d’une déclinaison recto uniquement de la carte validée ne comprenant que la partie nourriture & formules + frise CCEP, affichée à l’extérieur de l’établissement pour consultation par les consommateurs.</div></div><div ng-if=\"main.isImpressionCarte() || main.isImpressionQrCode() || main.isImpressionMenu()\"><hr><fieldset class=\"col-sm-12 exemplaires-carte\"><h2>Nombre d\'exemplaire à imprimer</h2><div class=\"form-group exemplaire\" ng-if=\"main.isImpressionCarte()\"><label class=\"col-sm-5\">Nb exemplaire Carte&#8239;:</label><div class=\"col-sm-3\"><select name=\"nbExemplaire\" class=\"form-control nbExemplaire\" id=\"nbExemplaire\" ng-model=\"main.ctx.project.infocarte.nombreExemplaire\" ng-class=\"{true: \'error\'}[main.submitted && validation.nbExemplaire.$invalid]\" required=\"\"><option value=\"\"></option><option ng-repeat=\"item in main.nbrCarte\" value=\"{{ item }}\">{{ item }}</option></select></div><div ng-if=\"main.submitted && validation.nbExemplaire.$invalid\" class=\"error-msg col-sm-4\">Choisir le nombre d\'exemplaire de carte</div></div><div class=\"form-group exemplaire\" ng-if=\"main.isImpressionMenu()\"><label class=\"col-sm-5\">Nb exemplaire menu extérieur&#8239;:</label><div class=\"col-sm-3\"><select name=\"nbExemplaireMenu\" class=\"form-control nbExemplaire\" id=\"nbExemplaireMenu\" ng-model=\"main.ctx.project.infocarte.nombreExemplaireMenu\" ng-class=\"{true: \'error\'}[main.submitted && validation.nbExemplaireMenu.$invalid]\" required=\"\"><option value=\"\"></option><option ng-repeat=\"item in main.nbrCarteMenu\" value=\"{{ item }}\">{{ item }}</option></select></div><div ng-if=\"main.submitted && validation.nbExemplaireMenu.$invalid\" class=\"error-msg col-sm-4\">Choisir le nombre d\'exemplaire menu extérieur</div></div><div class=\"form-group col-sm-12\" ng-if=\"main.isImpressionMenu()\"><label class=\"col-sm-5\">Orientation menu extérieur&#8239;:</label><div class=\"form-group radio-custom\"><label class=\"col-sm-3 control-label\"></label><div class=\"text-left col-sm-4 radio-qrcode\" ng-class=\"{true: \'error\'}[main.submitted && validation.orientationMenu.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"orientationMenu\" value=\"horizontal\" ng-model=\"main.ctx.project.infocarte.orientationMenu\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && validation.orientationMenu.$invalid]\"> <label>Horizontal</label></div><div class=\"radio\"><input type=\"radio\" name=\"orientationMenu\" ng-model=\"main.ctx.project.infocarte.orientationMenu\" value=\"vertical\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && validation.orientationMenu.$invalid]\"> <label>Vertical</label></div></div><div ng-if=\"main.submitted && validation.orientationMenu.$invalid\" class=\"error-msg\">Veuillez choisir une option.</div></div></div><div class=\"form-group exemplaire\" ng-if=\"main.isImpressionQrCode()\"><label class=\"col-sm-5\">Nb exemplaire QrCode&#8239;:</label><div class=\"col-sm-3\"><select name=\"nbExemplaireQrCode\" class=\"form-control nbExemplaire\" id=\"nbExemplaireQrCode\" ng-model=\"main.ctx.project.infocarte.nombreExemplaireQrCode\" ng-class=\"{true: \'error\'}[main.submitted && validation.nbExemplaireQrCode.$invalid]\" required=\"\"><option value=\"\"></option><option ng-repeat=\"item in main.nbrCarteQrCode\" value=\"{{ item }}\">{{ item }}</option></select></div><div ng-if=\"main.submitted && validation.nbExemplaireQrCode.$invalid\" class=\"error-msg col-sm-4\">Choisir le nombre d\'exemplaire de QrCode</div></div></fieldset></div><div ng-if=\"main.qrCodeEnabled() && main.isImpressionQrCode()\"><fieldset class=\"col-sm-12 modeles-qrcode\"><h2>Modèle d\'impression du QrCode</h2><div class=\"form-group row modeles-qrcode\"><label class=\"col-sm-5\">Modèle d\'impression des vignettes&#8239;:</label><div class=\"modeles-qrcode-list\"><div class=\"col-sm-6\" ng-repeat=\"(key, modeleqrcodesticker) in main.modelesqrcodestickers\" ng-class=\"{true: \'error\'}[main.submitted && validation.modeleqrcodesticker.$invalid]\"><div class=\"checkbox\"><input type=\"radio\" name=\"modeleqrcodesticker\" value=\"{{modeleqrcodesticker.name }}\" id=\"modeleqrcodesticker{{$index}}\" ng-model=\"main.ctx.project.infocarte.modeleQrCodeSticker.name\" ng-change=\"main.changeModeleQrCodeSticker(modeleqrcodesticker)\" required=\"\"> <label for=\"modeleqrcodesticker\"><div class=\"fond-img\"><img ng-src=\"{{ modeleqrcodesticker.field_modele_qrcode_image }}\" alt=\"{{ modeleqrcodesticker.name }}\" class=\"row\"></div><span class=\"modeles-qrcode-description\"><span class=\"name-support modele-qrcode-name\">{{ modeleqrcodesticker.name }}</span> <span class=\"custom-check\"></span></span></label> <input ng-model=\"main.ctx.project.infocarte.modeleQrCodeSticker.image\" type=\"text\" value=\"{{ modeleqrcodesticker.field_modele_qrcode_image }}\" style=\"visibility: hidden; height: 0; width: 0;\"></div></div></div><div ng-if=\"main.submitted && validation.modeleqrcodesticker.$invalid\" class=\"error-msg col-sm-4\">Veuillez choisir un modèles d\'impression.</div></div></fieldset></div><div ng-if=\"main.isImpressionCarte() || main.isImpressionQrCode()\"><hr><fieldset class=\"col-sm-12 group-adresse-livraison\"><h2>Adresse de livraison</h2><div class=\"form-group radio-custom\"><label class=\"col-sm-4 control-label\">Idem au bon de commande&#8239;:</label><div class=\"text-left col-sm-4 radio-livraison\" ng-class=\"{true: \'error\'}[main.submitted && validation.idemboncommande.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"idemboncommande\" value=\"oui\" ng-model=\"main.ctx.project.pdv.adresseIdemCommande\" ng-change=\"main.removeLivraison()\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && validation.idemboncommande.$invalid]\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"idemboncommande\" ng-model=\"main.ctx.project.pdv.adresseIdemCommande\" value=\"non\" ng-change=\"main.addLivraison()\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && validation.idemboncommande.$invalid]\"> <label>NON</label></div></div><div ng-if=\"main.submitted && validation.idemboncommande.$invalid\" class=\"error-msg col-sm-4\">Veuillez choisir une option.</div></div></fieldset><fieldset ng-if=\"main.ctx.project.pdv.adresseIdemCommande == \'oui\'\" class=\"col-sm-12 form-adresse-livraison-recap\"><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Nom du point de vente&#8239;:</label><div class=\"col-sm-8 text-left\"><span>{{ main.ctx.project.pdv.nomPDV }}</span></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Adresse&#8239;:</label><div class=\"col-sm-8 text-left\"><span>{{ main.ctx.project.pdv.adresse }}</span></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Code Postal&#8239;:</label><div class=\"col-sm-8 text-left\"><span>{{ main.ctx.project.pdv.codePostal }}</span></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Ville&#8239;:</label><div class=\"col-sm-8 text-left\"><span>{{ main.ctx.project.pdv.ville }}</span></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Nom&#8239;:</label><div class=\"col-sm-8 text-left\"><span>{{ main.ctx.project.pdv.nomClient }}</span></div></div><div class=\"form-group\"><label class=\"col-sm-4 control-label\">Téléphone&#8239;:</label><div class=\"col-sm-8 text-left\"><span>{{ main.ctx.project.pdv.telephone }}</span></div></div></fieldset><fieldset ng-if=\"main.ctx.project.pdv.adresseIdemCommande == \'non\'\" class=\"col-sm-12 form-adresse-livraison\"><div class=\"form-group\"><label class=\"text-left label-adresse-livraison\">ENTRER l\'ADRESSE DE LIVRAISON&#8239;:</label><div class=\"form-group nom-point-vente-livraison\"><label for=\"nompdv\" class=\"col-sm-4 control-label\">NOM DU POINT DE VENTE&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nompdv\" name=\"nompdv\" ng-model=\"main.ctx.project.pdv.adresseLivraison.nomPDV\" ng-class=\"{true: \'error\'}[main.submitted && validation.nompdv.$invalid]\" required=\"\"></div><div ng-if=\"main.submitted && validation.nompdv.$invalid\" class=\"text-left col-sm-3 error-msg\">Point de vente obligatoire</div></div><div class=\"form-group adresse-livraison\"><label for=\"adresse\" class=\"col-sm-4 control-label\">ADRESSE&#8239;:</label><div class=\"col-sm-5\"><textarea type=\"text\" class=\"form-control\" id=\"adresse\" name=\"adresse\" ng-model=\"main.ctx.project.pdv.adresseLivraison.adresse\" ng-class=\"{true: \'error\'}[main.submitted && validation.adresse.$invalid]\" required=\"\"></textarea></div><div ng-if=\"main.submitted && validation.adresse.$invalid\" class=\"text-left col-sm-3 error-msg\">Adresse obligatoire</div></div><div class=\"form-group code-postal-livraison\"><label for=\"codepostale\" class=\"col-sm-4 control-label\">CODE POSTAL&#8239;:</label><div class=\"col-sm-5\"><input type=\"number\" class=\"form-control\" id=\"codepostale\" name=\"codepostale\" ng-pattern=\"/^(\\d{5}-\\d{4}|\\d{5})$/\" max=\"99999\" ng-model=\"main.ctx.project.pdv.adresseLivraison.codePostale\" ng-class=\"{true: \'error\'}[main.submitted && validation.codepostale.$invalid]\" required=\"\"></div><div ng-if=\"main.submitted && validation.codepostale.$invalid && !validation.codepostale.$error.pattern\" class=\"text-left col-sm-3 error-msg\">Code Postal obligatoire</div><div ng-if=\"main.submitted && validation.codepostale.$error.pattern\" class=\"text-left col-sm-3 error-msg\">Code Postal incorrect</div></div><div class=\"form-group ville-livraison\"><label for=\"ville\" class=\"col-sm-4 control-label\">VILLE&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" name=\"ville\" id=\"ville\" class=\"form-control\" ng-model=\"main.ctx.project.pdv.adresseLivraison.ville\" ng-class=\"{true: \'error\'}[main.submitted && validation.ville.$invalid]\" required=\"\"></div><div ng-if=\"main.submitted && validation.ville.$invalid\" class=\"text-left col-sm-3 error-msg\">Ville obligatoire</div></div><div class=\"form-group nom-gerant-livraison\"><label for=\"gerant\" class=\"col-sm-4 control-label\">NOM DU GéRANT&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"gerant\" name=\"gerant\" ng-model=\"main.ctx.project.pdv.adresseLivraison.gerant\" ng-class=\"{true: \'error\'}[main.submitted && validation.gerant.$invalid]\" required=\"\"></div><div ng-if=\"main.submitted && validation.gerant.$invalid\" class=\"text-left col-sm-3 error-msg\">Nom Gérant obligatoire</div></div><div class=\"form-group telephone-livraison\"><label for=\"telephone\" class=\"col-sm-4 control-label\">TéLéPHONE&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" class=\"form-control\" id=\"telephone\" name=\"telephone\" ng-model=\"main.ctx.project.pdv.adresseLivraison.telephone\" ng-class=\"{true: \'error\'}[main.submitted && validation.telephone.$invalid]\" required=\"\"></div><div ng-if=\"main.submitted && validation.telephone.$invalid\" class=\"text-left col-sm-3 error-msg\">Téléphone obligatoire</div></div></div></fieldset></div><div class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"chr.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(validation)\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(validation)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Terminer</a></div></form></div>");
$templateCache.put("app/chr/chr-07-recapitulatif/chr-07-recapitulatif.html","<div class=\"container-fluid recapitulatif\"><div class=\"container\"><div id=\"alert-message\"><div uib-alert=\"\" class=\"alert alert-fade\" type=\"{{main.alert.type}}\" close=\"main.closeAlert()\" ng-if=\"main.alert.msg != undefined\">{{main.alert.msg}}</div></div><h2 ng-if=\"!chr.isUpdate()\">Votre commande est terminée.<br><span>Veuillez relire votre bon de commande avec attention et vous assurer que :<br>- Les informations de votre client (nom, établissement, coordonnées, etc.) sont correctes<br>- Les informations de la carte correspondent au choix de mon client (thème graphique, format, nombre d’exemplaires à imprimer)<br>- Les contenus de la carte (boissons, tarifs, formules, etc.) sont conformes</span></h2><div class=\"container-project\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>1.</span>INFORMATIONS CLIENT <a ui-sref=\"chr.info-pdv({id: main.ctx.project._id.$oid})\" style=\"float: right;\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit text-right\" aria-hidden=\"true\"></span></a></div><div class=\"panel-body\"><p>Nom du point de vente : <span>{{ main.ctx.project.pdv.nomPDV }}</span></p><p>Adresse : <span>{{ main.ctx.project.pdv.adresse }}</span></p><p>CP : <span>{{ main.ctx.project.pdv.codePostal }}</span></p><p>Ville : <span>{{ main.ctx.project.pdv.ville }}</span></p><p>Téléphone : <span>{{ main.ctx.project.pdv.telephone }}</span></p><p>N°Siret : <span>{{ main.ctx.project.pdv.nSiret }}</span></p><p>RCS : <span>{{ main.ctx.project.pdv.rcs }}</span></p><p>Nom du Gérant: <span>{{ main.ctx.project.pdv.nomClient }}</span></p><p>Téléphone du Gérant: <span>{{ main.ctx.project.pdv.telephoneCLient }}</span></p><p>Email du Gérant: <span>{{ main.ctx.project.pdv.emailCLient }}</span></p></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>2.</span>Création de la carte <a ui-sref=\"chr.creation.id_projet({id: main.ctx.project._id.$oid})\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a></div><div class=\"panel-body\"><div class=\"\"><p>Nom du Projet: <span>{{ main.ctx.project.idprojet.nameProjet }}</span></p><p>Thème graphique choisi : <span>{{ main.ctx.project.infocarte.template.name }}</span></p><p>Format choisi : <span>{{ main.ctx.project.infocarte.format.name }} - {{ main.ctx.project.infocarte.format.media_format }}</span></p><p>Matière choisie : <span>{{ main.ctx.project.infocarte.matiere.name }}</span></p></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>3.</span>Contenu de la carte</div><div class=\"panel-body\"><div class=\"\"><div class=\"row\"><a class=\"edit-data\" ui-sref=\"chr.contenu.gamme({id: main.ctx.project._id.$oid})\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a><p>Boissons CCE présentes sur la carte :</p><span style=\"color:#DE0B1C\"><div class=\"boisson-cce\"><span ng-repeat=\"(key,boissons) in main.ctx.project.infocarte.boissons\" class=\"col-sm-4\"><p>{{ key }}</p><span ng-repeat=\"boisson in boissons\">- {{ boisson.name }} {{ boisson.field_gamme_format_boissons }}<br></span></span></div></span></div><hr><div class=\"row\"><a class=\"edit-data\" ui-sref=\"chr.contenu.formules({id: main.ctx.project._id.$oid})\" ng-if=\"main.allowedUpdate()\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a><p>Formules : <span ng-if=\"main.ctx.project.infopdv.noFormule\">{{main.ctx.project.infopdv.noFormule}}</span></p><div class=\"formule\" ng-repeat=\"formule in main.ctx.project.infopdv.formules\"><p><span>{{ formule.nomFormule }} -</span><pre>{{ formule.compoFormule }} - </pre><span>{{ formule.tarifFormule }} €</span></p></div></div><hr><div class=\"row\"><a class=\"edit-data\" ui-sref=\"chr.contenu.cocktails({id: main.ctx.project._id.$oid})\" ng-if=\"main.allowedUpdate()\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a><p class=\"recap-cocktails\">Cocktails CCE présents sur la carte :<br><span ng-if=\"main.ctx.project.infocarte.cocktails.name\">{{ main.ctx.project.infocarte.cocktails.name }}</span> <span ng-if=\"!main.ctx.project.infocarte.cocktails.name\" ng-repeat=\"cocktail in main.ctx.project.infocarte.cocktails\" class=\"recap-cockatils-name\">{{ cocktail.name }}{{$last ? \'\' : ($index!=main.ctx.project.infocarte.cocktails.length-2) ? \': \' : \'\'}}<span class=\"ingredient\" ng-bind-html=\"cocktail.ingredient\"></span></span></p><p>Intégration des visuels cocktails sur la carte : <span>{{ main.ctx.project.infocarte.cocktails.visuelCocktails }}</span></p></div><hr><div class=\"row\"><a class=\"edit-data\" ui-sref=\"chr.contenu.illustrations({id: main.ctx.project._id.$oid})\" ng-if=\"main.allowedUpdate()\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a><p class=\"recap-frise\">Frise à intégrer :<br><span ng-if=\"main.ctx.project.infocarte.frise.name\">{{ main.ctx.project.infocarte.frise.name }}</span></p><p class=\"recap-illustration\">Illustrations à intégrer :<br><span ng-if=\"illust.name\" ng-repeat=\"illust in main.ctx.project.infocarte.illustrations track by $index\" class=\"recap-illust-name\">{{ illust.name }}{{$last ? \'\' : ($index!=main.ctx.project.infocarte.illustrations.length-2) ? \'\' : \'\'}}<br></span></p><br></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>4.</span>Photo de la carte <a ui-sref=\"chr.photo({id: main.ctx.project._id.$oid})\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a></div><div class=\"panel-body\"><div class=\"row\"><p ng-if=\"main.ctx.project.contenu_fichier_texte.hasFichierTexte == \'oui\'\">Le client dispose d\'un fichier texte : <span>{{ main.ctx.project.contenu_fichier_texte.hasFichierTexte }}</span> &nbsp;&nbsp; - &nbsp;&nbsp; Email de l\'expéditeur : <span>{{ main.ctx.project.contenu_fichier_texte.emailCLient }}</span></p><p>Photos de la carte :</p><div class=\"photo\" ng-repeat=\"photo in main.ctx.project.contenu\" ng-if=\"photo.photo\"><div style=\"color:#DE0B1C\"><span>{{ photo.photo }}</span> <span>: {{ photo.modificationCarte }}</span><div ng-repeat=\"file in main.files\"><img ng-if=\"file.filename.includes(photo.photo)\" src=\"{{file.url}}\" alt=\"impossible de prévisualiser le fichier\"></div></div></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>5.</span>Autres informations <a ui-sref=\"chr.autres-infos({id: main.ctx.project._id.$oid})\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a></div><div class=\"panel-body\"><div class=\"\"><p>Nom du point de vente : <span>{{ main.ctx.project.autresInfos.nomPdv }}</span></p><p>logo à intégrer : <span>{{ main.ctx.project.autresInfos.logoClient }}</span></p><p ng-if=\"main.ctx.project.autresInfos.telephoneDC\">Téléphone du DC :<span>{{ main.ctx.project.autresInfos.telephoneDC }}</span></p><p ng-if=\"main.ctx.project.autresInfos.siteInternet\">Site internet :<span>{{ main.ctx.project.autresInfos.siteInternet }}</span></p><p ng-if=\"main.ctx.project.autresInfos.pageFacebook\">Page facebook :<span>{{ main.ctx.project.autresInfos.pageFacebook }}</span></p><p ng-if=\"main.ctx.project.autresInfos.heureouverture\">Horaire d\'ouverture :<span>{{ main.ctx.project.autresInfos.heureouverture | date: \'HH:mm\' }}</span></p><p ng-if=\"main.ctx.project.autresInfos.heurefermeture\">Horaire de fermeture :<span>{{ main.ctx.project.autresInfos.heurefermeture | date: \'HH:mm\' }}</span></p><p ng-if=\"main.ctx.project.autresInfos.mttMinCB\">Montant minimum Carte Bancaire :<span>{{ main.ctx.project.autresInfos.mttMinCB }} €</span></p><p ng-if=\"main.ctx.project.autresInfos.autreInfo\">Autres :<span>{{ main.ctx.project.autresInfos.autreInfo }}</span></p></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>6.</span>Livraison <a ui-sref=\"chr.livraison({id: main.ctx.project._id.$oid})\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a></div><div class=\"panel-body\"><div class=\"\"><p>Version téléchargeable avec QR code : <span ng-if=\"main.ctx.project.infocarte.qrcode == \'oui\'\">{{ main.ctx.project.infocarte.qrcode }}</span> <a ng-if=\"main.ctx.project.infocarte.qrcode == \'oui\'\" alt=\"Gestion QrCode\" ng-click=\"main.goQrCode(main.ctx.project)\" href=\"\"><span class=\"glyphicon glyphicon-qrcode\" aria-hidden=\"true\"></span></a> <span ng-if=\"main.ctx.project.infocarte.qrcode !== \'oui\'\">non</span></p><p ng-if=\"main.isImpressionCarte()\">Nombre d\'exemplaire de carte à imprimer : <span>{{ main.ctx.project.infocarte.nombreExemplaire }}</span></p><p ng-if=\"main.isImpressionQrCode()\">Nombre d\'exemplaire de QrCode à imprimer : <span>{{ main.ctx.project.infocarte.nombreExemplaireQrCode }}</span></p><p ng-if=\"main.isImpressionQrCode()\">Modèle d\'impression des vignettes du QrCode : <span>{{ main.ctx.project.infocarte.modeleQrCodeSticker.name }}</span></p><p ng-if=\"main.isImpressionMenu()\">Nombre d\'exemplaire de menu extérieur : <span>{{ main.ctx.project.infocarte.nombreExemplaireMenu }}</span></p><p ng-if=\"main.isImpressionMenu()\">Orientation menu extérieur : <span>{{ main.ctx.project.infocarte.orientationMenu }}</span></p><div ng-if=\"!main.isImpressionAucun()\"><p ng-if=\"main.ctx.project.pdv.adresseIdemCommande == \'non\'\">Adresse de livraison : <span>{{ main.ctx.project.pdv.adresseLivraison.nomPDV }}<br>{{ main.ctx.project.pdv.adresseLivraison.adresse }}, {{ main.ctx.project.pdv.adresseLivraison.codePostale }} {{ main.ctx.project.pdv.adresseLivraison.ville }}<br>Gérant : {{ main.ctx.project.pdv.adresseLivraison.gerant }}. Téléphone : {{ main.ctx.project.pdv.adresseLivraison.telephone }}</span></p></div><p ng-if=\"main.ctx.project.pdv.adresseIdemCommande == \'oui\'\">Adresse de livraison : <span>Idem au bon de commande</span></p></div><div ng-if=\"main.isImpressionAucun()\"><p><span>PAS D\'IMPRESSION</span></p></div></div></div></div><div class=\"button\"><a type=\"submit\" ng-if=\"!chr.isUpdate() && main.allowedUpdate()\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(infopdv)\"><span class=\"glyphicon glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer et signer le Bon de commande</a> <a type=\"submit\" ng-if=\"chr.isUpdate() && main.allowedUpdate()\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(infopdv)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivi du Projet</a> <a type=\"submit\" ng-if=\"!main.allowedUpdate()\" class=\"btn btn-default btn-lg\" href=\"#/dashboard\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Retour Tableau de Bord</a></div></div></div><script type=\"text/ng-template\" id=\"signatureDC.html\"><div class=\"modal-body signature\" id=\"modal-body-signature-dc\"> <div class=\"modal-header\"><h2>Signature du DC</h2></div> <div class=\"modal-body\"> <signature-pad accept=\"accept\" clear=\"clear\" height=\"320\" width=\"640\"></signature-pad> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-clear\" ng-click=\"clear()\">Effacer signature</button> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.done()\">Signer</button> </div> </div></script><script type=\"text/ng-template\" id=\"signatureClient.html\"><div class=\"modal-body signature\" id=\"modal-body-signature-client\"> <div class=\"modal-header\"> <h2>Signature du Client</h2> <div class=\"mentions-signature\"> <p>Je certifie que les informations renseignées dans le bon de commande sont exactes.</p> <p>Les informations recueillies dans le cadre du site MY PLV (ci-après le « Site ») font l’objet d’un traitement informatique par CCEP destiné à la gestion du Site et de la relation client. Les destinataires des données sont CCE et ses prestataires. En application de la loi « Informatique et Libertés » du 6 janvier 1978, les destinataires du Site disposent d’un droit d’accès, de modification, de rectification et de suppression des données qui les concernent. Pour exercer ce droit, ils peuvent s’adresser à CCEP en écrivant à l’adresse ci-contre : Coca-Cola European Partners – 9, chemin de Bretagne 92784 Issy-les-Moulineaux Cedex 9 – France.</p> </div> </div> <div class=\"modal-body\"> <signature-pad accept=\"accept\" clear=\"clear\" height=\"320\" width=\"640\"></signature-pad> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-clear\" ng-click=\"clear()\">Effacer signature</button> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.done()\">Signer</button> </div> </div></script>");
$templateCache.put("app/components/add-file-invite-modal/add-file-invite-modal.html","<div class=\"modal-body modal-body-add-file-invite\"><div class=\"modal-header\"><h2 class=\"text-center\">Ajouter un fichier au projet</h2></div><div class=\"instructions\"><p>Ce formulaire envoi par mail, à un destinataire de votre choix, un lien à usage unique lui permettant d\'ajouter un fichier au projet dans MyPlv.</p><p>Vous pouvez personnaliser les instructions envoyées dans le mail. Le lien sera placé sous les instructions.</p></div><div uib-alert=\"\" class=\"alert alert-fade\" type=\"alert\" ng-if=\"vm.lastError\"><pre>{{vm.lastError}}</pre></div><form class=\"form-horizontal\" name=\"addFileInviteForm\"><div class=\"form-group row\"><label for=\"destEmail\" class=\"control-label\">Adresse email du destinataire</label> <input type=\"email\" class=\"form-control\" id=\"destEmail\" name=\"destEmail\" ng-model=\"vm.data.destEmail\" required=\"\" ng-class=\"{true: \'error\'}[vm.submitted && addFileInviteForm.destEmail.$invalid]\"><div ng-if=\"vm.submitted && addFileInviteForm.destEmail.$invalid\" class=\"error-msg\">Email incorrect</div></div><div class=\"form-group row\"><label for=\"textEmail\" class=\"control-label\">Instructions dans le mail</label> <textarea class=\"form-control\" id=\"textEmail\" name=\"textEmail\" ng-model=\"vm.data.textEmail\" required=\"\" ng-class=\"{true: \'error\'}[vm.submitted && addFileInviteForm.textEmail.$invalid]\">\n        </textarea><div ng-if=\"vm.submitted && addFileInviteForm.destEmail.$invalid\" class=\"error-msg\">Instructions obligatoire</div></div></form><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"$dismiss()\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.submit(addFileInviteForm)\">Envoyer</button></div></div>");
$templateCache.put("app/components/adresse-livraison/adresse-livraison.html","<h2>Adresse de livraison</h2><div class=\"form-group radio-custom\"><label class=\"col-sm-3 control-label\">Idem au bon de commande&#8239;*&#8239;:</label><div class=\"text-left col-sm-4 radio-livraison\" ng-class=\"{true: \'error\'}[adr.submitted && adr.form.idemboncommande.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"idemboncommande\" value=\"oui\" ng-model=\"adr.project.pdv.adresseIdemCommande\" required=\"\" ng-class=\"{true: \'error\'}[adr.submitted && adr.form.idemboncommande.$invalid]\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"idemboncommande\" ng-model=\"adr.project.pdv.adresseIdemCommande\" value=\"non\" ng-change=\"adr.addLivraison()\" required=\"\" ng-class=\"{true: \'error\'}[adr.submitted && adr.form.idemboncommande.$invalid]\"> <label>NON</label></div></div><div ng-if=\"adr.submitted && adr.form.idemboncommande.$invalid\" class=\"error-msg\">Veuillez choisir une option.</div></div><fieldset ng-if=\"adr.project.pdv.adresseIdemCommande == \'oui\'\" class=\"col-sm-12 form-adresse-livraison-recap\"><div class=\"form-group\"><label class=\"col-sm-6 control-label\">Nom du point de vente&#8239;:</label><div class=\"col-sm-6 text-left\"><span>{{ adr.project.pdv.nomPDV }}</span></div></div><div class=\"form-group\"><label class=\"col-sm-6 control-label\">Adresse&#8239;:</label><div class=\"col-sm-6 text-left\"><span>{{ adr.project.pdv.adresse }}</span></div></div><div class=\"form-group\"><label class=\"col-sm-6 control-label\">Code Postal&#8239;:</label><div class=\"col-sm-6 text-left\"><span>{{ adr.project.pdv.codePostal }}</span></div></div><div class=\"form-group\"><label class=\"col-sm-6 control-label\">Ville&#8239;:</label><div class=\"col-sm-6 text-left\"><span>{{ adr.project.pdv.ville }}</span></div></div><div class=\"form-group\"><label class=\"col-sm-6 control-label\">Nom&#8239;:</label><div class=\"col-sm-6 text-left\"><span>{{ adr.project.pdv.nomClient }}</span></div></div><div class=\"form-group\"><label class=\"col-sm-6 control-label\">Téléphone&#8239;:</label><div class=\"col-sm-6 text-left\"><span>{{ adr.project.pdv.telephone }}</span></div></div></fieldset><fieldset ng-if=\"adr.project.pdv.adresseIdemCommande == \'non\'\" class=\"col-sm-11 form-adresse-livraison\"><div class=\"form-group\"><label class=\"label-adresse-livraison\">ENTRER l\'ADRESSE DE LIVRAISON&#8239;:</label><div class=\"form-group nom-point-vente-livraison\"><label for=\"nompdv\" class=\"col-sm-4 control-label\">NOM DU POINT DE VENTE&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nompdv\" name=\"nompdv\" ng-model=\"adr.project.pdv.adresseLivraison.nomPDV\" ng-class=\"{true: \'error\'}[adr.submitted && adr.form.nompdv.$invalid]\" required=\"\"></div><div ng-if=\"adr.submitted && adr.form.nompdv.$invalid\" class=\"text-left col-sm-3 error-msg\">Point de vente obligatoire</div></div><div class=\"form-group adresse-livraison\"><label for=\"adresse\" class=\"col-sm-4 control-label\">ADRESSE&#8239;*&#8239;:</label><div class=\"col-sm-5\"><textarea type=\"text\" class=\"form-control\" id=\"adresse\" name=\"adresse\" ng-model=\"adr.project.pdv.adresseLivraison.adresse\" ng-class=\"{true: \'error\'}[adr.submitted && adr.form.adresse.$invalid]\" required=\"\"></textarea></div><div ng-if=\"adr.submitted && adr.form.adresse.$invalid\" class=\"text-left col-sm-3 error-msg\">Adresse obligatoire</div></div><div class=\"form-group code-postal-livraison\"><label for=\"codepostale\" class=\"col-sm-4 control-label\">CODE POSTAL&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"number\" class=\"form-control\" id=\"codepostale\" name=\"codepostale\" ng-pattern=\"/^(\\d{5}-\\d{4}|\\d{5})$/\" max=\"99999\" ng-model=\"adr.project.pdv.adresseLivraison.codePostale\" ng-class=\"{true: \'error\'}[adr.submitted && adr.form.codepostale.$invalid]\" required=\"\"></div><div ng-if=\"adr.submitted && adr.form.codepostale.$invalid && !adr.form.codepostale.$error.pattern\" class=\"text-left col-sm-3 error-msg\">Code Postal obligatoire</div><div ng-if=\"adr.submitted && adr.form.codepostale.$error.pattern\" class=\"text-left col-sm-3 error-msg\">Code Postal incorrect</div></div><div class=\"form-group ville-livraison\"><label for=\"ville\" class=\"col-sm-4 control-label\">VILLE&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" name=\"ville\" id=\"ville\" class=\"form-control\" ng-model=\"adr.project.pdv.adresseLivraison.ville\" ng-class=\"{true: \'error\'}[adr.submitted && adr.form.ville.$invalid]\" required=\"\"></div><div ng-if=\"adr.submitted && adr.form.ville.$invalid\" class=\"text-left col-sm-3 error-msg\">Ville obligatoire</div></div><div class=\"form-group nom-gerant-livraison\"><label for=\"gerant\" class=\"col-sm-4 control-label\">NOM DU GéRANT&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"gerant\" name=\"gerant\" ng-model=\"adr.project.pdv.adresseLivraison.gerant\" ng-class=\"{true: \'error\'}[adr.submitted && adr.form.gerant.$invalid]\" required=\"\"></div><div ng-if=\"adr.submitted && adr.form.gerant.$invalid\" class=\"text-left col-sm-3 error-msg\">Nom Gérant obligatoire</div></div><div class=\"form-group telephone-livraison\"><label for=\"telephone\" class=\"col-sm-4 control-label\">TéLéPHONE&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" class=\"form-control\" id=\"telephone\" name=\"telephone\" ng-pattern=\"/^0\\d(\\s|-)?(\\d{2}(\\s|-)?){4}$/\" ng-model=\"adr.project.pdv.adresseLivraison.telephone\" ng-class=\"{true: \'error\'}[adr.submitted && adr.form.telephone.$invalid]\" required=\"\"></div><div ng-if=\"adr.submitted && adr.form.telephone.$invalid\" class=\"text-left col-sm-3 error-msg\">Téléphone obligatoire</div><div ng-if=\"adr.submitted && adr.form.telephone.$error.pattern\" class=\"error-msg col-sm-3\">Téléphone incorrect</div></div></div></fieldset>");
$templateCache.put("app/components/alert-message/alert-message.html","<div id=\"alert-message\"><div uib-alert=\"\" class=\"alert alert-fade\" type=\"{{vm.type}}\" close=\"vm.closeAlert()\" ng-if=\"vm.msg\">{{vm.msg}}</div></div>");
$templateCache.put("app/components/brief/brief.html","<div ng-if=\"brief.board.state == \'pricelist\'\" class=\"brief-component\"><p ng-if=\"brief.board.brief.photo != undefined\" style=\"text-transform: none;\">Photo Pricelist:<br><span ng-repeat=\"photo in brief.board.brief.photo\">Nom: {{ photo.name }}<br>Texte:<br><span style=\"white-space: pre-line;\">{{ photo.texte }}</span><br></span></p><p ng-if=\"brief.board.brief.texte != undefined\" style=\"text-transform: none;\">Texte Pricelist:<br><span style=\"white-space: pre-line;\">{{ brief.board.brief.texte }}</span></p></div><div ng-if=\"brief.board.state == \'gamme-prix\'\" class=\"brief-component\"><p ng-repeat=\"(prix,boissons) in brief.arrayBoissons\"><span style=\"font-weight: bold;\">{{ prix | currency:\'€\':2 }}</span>: <span>{{boissons}}</span></p></div><div ng-if=\"brief.state2items.indexOf(brief.board.state) > -1\" class=\"brief-component\"><p>Formule : <span>{{ brief.board.brief.nomFormule }}</span></p><p>Solide : <span>{{ brief.board.brief.nomsolide }} (Visuel: {{brief.board.brief.nameSolide}})</span></p><p>Prix : <span>{{ brief.board.brief.prixformule }} €</span></p><p ng-if=\"brief.board.brief.prixbarre != undefined\">Prix barré: <span>{{ brief.board.brief.prixbarre }} €</span></p><p ng-if=\"brief.board.brief.prixAutreFormule != undefined\">{{brief.labelPrixAutreFormule}}: <span>{{ brief.board.brief.prixAutreFormule }} €</span></p></div><div ng-if=\"brief.state3items.indexOf(brief.board.state) > -1\" class=\"brief-component\"><p>Formule : <span>{{ brief.board.brief.nomFormule }}</span></p><p>Solide 1 : <span>{{ brief.board.brief.nomsolide }} (Visuel: {{ brief.getSolidePicture(brief.board.brief.solide, 1) }})</span></p><p>Solide 2 : <span>{{ brief.board.brief.nomsolidebis }} (Visuel: {{ brief.getSolidePicture(brief.board.brief.solide, 2) }})</span></p><p>Prix : <span>{{ brief.board.brief.prixformule }} €</span></p><p ng-if=\"brief.board.brief.prixbarre != undefined\">Prix barré: <span>{{ brief.board.brief.prixbarre }} €</span></p><p ng-if=\"brief.board.brief.prixAutreFormule != undefined\">{{brief.labelPrixAutreFormule}}: <span>{{ brief.board.brief.prixAutreFormule }} €</span></p></div><div ng-if=\"brief.state2x2items.indexOf(brief.board.state) > -1\" class=\"brief-component\"><div class=\"formules22\" ng-repeat=\"formule in brief.board.brief\"><p>Formule {{$index + 1}} : <span>{{ formule.nomFormule }}</span></p><p>Solide {{$index + 1}} : <span>{{ formule.nomsolide }} (Visuel: {{formule.solide.name}})</span></p><p>Prix {{$index + 1}} : <span>{{ formule.prixformule }} €</span></p><p ng-if=\"formule.prixbarre != undefined\">Prix barré {{$index + 1}}: <span>{{ formule.prixbarre }} €</span></p><p ng-if=\"formule.prixAutreFormule != undefined\">{{brief.labelPrixAutreFormule}}: <span>{{ formule.prixAutreFormule }} €</span></p><hr ng-if=\"$first\"></div></div><div ng-if=\"brief.state2x3items.indexOf(brief.board.state) > -1\" class=\"brief-component\"><div class=\"formules22\" ng-repeat=\"formule in brief.board.brief\"><p>Formule {{$index + 1}} : <span>{{ formule.nomFormule }}</span></p><p>Solide {{$index + 1}}1 : <span>{{ formule.nomsolide1 }} (Visuel: {{ brief.getSolidePicture(formule.solide, 1) }})</span></p><p>Solide {{$index + 1}}2 : <span>{{ formule.nomsolide2 }} (Visuel: {{ brief.getSolidePicture(formule.solide, 2) }})</span></p><p>Prix {{$index + 1}} : <span>{{ formule.prixformule }} €</span></p><p ng-if=\"formule.prixbarre != undefined\">Prix barré {{$index + 1}}: <span>{{ formule.prixbarre }} €</span></p><p ng-if=\"formule.prixAutreFormule != undefined\">{{brief.labelPrixAutreFormule}}: <span>{{ formule.prixAutreFormule }} €</span></p><hr ng-if=\"$first\"></div></div><div ng-if=\"brief.stateStandard2018.indexOf(brief.board.state) > -1\" class=\"brief-component\"><div class=\"formules22\" ng-init=\"formule = brief.board.brief.Formule1\"><p>Formule : <span>{{ formule.nomFormule }}</span></p><p>Solide 1 : <span>{{ formule.nomsolide }} (Visuel: {{formule.solide.name}})</span></p><p>Prix 1 : <span>{{ formule.prixformule }} €</span></p><p ng-if=\"!brief.board.brief.Formule2\"><span>Pas de solide 2</span></p></div><div class=\"formules22\" ng-if=\"brief.board.brief.Formule2\" ng-init=\"formule = brief.board.brief.Formule2\"><hr><p>Solide 2 : <span>{{ formule.nomsolide }} (Visuel: {{formule.solide.name}})</span></p><p>Prix supplément solide 2 : <span>{{ formule.prixformule }} €</span></p></div></div>");
$templateCache.put("app/components/date-picker/date-picker.html","<p class=\"input-group date-picker\"><div class=\"dropdown\"><a class=\"dropdown-toggle\" id=\"dropdown2\" role=\"button\" data-toggle=\"dropdown\" data-target=\"#\" href=\"\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-calendar\"></i></span></div></a><ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\"><datetimepicker data-ng-model=\"datePicker.value\" data-datetimepicker-config=\"{ dropdownSelector: \'#dropdown2\' }\" data-on-set-time=\"datePicker.onChange()\"></datetimepicker></ul></div></p>");
$templateCache.put("app/components/filtre-dashboard/filtre-dashboard.html","<select ng-if=\"db.dc\" name=\"searchFilter\" ng-options=\"option for option in db.filtres\" ng-model=\"db.searchSupport\"><option value=\"\">{{ db.textFiltre }}</option></select><select ng-if=\"!db.dc\" name=\"searchFilter\" ng-options=\"option for option in db.filtres\" ng-model=\"db.searchFormat\"><option value=\"\">{{ db.textFiltre }}</option></select><span class=\"glyphicon glyphicon-triangle-bottom\"></span>");
$templateCache.put("app/components/footer/footer-nav.html","<nav class=\"navbar navbar-default navbar-fixed-bottom footer-nav\"><div class=\"container\"><a class=\"navbar-link navbar-text\">MENTIONS LEGALES</a></div></nav>");
$templateCache.put("app/components/form-id-projet/id-projet.html","<script>\n  ClassicEditor\n          .create( document.querySelector( \'#briefPSM\' ), {\n            fontSize: {\n                options: [\n                    9,\n                    11,\n                    13,\n                    \'default\',\n                    17,\n                    19,\n                    21\n                ],\n                supportAllValues: true\n            },\n            toolbar: [ \'heading\', \'bold\', \'italic\', \'fontSize\', \'link\', \'bulletedList\', \'numberedList\' ]\n          } )\n          .then( editor => {\n            editor.setData(document.querySelector( \'#briefPSM\' ).value);\n            editor.model.document.on(\'change:data\', () => {\n              document.querySelector( \'#briefPSM\' ).value  = editor.getData();\n            })\n          } )\n          .catch( error => {\n            console.error( error );\n          } );\n</script><form class=\"form-horizontal row\" name=\"idprojet\"><h2>NOMMER VOTRE PROJET</h2><fieldset class=\"col-sm-offset-1\"><input type=\"hidden\" class=\"form-control\" id=\"numeroOutlet\" name=\"numeroOutlet\" ng-model=\"idp.project.pdv.nOutlet\" readonly=\"\"><div class=\"form-group\"><label for=\"nameProjet\" class=\"col-sm-3 control-label\">Nom du projet :</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nameProjet\" name=\"nameProjet\" maxlength=\"50\" ng-model=\"idp.project.idprojet.nameProjet\" required=\"\" readonly=\"\" ng-class=\"{true: \'error\'}[idp.submitted && idp.project.nameProjet.$invalid]\"></div><div ng-if=\"idp.submitted && idprojet.nameProjet.$invalid\" class=\"col-sm-4 error-msg text-left\">Nom du Projet obligatoire</div></div><div class=\"form-group\" ng-if=\"\'PSM\' == idp.project.typeProjet\"><label for=\"planProjet\" class=\"col-sm-3 control-label\">Type de projet :</label><div class=\"col-sm-5\"><select name=\"planProjet\" class=\"form-control planProjet\" id=\"planProjet\" ng-model=\"idp.project.idprojet.planProjet\" ng-class=\"{true: \'error\'}[idp.submitted && idprojet.planProjet.$invalid]\" required=\"\"><option ng-repeat=\"plan in idp.planList\" value=\"{{ plan }}\">{{ plan }}</option></select></div><div ng-if=\"idp.submitted && idprojet.planProjet.$invalid\" class=\"col-sm-4 error-msg text-left\">Type de Projet obligatoire</div></div><div class=\"form-group\" ng-if=\"!idp.user.hasRole(\'client\')\"><label for=\"agence\" class=\"col-sm-3 control-label\">Agence :</label><div class=\"col-sm-5 control-group\"><input type=\"text\" ng-model=\"idp.agenceMail\" required=\"\" id=\"agence\" name=\"agence\" class=\"form-control\" ng-class=\"{true: \'error\'}[idp.submitted && (!idp.validMail || !idp.agenceMail)]\"></div><div ng-if=\"idp.submitted && !idp.validMail\" class=\"col-sm-4 error-msg text-left\">Email inconnu</div></div><div class=\"form-group\" ng-if=\"idp.project.typeProjet == \'PSM\'\"><label for=\"briefPSM\" class=\"col-sm-3 control-label\">Brief :</label><div class=\"col-sm-7 controls\"><textarea id=\"briefPSM\" name=\"briefPSM\" rows=\"8\" cols=\"60\" ng-model=\"idp.project.briefPSM\" class=\"form-control\" ng-class=\"{true: \'error\'}[main.submitted && idprojet.briefPSM.$invalid]\">\n        </textarea></div></div></fieldset><div><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"idp.previous()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"idp.saveNomProjet(idprojet)\" ng-if=\"idp.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"idp.validateNomProjet(idprojet)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form>");
$templateCache.put("app/components/form-info-pdv/info-pdv.html","<form class=\"form-horizontal\" name=\"infopdv\"><fieldset class=\"col-sm-offset-1\"><span class=\"col-sm-offset-3 col-sm-9 help-block\">*Champs obligatoires</span><div class=\"form-group row\"><label for=\"noutlet\" class=\"col-sm-3 control-label\">N° OUTLET&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"noutlet\" class=\"form-control\" id=\"noutlet\" ng-model=\"inf.project.pdv.nOutlet\" required=\"\" ng-class=\"{true: \'error\'}[inf.submitted && infopdv.noutlet.$invalid]\"></div><div ng-if=\"inf.submitted && infopdv.noutlet.$invalid\" class=\"error-msg col-sm-4\">Numéro d\'OUTLET obligatoire</div></div><div class=\"form-group row\"><div class=\"col-sm-5 col-sm-offset-3\"><button type=\"button\" class=\"btn btn-default sails-force\" ng-click=\"inf.getPdvInfo()\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Remplir</button></div></div><ng-container ng-if=\"inf.project.pdv.medaillePDV\"><div class=\"form-group row\"><label for=\"medaillepdv\" style=\"padding-left: 0;\" class=\"col-sm-3 control-label\">Médaille du PDV :</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"medaillepdv\" name=\"medaillepdv\" ng-model=\"inf.project.pdv.medaillePDV\" ng-disabled=\"1\"></div></div><div class=\"form-group row\"><label for=\"namepdv\" style=\"padding-left: 0;\" class=\"col-sm-3 control-label\">Nom du point de vente&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"namepdv\" name=\"namepdv\" ng-model=\"inf.project.pdv.nomPDV\" required=\"\" ng-class=\"{true: \'error\'}[inf.submitted && infopdv.namepdv.$invalid]\"></div><div ng-if=\"inf.submitted && infopdv.namepdv.$invalid\" class=\"error-msg col-sm-4\">Nom du point de vente obligatoire</div></div><div class=\"form-group row\"><label for=\"adressepdv\" class=\"col-sm-3 control-label\">Adresse&#8239;*&#8239;:</label><div class=\"col-sm-5\"><textarea class=\"form-control\" rows=\"3\" ng-model=\"inf.project.pdv.adresse\" name=\"adressepdv\" id=\"adressepdv\" required=\"\" ng-class=\"{true: \'error\'}[inf.submitted && infopdv.adressepdv.$invalid]\"></textarea></div><div ng-if=\"inf.submitted && infopdv.adressepdv.$invalid\" class=\"error-msg col-sm-4\">Adresse du point de vente obligatoire</div></div><div class=\"form-group row\"><label for=\"codepostal\" class=\"col-sm-3 control-label\">CODE POSTAL&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"codepostal\" class=\"form-control\" id=\"codepostal\" ng-pattern=\"/^(\\d{5}-\\d{4}|\\d{5})$/\" max=\"99999\" ng-model=\"inf.project.pdv.codePostal\" required=\"\" ng-class=\"{true: \'error\'}[inf.submitted && infopdv.codepostal.$invalid]\"></div><div ng-if=\"inf.submitted && infopdv.codepostal.$invalid && !infopdv.codepostal.$error.pattern\" class=\"error-msg col-sm-4\">Code postal obligatoire</div><div ng-if=\"inf.submitted && infopdv.codepostal.$error.pattern\" class=\"error-msg col-sm-4\">Code postal incorrect</div></div><div class=\"form-group row\"><label for=\"ville\" class=\"col-sm-3 control-label\">VILLE&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" name=\"ville\" class=\"form-control\" id=\"ville\" ng-model=\"inf.project.pdv.ville\" required=\"\" ng-class=\"{true: \'error\'}[inf.submitted && infopdv.ville.$invalid]\"></div><div ng-if=\"inf.submitted && infopdv.ville.$invalid\" class=\"error-msg col-sm-4\">Ville obligatoire</div></div><div class=\"form-group row\"><label for=\"telephone\" class=\"col-sm-3 control-label\">TéLéPHONE&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"telephone\" class=\"form-control\" id=\"telephone\" ng-pattern=\"/^0\\d(\\s|-)?(\\d{2}(\\s|-)?){4}$/\" ng-model=\"inf.project.pdv.telephone\" required=\"\" placeholder=\"ex: 0652413698\" ng-class=\"{true: \'error\'}[inf.submitted && infopdv.telephone.$invalid]\"></div><div ng-if=\"inf.submitted && infopdv.telephone.$invalid && infopdv.telephone.$error.required\" class=\"error-msg col-sm-4\">Téléphone obligatoire</div><div ng-if=\"inf.submitted && infopdv.telephone.$error.pattern\" class=\"error-msg col-sm-4\">Téléphone incorrect</div></div><div class=\"form-group row\"><label for=\"nsiret\" class=\"col-sm-3 control-label\">N° SIRET&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"nsiret\" class=\"form-control\" id=\"nsiret\" ng-pattern=\"/^[0-9]{14}$/\" ng-model=\"inf.project.pdv.nSiret\" required=\"\" ng-class=\"{true: \'error\'}[inf.submitted && infopdv.nsiret.$invalid]\"></div><div ng-if=\"inf.submitted && infopdv.nsiret.$invalid && infopdv.nsiret.$error.required\" class=\"error-msg col-sm-4\">N°SIRET obligatoire</div><div ng-if=\"inf.submitted && infopdv.nsiret.$error.pattern\" class=\"error-msg col-sm-4\">N°SIRET incorrect: 14 chiffres</div></div><div class=\"form-group row\"><label for=\"rcs\" class=\"col-sm-3 control-label\">RCS&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"rcs\" class=\"form-control\" id=\"rcs\" ng-model=\"inf.project.pdv.rcs\"></div></div><div class=\"form-group row\"><label for=\"nomclient\" class=\"col-sm-3 control-label\">NOM DU CLIENT&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" name=\"nomclient\" class=\"form-control\" id=\"nomclient\" ng-model=\"inf.project.pdv.nomClient\" required=\"\" ng-class=\"{true: \'error\'}[inf.submitted && infopdv.nomclient.$invalid]\"></div><div ng-if=\"inf.submitted && infopdv.nomclient.$invalid\" class=\"error-msg col-sm-4\">Nom du Client obligatoire</div></div><div class=\"form-group row\"><label for=\"telclient\" class=\"col-sm-3 control-label\">TéLéPHONE DU CLIENT&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"telclient\" class=\"form-control\" id=\"telclient\" ng-pattern=\"/^0\\d(\\s|-)?(\\d{2}(\\s|-)?){4}$/\" ng-model=\"inf.project.pdv.telephoneCLient\" required=\"\" placeholder=\"ex: 0652413698\" ng-class=\"{true: \'error\'}[inf.submitted && infopdv.telclient.$invalid]\"></div><div ng-if=\"inf.submitted && infopdv.telclient.$invalid && infopdv.telclient.$error.required\" class=\"error-msg col-sm-4\">Téléphone Client obligatoire</div><div ng-if=\"inf.submitted && infopdv.telclient.$error.pattern\" class=\"error-msg col-sm-4\">Téléphone incorrect</div></div><div class=\"form-group row\"><label for=\"emailclient\" class=\"col-sm-3 control-label\">EMAIL DU CLIENT&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"email\" name=\"emailclient\" class=\"form-control\" id=\"emailclient\" ng-model=\"inf.project.pdv.emailCLient\" required=\"\" ng-class=\"{true: \'error\'}[inf.submitted && infopdv.emailclient.$invalid]\"><div ng-switch=\"inf.project.type\"><span ng-switch-when=\"Sur Mesure\" class=\"help-block\">Attention vous devez fournir un email valide.<br>En cas de problème votre client sera contacté à cette adresse</span> <span ng-switch-default=\"\" class=\"help-block\">Attention, vous devez fournir un email valide.<br>{{inf.textTypeProj()}} à votre client sur cette adresse mail afin d\'obtenir sa validation.</span></div></div><div ng-if=\"inf.submitted && infopdv.emailclient.$invalid && infopdv.emailclient.$error.required\" class=\"error-msg col-sm-4\">Email client obligatoire</div><div ng-if=\"inf.submitted && infopdv.emailclient.$error.email\" class=\"error-msg col-sm-4\">Email invalid</div></div></ng-container></fieldset><div><a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"inf.saveForm(infopdv)\" ng-if=\"inf.update\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"inf.validateForm(infopdv)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form><script type=\"text/ng-template\" id=\"alertNotSilverPDV.html\"><div class=\"modal-body\" id=\"modal-body-msg\"> <div class=\"modal-header\"><h2>Les projets sur mesure sont réservés uniquement pour les PDV Gold et Platinium. Veuillez choisir un outil générique (MyPLV CHR ou Mon Menu).</h2> <p>Si vous estimez que la médaille de votre PDV est mal codifiée, veuillez ouvrir un Case. </p></div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"$close()\">ANNULER</button> </div> </div></script><script type=\"text/ng-template\" id=\"alertUnknownPDV.html\"><div class=\"modal-body\" id=\"modal-body-msg\"> <div class=\"modal-header\"><h2>PDV Inconnu.</h2> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"$dismiss()\">ANNULER</button> </div> </div></script>");
$templateCache.put("app/components/gamme-display/gamme-display.html","<div name=\"gammeDisplay\" ng-click=\"vm.click()\"><div class=\"boissonList\" ng-repeat=\"(famille, boissonList) in vm.boissonsObj\"><div class=\"sub-class-image-item\" ng-repeat=\"boisson in boissonList\"><img ng-src=\"{{vm.gammes[famille][boisson.name].image}}\"></div></div></div>");
$templateCache.put("app/components/gamme-selector/gamme-selector.html","<div name=\"gammeSelector\"><div class=\"form-group boisson well\" ng-repeat=\"(parent, enfants) in vm.gammes | groupBy:\'name\'\"><div class=\"part-left\" ng-repeat=\"imgParent in enfants\" ng-if=\"$first\" ng-click=\"vm.selectAll(parent)\"><img ng-src=\"{{ imgParent.field_gamme_image_boissons_1}}\" alt=\"\"></div><div class=\"part-right\"><div class=\"checkbox checkbox-custom\" ng-repeat=\"enfant in enfants| orderBy:\'weight_children\'\"><input type=\"checkbox\" name=\"{{parent}}-{{ $index}}\" ng-true-value=\"\'{{ enfant.fullName }}\'\" ng-model=\"vm.boissonsObj[parent][$index].name\" ng-disabled=\"vm.user.hasRole(\'client\')\" ng-change=\"vm.onChangeBoissons(vm.boissonsObj[parent], parent, enfant, $index)\"> <label><span class=\"gamme-name\">{{ enfant.name_1}}</span> <span class=\"gamme-format\">{{ enfant.field_gamme_format_boissons}}</span></label> <span class=\"image\"><img ng-src=\"{{ enfant.field_gamme_image_boissons}}\" alt=\"\"></span></div></div></div></div>");
$templateCache.put("app/components/header/header-nav.html","<nav class=\"navbar navbar-default header-nav\"><div class=\"container\"><p class=\"navbar-text navbar-left\"><a class=\"navbar-link logo\" href=\"\" ng-click=\"hCtrl.home()\">Home</a></p><p class=\"navbar-text navbar-right\"><a class=\"navbar-link\" ng-click=\"hCtrl.logout()\"><span class=\"glyphicon glyphicon-log-out\"></span> <span class=\"fonction\">déconnexion</span></a></p><p class=\"navbar-text navbar-right\"><a class=\"navbar-link\" ui-sref=\"help\"><span class=\"glyphicon glyphicon-question-sign\"></span> <span class=\"fonction\">aide</span></a></p><p class=\"navbar-text navbar-right\"><a class=\"navbar-link\" href=\"\" ng-click=\"hCtrl.home()\"><span class=\"glyphicon glyphicon-home\"></span> <span class=\"fonction\">Accueil</span></a></p></div></nav>");
$templateCache.put("app/components/loading-screen/loading-screen.html","<div class=\"loading-screen animated-container\" ng-if=\"ls.loading\"><div class=\"wrapper-loading\"><span class=\"glyphicon loader\" aria-hidden=\"true\"></span></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-default\"><div class=\"container\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#navbar\" aria-expanded=\"false\" aria-controls=\"navbar\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" href=\"#\"><span class=\"glyphicon glyphicon-home\"></span> Modular WebApp</a></div><div id=\"navbar\" class=\"collapse navbar-collapse\"><ul class=\"nav navbar-nav\"><li ng-class=\"{dropdown: vm.hasSubMenu(action)}\" ng-switch=\"vm.hasSubMenu(action)\" ng-repeat=\"action in vm.actions\"><a ng-switch-default=\"\" href=\"\" ng-click=\"vm.exec(action)\">{{ vm.label(action) }}</a> <a ng-switch-when=\"true\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\" href=\"\">{{ vm.label(action) }} <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li ng-repeat=\"action in vm.subActions(action)\"><a href=\"\" ng-click=\"vm.exec(action)\">{{ vm.label(action) }}</a></li></ul></li></ul><ul class=\"nav navbar-nav navbar-right\"><li ng-class=\"{dropdown: vm.hasSubMenu(action)}\" ng-switch=\"vm.hasSubMenu(action)\" ng-repeat=\"action in vm.secondaryActions\"><a ng-switch-default=\"\" href=\"\" ng-click=\"vm.exec(action)\">{{ vm.label(action) }}</a> <a ng-switch-when=\"true\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\" href=\"\">{{ vm.label(action) }} <span class=\"caret\"></span></a><ul class=\"dropdown-menu\"><li ng-repeat=\"action in vm.subActions(action)\"><a href=\"\" ng-click=\"vm.exec(action)\">{{ vm.label(action) }}</a></li></ul></li></ul><ul class=\"nav navbar-nav\"><li><a ng-href=\"#\" ng-click=\"main.logout()\">Logout</a></li></ul></div></div></nav>");
$templateCache.put("app/components/navbar-icon/navbar-icon.html","<div class=\"container\"><ul class=\"nav nav-tabs nav-bar-icon text-center\"><li class=\"\" ng-class=\"{ active: vm.isSet(\'info-pdv\') }\"><a href=\"\" ng-click=\"vm.navClick(\'info-pdv\')\"><span class=\"number\">1.</span><span>INFORMATIONS CLIENT</span></a></li><li class=\"\" ng-class=\"{ active: vm.isSet(\'id-projet\') }\"><a href=\"\" ng-click=\"vm.navClick(\'id-projet\')\"><span class=\"number\">2.</span><span>CREATION<br>DE LA CARTE</span></a></li><li class=\"\" ng-class=\"{ active: vm.isSet(\'carte\') }\"><a href=\"\" ng-click=\"vm.navClick(\'carte\')\"><span class=\"number\">3.</span><span>CONTENU<br>DE LA CARTE</span></a></li><li class=\"\" ng-class=\"{ active: vm.isSet(\'contenu\') }\"><a href=\"\" ng-click=\"vm.navClick(\'contenu\')\"><span class=\"number\">4.</span><span>PHOTO<br>DE LA CARTE</span></a></li><li class=\"\" ng-class=\"{ active: vm.isSet(\'autres-informations\') }\"><a href=\"\" ng-click=\"vm.navClick(\'autres-informations\')\"><span class=\"number\">5.</span><span>AUTRES INFORMATIONS</span></a></li><li class=\"\" ng-class=\"{ active: vm.isSet(\'validation\') }\"><a href=\"\" ng-click=\"vm.navClick(\'validation\')\"><span class=\"number\">6.</span><span>LIVRAISON</span></a></li></ul></div>");
$templateCache.put("app/components/photo-list/photo-list.html","<fieldset class=\"col-sm-12 list-photo-added\" ng-if=\"vm.hasPhoto\"><h4>Liste des photos déjà prises:</h4><ul class=\"list-group\"><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"photo in vm.photosObjFiltered\"><uib-accordion-heading>{{photo.photo}}<i class=\"pull-right glyphicon glyphicon-chevron-down\"></i></uib-accordion-heading><table class=\"table\"><tr><td>Modifications: {{ photo.comment }}</td><td class=\"group-btn-contenu-edition\"><a class=\"photo-contenu-edition\" ng-click=\"vm.modifPhoto(photo)\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></a> <a class=\"comment-contenu-edition\" ng-click=\"vm.annotate(photo)\"><span class=\"glyphicon glyphicon-comment\" aria-hidden=\"true\"></span></a></td></tr><tr ng-if=\"photo.anno.length > 0\"><td><div class=\"conteneur-edition\"><p class=\"paragraphe-edition\">Post-It:</p></div><ol><li ng-repeat=\"postit in photo.anno\">{{ postit.text}}</li></ol></td><td></td></tr></table></div></uib-accordion></ul></fieldset>");
$templateCache.put("app/components/photo-list/photo-modif-popin.html","<div class=\"modal-body alert-modif-photo\" id=\"modal-body-alert-modif-photo\"><div class=\"modal-header\"><h2 class=\"text-center\">Modification de la carte</h2></div><div class=\"modal-body\"><textarea name=\"modifphoto\" id=\"\" cols=\"30\" rows=\"10\" ng-model=\"vm.photoModif\"></textarea></div><div class=\"modal-footer\"><button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">ANNULER</button> <button class=\"btn btn-default\" ng-click=\"vm.validate()\">VALIDER</button></div></div>");
$templateCache.put("app/components/photo-list-projet/photo-list-projet.html","<alert-message></alert-message><div class=\"panel panel-default row file-projet\"><div class=\"panel-heading\">DOCUMENTS DU PROJET <a class=\"add-asset\" href=\"\" ng-if=\"vm.isAddFileEnabled()\" ng-click=\"vm.openAddFilePopin()\">Inviter à joindre un fichier <span class=\"glyphicon glyphicon-paperclip\" aria-hidden=\"true\"></span></a></div><div class=\"panel-body text-center\"><div><table class=\"table table-striped\"><tr ng-repeat=\"file in vm.files | orderBy:\'dateFile\'\"><td>{{ file.filename }}</td><td>{{ file.dateFile | date:\'dd-MM-yyyy HH:mm\' }}</td><td><a ng-if=\"vm.isAnnotable(file)\" href=\"\" ng-click=\"vm.annotate(file)\" title=\"Annoter la photo !\" style=\"position: initial;\"><span class=\"glyphicon glyphicon-comment\" aria-hidden=\"true\"></span></a></td><td><a href=\"{{ file.url }}\" download=\"\" style=\"position: initial;\"><span class=\"glyphicon glyphicon-save\" aria-hidden=\"true\"></span></a></td><td ng-if=\"vm.user.hasRole(\'agence\') || vm.user.hasRole(\'administrator\') || vm.user.hasRole(\'siege\')\"><a style=\"position: initial;\" ng-click=\"vm.delete(file)\"><span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span></a></td></tr></table></div></div></div><script type=\"text/ng-template\" id=\"confirmDelete.html\"><div class=\"modal-body\" id=\"modal-body-msg\"> <div class=\"modal-header\"><h2 class=\"text-center\">Vous allez supprimer le fichier : <span>{{vm.fileToDelete}}</span>. </h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"$close()\">Confirmer</button> </div> </div></script>");
$templateCache.put("app/components/photo-upload/photo-delete-confirm.html","<div class=\"modal-body alert-delete-photo\" id=\"modal-body-alert-delete-photo\"><div class=\"modal-header\"><h2 class=\"text-center\">Voulez vraiment supprimer cette photo ?</h2></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"$close()\">OUI</button> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">ANNULER</button></div></div>");
$templateCache.put("app/components/photo-upload/photo-upload.html","<fieldset class=\"panel col-sm-12\" ng-repeat=\"(key,item) in vm.uploader.queue | filter:{myplv_file_type: vm.fileType}\"><div class=\"well index--{{$index}}\"><div class=\"text-right\"><span ng-if=\"vm.annotationEnabled\" ng-click=\"vm.annotatePhoto($index, item)\" class=\"glyphicon glyphicon-pencil\"></span> <span ng-click=\"vm.deletePhoto($index, item)\" class=\"glyphicon glyphicon-trash\"></span></div><div class=\"form-group\"><label ng-bind=\"item.file.name\" class=\"col-sm-6\"></label><div class=\"col-sm-6\"><input type=\"hidden\" ng-init=\"vm.photosObj[item.file.firtsName].photo = item.file.name\" value=\"{{item.file.name}}\" readonly=\"\"> <input type=\"hidden\" ng-init=\"vm.photosObj[item.file.firtsName].file_type = item.file_type\" value=\"{{item.file.name}}\" readonly=\"\"></div><p ng-show=\"vm.uploader.isHTML5\" nowrap=\"\" class=\"col-sm-3\">Taille : {{ item.file.size / 1024 / 1024|number:2 }} MB</p></div><div class=\"form-group\"><label for=\"comment\" class=\"control-label\">Commentaire&#8239;:</label><div class=\"\"><textarea class=\"form-control\" id=\"modification\" name=\"comment\" ng-model=\"vm.photosObj[item.file.firtsName].comment\"></textarea></div></div></div></fieldset><fieldset class=\"panel col-sm-12 addphoto\"><div class=\"photo-action\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">Ajouter une photo :</label><div class=\"\"><input type=\"file\" accept=\"application/pdf,image/*\" class=\"form-control\" nv-file-select=\"\" uploader=\"vm.uploader\" options=\"{file_type:vm.fileType}\" sn-model-file=\"vm.file\" multiple=\"\"></div></div></div></fieldset>");
$templateCache.put("app/components/progress-bar-upload/progress-bar-upload.html","<div class=\"progress\" style=\"\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': pbu.uploader.progress + \'%\' }\"></div></div>");
$templateCache.put("app/components/projet-actions/confirm-cancel.html","<div class=\"modal-body\" id=\"modal-body-delete\"><div class=\"modal-header\"><h2 style=\"margin-bottom: 0;\">Confirmation</h2></div><h3 class=\"modal-body\" style=\"margin: 0;\">Voulez-vous annuler le projet {{ vm.project.idprojet.nameProjet}} ?</h3><div class=\"modal-footer\"><button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.cancelProject()\">Confirmer</button></div></div>");
$templateCache.put("app/components/projet-actions/confirm-delete.html","<div class=\"modal-body\" id=\"modal-body-delete\"><div class=\"modal-header\"><h2>Confirmation</h2></div><div class=\"modal-body\">Voulez-vous supprimer le projet {{ vm.project.idprojet.nameProjet}} ?</div><div class=\"modal-footer\"><button class=\"btn btn-default btn-cancel\" ng-click=\"$close()\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.deleteProject()\">Confirmer</button></div></div>");
$templateCache.put("app/components/projet-actions/projet-action.html","<a href=\"\" ng-click=\"action.exec()\" ng-class=\"action.class\" ng-if=\"action.isAvailable()\" title=\"{{action.title}}\"><span ng-class=\"action.glyphiconClass\" aria-hidden=\"true\"></span></a>");
$templateCache.put("app/components/statut-projet-navbar/statut-projet-navbar.html","<div class=\"container\"><ul class=\"nav nav-tabs nav-bar-icon text-center\"><li class=\"statut-projet\" ng-class=\"{active: vm.ctx.project.statut == statut}\" ng-repeat=\"statut in vm.statutProjet\"><a href=\"\" disabled=\"\"><span class=\"number number-{{$index+1}}\">{{$index+1}}.</span><span>{{statut}}</span></a></li></ul></div>");
$templateCache.put("app/components/suivi-projet-actions/admin-change-statut-action.html","<div ng-if=\"action.isAvailable()\" class=\"panel panel-default no-allowed-statut\"><div class=\"panel-heading\">Forcer le statut</div><div class=\"panel-body text-center\">Réservé aux administrateurs :<select ng-model=\"action.selectedStatut\"><option value=\"\">== Sélectionner un statut ==</option><option ng-repeat=\"option in action.statutProjet\" value=\"{{option}}\">{{option}}</option></select><span class=\"glyphicon glyphicon-triangle-bottom\"></span> <button class=\"btn btn-default\" ng-click=\"action.exec()\" ng-disabled=\"!action.selectedStatut\">Forcer le statut</button></div></div>");
$templateCache.put("app/da/da-00-dc/da-00-dc-layout.html","<div class=\"container id-projet text-center wrapp\"><ul class=\"nav nav-tabs sub-menu text-center\"><li class=\"col-sm-4 disabled\" ng-class=\"{active: da.$state.is(\'da.dc.info_client\')}\"><a disabled=\"\">INFORMATION CLIENT</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: da.$state.is(\'da.dc.info_projet\')}\"><a disabled=\"\">NOM DU PROJET</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: da.$state.is(\'da.dc.gamme\')}\"><a disabled=\"\">GAMMES CCEP</a></li></ul><div ui-view=\"\" autoscroll=\"true\"></div></div>");
$templateCache.put("app/da/da-01-support/da-01-support.html","<div class=\"container text-center livraison\"><form class=\"form-horizontal row\" name=\"support\"><fieldset class=\"col-sm-12\"><label for=\"nameProjet\" class=\"col-sm-3 control-label\">Nom du projet :</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nameProjet\" name=\"nameProjet\" maxlength=\"50\" ng-model=\"main.ctx.project.idprojet.nameProjet\" required=\"\" readonly=\"\" ng-class=\"{true: \'error\'}[main.submitted && main.ctx.project.nameProjet.$invalid]\"></div></fieldset><fieldset class=\"col-sm-12 exemplaires-carte\"><h2>Nombre d\'exemplaire à imprimer</h2><div class=\"form-group exemplaire\"><label class=\"col-sm-5\">Nb exemplaire Carte&#8239;:</label><div class=\"col-sm-3\"><select name=\"nbExemplaire\" class=\"form-control nbExemplaire\" id=\"nbExemplaire\" ng-model=\"main.ctx.project.infocarte.nombreExemplaire\" ng-class=\"{true: \'error\'}[main.submitted && validation.nbExemplaire.$invalid]\" required=\"\"><option value=\"\"></option><option ng-repeat=\"item in main.nbrCarte\" value=\"{{ item }}\">{{ item }}</option></select></div><div ng-if=\"main.submitted && validation.nbExemplaire.$invalid\" class=\"error-msg col-sm-4\">Choisir le nombre d\'exemplaire de carte</div></div></fieldset><fieldset class=\"col-sm-12 group-qrcode\" id=\"errorValidation\"><h2>Souhaitez-vous ajouter un QR code ?</h2><div class=\"form-group radio-custom\"><label class=\"col-sm-3 control-label\"></label><div class=\"text-left col-sm-4 radio-qrcode\" ng-class=\"{true: \'error\'}[main.submitted && validation.qrcode.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"qrcode\" value=\"oui\" ng-model=\"main.ctx.project.infocarte.qrcode\" required=\"\" ng-change=\"main.changeQrCode(\'oui\')\" ng-class=\"{true: \'error\'}[main.submitted && validation.qrcode.$invalid]\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"qrcode\" ng-model=\"main.ctx.project.infocarte.qrcode\" value=\"non\" required=\"\" ng-change=\"main.changeQrCode(\'non\')\" ng-class=\"{true: \'error\'}[main.submitted && validation.qrcode.$invalid]\"> <label>NON</label></div></div><div ng-if=\"main.submitted && validation.qrcode.$invalid\" class=\"error-msg\">Veuillez choisir une option.</div></div></fieldset><fieldset class=\"col-sm-12 modeles-qrcode\" ng-if=\"main.ctx.project.infocarte.qrcode == \'oui\'\"><h2>Modèle d\'impression du QrCode</h2><div class=\"form-group row modeles-qrcode\"><label class=\"col-sm-5\">Modèle d\'impression des vignettes&#8239;:</label><div class=\"modeles-qrcode-list\"><div class=\"col-sm-6\" ng-repeat=\"(key, modeleqrcodesticker) in main.modelesqrcodestickers\" ng-class=\"{true: \'error\'}[main.submitted && validation.modeleqrcodesticker.$invalid]\"><div class=\"checkbox\"><input type=\"radio\" name=\"modeleqrcodesticker\" value=\"{{modeleqrcodesticker.name }}\" id=\"modeleqrcodesticker{{$index}}\" ng-model=\"main.ctx.project.infocarte.modeleQrCodeSticker.name\" ng-change=\"main.changeModeleQrCodeSticker(modeleqrcodesticker)\" required=\"\"> <label for=\"modeleqrcodesticker\"><div class=\"fond-img\"><img ng-src=\"{{ modeleqrcodesticker.field_modele_qrcode_image }}\" alt=\"{{ modeleqrcodesticker.name }}\" class=\"row\"></div><span class=\"modeles-qrcode-description\"><span class=\"name-support modele-qrcode-name\">{{ modeleqrcodesticker.name }}</span> <span class=\"custom-check\"></span></span></label> <input ng-model=\"main.ctx.project.infocarte.modeleQrCodeSticker.image\" type=\"text\" value=\"{{ modeleqrcodesticker.field_modele_qrcode_image }}\" style=\"visibility: hidden; height: 0; width: 0;\"></div></div></div><div ng-if=\"main.submitted && validation.modeleqrcodesticker.$invalid\" class=\"error-msg col-sm-4\">Veuillez choisir un modèles d\'impression.</div></div></fieldset><fieldset class=\"col-sm-12 exemplaires-carte\" ng-if=\"main.ctx.project.infocarte.qrcode == \'oui\'\"><h2>Nombre d\'exemplaire à imprimer</h2><div class=\"form-group exemplaire\"><label class=\"col-sm-5\">Nb exemplaire QrCode&#8239;:</label><div class=\"col-sm-3\"><select name=\"nbExemplaireQrCode\" class=\"form-control nbExemplaire\" id=\"nbExemplaireQrCode\" ng-model=\"main.ctx.project.infocarte.nombreExemplaireQrCode\" ng-class=\"{true: \'error\'}[main.submitted && validation.nbExemplaireQrCode.$invalid]\" required=\"\"><option value=\"\"></option><option ng-repeat=\"item in main.nbrCarteQrCode\" value=\"{{ item }}\">{{ item }}</option></select></div><div ng-if=\"main.submitted && validation.nbExemplaireQrCode.$invalid\" class=\"error-msg col-sm-4\">Choisir le nombre d\'exemplaire de QrCode</div></div></fieldset></form><div class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"da.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(support)\" ng-if=\"da.isUpdate()t\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(support)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></div>");
$templateCache.put("app/da/da-02-format/da-02-format.html","<div class=\"container text-center\"><form name=\"format\" class=\"row\"><fieldset class=\"formats-carte col-sm-12\"><h2>Sélectionner le format de votre choix</h2><div class=\"form-group row\" id=\"errorFormat\"><div ng-if=\"main.submitted && format.format.$invalid\" class=\"error-msg text-left\">Le choix d\'un format est obligatoire</div><div class=\"col-sm-4\" ng-class=\"{true: \'error\'}[main.submitted && format.format.$invalid]\" ng-repeat=\"(key,format) in main.formats\"><div class=\"checkbox\"><input type=\"radio\" name=\"format\" id=\"format{{$index}}\" value=\"{{format.name}}\" class=\"col-sm-2\" ng-model=\"main.ctx.project.infocarte.format.name\" ng-change=\"main.formatChange(format)\" required=\"\"> <label><div class=\"fond-img\"><img ng-src=\"{{ format.field_media_image_3 }}\" alt=\"{{format.name}}\" title=\"{{format.name}}\" class=\"row\"></div><span class=\"format-description\"><span class=\"name-support\">{{ format.name }}</span> <span class=\"help-block\">{{ format.field_media_format }}</span> <span class=\"custom-check\"></span></span></label> <input ng-model=\"main.ctx.project.infocarte.format.media_format\" type=\"text\" value=\"{{ format.field_media_format }}\" style=\"visibility: hidden; height: 0; width: 0;\"></div></div></div></fieldset><fieldset class=\"col-sm-12\"><h2>Matière</h2><div class=\"col-sm-3\"><select name=\"matiereFormat\" class=\"form-control matiereFormat\" id=\"matiereFormat\" ng-model=\"main.ctx.project.infocarte.matiereFormat\" ng-class=\"{true: \'error\'}[main.submitted && validation.matiereFormat.$invalid]\" required=\"\" ng-if=\"main.ctx.project.infocarte.format.field_1_volet == \'oui\' && main.ctx.project.infocarte.format.field_2_volets == \'non\'\" ng-options=\"material.name as material.name for material in main.materials | filter:{field_1_volet:\'oui\'}\"></select><select name=\"matiereFormat\" class=\"form-control matiereFormat\" id=\"matiereFormat\" ng-model=\"main.ctx.project.infocarte.matiereFormat\" ng-class=\"{true: \'error\'}[main.submitted && validation.matiereFormat.$invalid]\" required=\"\" ng-if=\"main.ctx.project.infocarte.format.field_2_volets == \'oui\'\" ng-options=\"material.name as material.name for material in main.materials | filter:{field_2_volets:\'oui\'}\"></select></div><div ng-if=\"main.submitted && validation.matiereFormat.$invalid\" class=\"error-msg col-sm-4\">Choisir la matière</div></fieldset><div><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"da.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(format)\" ng-if=\"da.isUpdate()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" id=\"submit-format\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validateFormat(format)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form></div>");
$templateCache.put("app/da/da-03-brief/da-03-brief.html","<script>\r\n    ClassicEditor\r\n            .create( document.querySelector( \'#briefPDA\' ), {\r\n              fontSize: {\r\n                  options: [\r\n                      9,\r\n                      11,\r\n                      13,\r\n                      \'default\',\r\n                      17,\r\n                      19,\r\n                      21\r\n                  ],\r\n                  supportAllValues: true\r\n              },\r\n              toolbar: [ \'heading\', \'bold\', \'italic\', \'fontSize\', \'link\', \'bulletedList\', \'numberedList\' ]\r\n            } )\r\n            .then( editor => {\r\n              editor.setData(document.querySelector( \'#briefPDA\' ).value);\r\n              editor.model.document.on(\'change:data\', () => {\r\n                document.querySelector( \'#briefPDA\' ).value  = editor.getData();\r\n              })\r\n            } )\r\n            .catch( error => {\r\n              console.error( error );\r\n            } );\r\n</script><alert-message></alert-message><div class=\"container text-center\"><form class=\"format form-horizontal charte-support\" name=\"charteForm\"><div class=\"col-sm-12\"><h2>Brief détaillé &#8239;:</h2></div><div class=\"col-sm-12 form-group\"><textarea id=\"briefPDA\" name=\"briefPDA\" rows=\"8\" cols=\"60\" ng-model=\"main.project.briefPDA\" class=\"form-control\" ng-class=\"{true: \'error\'}[main.submitted && main.briefPDA.$invalid]\">\r\n                </textarea></div><div class=\"col-sm-3\"><h2>Charte à intégrer &#8239;:</h2></div><div class=\"col-sm-9 radio-custom\"><div class=\"text-left\" ng-class=\"{true: \'error\'}[main.submitted && charteForm.charteClient.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"charteClient\" ng-model=\"main.ctx.project.charte.charteClient\" value=\"oui\" required=\"\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"charteClient\" ng-model=\"main.ctx.project.charte.charteClient\" value=\"non\" required=\"\"> <label>NON</label></div></div></div><div ng-if=\"main.submitted && charteForm.charteClient.$invalid\" class=\"error-msg text-left col-sm-12 text-center\">Photo obligatoire</div><div class=\"col-sm-12 charte-details\" ng-if=\"main.ctx.project.charte.charteClient === \'oui\'\"><div class=\"charteCCE_no\"><div class=\"photo_charte\"><h3>Afin d\'expliquer votre charte, merci de joindre une photo de votre charte :</h3><p class=\"help-block\">Merci de prendre une photo de bonne qualité et de vérifier la lisibilité du texte.</p><photo-upload photos-obj=\"main.ctx.project.charte.photo_charte\" uploader=\"main.uploader\" file-type=\"\'photo_charte\'\" annotation-enabled=\"true\"></photo-upload><photo-list photos-obj=\"main.ctx.project.charte.photo_charte\" files-project=\"main.filesProject\"></photo-list></div></div><progress-bar-upload ng-show=\"main.uploader.queue.length\" uploader=\"main.uploader\" class=\"col-sm-12\"></progress-bar-upload></div><div class=\"col-sm-3\"><h2>Logo à intégrer &#8239;:</h2></div><div class=\"col-sm-9 radio-custom\"><div class=\"text-left\" ng-class=\"{true: \'error\'}[main.submitted && charteForm.logoClient.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"logoClient\" ng-model=\"main.ctx.project.charte.logoClient\" value=\"oui\" required=\"\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"logoClient\" ng-model=\"main.ctx.project.charte.logoClient\" value=\"non\" required=\"\"> <label>NON</label></div></div></div><div ng-if=\"main.submitted && charteForm.logoClient.$invalid\" class=\"error-msg text-left col-sm-12 text-center\">Photo obligatoire</div><div class=\"col-sm-12 charte-details\" ng-if=\"main.ctx.project.charte.logoClient === \'oui\'\"><div class=\"charteCCE_no\"><div class=\"photo_logo\"><p class=\"help-block\">Merci de prendre une photo de bonne qualité et de vérifier la lisibilité du texte.<br>Le logo en HD doit être envoyé à l\'agence par mail.</p><photo-upload photos-obj=\"main.ctx.project.charte.photo_logo\" uploader=\"main.uploader\" file-type=\"\'photo_logo\'\" annotation-enabled=\"true\"></photo-upload><photo-list photos-obj=\"main.ctx.project.charte.photo_logo\" files-project=\"main.filesProject\"></photo-list></div></div><progress-bar-upload ng-show=\"main.uploader.queue.length\" uploader=\"main.uploader\" class=\"col-sm-12\"></progress-bar-upload></div><div class=\"col-sm-3\"><h2>Typographie à intégrer &#8239;:</h2></div><div class=\"col-sm-9 radio-custom\"><div class=\"text-left\" ng-class=\"{true: \'error\'}[main.submitted && charteForm.typoClient.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"typoClient\" ng-model=\"main.ctx.project.charte.typoClient\" value=\"oui\" required=\"\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"typoClient\" ng-model=\"main.ctx.project.charte.typoClient\" value=\"non\" required=\"\"> <label>NON</label></div></div></div><div ng-if=\"main.submitted && charteForm.typoClient.$invalid\" class=\"error-msg text-left col-sm-12 text-center\">Photo obligatoire</div><div class=\"typographie_charte form-group col-sm-12\" ng-if=\"main.ctx.project.charte.typoClient === \'oui\'\"><div class=\"charteCCE_no\"><div class=\"photo_typo\"><p class=\"help-block\">Merci de prendre une photo de bonne qualité et de vérifier la lisibilité du texte.</p><photo-upload photos-obj=\"main.ctx.project.charte.photo_typo\" uploader=\"main.uploader\" file-type=\"\'photo_typo\'\" annotation-enabled=\"true\"></photo-upload><photo-list photos-obj=\"main.ctx.project.charte.photo_typo\" files-project=\"main.filesProject\"></photo-list></div></div><progress-bar-upload ng-show=\"main.uploader.queue.length\" uploader=\"main.uploader\" class=\"col-sm-12\"></progress-bar-upload><div class=\"control-group col-sm-12\"><label for=\"nomTypoClient\" class=\"control-label\">Nom de la Typographie (si connue) :</label><div class=\"controls\"><input type=\"text\" name=\"nomTypoClient\" ng-model=\"main.ctx.project.charte.nomTypoClient\" class=\"form-control\"></div></div></div><div class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"da.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(charteForm)\" ng-if=\"da.isUpdate()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" id=\"submit-brief\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(charteForm)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form></div>");
$templateCache.put("app/da/da-04-contenu/da-04-contenu.html","<alert-message></alert-message><div class=\"container text-center photo-carte\"><h2>Veuillez renseigner le contenu de la carte à saisir.</h2><form class=\"form-horizontal-photo row\" name=\"filecarte\" novalidate=\"\"><fieldset class=\"col-sm-12 list-photo-added\"><h4>Liste des fichier déjà fournis:</h4><ul class=\"list-group\"><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"(key,photo) in main.ctx.project.contenu\"><uib-accordion-heading>{{photo.photo}}<i class=\"pull-right glyphicon glyphicon-chevron-down\"></i></uib-accordion-heading><table class=\"table\"><tr><td>Modifications: {{ photo.modificationCarte }}</td><td class=\"photo-picto-group\"><a class=\"photo-pencil\" ng-click=\"main.modifCarte(photo)\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></a></td></tr><tr ng-if=\"photo.anno.length > 0\"><td><p>Post-It:</p><ol><li ng-repeat=\"(key,postit) in photo.anno\">{{ postit.text }}</li></ol></td><td></td></tr></table></div></uib-accordion></ul></fieldset><fieldset class=\"panel col-sm-12\" ng-repeat=\"(key,item) in main.uploader.queue | filter:{myplv_file_type: main.file_type}\"><div class=\"well index--{{$index}}\"><div class=\"text-right\"><span ng-click=\"main.deletePhoto($index, item)\" class=\"glyphicon glyphicon-trash\"></span></div><div class=\"form-group\"><label ng-bind=\"item.file.name\" class=\"col-sm-6\"></label><div class=\"col-sm-6\"><input type=\"hidden\" ng-init=\"main.ctx.project.contenu[item.file.firtsName].photo = item.file.name\" value=\"{{item.file.name}}\" readonly=\"\"></div><p ng-show=\"main.uploader.isHTML5\" nowrap=\"\" class=\"col-sm-3\">Taille : {{ item.file.size / 1024 / 1024|number:2 }} MB</p></div><div class=\"form-group\"><label for=\"modification\" class=\"col-sm-3 control-label\">Modification à apporter&#8239;:</label><div class=\"col-sm-9\"><textarea class=\"form-control\" id=\"modification\" name=\"modification\" ng-model=\"main.ctx.project.contenu[item.file.firtsName].modificationCarte\"></textarea></div></div></div></fieldset><fieldset class=\"panel col-sm-12\"><span class=\"help-block\">Attention à donner le fichier le plus clair possible au niveau des appellations et des prix,. Formats autorisés : Word, Excel, PDF, Illustrator, Photoshop</span><div class=\"photo-action\"><div class=\"form-group\"><label for=\"photo\" class=\"col-sm-3 control-label\">Ajouter un fichier&#8239;:</label><div class=\"\"><input type=\"file\" accept=\"application/pdf,.doc,.docx,application/msword,.xls,.psd,.ai\" class=\"form-control\" id=\"photo\" name=\"photo\" nv-file-select=\"\" uploader=\"main.uploader\" options=\"{file_type:\'photo_carte\'}\" sn-model-file=\"main.file\" multiple=\"\"></div></div></div></fieldset><progress-bar-upload ng-show=\"main.uploader.queue.length\" uploader=\"main.uploader\" class=\"col-sm-12\"></progress-bar-upload><fieldset id=\"errorIllustrations\" class=\"illustrations col-sm-12\"><h2>Sélectionner les illustrations additionnelles que vous souhaitez voir apparaître sur la carte</h2><div class=\"form-group row\"><div ng-if=\"main.submitted && main.nbIllust <= 0\" class=\"error-msg text-left\">Veuillez choisir au moins une des options</div><div class=\"col-sm-4\" ng-class=\"{true: \'error\'}[main.submittedFormat && illustration.format.$invalid]\" ng-repeat=\"(key,illustration) in main.illustrations\"><div class=\"checkbox\"><input type=\"checkbox\" name=\"illustration{{$index}}\" id=\"illustration{{$index}}\" ng-true-value=\"\'{{illustration.name}}\'\" class=\"col-sm-2\" ng-model=\"main.ctx.project.infocarte.illustrations[key].name\" ng-change=\"main.removeIllustrat(main.ctx.project.infocarte.illustrations[key] ,illustration.field_media_image_illustration, $index)\" required=\"\"> <label><div class=\"fond-img\"><img ng-src=\"{{ illustration.field_media_image_illustration }}\" alt=\"\" class=\"row\"></div><span class=\"format-description\"><span class=\"name-illustration\">{{ illustration.name }}</span><span class=\"custom-check\"></span></span></label></div></div></div></fieldset><div class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"da.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(filecarte)\" ng-if=\"da.isUpdate()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(filecarte)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form></div><script type=\"text/ng-template\" id=\"confirmDelePhoto.html\"><div class=\"modal-body alert-delete-photo\" id=\"modal-body-alert-delete-photo\"> <div class=\"modal-header\"><h2 class=\"text-center\">Voulez vraiment supprimer cette photo ?</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"$close()\">OUI</button> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">ANNULER</button> </div> </div></script><script type=\"text/ng-template\" id=\"modifPhoto.html\"><div class=\"modal-body alert-modif-photo\" id=\"modal-body-alert-modif-photo\"> <div class=\"modal-header\"><h2 class=\"text-center\">Modification de la carte</h2></div> <div class=\"modal-body\"> <textarea name=\"modifphoto\" id=\"\" cols=\"30\" rows=\"10\" ng-model=\"vm.photoModif\"></textarea> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">ANNULER</button> <button class=\"btn btn-default\" ng-click=\"vm.validate()\">VALIDER</button> </div> </div></script>");
$templateCache.put("app/da/da-05-livraison/da-05-livraison.html","<alert-message></alert-message><div class=\"container text-center livraison\"><form class=\"form-horizontal\" name=\"livraison\"><fieldset class=\"col-sm-12 form-adresse-livraison\"><div class=\"form-group\"><label class=\"text-left label-adresse-livraison\">ENTRER l\'ADRESSE DE LIVRAISON&#8239;:</label><div class=\"form-group nom-point-vente-livraison\"><label for=\"nompdv\" class=\"col-sm-4 control-label\">NOM DU POINT DE VENTE&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nompdv\" name=\"nompdv\" ng-model=\"main.ctx.project.pdv.adresseLivraison.nomPDV\" ng-class=\"{true: \'error\'}[main.submitted && livraison.nompdv.$invalid]\" required=\"\"></div><div ng-if=\"main.submitted && livraison.nompdv.$invalid\" class=\"text-left col-sm-3 error-msg\">Point de vente obligatoire</div></div><div class=\"form-group adresse-livraison\"><label for=\"adresse\" class=\"col-sm-4 control-label\">ADRESSE&#8239;:</label><div class=\"col-sm-5\"><textarea type=\"text\" class=\"form-control\" id=\"adresse\" name=\"adresse\" ng-model=\"main.ctx.project.pdv.adresseLivraison.adresse\" ng-class=\"{true: \'error\'}[main.submitted && livraison.adresse.$invalid]\" required=\"\"></textarea></div><div ng-if=\"main.submitted && livraison.adresse.$invalid\" class=\"text-left col-sm-3 error-msg\">Adresse obligatoire</div></div><div class=\"form-group code-postal-livraison\"><label for=\"codepostale\" class=\"col-sm-4 control-label\">CODE POSTAL&#8239;:</label><div class=\"col-sm-5\"><input type=\"number\" class=\"form-control\" id=\"codepostale\" name=\"codepostale\" ng-pattern=\"/^(\\d{5}-\\d{4}|\\d{5})$/\" max=\"99999\" ng-model=\"main.ctx.project.pdv.adresseLivraison.codePostale\" ng-class=\"{true: \'error\'}[main.submitted && livraison.codepostale.$invalid]\" required=\"\"></div><div ng-if=\"main.submitted && livraison.codepostale.$invalid && !livraison.codepostale.$error.pattern\" class=\"text-left col-sm-3 error-msg\">Code Postal obligatoire</div><div ng-if=\"main.submitted && livraison.codepostale.$error.pattern\" class=\"text-left col-sm-3 error-msg\">Code Postal incorrect</div></div><div class=\"form-group ville-livraison\"><label for=\"ville\" class=\"col-sm-4 control-label\">VILLE&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" name=\"ville\" id=\"ville\" class=\"form-control\" ng-model=\"main.ctx.project.pdv.adresseLivraison.ville\" ng-class=\"{true: \'error\'}[main.submitted && livraison.ville.$invalid]\" required=\"\"></div><div ng-if=\"main.submitted && livraison.ville.$invalid\" class=\"text-left col-sm-3 error-msg\">Ville obligatoire</div></div><div class=\"form-group nom-gerant-livraison\"><label for=\"gerant\" class=\"col-sm-4 control-label\">NOM DU GéRANT&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"gerant\" name=\"gerant\" ng-model=\"main.ctx.project.pdv.adresseLivraison.gerant\" ng-class=\"{true: \'error\'}[main.submitted && livraison.gerant.$invalid]\" required=\"\"></div><div ng-if=\"main.submitted && livraison.gerant.$invalid\" class=\"text-left col-sm-3 error-msg\">Nom Gérant obligatoire</div></div><div class=\"form-group telephone-livraison\"><label for=\"telephone\" class=\"col-sm-4 control-label\">TéLéPHONE&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" class=\"form-control\" id=\"telephone\" name=\"telephone\" ng-model=\"main.ctx.project.pdv.adresseLivraison.telephone\" ng-class=\"{true: \'error\'}[main.submitted && livraison.telephone.$invalid]\" required=\"\"></div><div ng-if=\"main.submitted && livraison.telephone.$invalid\" class=\"text-left col-sm-3 error-msg\">Téléphone obligatoire</div></div></div></fieldset></form></div><div class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"da.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(livraison)\" ng-if=\"da.isUpdate()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(livraison)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Terminer</a></div><script type=\"text/ng-template\" id=\"confirmationProjet.html\"><div class=\"modal-body-alert-agence modal-body\" id=\"modal-body-alert-agence\"> <div class=\"modal-header\"><h2 class=\"text-center\">Vous êtes sur le point d\'envoyer ce projet à l\'agence. </h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"$close()\">Confirmer</button> </div> </div></script><script type=\"text/ng-template\" id=\"sendMsg.html\"><div class=\"modal-body\" id=\"modal-body-msg\"> <div class=\"modal-header\"><h2>{{ vm.text }}</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"$close()\">OK</button> </div> </div></script><script type=\"text/ng-template\" id=\"signatureClient.html\"><div class=\"modal-body signature\" id=\"modal-body-signature-client\"> <div class=\"modal-header\"> <h2>Signature du Client</h2> <div class=\"mentions-signature\"> <p>Je certifie que les informations renseignées dans le bon de commande sont exactes.</p> <p>Les informations recueillies dans le cadre du site MY PLV (ci-après le « Site ») font l’objet d’un traitement informatique par CCEP destiné à la gestion du Site et de la relation client. Les destinataires des données sont CCE et ses prestataires. En application de la loi « Informatique et Libertés » du 6 janvier 1978, les destinataires du Site disposent d’un droit d’accès, de modification, de rectification et de suppression des données qui les concernent. Pour exercer ce droit, ils peuvent s’adresser à CCEP en écrivant à l’adresse ci-contre : Coca-Cola European Partners – 9, chemin de Bretagne 92784 Issy-les-Moulineaux Cedex 9 – France.</p> </div> </div> <div class=\"modal-body\"> <signature-pad accept=\"accept\" clear=\"clear\" height=\"320\" width=\"640\"></signature-pad> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-clear\" ng-click=\"clear()\">Effacer signature</button> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.done()\">Signer</button> </div> </div></script>");
$templateCache.put("app/da/da-recapitulatif/da-recapitulatif.html","<div class=\"container-fluid recapitulatif\" id=\"project-view\"><div class=\"container-project\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>0.</span>INFORMATIONS CLIENT</div><div class=\"panel-body\"><p>Nom du point de vente : <span>{{ main.ctx.project.pdv.nomPDV }}</span></p><p>Adresse : <span>{{ main.ctx.project.pdv.adresse }}</span></p><p>CP : <span>{{ main.ctx.project.pdv.codePostal }}</span></p><p>Ville : <span>{{ main.ctx.project.pdv.ville }}</span></p><p>Téléphone : <span>{{ main.ctx.project.pdv.telephone }}</span></p><p>N°Siret : <span>{{ main.ctx.project.pdv.nSiret }}</span></p><p>RCS : <span>{{ main.ctx.project.pdv.rcs }}</span></p><p>Nom du Gérant: <span>{{ main.ctx.project.pdv.nomClient }}</span></p><p>Téléphone du Gérant: <span>{{ main.ctx.project.pdv.telephoneCLient }}</span></p><p>Email du Gérant: <span>{{ main.ctx.project.pdv.emailCLient }}</span></p></div><div class=\"panel-body\"><div class=\"\"><div class=\"row\"><p>Gamme(s) mise(s) en avant sur ce support :</p><span style=\"color:#DE0B1C\"><div class=\"boisson-cce\"><span ng-repeat=\"(key,boissons) in main.ctx.project.boissons\" class=\"col-sm-4\"><p>{{ key }}</p><span ng-repeat=\"boisson in boissons\">- {{ boisson.name }}<br></span></span></div></span></div></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>1.</span>Support</div><div class=\"panel-body\"><div class=\"\"><p>Nom du Projet: <span>{{ main.ctx.project.idprojet.nameProjet }}</span></p></div><div class=\"\"><p>Nombre d\'exemplaire de carte à imprimer : <span>{{ main.ctx.project.infocarte.nombreExemplaire }}</span></p><p>Version téléchargeable avec QrCode: <span>{{ main.ctx.project.infocarte.qrcode }}</span></p></div><div class=\"\" ng-if=\"main.ctx.project.infocarte.qrcode == \'oui\'\"><p>Modèle d\'impression des vignettes du QrCode : <span>{{ main.ctx.project.infocarte.modeleQrCodeSticker.name }}</span></p><p>Nombre d\'exemplaire de QrCode à imprimer : <span>{{ main.ctx.project.infocarte.nombreExemplaireQrCode }}</span></p></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>2.</span>Format</div><div class=\"panel-body\"><div class=\"\"><p>Format choisi : <span>{{ main.ctx.project.infocarte.format.name }}</span></p><p>Matière choisie: <span>{{ main.ctx.project.infocarte.matiereFormat }}</span></p></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>3.</span>Brief</div><div class=\"panel-body\"><div class=\"\"><p style=\"color:black\">Brief: <span style=\"color:#DE0B1C\">{{ main.ctx.project.briefPDA }}</span></p></div><div class=\"row\"><div class=\"row\"><div class=\"row\"><div class=\"col-sm-12\" style=\"color:#DE0B1C\"><p>CHARTE A INTEGRER : {{ main.ctx.project.charte.charteClient }}</p></div></div><div style=\"color:#DE0B1C\" ng-if=\"main.ctx.project.charte.photo_charte\"><div class=\"photo row\"><div class=\"col-sm-12 photo-charte\"><div ng-repeat=\"photo in main.ctx.project.charte.photo_charte\"><div ng-if=\"photo.photo\"><div ng-repeat=\"file in files\"><div class=\"photo\" ng-if=\"file.namePhoto == \'photo_charte_\'~photo.photo\"><p><span class=\"name-photo\">{{ photo.photo }} : {{ photo.comment }}</span></p><ol class=\"list-annos\" ng-if=\"photo.anno\"><li class=\"anno\" ng-repeat=\"anno in photo.anno\">{{ anno.text }}</li></ol></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"row\"><div class=\"col-sm-12\" style=\"color:#DE0B1C\"><p>LOGO A INTEGRER : {{ main.ctx.project.charte.logoClient }}</p></div></div><div style=\"color:#DE0B1C\" ng-if=\"main.ctx.project.charte.photo_logo\"><div class=\"photo row\"><div class=\"col-sm-12 photo-logo\"><div ng-repeat=\"photo in main.ctx.project.charte.photo_logo\"><div ng-if=\"photo.photo\"><div ng-repeat=\"file in files\"><div class=\"photo\" ng-if=\"file.namePhoto == \'photo_logo_\'~photo.photo\"><p><span class=\"name-photo\">{{ photo.photo }} : {{ photo.comment }}</span></p><ol class=\"list-annos\" ng-if=\"photo.anno\"><li class=\"anno\" ng-repeat=\"anno in photo.anno\">{{ anno.text }}</li></ol></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"row\"><div class=\"col-sm-12\" style=\"color:#DE0B1C\"><p>TYPOGRAPHIE A INTEGRER : {{ main.ctx.project.charte.typoClient }}</p></div><div class=\"col-sm-12\" style=\"color:#DE0B1C\" ng-if=\"main.ctx.project.nomTypoClient\"><p>Nom de la Typographie : {{ main.ctx.project.charte.nomTypoClient }}</p></div></div><div style=\"color:#DE0B1C\" ng-if=\"main.ctx.project.charte.photo_typo\"><div class=\"photo row\"><div class=\"col-sm-12 photo-typo\"><div ng-repeat=\"photo in main.ctx.project.charte.photo_typo\"><div ng-if=\"photo.photo\"><div ng-repeat=\"file in files\"><div class=\"photo\" ng-if=\"file.namePhoto == \'photo_typo_\'~photo.photo\"><p><span class=\"name-photo\">{{ photo.photo }} : {{ photo.comment }}</span></p><ol class=\"list-annos\" ng-if=\"photo.anno\"><li class=\"anno\" ng-repeat=\"anno in photo.anno\">{{ anno.text }}</li></ol></div></div></div></div></div></div></div></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>4.</span>Contenu</div><div class=\"panel-body\"><div class=\"\"><p style=\"color:black\">Fichier(s):</p></div><div class=\"\"><div ng-repeat=\"file in main.ctx.project.contenu\"><p><span class=\"name-photo\">{{ file.photo }} : {{ file.modificationCarte }}</span></p></div></div></div><div class=\"panel-body\"><div class=\"row\"><p class=\"recap-illustration\" ng-if=\"main.ctx.project.infocarte.illustrations.name\">Illustrations à intégrer :<br><span>{{ projet.infocarte.illustrations.name }}</span> <span class=\"recap-illust-name\" ng-repeat=\"illust in main.ctx.project.infocarte.illustrations\">{{ illust.name }}{{loop.last ? \'\' : (loop.index!=projet.infocarte.illustrations.length-2) ? \'\' : \'\'}}<br></span></p></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>5.</span>Livraison</div><div class=\"panel-body\"><div class=\"\"><p>Adresse de livraison : <span>{{ main.ctx.project.pdv.adresseLivraison.nomPDV }}<br>{{ main.ctx.project.pdv.adresseLivraison.adresse }}, {{ main.ctx.project.pdv.adresseLivraison.codePostale }} {{ projet.pdv.adresseLivraison.ville }}<br>Gérant : {{ main.ctx.project.pdv.adresseLivraison.gerant }}. Téléphone : {{ main.ctx.project.pdv.adresseLivraison.telephone }}</span></p></div></div></div></div>");
$templateCache.put("app/main/accueil-agence/accueil-agence.html","<div class=\"group-btn-agence col-sm-7 accueil-agence-component\"><h1>Séléction du statut des projets</h1><div class=\"count-mise-en-avant\"><div class=\"card-statut-projet card-statut-agence\" ng-click=\"vm.go(\'dashboard\',\'Agence\')\"><h3>Agence</h3><p><span>{{vm.countByStatus[\'Agence\'] ? vm.countByStatus[\'Agence\'] : 0}}</span> <span>{{ vm.singular(vm.countByStatus[\'Agence\'] ? vm.countByStatus[\'Agence\'] : 0)}}</span></p></div><div class=\"card-statut-projet card-statut-execution\" ng-click=\"vm.go(\'dashboard\',\'Exécution\')\"><h3>Exécution</h3><p><span>{{vm.countByStatus[\'Exécution\'] ? vm.countByStatus[\'Exécution\'] : 0}}</span> <span>{{ vm.singular(vm.countByStatus[\'Exécution\'] ? vm.countByStatus[\'Exécution\'] : 0)}}</span></p></div></div><div class=\"count-default-style\"><div class=\"card-statut-projet card-statut-brouillon\" ng-click=\"vm.go(\'dashboard\',\'Brouillon\')\"><h3>Brouillon</h3><p><span>{{vm.countByStatus[\'Brouillon\'] ? vm.countByStatus[\'Brouillon\'] : 0}}</span> <span>{{ vm.singular(vm.countByStatus[\'Brouillon\'] ? vm.countByStatus[\'Brouillon\'] : 0)}}</span></p></div><div class=\"card-statut-projet card-statut-validation-dc\" ng-click=\"vm.go(\'dashboard\',\'Validation DC\')\"><h3>Validation DC</h3><p><span>{{vm.countByStatus[\'Validation DC\'] ? vm.countByStatus[\'Validation DC\'] : 0}}</span> <span>{{ vm.singular(vm.countByStatus[\'Validation DC\'] ? vm.countByStatus[\'Validation DC\'] : 0)}}</span></p></div><div class=\"card-statut-projet card-statut-validation-client\" ng-click=\"vm.go(\'dashboard\',\'Validation Client\')\"><h3>Validation Client</h3><p><span>{{vm.countByStatus[\'Validation Client\'] ? vm.countByStatus[\'Validation Client\'] : 0}}</span> <span>{{ vm.singular(vm.countByStatus[\'Validation Client\'] ? vm.countByStatus[\'Validation Client\'] : 0)}}</span></p></div></div><div class=\"count-mise-en-avant\"><div class=\"card-statut-projet card-statut-impression\" ng-click=\"vm.go(\'dashboard\',\'Impression\')\"><h3>Impression</h3><p><span>{{vm.countByStatus[\'Impression\'] ? vm.countByStatus[\'Impression\'] : 0}}</span> <span>{{ vm.singular(vm.countByStatus[\'Impression\'] ? vm.countByStatus[\'Impression\'] : 0)}}</span></p></div><div class=\"card-statut-projet card-statut-imprime\" ng-click=\"vm.go(\'dashboard\',\'Imprimé\')\"><h3>Imprimé</h3><p><span>{{vm.countByStatus[\'Imprimé\'] ? vm.countByStatus[\'Imprimé\'] : 0}}</span> <span>{{ vm.singular(vm.countByStatus[\'Imprimé\'] ? vm.countByStatus[\'Imprimé\'] : 0)}}</span></p></div></div></div>");
$templateCache.put("app/main/accueil-imprimeur/accueil-imprimeur.html","<div class=\"group-btn-agence col-sm-7 accueil-imprimeur-component\"><h1>Séléction du statut des projets</h1><div class=\"count-mise-en-avant\"><div class=\"card-statut-projet card-statut-brouillon\" ng-click=\"vm.go(\'dashboard\',\'Brouillon\')\"><h3>Brouillon</h3><p><span>{{vm.countByStatus[\'Brouillon\'] ? vm.countByStatus[\'Brouillon\'] : 0}}</span> <span>{{ vm.singular(vm.countByStatus[\'Brouillon\'] ? vm.countByStatus[\'Brouillon\'] : 0)}}</span></p></div><div class=\"card-statut-projet card-statut-agence\" ng-click=\"vm.go(\'dashboard\', \'Agence\')\"><h3>Agence</h3><p><span>{{vm.countByStatus[\'Agence\'] ? vm.countByStatus[\'Agence\'] : 0}}</span> <span>{{ vm.singular(vm.countByStatus[\'Agence\'] ? vm.countByStatus[\'Agence\'] : 0)}}</span></p></div></div><div class=\"count-default-style\"><div class=\"card-statut-projet card-statut-impression\" ng-click=\"vm.go(\'dashboard\',\'Impression\')\"><h3>Impression</h3><p><span>{{vm.countByStatus[\'Impression\'] ? vm.countByStatus[\'Impression\'] : 0}}</span> <span>{{ vm.singular(vm.countByStatus[\'Impression\'] ? vm.countByStatus[\'Impression\'] : 0)}}</span></p></div><div class=\"card-statut-projet card-statut-imprime\" ng-click=\"vm.go(\'dashboard\',\'Imprimé\')\"><h3>Imprimé</h3><p><span>{{vm.countByStatus[\'Imprimé\'] ? vm.countByStatus[\'Imprimé\'] : 0}}</span> <span>{{ vm.singular(vm.countByStatus[\'Imprimé\'] ? vm.countByStatus[\'Imprimé\'] : 0)}}</span></p></div><div class=\"card-statut-projet card-statut-termine\" ng-click=\"vm.go(\'dashboard\',\'Terminé\')\"><h3>Terminé</h3><p><span>{{vm.countByStatus[\'Terminé\'] ? vm.countByStatus[\'Terminé\'] : 0}}</span> <span>{{ vm.singular(vm.countByStatus[\'Terminé\'] ? vm.countByStatus[\'Terminé\'] : 0)}}</span></p></div></div></div>");
$templateCache.put("app/main/accueil-siege/accueil-siege.html","<div class=\"group-btn-siege col-sm-7\"><div class=\"panel panel-default col-sm-12\"><div class=\"panel-heading text-center\"><span class=\"glyphicon glyphicon-list\" aria-hidden=\"true\"></span> Gestion des projets</div><div class=\"panel-body\"><a type=\"submit\" class=\"btn btn-default\" href=\"\" ui-sref=\"gestion-projets({q_typeProjet:\'CHR\'})\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> <span>CHR</span></a></div><div class=\"panel-body\"><a type=\"submit\" class=\"btn btn-default\" href=\"\" ui-sref=\"gestion-projets({q_typeProjet:\'PDA\'})\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> <span>Direct Agence</span></a></div><div class=\"panel-body\"><a type=\"submit\" class=\"btn btn-default\" href=\"\" ui-sref=\"gestion-projets({q_typeProjet:\'PSM\'})\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> <span>SUR-MESURE</span></a></div></div><h3 class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default\" ui-sref=\"suivi-quotas()\"><span class=\"glyphicon glyphicon-stats\" aria-hidden=\"true\"></span> Suivi des quotas</a></h3><h3 class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default disabled\"><span class=\"glyphicon glyphicon-custom\" aria-hidden=\"true\"></span> Reporting</a></h3></div>");
$templateCache.put("app/sm/sm-01-info-pdv/sm-01-info-pdv.html","<div class=\"container text-center info-pdv\"><info-pdv project=\"main.ctx.project\" validate=\"main.validate()\" save=\"main.save()\" update-project=\"main.updateProject\"></info-pdv></div>");
$templateCache.put("app/sm/sm-02-creation/sm-02-creation-layout.html","<div class=\"container id-projet text-center wrapp creation-sm\"><ul class=\"nav nav-tabs sub-menu text-center\"><li class=\"col-sm-4 disabled\" ng-class=\"{active: sm.$state.is(\'sm.creation.id_projet\')}\"><a disabled=\"\">NOM DU PROJET</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: sm.$state.is(\'sm.creation.support\')}\"><a disabled=\"\">CHOIX DES SUPPORTS</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: sm.$state.is(\'sm.creation.charte\')}\"><a disabled=\"\">CHARTE</a></li></ul><div ui-view=\"\" autoscroll=\"true\"></div></div>");
$templateCache.put("app/sm/sm-03-contenu/sm-03-contenu-layout.html","<div class=\"container text-center contenu\"><ul class=\"nav nav-tabs sub-menu text-center\"><li class=\"col-sm-4 disabled\" ng-class=\"{active: sm.$state.current.name.startsWith(\'sm.contenu.gamme\')}\"><a disabled=\"\">GAMME CCEP</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: sm.$state.current.name.startsWith(\'sm.contenu.edition\')}\"><a disabled=\"\">EDITION</a></li></ul><div ui-view=\"\" autoscroll=\"true\"></div></div>");
$templateCache.put("app/sm/sm-04-autres-infos/sm-04-autres-infos.html","<div class=\"container contenu-info-plus-carte text-center\"><alert-message></alert-message><h2 class=\"text-left\">INFORMATIONS SUPPLÉMENTAIRES</h2><form class=\"form-horizontal row\" name=\"infopluscarte\" id=\"errorAutresInfos\"><fieldset class=\"col-sm-12\"><div class=\"form-group form-logo\"><label class=\"col-sm-3 col-sm-offset-1 control-label\">IMPRESSION &#8239;:</label><div class=\"radio-custom col-sm-5\"><div class=\"text-left\"><div class=\"radio\"><input type=\"radio\" name=\"impression\" ng-model=\"main.ctx.project.autresInfos.impression\" ng-class=\"{true: \'error\'}[main.submitted && infopluscarte.impression.$invalid]\" value=\"oui\" ng-change=\"main.onImpressionChange()\" required=\"\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"impression\" ng-model=\"main.ctx.project.autresInfos.impression\" ng-class=\"{true: \'error\'}[main.submitted && infopluscarte.impression.$invalid]\" value=\"non\" ng-change=\"main.onImpressionChange()\" required=\"\"> <label>NON</label></div></div></div></div></fieldset><div class=\"col-sm-12 contact-pose\"><div class=\"form-group row\"><label for=\"nomContactPose\" style=\"padding-left: 0;\" class=\"col-sm-3 control-label\">Nom du DC&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nomContactPose\" name=\"nomContactPose\" required=\"\" ng-model=\"main.ctx.project.pose.contact.nom\" ng-class=\"{true: \'error\'}[main.submitted && infopluscarte.nomContactPose.$invalid]\" disabled=\"\"></div><div ng-if=\"main.submitted && infopluscarte.nomContactPose.$invalid\" class=\"error-msg col-sm-4 text-left\">Nom du DC obligatoire</div></div><div class=\"form-group row\"><label for=\"emailCntactPose\" style=\"padding-left: 0;\" class=\"col-sm-3 control-label\">Email du DC&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nomContactPose\" name=\"emailContactPose\" required=\"\" ng-model=\"main.ctx.project.pose.contact.email\" ng-class=\"{true: \'error\'}[main.submitted && infopluscarte.emailContactPose.$invalid]\" disabled=\"\"></div><div ng-if=\"main.submitted && infopluscarte.nomContactPose.$invalid\" class=\"error-msg col-sm-4 text-left\">Nom du DC obligatoire</div></div><div class=\"form-group row\"><label for=\"telContactPose\" class=\"col-sm-3 control-label\">Téléphone du DC&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" class=\"form-control\" ng-model=\"main.ctx.project.pose.contact.telephone\" ng-pattern=\"/^0\\d(\\s|-)?(\\d{2}(\\s|-)?){4}$/\" name=\"telContactPose\" id=\"telContactPose\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && infopluscarte.telContactPose.$invalid]\"></div><div ng-if=\"main.submitted && infopluscarte.telContactPose.$invalid && infopluscarte.telContactPose.$error.required\" class=\"error-msg col-sm-4 text-left\">Téléphone portable du DC obligatoire</div><div ng-if=\"main.submitted && infopluscarte.telContactPose.$error.pattern\" class=\"error-msg col-sm-4\">Téléphone incorrect</div></div></div><div class=\"container text-center pose\"><div class=\"pose-vae row form-horizontal\"><fieldset class=\"col-sm-12 choix-pose\"><div class=\"form-group row\"><label class=\"col-sm-6\"><h2>Souhaitez-vous une pose de votre projet par un installeur professionnel ?</h2></label><div class=\"col-sm-4 radio-custom\"><div class=\"text-left\"><div class=\"radio\"><input type=\"radio\" name=\"pose\" ng-model=\"main.ctx.project.pose.pose\" ng-class=\"{true: \'error\'}[main.submitted && infopluscarte.pose.$invalid]\" ng-change=\"main.changePose()\" value=\"oui\" required=\"\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"pose\" ng-model=\"main.ctx.project.pose.pose\" ng-class=\"{true: \'error\'}[main.submitted && infopluscarte.pose.$invalid]\" ng-change=\"main.changePose()\" value=\"non\" required=\"\"> <label>NON</label></div></div></div><div class=\"col-sm-12\" ng-if=\"main.isPose\"><div class=\"col-sm-12\"><label class=\"col-sm-3\">Merci de préciser la pose&#8239;:&#8239;</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" name=\"infoPose\" ng-model=\"main.ctx.project.pose.infoPose\" ng-class=\"{true: \'error\'}[main.submitted && infopluscarte.infoPose.$invalid]\" required=\"\"> <span class=\"help-block\">Exemple:<br>-Fixation sur mur<br>-Pose avec tringle....<br></span></div></div><div class=\"col-sm-6\"></div></div></div></fieldset><fieldset class=\"col-sm-12\" ng-if=\"main.isPose\"><div class=\"form-group\"><h2>Autres Informations</h2><div class=\"col-sm-12 jours-part\"><label class=\"col-sm-11 col-sm-offset-1 jour-label text-left\">Jours d\'ouverture&#8239;:&#8239;</label><div class=\"jours\"><div class=\"checkbox checkbox-custom checkbox-inline\" ng-repeat=\"jour in main.arrayDays\"><input type=\"checkbox\" name=\"jour\" ng-true-value=\"\'{{jour}}\'\" ng-model=\"main.ctx.project.pose.jours[$index]\" ng-change=\"main.choseDay(main.ctx.project.pose.jours, $index)\"> <label class=\"jour\">{{ jour }}</label></div></div></div><div class=\"horaires col-sm-12\"><div class=\"form-group\"><label for=\"heureouverture\" class=\"col-sm-3 ouverture control-label\">Heure d\'ouverture&#8239;:&#8239;</label><div class=\"col-sm-2 group-horaires\"><input type=\"time\" class=\"form-control\" id=\"heureouverture\" name=\"heureouverture\" ng-model=\"main.ctx.project.pose.heureouverture\"></div></div></div><div class=\"horaires col-sm-12\"><div class=\"form-group\"><label for=\"heurefermeture\" class=\"col-sm-3 control-label fermeture\">Heure de fermeture&#8239;:&#8239;</label><div class=\"col-sm-2 group-horaires\"><input type=\"time\" class=\"form-control\" id=\"heurefermeture\" name=\"heurefermeture\" ng-model=\"main.ctx.project.pose.heurefermeture\"></div></div></div></div></fieldset></div></div></form></div><div class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"sm.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-if=\"sm.isUpdate()\" ng-click=\"main.save(infopluscarte)\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(infopluscarte)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div>");
$templateCache.put("app/sm/sm-05-livraison/sm-05-livraison.html","<div class=\"container text-center livraison\"><alert-message></alert-message><form class=\"livraison-sm row form-horizontal\" name=\"livraison\" ng-switch=\"main.ctx.project.autresInfos.impression\"><div ng-switch-when=\"oui\"><h2>Indiquer le nombre d\'exemplaires à imprimer pour chaque support</h2><div class=\"form-group group-livraison row\" ng-repeat=\"support in main.ctx.project.supports\" ng-form=\"livraisonSupport\"><div class=\"part-left-livraison col-sm-6\"><div class=\"format-name-board\"><label class=\"col-sm-12 name-board\">{{support.name}}</label> <span class=\"col-sm-12 help-text board-format\">{{support.type}}</span> <span class=\"col-sm-12 help-text board-format\">{{support.matiere}}</span> <span class=\"col-sm-12 help-text board-format\">{{support.largeur}} x {{support.hauteur}} cm</span></div></div><div class=\"part-right-livraison col-sm-6\"><div class=\"livraison-select-nbr\"><div class=\"form-group\"><label class=\"title-select-livraison\">Nombre d\'exemplaires&#8239;:</label><div class=\"block-select-livraison\"><input type=\"number\" min=\"0\" step=\"1\" class=\"form-control nbExemplaire\" ng-model=\"support.nombreExemplaire\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && livraisonSupport.$invalid]\"></div></div></div></div></div><adresse-livraison project=\"main.ctx.project\" submitted=\"main.submitted\" form=\"livraison\"></adresse-livraison></div><div ng-switch-default=\"\"><h2>Votre projet en haute définition sera envoyé à l\'adresse mail de votre client</h2></div><div class=\"suivant\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"sm.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(livraison)\" ng-if=\"sm.isUpdate()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(livraison)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Terminer</a></div></form></div>");
$templateCache.put("app/sm/sm-06-recapitulatif/sm-06-recapitulatif.html","<div class=\"container-fluid recapitulatif\"><div class=\"container\"><div id=\"alert-message\"><div uib-alert=\"\" class=\"alert alert-fade\" type=\"{{main.alert.type}}\" close=\"main.closeAlert()\" ng-if=\"main.alert.msg != undefined\">{{main.alert.msg}}</div></div><h2 ng-if=\"!sm.isUpdate()\">Votre commande est terminée.<br><span>Veuillez relire votre bon de commande avec attention et vous assurer que :<br>- Les informations de votre client (nom, établissement, coordonnées, etc.) sont correctes<br>- Les informations des supports correspondent au choix de mon client (format, nombre d’exemplaires à imprimer)<br>- Les contenus des supports (boissons, tarifs, formules, etc.) sont conformes</span></h2><div class=\"container-project\"><h1 class=\"text-center\">{{ main.ctx.project.type }}</h1><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>1.</span>INFORMATIONS CLIENT <a ui-sref=\"sm.info-pdv({id: main.ctx.project._id.$oid})\" style=\"float: right;\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit text-right\" aria-hidden=\"true\"></span></a></div><div class=\"panel-body\"><p>Nom du point de vente : <span>{{ main.ctx.project.pdv.nomPDV }}</span></p><p>Adresse : <span>{{ main.ctx.project.pdv.adresse }}</span></p><p>CP : <span>{{ main.ctx.project.pdv.codePostal }}</span></p><p>Ville : <span>{{ main.ctx.project.pdv.ville }}</span></p><p>Téléphone : <span>{{ main.ctx.project.pdv.telephone }}</span></p><p>N°Siret : <span>{{ main.ctx.project.pdv.nSiret }}</span></p><p>RCS : <span>{{ main.ctx.project.pdv.rcs }}</span></p><p>Nom du Gérant: <span>{{ main.ctx.project.pdv.nomClient }}</span></p><p>Téléphone du Gérant: <span>{{ main.ctx.project.pdv.telephoneCLient }}</span></p><p>Email du Gérant: <span>{{ main.ctx.project.pdv.emailCLient }}</span></p></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>2.</span>Création des supports</div><div class=\"panel-body\"><div class=\"\"><div class=\"row\"><a class=\"edit-data\" ui-sref=\"sm.creation.id_projet({id: main.ctx.project._id.$oid})\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a><p>Nom du Projet: <span>{{ main.ctx.project.idprojet.nameProjet }}</span></p><p>Agence: <span>{{ main.ctx.project.agence }}</span></p><p ng-if=\"main.ctx.project.imprimeur\">Imprimeur: <span>{{ main.ctx.project.imprimeur }}</span></p><p ng-if=\"main.ctx.project.briefPSM\" class=\"brief\">Brief:<pre ng-bind-html=\"main.ctx.project.briefPSM\"></pre></p></div><hr><div class=\"row\"><a class=\"edit-data\" ui-sref=\"sm.creation.support({id: main.ctx.project._id.$oid})\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a><p>Choix des supports :</p><div style=\"color:#DE0B1C\"><div class=\"row\"><div ng-repeat=\"board in main.ctx.project.supports\" class=\"support col-sm-6\"><span>- SUPPORT {{$index}} :</span><br><span>NOM : {{ board.name }}</span><br><span>SUPPORT : {{ board.type }}</span><br><span>MATIÈRE : {{ board.matiere }}</span><br><span>DIMENSIONS : {{ board.largeur }} x {{ board.hauteur }} cm</span><br><span>EXEMPLAIRES : {{ board.nombreExemplaire }}</span><br></div></div></div></div><hr><div class=\"row\"><a class=\"edit-data\" ui-sref=\"sm.creation.charte({id: main.ctx.project._id.$oid})\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a><p>Charte :</p><div class=\"isCharteCCE\"><div class=\"row\" style=\"color:#DE0B1C\"><div class=\"col-sm-6\"><span>CHARTE CCEP : {{ main.ctx.project.charte.isCharteCCE }}</span></div><div class=\"col-sm-6\"><span>CHARTE : {{ main.ctx.project.charte.charteCCE }}</span></div></div></div><div style=\"margin-bottom: 20px\"><div class=\"row\" style=\"color:#DE0B1C\"><div class=\"col-sm-12\"><p>CHARTE CLIENT : {{ main.ctx.project.charte.charteClient }}</p></div></div><div class=\"row photo_charte\" style=\"color:#DE0B1C\" ng-if=\"main.ctx.project.charte.charteClient == \'oui\'\"><div ng-repeat=\"(name, photo) in main.ctx.project.charte.photo_charte\"><span>{{photo.photo}}</span> <span ng-if=\"photo.comment\">: {{photo.comment}}</span><div ng-repeat=\"file in main.files\"><img ng-if=\"file.filename.includes(photo.photo)\" src=\"{{file.url}}\" alt=\"impossible de prévisualiser le fichier\"></div></div></div></div><div style=\"margin-bottom: 20px\"><div class=\"row\" style=\"color:#DE0B1C\"><div class=\"col-sm-12\"><p>Logo a intégrer : {{ main.ctx.project.charte.logoClient }}</p></div></div><div class=\"row photo_charte\" style=\"color:#DE0B1C\" ng-if=\"main.ctx.project.charte.logoClient == \'oui\'\"><div ng-repeat=\"(name, photo) in main.ctx.project.charte.photo_logo\"><span>{{photo.photo}}</span> <span ng-if=\"photo.comment\">: {{photo.comment}}</span><div ng-repeat=\"file in main.files\"><img ng-if=\"file.filename.includes(photo.photo)\" src=\"{{file.url}}\" alt=\"impossible de prévisualiser le fichier\"></div></div></div></div><div><div class=\"row\" style=\"color:#DE0B1C\"><div class=\"col-sm-12\"><p>Typographie a intégrer : {{ main.ctx.project.charte.typoClient }}</p></div></div><div class=\"col-sm-12\" ng-if=\"main.ctx.project.charte.nomTypoClient\" style=\"color:#DE0B1C\"><span>Nom de la Typographie : {{ main.ctx.project.charte.nomTypoClient }}</span></div><div class=\"row photo_charte\" style=\"color:#DE0B1C\" ng-if=\"main.ctx.project.charte.typoClient && main.ctx.project.charte.typoClient == \'oui\'\"><div ng-repeat=\"(name, photo) in main.ctx.project.charte.photo_typo\"><span>{{photo.photo}}</span> <span ng-if=\"photo.comment\">: {{photo.comment}}</span><div ng-repeat=\"file in main.files\"><img ng-if=\"file.filename.includes(photo.photo)\" src=\"{{file.url}}\" alt=\"impossible de prévisualiser le fichier\"></div></div></div></div></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>3.</span>Contenu des supports</div><div class=\"row\"><div class=\"panel-body\"><a class=\"edit-data\" ui-sref=\"sm.contenu.gamme({id: main.ctx.project._id.$oid})\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a><p>Gammes :</p><div class=\"row\"><div ng-repeat=\"board in main.ctx.project.supports\" style=\"color:#DE0B1C\" class=\"support col-sm-6\"><span>SUPPORT {{$index}} : {{ board.name }}</span><br><div ng-repeat=\"(famille, boissons) in board.boissons\" ng-if=\"board.boissons\"><span ng-repeat=\"(key, boisson) in boissons\">{{ famille }} {{ boisson.name }}</span></div><div ng-if=\"!board.boissons\"><span>Pas de mise en avant.</span></div></div></div><hr><a class=\"edit-data\" ui-sref=\"sm.contenu.edition({id: main.ctx.project._id.$oid})\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a><p>Edition :</p><div class=\"row\"><div ng-repeat=\"board in main.ctx.project.supports\" style=\"color:#DE0B1C\" class=\"support col-sm-12\"><span>SUPPORT {{$index}} : {{ board.name }}</span><br><div ng-repeat=\"(name, photo) in board.creation\"><p><span>{{photo.photo}}</span> <span ng-if=\"photo.comment\">: {{photo.comment}}</span><div ng-repeat=\"file in main.files\"><img ng-if=\"file.filename.includes(photo.photo)\" src=\"{{file.url}}\" alt=\"impossible de prévisualiser le fichier\"></div></p><ul><li ng-repeat=\"anno in photo.anno\">{{anno.text | json}}</li></ul></div></div></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>4.</span>Autres informations <a ui-sref=\"sm.autres-infos({id: main.ctx.project._id.$oid})\" style=\"float: right;\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit text-right\" aria-hidden=\"true\"></span></a></div><div class=\"panel-body\"><p>Impression : <span>{{ main.ctx.project.autresInfos.impression }}</span></p><p>Contact :<br><b>Nom du Délégué Commercial : <span>{{ main.ctx.project.pose.contact.nom }}</span><br></b> <b>Email du Délégué Commercial : <span>{{ main.ctx.project.pose.contact.email }}</span><br></b> <b>Téléphone du Délégué Commercial : <span>{{ main.ctx.project.pose.contact.telephone }}.</span></b></p><p ng-if=\"main.ctx.project.pose.pose == \'oui\'\">Pose souhaité : <span>OUI.</span><br><b>Pose : <span>{{ main.ctx.project.pose.infoPose }}</span></b><br></p><p ng-if=\"main.ctx.project.pose.pose == \'oui\' && main.ctx.project.pose.jours != undefined\">Jours d\'ouverture : <span ng-repeat=\"jour in main.ctx.project.pose.jours\">{{ jour }}&nbsp;</span></p><p ng-if=\"main.ctx.project.pose.pose == \'oui\' && main.ctx.project.pose.heureouverture != undefined\">Heure d\'ouverture : <span>{{ main.ctx.project.pose.heureouverture | date: \'HH:mm\' }}</span></p><p ng-if=\"main.ctx.project.pose.pose == \'oui\' && main.ctx.project.pose.heurefermeture != undefined\">Heure de fermeture : <span>{{ main.ctx.project.pose.heurefermeture | date: \'HH:mm\' }}</span></p><p ng-if=\"main.ctx.project.pose.pose == \'non\'\"><span>Pas de pose souhaitée</span></p></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>5.</span>Livraison <a ui-sref=\"sm.livraison({id: main.ctx.project._id.$oid})\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a></div><div class=\"panel-body\"><p>Nombre d\'exemplaires</p><div ng-repeat=\"board in main.ctx.project.supports\" style=\"color:#DE0B1C\" class=\"support col-sm-6\"><span>SUPPORT {{$index}} / {{ board.name }} : {{board.nombreExemplaire}}</span><br></div></div><div class=\"panel-body\"><p ng-if=\"main.ctx.project.pdv.adresseIdemCommande == \'non\'\">Adresse de livraison : <span>{{ main.ctx.project.pdv.adresseLivraison.nomPDV }}<br>{{ main.ctx.project.pdv.adresseLivraison.adresse }}, {{ main.ctx.project.pdv.adresseLivraison.codePostale }} {{ main.ctx.project.pdv.adresseLivraison.ville }}<br>Gérant : {{ main.ctx.project.pdv.adresseLivraison.gerant }}. Téléphone : {{ main.ctx.project.pdv.adresseLivraison.telephone }}</span></p><p ng-if=\"main.ctx.project.pdv.adresseIdemCommande == \'oui\'\">Adresse de livraison : <span>Idem au bon de commande</span></p></div></div></div><div class=\"button\"><a type=\"submit\" ng-if=\"!sm.isUpdate() && main.allowedUpdate()\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(infopdv)\"><span class=\"glyphicon glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer et signer le Bon de commande</a><a type=\"submit\" ng-if=\"sm.isUpdate() && main.allowedUpdate()\" class=\"btn btn-default btn-lg\" ng-click=\"main.backSuiviProjet()\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivi du Projet</a> <a type=\"submit\" ng-if=\"!main.allowedUpdate()\" class=\"btn btn-default btn-lg btn-suivi\" ng-click=\"main.backSuiviProjet()\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivi du Projet</a></div></div></div><script type=\"text/ng-template\" id=\"signatureDC.html\"><div class=\"modal-body signature\" id=\"modal-body-signature-dc\"> <div class=\"modal-header\"><h2>Signature du DC</h2></div> <div class=\"modal-body\"> <signature-pad accept=\"accept\" clear=\"clear\" height=\"320\" width=\"640\"></signature-pad> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-clear\" ng-click=\"clear()\">Effacer signature</button> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss(\'annuler\')\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.done()\">Signer</button> </div> </div></script><script type=\"text/ng-template\" id=\"signatureClient.html\"><div class=\"modal-body signature\" id=\"modal-body-signature-client\"> <div class=\"modal-header\"> <h2>Signature du Client</h2> <div class=\"mentions-signature\"> <p>Je certifie que les informations renseignées dans le bon de commande sont exactes.</p> <p>Les informations recueillies dans le cadre du site MY PLV (ci-après le « Site ») font l’objet d’un traitement informatique par CCEP destiné à la gestion du Site et de la relation client. Les destinataires des données sont CCE et ses prestataires. En application de la loi « Informatique et Libertés » du 6 janvier 1978, les destinataires du Site disposent d’un droit d’accès, de modification, de rectification et de suppression des données qui les concernent. Pour exercer ce droit, ils peuvent s’adresser à CCEP en écrivant à l’adresse ci-contre : Coca-Cola European Partners – 9, chemin de Bretagne 92784 Issy-les-Moulineaux Cedex 9 – France.</p> </div> </div> <div class=\"modal-body\"> <signature-pad accept=\"accept\" clear=\"clear\" height=\"320\" width=\"640\"></signature-pad> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-clear\" ng-click=\"clear()\">Effacer signature</button> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss(\'annuler\')\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.done()\">Signer</button> </div> </div></script>");
$templateCache.put("app/vae/vae-01-info-pdv/vae-01-info-pdv.html","<div class=\"container text-center info-pdv\"><info-pdv project=\"main.ctx.project\" validate=\"main.validate()\" save=\"main.save()\" update-project=\"main.updateProject\"></info-pdv></div>");
$templateCache.put("app/vae/vae-02-creation/vae-02-creation-layout.html","<div class=\"container id-projet text-center wrapp creation-boards\"><ul class=\"nav nav-tabs sub-menu text-center\" ng-if=\"vae.ctx.project.type !== \'Digital\'\"><li class=\"col-sm-4 disabled\" ng-class=\"{active: vae.$state.is(\'vae.creation.id-projet\')}\"><a disabled=\"\">NOM DU PROJET</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: vae.$state.is(\'vae.creation.choix-boards\')}\"><a disabled=\"\">CHOIX DES BOARDS</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: vae.$state.is(\'vae.creation.format\')}\"><a disabled=\"\">FORMAT</a></li></ul><ul class=\"nav nav-tabs sub-menu text-center\" ng-if=\"vae.ctx.project.type === \'Digital\'\"><li class=\"col-sm-4 disabled\" ng-class=\"{active: vae.$state.is(\'vae-digital.creation.id-projet\')}\"><a disabled=\"\">NOM DU PROJET</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: vae.$state.is(\'vae-digital.creation.choix-boards\')}\"><a disabled=\"\">CHOIX DES BOARDS</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: vae.$state.is(\'vae-digital.creation.format\')}\"><a disabled=\"\">FORMAT</a></li></ul><div ui-view=\"\" autoscroll=\"true\"></div></div>");
$templateCache.put("app/vae/vae-03-contenu/vae-03-contenu-layout.html","<div ui-view=\"\" autoscroll=\"false\"></div>");
$templateCache.put("app/vae/vae-03-contenu/vae-03-contenu.html","<div class=\"container text-center contenu\"><form class=\"contenu-board form-horizontal\" name=\"contenu\"><h2>éditer les boards pour renseigner les informations</h2><div id=\"alert-message\"><div uib-alert=\"\" class=\"alert alert-fade\" type=\"{{main.alert.type}}\" close=\"main.closeAlert()\" ng-if=\"main.alert.msg != undefined\">{{main.alert.msg}}</div></div><div class=\"form-group group-board-contenu row\" ng-repeat=\"boards in main.ctx.project.boards\"><div class=\"part-left col-sm-6\"><div class=\"col-sm-7 format-name-board\"><div><label class=\"name-board\">{{ boards.displayName }}</label> <span class=\"help-text board-format\">{{ boards.format }}</span></div></div><span class=\"image-board col-sm-5\"><img ng-src=\"{{ boards.imageBoard }}\" alt=\"{{ boards.displayName }}\"></span></div><div class=\"part-right col-sm-6\"><div class=\"trash-icon\"><span ng-click=\"main.deleteBoard($index)\" class=\"glyphicon glyphicon-trash\"></span></div><div class=\"form-group row\"><a type=\"submit\" class=\"btn btn-default edit-board\" href=\"\" ng-click=\"main.editeBoard($index, boards)\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span> éditer le board</a> <span class=\"\" aria-hidden=\"true\" ng-class=\"{\'glyphicon glyphicon-remove-sign\':[boards.brief == undefined], \'glyphicon glyphicon-ok-sign\': boards.brief != undefined}\"></span></div></div></div><div class=\"form-group-btn\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"vae.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear disabled\" href=\"\" ng-if=\"vae.isUpdate()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate()\" ng-class=\"{\'disabled\': !main.editedAll}\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form></div><script type=\"text/ng-template\" id=\"confirmDeleBoard.html\"><div class=\"modal-body alert-delete-board\" id=\"modal-body-alert-delete-board\"> <div class=\"modal-header\"><h2 class=\"text-center\">Voulez-vous vraiment supprimer ce board ?</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">ANNULER <span class=\"glyphicon glyphicon-remove-sign\" aria-hidden=\"true\"></span></button> <button class=\"btn btn-default\" ng-click=\"$close()\"><span class=\"glyphicon glyphicon-ok-sign\" aria-hidden=\"true\"></span> OUI</button> </div> </div></script><div ui-view=\"\" autoscroll=\"false\" ng-if=\"main.hide\"></div>");
$templateCache.put("app/vae/vae-04-pose/vae-04-pose.html","<div class=\"container text-center pose\"><form class=\"pose-vae row form-horizontal\" name=\"pose\"><div ng-if=\"!main.isPoseDisabled\"><fieldset class=\"col-sm-12 choix-pose\"><div class=\"form-group row\"><label class=\"col-sm-6\"><h2>Souhaitez-vous une pose des boards par un installeur professionnel ?</h2></label><div class=\"col-sm-4 radio-custom\"><div class=\"text-left\" ng-class=\"{true: \'error\'}[main.submitted && pose.pose.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"pose\" value=\"oui\" ng-model=\"main.ctx.project.pose.pose\" ng-class=\"{true: \'error\'}[main.submitted && pose.pose.$invalid]\" required=\"\" ng-change=\"main.changePose()\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"pose\" ng-model=\"main.ctx.project.pose.pose\" value=\"non\" ng-class=\"{true: \'error\'}[main.submitted && pose.pose.$invalid]\" required=\"\" ng-change=\"main.changePose()\"> <label>NON</label></div></div></div><div class=\"col-sm-12\"><p class=\"help-block\" style=\"text-align: justify;\">Si vous cliquez sur OUI, notre installateur prendra contact avec le point de vente sous 48h afin d’organiser une première visite d’audit. Cette première visite aura lieu dans les 5 jours ouvrés qui suivent la confirmation et l’envoi du bon de commande. Notre installateur aura pour mission de vérifier la conformité du bon de commande et d’effectuer les premières mesures pour l’installation des boards.</p></div><div class=\"col-sm-12\" ng-if=\"main.ctx.project.pose.pose == \'oui\' && main.ctx.project.type == \'Boards PVC\'\"><label class=\"col-sm-3 label-tringle\">Tringle:</label><div class=\"col-sm-4 radio-custom\"><div class=\"text-left\" ng-class=\"{true: \'error\'}[main.submitted && pose.tringle.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"tringle\" value=\"oui\" ng-model=\"main.ctx.project.pose.tringle\" ng-class=\"{true: \'error\'}[main.submitted && pose.tringle.$invalid]\" required=\"\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"tringle\" ng-model=\"main.ctx.project.pose.tringle\" value=\"non\" ng-class=\"{true: \'error\'}[main.submitted && pose.tringle.$invalid]\" required=\"\"> <label>NON</label></div></div></div></div></div></fieldset><fieldset class=\"col-sm-12\" ng-if=\"main.ctx.project.pose.pose == \'oui\'\"><div class=\"form-group\"><label class=\"col-sm-12\"><h2>Autres Informations</h2></label><div class=\"col-sm-12 jours-part\"><label class=\"col-sm-11 col-sm-offset-1 jour-label text-left\">Jours d\'ouverture&#8239;:&#8239;</label><div class=\"jours\" ng-class=\"{true: \'error\'}[main.submitted && pose.pose.$invalid]\"><div class=\"checkbox checkbox-custom checkbox-inline\" ng-repeat=\"jour in main.arrayDays\"><input type=\"checkbox\" name=\"jour{{$index}}\" ng-true-value=\"\'{{jour}}\'\" ng-model=\"main.ctx.project.pose.jours[$index]\" ng-change=\"main.choseDay(main.ctx.project.pose.jours, $index)\"> <label class=\"\">{{ jour }}</label></div></div></div><div class=\"horaires col-sm-12\"><div class=\"form-group\"><label for=\"heureouverture\" class=\"col-sm-3 ouverture control-label\">Heure d\'ouverture&#8239;:&#8239;</label><div class=\"col-sm-2 group-horaires\"><input type=\"time\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" id=\"heureouverture\" name=\"heureouverture\" ng-model=\"main.ctx.project.pose.heureouverture\" aria-invalid=\"false\"></div></div></div><div class=\"horaires col-sm-12\"><div class=\"form-group\"><label for=\"heurefermeture\" class=\"col-sm-3 control-label fermeture\">Heure de fermeture&#8239;:&#8239;</label><div class=\"col-sm-2 group-horaires\"><input type=\"time\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" id=\"heurefermeture\" name=\"heurefermeture\" ng-model=\"main.ctx.project.pose.heurefermeture\" aria-invalid=\"false\"></div></div></div><div class=\"col-sm-12 contact-pose\"><div class=\"form-group row\"><label for=\"nomContactPose\" style=\"padding-left: 0;\" class=\"col-sm-3 control-label\">Contact&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nomContactPose\" name=\"nomContactPose\" ng-model=\"main.ctx.project.pose.contact.nom\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && pose.nomContactPose.$invalid]\"></div><div ng-if=\"main.submitted && pose.nomContactPose.$invalid\" class=\"error-msg col-sm-4 text-left\">Nom du contact obligatoire</div></div><div class=\"form-group row\"><label for=\"telContactPose\" class=\"col-sm-3 control-label\">Téléphone&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" class=\"form-control\" ng-model=\"main.ctx.project.pose.contact.telephone\" ng-pattern=\"/^0\\d(\\s|-)?(\\d{2}(\\s|-)?){4}$/\" name=\"telContactPose\" id=\"telContactPose\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && pose.telContactPose.$invalid]\"></div><div ng-if=\"main.submitted && pose.telContactPose.$invalid && pose.telContactPose.$error.required\" class=\"error-msg col-sm-4 text-left\">Téléphone portable du contact obligatoire</div><div ng-if=\"main.submitted && pose.telContactPose.$error.pattern\" class=\"error-msg col-sm-4\">Téléphone incorrect</div></div></div></div></fieldset></div><div class=\"container text-center pose\" ng-if=\"main.isPoseDisabled\"><h2>La pose n\'est pas possible pour les projets de type <i>{{ main.ctx.project.type }}</i>. Vous pouvez passer à l\'étape suivante.</h2></div><div class=\"form-group-btn\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"vae.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear disabled\" href=\"\" ng-if=\"vae.isUpdate()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(pose)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form></div>");
$templateCache.put("app/vae/vae-05-2-video/vae-05-2-video.html","<div class=\"container text-center livraison\"><form class=\"livraison-vae row form-horizontal\" name=\"livraison\"><h2>Email de livraison</h2><div id=\"errorLivraison\"><div ng-if=\"main.submitted && livraion.$invalid\" class=\"error-msg\">L\'adresse email est obligatoire</div></div><div class=\"form-group row\"><label>Un lien permettant de télécharger la vidéo sera envoyé par email à votre client.</label></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && livraion.emaillivraison.$invalid]\"><label for=\"emailLivraison\" class=\"col-sm-3 control-label\">Adresse email de livraison :</label><div class=\"col-sm-6\"><input type=\"email\" required=\"\" name=\"emaillivraison\" class=\"form-control\" id=\"emailLivraison\" ng-model=\"main.ctx.project.livraison.video_email\" ng-class=\"{true: \'error\'}[main.submitted && livraison.emaillivraison.$invalid]\"></div></div><div class=\"form-group-btn\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"vae.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(livraison)\" ng-if=\"vae.isUpdate()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(livraison)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Terminer</a></div></form></div>");
$templateCache.put("app/vae/vae-05-livraison/vae-05-livraison.html","<div class=\"container text-center livraison\"><form class=\"livraison-vae row form-horizontal\" name=\"livraison\"><h2>Indiquer le nombre d\'exemplaires à imprimer pour chaque board</h2><div id=\"errorLivraison\"><p ng-if=\"main.submitted && livraison.$invalid\" class=\"error-msg text-left\">Vous devez choisir un nombre d\'exemplaires pour chaque board.</p></div><div class=\"form-group group-livraison row\" ng-repeat=\"boards in main.ctx.project.boards\"><div class=\"part-left col-sm-6\"><div class=\"col-sm-7 format-name-board\"><div><label class=\"name-board\">{{ boards.displayName }}</label> <span class=\"help-text board-format\">{{ boards.format }}</span></div></div><span class=\"image-board col-sm-5\"><img ng-src=\"{{ boards.imageBoard }}\" alt=\"{{ boards.displayName }}\"></span></div><div class=\"part-right col-sm-6\"><div class=\"form-group livraison-select-nbr row\"><label class=\"\">Nombre d\'exemplaires&#8239;:</label><select name=\"nbExemplaire{{$index}}\" class=\"form-control nbExemplaire\" id=\"nbExemplaire{{$index}}\" ng-model=\"boards.nombreExemplaire\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && livraison.nbExemplaire{{$index}}.$invalid]\" ng-init=\"boards.nombreExemplaire = \'1\'\"><option value=\"\"></option><option value=\"1\" ng-selected=\"true\" selected=\"\">1</option><option value=\"2\">2</option><option value=\"3\">3</option><option value=\"4\">4</option><option value=\"5\">5</option></select><span class=\"glyphicon glyphicon-triangle-bottom\"></span></div></div></div><adresse-livraison project=\"main.ctx.project\" submitted=\"main.submitted\" form=\"livraison\"></adresse-livraison><div class=\"form-group-btn\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"vae.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(livraison)\" ng-if=\"vae.isUpdate()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(livraison)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Terminer</a></div></form></div>");
$templateCache.put("app/vae/vae-06-recapitulatif/vae-06-recapitulatif.html","<div class=\"container-fluid recapitulatif\"><div class=\"container\"><div id=\"alert-message\"><div uib-alert=\"\" class=\"alert alert-fade\" type=\"{{main.alert.type}}\" close=\"main.closeAlert()\" ng-if=\"main.alert.msg != undefined\">{{main.alert.msg}}</div></div><h2 ng-if=\"!vae.isUpdate()\">Votre commande est terminée.<br><span>Veuillez relire votre bon de commande avec attention et vous assurer que :<br>- Les informations de votre client (nom, établissement, coordonnées, etc.) sont correctes<br>- Les informations des boards correspondent au choix de mon client (format, nombre d’exemplaires à imprimer)<br>- Les contenus des boards (boissons, tarifs, formules, etc.) sont conformes</span></h2><div class=\"container-project\"><h1 class=\"text-center\">{{ main.ctx.project.type }}</h1><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>1.</span>INFORMATIONS CLIENT <a href=\"\" ng-click=\"vae.go(vae.statePrefix+\'.info-pdv\')\" style=\"float: right;\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit text-right\" aria-hidden=\"true\"></span></a></div><div class=\"panel-body\"><p>Nom du point de vente : <span>{{ main.ctx.project.pdv.nomPDV }}</span></p><p>Adresse : <span>{{ main.ctx.project.pdv.adresse }}</span></p><p>CP : <span>{{ main.ctx.project.pdv.codePostal }}</span></p><p>Ville : <span>{{ main.ctx.project.pdv.ville }}</span></p><p>Téléphone : <span>{{ main.ctx.project.pdv.telephone }}</span></p><p>N°Siret : <span>{{ main.ctx.project.pdv.nSiret }}</span></p><p>RCS : <span>{{ main.ctx.project.pdv.rcs }}</span></p><p>Nom du Gérant: <span>{{ main.ctx.project.pdv.nomClient }}</span></p><p>Téléphone du Gérant: <span>{{ main.ctx.project.pdv.telephoneCLient }}</span></p><p>Email du Gérant: <span>{{ main.ctx.project.pdv.emailCLient }}</span></p></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>2.</span>Création des boards</div><div class=\"panel-body\"><div class=\"\"><div class=\"row\"><a class=\"edit-data\" href=\"\" ng-click=\"vae.go(vae.statePrefix+\'.creation.id-projet\')\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a><p>Nom du Projet: <span>{{ main.ctx.project.idprojet.nameProjet }}</span></p></div><hr><div class=\"row\"><a class=\"edit-data\" href=\"\" ng-click=\"vae.go(vae.statePrefix+\'.creation.choix-boards\')\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a><p>Boards sélectionnés :</p><div style=\"color:#DE0B1C\"><div class=\"boisson-cce row\"><div ng-repeat=\"board in main.ctx.project.boards\" class=\"col-sm-6\"><span>- {{ board.displayName }} (type: {{ board.name }}) :</span><br><span>Format : {{ board.format }}</span><br><span>Nombre d\'exemplaires : {{ board.nombreExemplaire }}</span><br><brief projet=\"main.ctx.project\" board=\"board\"></brief><span ng-if=\"board.optionStopTrottoir\"><strong>A dupliquer en STOP-TROTTOIR {{board.formatStopTrottoir}}</strong></span></div></div></div></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>3.</span>Pose <a href=\"\" ng-click=\"vae.go(vae.statePrefix+\'.pose\')\" style=\"float: right;\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit text-right\" aria-hidden=\"true\"></span></a></div><div class=\"panel-body\"><div ng-if=\"main.ctx.project.type !== \'Caissons Lumineux\' && main.ctx.project.type !== \'Digital\'\"><p ng-if=\"main.ctx.project.pose.pose == \'oui\'\">Pose souhaité : <span>OUI.</span><br><b ng-if=\"main.ctx.project.type == \'Boards PVC\'\">Tringle: <span>{{ main.ctx.project.pose.tringle | uppercase }}</span><br></b> Contact pour la pose :<br><b>Nom : <span>{{ main.ctx.project.pose.contact.nom }}</span><br></b> <b>Téléphone : <span>{{ main.ctx.project.pose.contact.telephone }}.</span></b></p><p ng-if=\"main.ctx.project.pose.pose == \'oui\' && main.ctx.project.pose.jours != undefined\">Jours d\'ouverture : <span ng-repeat=\"jour in main.ctx.project.pose.jours\">{{ jour }}&nbsp;</span></p><p ng-if=\"main.ctx.project.pose.pose == \'oui\' && main.ctx.project.pose.heureouverture != undefined\">Heure d\'ouverture : <span>{{ main.ctx.project.pose.heureouverture | date: \'HH:mm\' }}</span></p><p ng-if=\"main.ctx.project.pose.pose == \'oui\' && main.ctx.project.pose.heurefermeture != undefined\">Heure de fermeture : <span>{{ main.ctx.project.pose.heurefermeture | date: \'HH:mm\' }}</span></p><p ng-if=\"main.ctx.project.pose.pose == \'non\'\"><span>Pas de pose souhaité</span></p></div><div ng-if=\"main.ctx.project.type === \'Caissons Lumineux\' || main.ctx.project.type === \'Digital\'\"><p><span>La pose n\'est pas possible pour les projets de type <i>{{main.ctx.project.type}}</i>.</span></p></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><span>4.</span>Livraison <a href=\"\" ng-click=\"vae.go(vae.statePrefix+\'.livraison\')\" ng-if=\"main.canProjetUpdate\"><span class=\"glyphicon glyphicon-edit\" aria-hidden=\"true\"></span></a></div><div class=\"panel-body\"><div class=\"\" ng-if=\"main.ctx.project.type !== \'Digital\'\"><p ng-if=\"main.ctx.project.pdv.adresseIdemCommande == \'non\'\">Adresse de livraison : <span>{{ main.ctx.project.pdv.adresseLivraison.nomPDV }}<br>{{ main.ctx.project.pdv.adresseLivraison.adresse }}, {{ main.ctx.project.pdv.adresseLivraison.codePostale }} {{ main.ctx.project.pdv.adresseLivraison.ville }}<br>Gérant : {{ main.ctx.project.pdv.adresseLivraison.gerant }}. Téléphone : {{ main.ctx.project.pdv.adresseLivraison.telephone }}</span></p><p ng-if=\"main.ctx.project.pdv.adresseIdemCommande == \'oui\'\">Adresse de livraison : <span>Idem au bon de commande</span></p></div><div class=\"\" ng-if=\"main.ctx.project.type === \'Digital\'\"><p>Adresse email de livraison : <span>{{ main.ctx.project.livraison.video_email }}</span></p></div></div></div></div><div class=\"button\"><a type=\"submit\" ng-if=\"!vae.isUpdate() && main.allowedUpdate()\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(infopdv)\"><span class=\"glyphicon glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer et signer le Bon de commande</a><a type=\"submit\" ng-if=\"vae.isUpdate() && main.allowedUpdate()\" class=\"btn btn-default btn-lg\" ng-click=\"main.backSuiviProjet()\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivi du Projet</a> <a type=\"submit\" ng-if=\"!main.allowedUpdate()\" class=\"btn btn-default btn-lg btn-suivi\" ng-click=\"main.backSuiviProjet()\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivi du Projet</a></div></div></div><script type=\"text/ng-template\" id=\"signatureDC.html\"><div class=\"modal-body signature\" id=\"modal-body-signature-dc\"> <div class=\"modal-header\"><h2>Signature du DC</h2></div> <div class=\"modal-body\"> <signature-pad accept=\"accept\" clear=\"clear\" height=\"320\" width=\"640\"></signature-pad> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-clear\" ng-click=\"clear()\">Effacer signature</button> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss(\'annuler\')\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.done()\">Signer</button> </div> </div></script><script type=\"text/ng-template\" id=\"signatureClient.html\"><div class=\"modal-body signature\" id=\"modal-body-signature-client\"> <div class=\"modal-header\"> <h2>Signature du Client</h2> <div class=\"mentions-signature\"> <p>Je certifie que les informations renseignées dans le bon de commande sont exactes.</p> <p>Les informations recueillies dans le cadre du site MY PLV (ci-après le « Site ») font l’objet d’un traitement informatique par CCEP destiné à la gestion du Site et de la relation client. Les destinataires des données sont CCE et ses prestataires. En application de la loi « Informatique et Libertés » du 6 janvier 1978, les destinataires du Site disposent d’un droit d’accès, de modification, de rectification et de suppression des données qui les concernent. Pour exercer ce droit, ils peuvent s’adresser à CCEP en écrivant à l’adresse ci-contre : Coca-Cola European Partners – 9, chemin de Bretagne 92784 Issy-les-Moulineaux Cedex 9 – France.</p> </div> </div> <div class=\"modal-body\"> <signature-pad accept=\"accept\" clear=\"clear\" height=\"320\" width=\"640\"></signature-pad> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-clear\" ng-click=\"clear()\">Effacer signature</button> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss(\'annuler\')\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.done()\">Signer</button> </div> </div></script>");
$templateCache.put("app/chr/chr-02-creation/chr-21-id-projet/chr-21-id-projet.html","<form class=\"form-horizontal row\" name=\"idprojet\"><h2>NOMMER VOTRE PROJET</h2><fieldset class=\"col-sm-offset-1\"><input type=\"hidden\" class=\"form-control\" id=\"numeroOutlet\" name=\"numeroOutlet\" ng-model=\"main.ctx.project.pdv.nOutlet\" readonly=\"\"><div class=\"form-group\"><label for=\"nameProjet\" class=\"col-sm-3 control-label\">Nom du projet :</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nameProjet\" name=\"nameProjet\" maxlength=\"50\" ng-model=\"main.ctx.project.idprojet.nameProjet\" required=\"\" readonly=\"\" ng-class=\"{true: \'error\'}[main.submitted && idprojet.nameProjet.$invalid]\"></div><div ng-if=\"main.submitted && idprojet.nameProjet.$invalid\" class=\"error-msg text-left\">Nom du Projet obligatoire</div></div></fieldset><div><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"chr.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(idprojet)\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validateNomProjet(idprojet)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form>");
$templateCache.put("app/chr/chr-02-creation/chr-22-theme/chr-22-theme.html","<loading-screen loading=\"main.loading\" class=\"projet-loading\"></loading-screen><form name=\"themeGraphique\" class=\"row\"><fieldset class=\"templates-carte col-sm-12\"><h2>Sélectionner le thème graphique de votre choix</h2><div class=\"form-group row\" id=\"errorTemplate\"><div ng-if=\"main.submitted && themeGraphique.theme.$invalid\" class=\"error-msg text-left\">Le choix d\'un thème est obligatoire</div><div class=\"col-sm-4\" ng-repeat=\"(key,theme) in main.themeGraphique\"><div class=\"checkbox\"><input type=\"radio\" name=\"theme\" id=\"theme\" value=\"{{theme.name}}\" ng-model=\"main.ctx.project.infocarte.template.name\" ng-change=\"main.themeChange(theme.field_support_image)\" required=\"\"> <label><img ng-src=\"{{ theme.field_support_image }}\" alt=\"{{theme.name}}\" title=\"{{theme.name}}\" width=\"100%\"> <span class=\"theme-description\">{{ theme.name }}<span class=\"custom-check\"></span></span></label> <span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\" ng-click=\"main.zoomTemplate(theme.field_support_image_preview, theme.name)\"></span></div></div></div></fieldset><div><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"chr.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(themeGraphique)\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" id=\"submit-template\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validateTemplates(themeGraphique)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form><script type=\"text/ng-template\" id=\"zoomTemplates.html\"><div class=\"modal-body zoom-templates\" id=\"modal-body-zoom-templates\"> <span class=\"glyphicon glyphicon-remove\" ng-click=\"$close()\" aria-hidden=\"true\"></span> <img ng-src=\"{{ vm.img }}\" alt=\"{{ vm.themeName }}\" title=\"{{ vm.themeName }}\" style=\"width: 97%;\"/> </div></script>");
$templateCache.put("app/chr/chr-02-creation/chr-23-format/chr-23-format.html","<form name=\"format\" class=\"row\"><fieldset class=\"formats-carte col-sm-12\"><h2>Sélectionner le format de votre choix</h2><div class=\"form-group row\" id=\"errorFormat\"><div ng-if=\"main.submitted && format.format.$invalid\" class=\"error-msg text-left\">Le choix d\'un format est obligatoire</div><div class=\"col-sm-4\" ng-class=\"{true: \'error\'}[main.submitted && format.format.$invalid]\" ng-repeat=\"(key,format) in main.formats\"><div class=\"checkbox\"><input type=\"radio\" name=\"format\" id=\"format{{$index}}\" value=\"{{format.name}}\" class=\"col-sm-2\" ng-model=\"main.ctx.project.infocarte.format.name\" ng-change=\"main.formatChange(format)\" required=\"\"> <label><div class=\"fond-img\"><img ng-src=\"{{ format.field_media_image }}\" alt=\"{{format.name}}\" title=\"{{format.name}}\" class=\"row\"></div><div class=\"format-description\"><div class=\"description\"><span class=\"name-support\">{{ format.name }}</span> <span class=\"help-block\">{{ format.field_media_format }}</span></div><span class=\"custom-check\"></span></div></label> <input ng-model=\"main.ctx.project.infocarte.format.media_format\" type=\"text\" value=\"{{ format.field_media_format }}\" style=\"visibility: hidden; height: 0; width: 0;\"></div></div></div></fieldset><fieldset class=\"col-sm-12\"><h2>Matière</h2><div class=\"form-group row\" id=\"errorMatiere\"><div class=\"col-sm-3\"><select name=\"matiere\" class=\"form-control matiere\" id=\"matiere\" ng-model=\"main.ctx.project.infocarte.matiere\" ng-class=\"{true: \'error\'}[main.submitted && !main.ctx.project.infocarte.matiere]\" required=\"\" ng-options=\"material.name for material in main.materials track by material.name\"></select></div></div><div ng-if=\"main.submitted && !main.ctx.project.infocarte.matiere\" class=\"error-msg col-sm-4\">Choisir la matière</div></fieldset><div><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"chr.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(format)\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" id=\"submit-format\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validateFormat(format)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form>");
$templateCache.put("app/chr/chr-03-contenu/chr-31-gamme/chr-31-gamme.html","<loading-screen loading=\"main.loading\" class=\"projet-loading\"></loading-screen><form name=\"boissons\" class=\"row\"><h2>SÉLECTIONNER LA GAMME RÉFÉRENCÉE DANS LE POINT DE VENTE</h2><div ng-if=\"main.submitted && main.nbrChecked < 4\" class=\"error-msg text-left\">Vous devez choisir au moins 4 gammes</div><div class=\"form-group boisson well\" ng-repeat=\"(parent, enfants) in main.gammes | groupBy:\'name\'\"><div class=\"part-left\" ng-repeat=\"imgParent in enfants\" ng-if=\"$first\" ng-click=\"main.selectAll(parent)\"><img ng-src=\"{{ imgParent.field_gamme_image_boissons_1 }}\" alt=\"\"></div><div class=\"part-right\"><div class=\"checkbox checkbox-custom\" ng-repeat=\"enfant in enfants | orderBy:\'weight_children\'\"><input type=\"checkbox\" name=\"{{parent}}-{{ $index }}\" ng-true-value=\"\'{{ enfant.name_1 }} {{ enfant.field_gamme_format_boissons }}\'\" id=\"{{parent}}-{{ enfant.name_1 }}-{{ enfant.field_gamme_format_boissons }}\" ng-model=\"main.ctx.project.infocarte.boissons[parent][$index].name\" ng-change=\"main.onChangeBoissons(main.ctx.project.infocarte.boissons[parent][$index], parent, $index)\"> <label for=\"{{parent}}-{{ enfant.name_1 }}-{{ enfant.field_gamme_format_boissons }}\"><span class=\"gamme-name\">{{ enfant.name_1 }}</span> <span class=\"gamme-format\">{{ enfant.field_gamme_format_boissons }}</span></label> <span class=\"image\"><img ng-src=\"{{ enfant.field_gamme_image_boissons }}\" alt=\"\"></span></div></div></div><div class=\"col-sm-12 text-center buttons\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"chr.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save()\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validateGame()\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form><script type=\"text/ng-template\" id=\"boissonsChoices.html\"><div class=\"modal-body alert-boissons\" id=\"modal-body-alert-boissons\"> <div class=\"modal-header\"><h2 class=\"text-center\">Un minimum de 4 références CCEP est requis pour la création d’une carte brasserie</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"$close()\">OK</button> </div> </div></script>");
$templateCache.put("app/chr/chr-03-contenu/chr-32-cocktails/chr-32-cocktails.html","<loading-screen loading=\"main.loading\" class=\"projet-loading\"></loading-screen><form class=\"text-center cocktails row\" name=\"cocktails\"><fieldset id=\"errorCocktails\" class=\"cocktails-data col-sm-12\"><h2>SÉLECTIONNER LES COCKTAILS RÉFÉRENCÉS DANS LE POINT DE VENTE</h2><div class=\"form-group row\"><div ng-if=\"main.submitted && main.nbCocktails < 0\" class=\"error-msg text-left\">Veuillez choisir une option</div><div class=\"col-sm-4\"><div class=\"checkbox\"><input type=\"checkbox\" name=\"aucunCocktail\" id=\"aucunCocktail\" ng-true-value=\"\'Aucun Cocktail\'\" class=\"col-sm-2\" ng-model=\"main.ctx.project.infocarte.cocktails.name\" ng-change=\"main.onChangeCocktail(main.ctx.project.infocarte.cocktails.name)\" required=\"\"> <label for=\"aucunCocktail\"><div class=\"fond-img aucun-cocktail\"><img src=\"\" alt=\"\" class=\"row\"></div><div class=\"cocktail-description\"><div class=\"top-part\"><span class=\"name-cocktail\">Aucun</span></div><div class=\"cocktail-choice\"><span class=\"custom-check\"></span> <span>CHOISIR</span></div></div></label></div></div><div class=\"col-sm-4\" ng-repeat=\"(key,cocktail) in main.cocktails\"><div class=\"checkbox\"><input type=\"checkbox\" name=\"cocktail{{$index}}\" id=\"cocktail{{$index}}\" ng-true-value=\"\'{{cocktail.name}}\'\" class=\"col-sm-2\" ng-model=\"main.ctx.project.infocarte.cocktails[key].name\" ng-change=\"main.onChangeCocktail(main.ctx.project.infocarte.cocktails[key], cocktail, $index)\" required=\"\"> <label for=\"cocktail{{$index}}\"><div class=\"fond-img\"><img ng-src=\"{{ cocktail.field_media_image_cocktails }}\" alt=\"{{ cocktail.name }}\" class=\"row\"></div><div class=\"cocktail-description\"><div class=\"top-part\"><span class=\"name-cocktail\">{{ cocktail.name }}</span> <span class=\"help-block\" ng-bind-html=\"cocktail.field_media_ingredients_cocktail\"></span></div><div class=\"cocktail-choice\"><span class=\"custom-check\"></span> <span>CHOISIR</span></div></div></label></div></div></div></fieldset><script type=\"text/ng-template\" id=\"visuelCocktail.html\"><div class=\"modal-body text-center\" id=\"modal-body-visuel-cocktail\"> <div class=\"modal-header\"> <h2>Souhaitez-vous intégrer le visuel de chaque cocktail sur la carte ?</h2> </div> <div class=\"modal-body\"> <form name=\"visuelCocktails\"> <div class=\"form-group radio-custom\"> <div class=\"text-left\" ng-class=\"{true: \'error\'}[vm.submitted && visuelCocktails.visuel.$invalid]\"> <div class=\"radio\"> <input type=\"radio\" name=\"visuel\" id=\"visuel1\" value=\"oui\" required ng-model=\"vm.ctx.project.infocarte.cocktails.visuelCocktails\" ng-class=\"{true: \'error\'}[vm.submitted && visuelCocktails.visuel.$invalid]\"> <label for=\"visuel1\"> OUI </label> </div> <div class=\"radio\"> <input type=\"radio\" name=\"visuel\" id=\"visuel2\" value=\"non\" required ng-model=\"vm.ctx.project.infocarte.cocktails.visuelCocktails\" ng-class=\"{true: \'error\'}[vm.submitted && visuelCocktails.visuel.$invalid]\"> <label for=\"visuel2\"> NON </label> </div> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">Annuler</button> <button class=\"btn btn-default\" ng-click=\"vm.visuelCocktail(visuelCocktails)\">Confirmer</button> </div> </div></script><div class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"chr.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(cocktails, main.ctx.project)\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" id=\"submit-cocktails\" href=\"\" ng-click=\"main.validateCocktails(cocktails, main.ctx.project)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form>");
$templateCache.put("app/chr/chr-03-contenu/chr-33-illustrations/chr-33-illustrations.html","<loading-screen loading=\"main.loading\" class=\"projet-loading\"></loading-screen><form class=\"text-center row\" name=\"illustration\"><fieldset id=\"errorFrise\" class=\"frises illustrations col-sm-12\"><h2>Sélectionner la frise que vous souhaitez voir apparaître sur la carte</h2><div class=\"form-group row\"><div ng-if=\"main.submitted && !main.ctx.project.infocarte.frise.name\" class=\"error-msg text-left\">Veuillez choisir au moins une des options</div><div class=\"col-sm-4\" ng-class=\"{true: \'error\'}[main.submittedFormat && frise.format.$invalid]\" ng-repeat=\"(key,frise) in main.frises\"><div class=\"checkbox\"><input type=\"checkbox\" name=\"frise{{$index}}\" id=\"frise{{$index}}\" ng-true-value=\"\'{{frise.name}}\'\" class=\"col-sm-2\" ng-model=\"main.ctx.project.infocarte.frise.name\" ng-change=\"main.ctx.project.infocarte.frise.image = {{frise.field_media_image_illustration}}\" required=\"\"> <label><div class=\"fond-img\"><img ng-src=\"{{ frise.field_media_image_illustration }}\" alt=\"\" class=\"row\"></div><span class=\"format-description\"><span class=\"name-illustration\">{{ frise.name }}</span><span class=\"custom-check\"></span></span></label></div></div></div></fieldset><fieldset id=\"errorIllustrations\" class=\"illustrations col-sm-12\"><h2>Sélectionner les illustrations additionnelles que vous souhaitez voir apparaître sur la carte</h2><div class=\"form-group row\"><div ng-if=\"main.submitted && !count(main.ctx.project.infocarte.illustrations)\" class=\"error-msg text-left\">Veuillez choisir au moins une des options</div><div class=\"col-sm-4\" ng-class=\"{true: \'error\'}[main.submittedFormat && illustration.format.$invalid]\" ng-repeat=\"(key,illustration) in main.illustrations\"><div class=\"checkbox\"><input type=\"checkbox\" name=\"illustration{{$index}}\" id=\"illustration{{$index}}\" ng-true-value=\"\'{{illustration.name}}\'\" class=\"col-sm-2\" ng-model=\"main.ctx.project.infocarte.illustrations[key].name\" ng-change=\"main.removeIllustrat(main.ctx.project.infocarte.illustrations[key] ,illustration.field_media_image_illustration, $index)\" required=\"\"> <label><div class=\"fond-img\"><img ng-src=\"{{ illustration.field_media_image_illustration }}\" alt=\"\" class=\"row\"></div><span class=\"format-description\"><span class=\"name-illustration\">{{ illustration.name }}</span><span class=\"custom-check\"></span></span></label></div></div></div></fieldset><div class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"chr.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save()\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" id=\"submit-illustration\" href=\"\" ng-click=\"main.validateIllustrations()\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form>");
$templateCache.put("app/chr/chr-03-contenu/chr-34-formules/chr-34-formules.html","<div class=\"col-sm-12\"><form class=\"form-horizontal row\" name=\"formules\"><h2>Préciser le nom de la formule (ex: \"formule déjeuner\"), les éléments qui la composent et le tarif en € et TTC</h2><div><span>Le saviez-vous ? Les formules sont une attente de vos convives : <b>7 français sur 10</b> souhaitent avoir une FORMULE dans un PDV HORECA. <b>(1)</b></span><br><span>Ajouter une <b>boisson</b> à votre formule permet de <b>multiplier par 3</b> le % de convives qui va prendre une boisson et développe le <b>ticket moyen de +20%</b> ! (2)</span><br></div><div ng-if=\"main.submitted && formules.$invalid\" class=\"error-msg text-left\">Veuillez compléter les formules ou indiquer que vous n\'en avez aucune.</div><fieldset id=\"errorFormules\"><div class=\"form-group\"><div class=\"checkbox checkbox-custom\"><input name=\"pasdeformule\" id=\"pasdeformule\" type=\"checkbox\" ng-required=\"main.requiredNoformule\" ng-change=\"main.onNoFormule(main.ctx.project.infopdv.noFormule)\" ng-model=\"main.ctx.project.infopdv.noFormule\" ng-true-value=\"\'Aucune formule\'\"> <label for=\"pasdeformule\" class=\"col-sm-offset-1 col-sm-3\">Aucune formule</label></div></div></fieldset><fieldset class=\"panel\" ng-repeat=\"(key,formule) in main.ctx.project.infopdv.formules\"><div class=\"well index--{{$index}}\"><div class=\"text-right\"><span ng-click=\"main.deleteFormule($index)\" class=\"glyphicon glyphicon-trash\"></span></div><div class=\"form-group\"><label for=\"nomFormule\" class=\"col-sm-3 control-label\">Nom de la formule&#8239;:</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"nomFormule\" name=\"nomFormule\" ng-model=\"main.ctx.project.infopdv.formules[key].nomFormule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && formules.nomFormule.$invalid]\"></div></div><div class=\"form-group\"><label for=\"compoFormule\" class=\"col-sm-3 control-label\">Composition de la formule&#8239;:</label><div class=\"col-sm-9\"><textarea type=\"text\" class=\"form-control\" id=\"compoFormule\" name=\"compoFormule\" ng-model=\"main.ctx.project.infopdv.formules[key].compoFormule\" rows=\"8\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && formules.compoFormule.$invalid]\"></textarea></div></div><div class=\"form-group\"><label for=\"tarifFormule\" class=\"col-sm-3 control-label\">Tarif&#8239;:</label><div class=\"col-sm-9\"><input type=\"tel\" class=\"form-control\" id=\"tarifFormule\" name=\"tarifFormule\" ng-model=\"main.ctx.project.infopdv.formules[key].tarifFormule\" required=\"\" placeholder=\"En € et TTC\" ng-class=\"{true: \'error\'}[main.submitted && formules.tarifFormule.$invalid]\"></div></div></div></fieldset><div class=\"col-sm-12 text-center\"><a class=\"btn btn-link\" ng-click=\"main.addFormules()\">Ajouter une formule<br><span class=\"glyphicon glyphicon-plus-sign\" aria-hidden=\"true\"></span></a></div><div class=\"col-sm-12\" style=\"margin-bottom: 20px;\"><span style=\"font-size: 13px;\"><i><b>(1)</b> Food Service Vision « les paroles du convive » 2016</i></span><br><span style=\"font-size: 13px;\"><i>(2) CREST Q1 2023</i></span></div><div class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"chr.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(formules)\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validateFormules(formules)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form></div><script type=\"text/ng-template\" id=\"confirmDeleFormule.html\"><div class=\"modal-body alert-delete-formule\" id=\"modal-body-alert-delete-formule\"> <div class=\"modal-header\"><h2 class=\"text-center\">Voulez vraiment supprimer cette formule ?</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"$close()\">OUI</button> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">ANNULER</button> </div> </div></script>");
$templateCache.put("app/da/da-00-dc/da-01-dc-info-client/da-01-dc-info-client.html","<div class=\"container text-center info-pdv\"><form class=\"form-horizontal\" name=\"infopdv\"><fieldset class=\"col-sm-offset-1\"><span class=\"col-sm-offset-3 col-sm-9 help-block\">*Champs obligatoires</span><div class=\"form-group row\"><label for=\"noutlet\" class=\"col-sm-3 control-label\">N° OUTLET&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"noutlet\" class=\"form-control\" id=\"noutlet\" ng-model=\"main.ctx.project.pdv.nOutlet\" required=\"\" ng-readonly=\"main.user.hasRole(\'client\')\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.noutlet.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.noutlet.$invalid\" class=\"error-msg col-sm-4\">Numéro d\'OUTLET obligatoire</div></div><div class=\"form-group row\"><div class=\"col-sm-5 col-sm-offset-3\"><button type=\"button\" class=\"btn btn-default sails-force\" ng-click=\"main.getPdvInfo()\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span>Remplir</button></div></div><div class=\"form-group row\"><label for=\"namepdv\" style=\"padding-left: 0;\" class=\"col-sm-3 control-label\">Nom du point de vente&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"namepdv\" name=\"namepdv\" ng-model=\"main.ctx.project.pdv.nomPDV\" required=\"\" ng-readonly=\"main.user.hasRole(\'client\')\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.namepdv.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.namepdv.$invalid\" class=\"error-msg col-sm-4\">Nom du point de vente obligatoire</div></div><div class=\"form-group row\"><label for=\"adressepdv\" class=\"col-sm-3 control-label\">Adresse&#8239;*&#8239;:</label><div class=\"col-sm-5\"><textarea class=\"form-control\" rows=\"3\" ng-model=\"main.ctx.project.pdv.adresse\" name=\"adressepdv\" id=\"adressepdv\" required=\"\" ng-readonly=\"main.user.hasRole(\'client\')\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.adressepdv.$invalid]\"></textarea></div><div ng-if=\"main.submitted && infopdv.adressepdv.$invalid\" class=\"error-msg col-sm-4\">Adresse du point de vente obligatoire</div></div><div class=\"form-group row\"><label for=\"codepostal\" class=\"col-sm-3 control-label\">CODE POSTAL&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"codepostal\" class=\"form-control\" id=\"codepostal\" ng-pattern=\"/^(\\d{5}-\\d{4}|\\d{5})$/\" max=\"99999\" ng-model=\"main.ctx.project.pdv.codePostal\" required=\"\" ng-readonly=\"main.user.hasRole(\'client\')\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.codepostal.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.codepostal.$invalid && !infopdv.codepostal.$error.pattern\" class=\"error-msg col-sm-4\">Code postal obligatoire</div><div ng-if=\"main.submitted && infopdv.codepostal.$error.pattern\" class=\"error-msg col-sm-4\">Code postal incorrect</div></div><div class=\"form-group row\"><label for=\"ville\" class=\"col-sm-3 control-label\">VILLE&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" name=\"ville\" class=\"form-control\" id=\"ville\" ng-model=\"main.ctx.project.pdv.ville\" required=\"\" ng-readonly=\"main.user.hasRole(\'client\')\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.ville.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.ville.$invalid\" class=\"error-msg col-sm-4\">Ville obligatoire</div></div><div class=\"form-group row\"><label for=\"telephone\" class=\"col-sm-3 control-label\">TéLéPHONE&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"telephone\" class=\"form-control\" id=\"telephone\" ng-pattern=\"/^0\\d(\\s|-)?(\\d{2}(\\s|-)?){4}$/\" ng-model=\"main.ctx.project.pdv.telephone\" required=\"\" placeholder=\"ex: 0652413698\" ng-readonly=\"main.user.hasRole(\'client\')\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.telephone.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.telephone.$invalid && infopdv.telephone.$error.required\" class=\"error-msg col-sm-4\">Téléphone obligatoire</div><div ng-if=\"main.submitted && infopdv.telephone.$error.pattern\" class=\"error-msg col-sm-4\">Téléphone incorrect</div></div><div class=\"form-group row\"><label for=\"nsiret\" class=\"col-sm-3 control-label\">N° SIRET&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"nsiret\" class=\"form-control\" id=\"nsiret\" ng-pattern=\"/^[0-9]{14}$/\" ng-model=\"main.ctx.project.pdv.nSiret\" required=\"\" ng-readonly=\"main.user.hasRole(\'client\')\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.nsiret.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.nsiret.$invalid && infopdv.nsiret.$error.required\" class=\"error-msg col-sm-4\">N°SIRET obligatoire</div><div ng-if=\"main.submitted && infopdv.nsiret.$error.pattern\" class=\"error-msg col-sm-4\">N°SIRET incorrect: 14 chiffres</div></div><div class=\"form-group row\"><label for=\"rcs\" class=\"col-sm-3 control-label\">RCS&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"rcs\" class=\"form-control\" id=\"rcs\" ng-readonly=\"main.user.hasRole(\'client\')\" ng-model=\"main.ctx.project.pdv.rcs\"></div></div><div class=\"form-group row\"><label for=\"nomclient\" class=\"col-sm-3 control-label\">NOM DU CLIENT&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"text\" name=\"nomclient\" class=\"form-control\" id=\"nomclient\" ng-model=\"main.ctx.project.pdv.nomClient\" required=\"\" ng-readonly=\"main.user.hasRole(\'client\')\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.nomclient.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.nomclient.$invalid\" class=\"error-msg col-sm-4\">Nom du Client obligatoire</div></div><div class=\"form-group row\"><label for=\"telclient\" class=\"col-sm-3 control-label\">TéLéPHONE DU CLIENT&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"tel\" name=\"telclient\" class=\"form-control\" id=\"telclient\" ng-pattern=\"/^0\\d(\\s|-)?(\\d{2}(\\s|-)?){4}$/\" ng-model=\"main.ctx.project.pdv.telephoneCLient\" required=\"\" placeholder=\"ex: 0652413698\" ng-readonly=\"main.user.hasRole(\'client\')\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.telclient.$invalid]\"></div><div ng-if=\"main.submitted && infopdv.telclient.$invalid && infopdv.telclient.$error.required\" class=\"error-msg col-sm-4\">Téléphone Client obligatoire</div><div ng-if=\"main.submitted && infopdv.telclient.$error.pattern\" class=\"error-msg col-sm-4\">Téléphone incorrect</div></div><div class=\"form-group row\"><label for=\"emailclient\" class=\"col-sm-3 control-label\">EMAIL DU CLIENT&#8239;*&#8239;:</label><div class=\"col-sm-5\"><input type=\"email\" name=\"emailclient\" class=\"form-control\" id=\"emailclient\" ng-model=\"main.ctx.project.pdv.emailCLient\" required=\"\" ng-readonly=\"main.user.hasRole(\'client\')\" ng-class=\"{true: \'error\'}[main.submitted && infopdv.emailclient.$invalid]\"> <span class=\"help-block\">Attention vous devez fournir un email valide : votre client sera contacté à cette adresse pour la création de son projet</span></div><div ng-if=\"main.submitted && infopdv.emailclient.$invalid && infopdv.emailclient.$error.required\" class=\"error-msg col-sm-4\">Email client obligatoire</div><div ng-if=\"main.submitted && infopdv.emailclient.$error.email\" class=\"error-msg col-sm-4\">Email invalid</div></div></fieldset><div><a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save(infopdv)\" ng-if=\"da.isUpdate()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(infopdv)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form></div>");
$templateCache.put("app/da/da-00-dc/da-02-dc-info-projet/da-02-dc-info-projet.html","<id-projet project=\"main.ctx.project\" validate=\"main.validate()\" save=\"main.save()\" update-project=\"main.updateProject\" previous=\"main.previousState()\"></id-projet>");
$templateCache.put("app/da/da-00-dc/da-03-dc-gamme/da-03-dc-gamme.html","<h2>Sélectionnez la gamme mise en avant sur ce support</h2><h3 class=\"support-name\">{{main.support.name}}</h3><gamme-selector boissons-obj=\"main.boissonsObj\"></gamme-selector><div class=\"suivant\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"da.previousState()\">Précedent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate()\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Valider</a></div><script type=\"text/ng-template\" id=\"sendMsg.html\"><div class=\"modal-body\" id=\"modal-body-msg\"> <div class=\"modal-header\"><h2>{{ vm.text }}</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"$close()\">OK</button> </div> </div></script>");
$templateCache.put("app/sm/sm-02-creation/sm-21-id-projet/sm-21-id-projet.html","<id-projet project=\"main.ctx.project\" validate=\"main.validate()\" save=\"main.save()\" update-project=\"main.updateProject\" previous=\"main.previousState()\"></id-projet>");
$templateCache.put("app/sm/sm-02-creation/sm-22-choix-support/sm-22-choix-support.html","<loading-screen loading=\"main.loading\" class=\"projet-loading\"></loading-screen><alert-message></alert-message><form name=\"supportList\" novalidate=\"\" class=\"form-horizontal choix-support-sm\"><h2>AJOUTEZ UN SUPPORT ET RENSEIGNEZ SON NOM, TYPE, MATIERE ET DIMENSION.</h2><div class=\"help-block\">Si vous ne connaissez pas la matière, merci de ne pas renseigner le champ.</div><div class=\"form-group group-sm-format row\" ng-repeat=\"support in main.ctx.project.supports\" ng-form=\"supportForm\"><div class=\"part-left col-sm-9\"><label class=\"col-sm-12\">Support {{$index + 1}}</label><div class=\"col-sm-12\"><div class=\"col-sm-6 control-group\"><label class=\"control-label\" for=\"name\">Nom&nbsp;:</label> <input type=\"text\" id=\"name\" name=\"name\" ng-model=\"support.name\" ng-class=\"{true: \'error\'}[main.submitted && supportForm.name.$invalid]\" required=\"\"></div><div class=\"col-sm-6 control-group\"><label class=\"control-label\" for=\"type\">Type&nbsp;:</label><select id=\"type\" name=\"type\" ng-model=\"support.type\" ng-options=\"support.name as support.name for support in main.availableSupports\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && supportForm.type.$invalid]\"></select><span class=\"glyphicon glyphicon-triangle-bottom\"></span></div></div><div class=\"col-sm-12\"><div class=\"col-sm-6 control-group\"><label class=\"control-label\" for=\"matiere\">Matière&nbsp;:</label> <input type=\"text\" id=\"matiere\" name=\"matiere\" ng-model=\"support.matiere\"></div><div class=\"col-sm-6\"><div class=\"col-sm-6 control-group\"><label class=\"control-label\" for=\"largeur\">Largeur&nbsp;:<span>cm</span></label> <input type=\"number\" id=\"largeur\" name=\"largeur\" min=\"0\" step=\"1\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && supportForm.largeur.$invalid]\" ng-model=\"support.largeur\"></div><div class=\"col-sm-6 control-group\"><label class=\"control-label\" for=\"hauteur\">Hauteur&nbsp;:<span>cm</span></label> <input type=\"number\" id=\"hauteur\" name=\"hauteur\" min=\"0\" step=\"1\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && supportForm.hauteur.$invalid]\" ng-model=\"support.hauteur\"></div></div></div></div><div class=\"part-right col-sm-3\"><div class=\"trash-icon\"><span ng-click=\"sm.deleteSupport($index)\" class=\"glyphicon glyphicon-trash\"></span></div><div class=\"validity-icon\"><span class=\"glyphicon glyphicon-remove-sign\" ng-if=\"supportForm.$invalid\" aria-hidden=\"true\"></span> <span class=\"glyphicon glyphicon-ok-sign\" ng-if=\"!supportForm.$invalid\" aria-hidden=\"true\"></span></div></div></div><div class=\"new-board-block\"><a class=\"add-new-board\" href=\"\" ng-click=\"main.addNewSupport()\"><span>Ajouter un support</span> <span class=\"glyphicon glyphicon-plus-sign\" aria-hidden=\"true\" role=\"button\"></span></a></div><div class=\"suivant\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"sm.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-if=\"sm.isUpdate()\" ng-click=\"main.save(supportList)\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(supportList)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form>");
$templateCache.put("app/sm/sm-02-creation/sm-23-charte/sm-23-charte.html","<alert-message></alert-message><form class=\"format form-horizontal charte-support\" name=\"charteForm\"><div class=\"col-sm-6\"><h2>Souhaitez-vous utiliser une charte CCEP ?</h2></div><div class=\"col-sm-6 radio-custom\"><div class=\"text-left\" ng-class=\"{true: \'error\'}[main.submitted && charteForm.isCharteCCE.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"isCharteCCE\" value=\"oui\" ng-model=\"main.ctx.project.charte.isCharteCCE\" required=\"\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"isCharteCCE\" value=\"non\" ng-model=\"main.ctx.project.charte.isCharteCCE\" required=\"\"> <label>NON</label></div></div></div><div class=\"col-sm-12 charte-details\" ng-if=\"main.ctx.project.charte.isCharteCCE == \'oui\'\"><div class=\"charteCCE_yes control-group\"><label class=\"control-label\" for=\"charteCCE\">Sélectionnez une charte :</label><div class=\"controls\"><select id=\"charteCCE\" name=\"charteCCE\" ng-model=\"main.ctx.project.charte.charteCCE\" ng-options=\"charte.name as charte.name for charte in main.availableCharteCCE\" ng-class=\"{true: \'error\'}[main.submitted && charteForm.charteCCE.$invalid]\" required=\"\"></select><span class=\"glyphicon glyphicon-triangle-bottom\"></span></div></div></div><div class=\"col-sm-3\"><h2>Charte à intégrer &#8239;:</h2></div><div class=\"col-sm-9 radio-custom\"><div class=\"text-left\" ng-class=\"{true: \'error\'}[main.submitted && charteForm.charteClient.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"charteClient\" ng-model=\"main.ctx.project.charte.charteClient\" value=\"oui\" required=\"\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"charteClient\" ng-model=\"main.ctx.project.charte.charteClient\" value=\"non\" required=\"\"> <label>NON</label></div></div></div><div class=\"col-sm-12 charte-details\" ng-if=\"main.ctx.project.charte.charteClient === \'oui\'\"><div class=\"charteCCE_no\"><div class=\"photo_charte\"><h3>Afin d\'expliquer la charte de votre client, merci de remplir les questions ci-dessous et/ou joindre une photo de la charte client :</h3><p class=\"help-block\">Merci de prendre une photo de bonne qualité et de vérifier la lisibilité du texte.</p><photo-upload photos-obj=\"main.ctx.project.charte.photo_charte\" uploader=\"main.uploader\" file-type=\"\'photo_charte\'\" annotation-enabled=\"true\"></photo-upload><photo-list photos-obj=\"main.ctx.project.charte.photo_charte\" files-project=\"main.filesProject\"></photo-list></div></div><progress-bar-upload ng-show=\"main.uploader.queue.length\" uploader=\"main.uploader\" class=\"col-sm-12\"></progress-bar-upload></div><div class=\"col-sm-3\"><h2>Logo à intégrer &#8239;:</h2></div><div class=\"col-sm-9 radio-custom\"><div class=\"text-left\" ng-class=\"{true: \'error\'}[main.submitted && charteForm.logoClient.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"logoClient\" ng-model=\"main.ctx.project.charte.logoClient\" value=\"oui\" required=\"\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"logoClient\" ng-model=\"main.ctx.project.charte.logoClient\" value=\"non\" required=\"\"> <label>NON</label></div></div></div><div class=\"col-sm-12 charte-details\" ng-if=\"main.ctx.project.charte.logoClient === \'oui\'\"><div class=\"charteCCE_no\"><div class=\"photo_logo\"><p class=\"help-block\">Merci de prendre une photo de bonne qualité et de vérifier la lisibilité du texte.<br>Le logo en HD doit être envoyé à l\'agence par mail.</p><photo-upload photos-obj=\"main.ctx.project.charte.photo_logo\" uploader=\"main.uploader\" file-type=\"\'photo_logo\'\" annotation-enabled=\"true\"></photo-upload><photo-list photos-obj=\"main.ctx.project.charte.photo_logo\" files-project=\"main.filesProject\"></photo-list></div></div><progress-bar-upload ng-show=\"main.uploader.queue.length\" uploader=\"main.uploader\" class=\"col-sm-12\"></progress-bar-upload></div><div class=\"col-sm-3\"><h2>Typographie à intégrer &#8239;:</h2></div><div class=\"col-sm-9 radio-custom\"><div class=\"text-left\" ng-class=\"{true: \'error\'}[main.submitted && charteForm.typoClient.$invalid]\"><div class=\"radio\"><input type=\"radio\" name=\"typoClient\" ng-model=\"main.ctx.project.charte.typoClient\" value=\"oui\" required=\"\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"typoClient\" ng-model=\"main.ctx.project.charte.typoClient\" value=\"non\" required=\"\"> <label>NON</label></div></div></div><div class=\"typographie_charte form-group col-sm-12\" ng-if=\"main.ctx.project.charte.typoClient === \'oui\'\"><div class=\"charteCCE_no\"><div class=\"photo_typo\"><p class=\"help-block\">Merci de prendre une photo de bonne qualité et de vérifier la lisibilité du texte.</p><photo-upload photos-obj=\"main.ctx.project.charte.photo_typo\" uploader=\"main.uploader\" file-type=\"\'photo_typo\'\" annotation-enabled=\"true\"></photo-upload><photo-list photos-obj=\"main.ctx.project.charte.photo_typo\" files-project=\"main.filesProject\"></photo-list></div></div><progress-bar-upload ng-show=\"main.uploader.queue.length\" uploader=\"main.uploader\" class=\"col-sm-12\"></progress-bar-upload><div class=\"control-group col-sm-12\"><label for=\"nomTypoClient\" class=\"control-label\">Nom de la Typographie (si connue) :</label><div class=\"controls\"><input type=\"text\" name=\"nomTypoClient\" ng-model=\"main.ctx.project.charte.nomTypoClient\" class=\"form-control\"></div></div></div><div class=\"suivant\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"sm.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-if=\"sm.isUpdate()\" ng-click=\"main.save(charteForm)\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(charteForm)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form>");
$templateCache.put("app/sm/sm-03-contenu/sm-31-gamme/sm-31-gamme.html","<alert-message></alert-message><form class=\"format form-horizontal gamme-support\" name=\"gammeList\"><h2>Sélectionnez la gamme à mettre en avant sur chaque support</h2><div class=\"form-group group-sm-gamme row\" ng-repeat=\"support in main.ctx.project.supports\" ng-form=\"supportForm\"><div class=\"part-left-gamme col-sm-4\"><div class=\"col-sm-12\"><label for=\"menu_winter\" class=\"col-sm-12 name\">{{support.name}}</label></div><div class=\"col-sm-12 type\">{{support.type}}</div><div class=\"col-sm-12 matiere\">{{support.matiere}}</div><div class=\"col-sm-12 dimensions\">{{support.largeur}} x {{support.hauteur}} cm</div></div><div class=\"part-right-gamme radio-custom col-sm-8\"><div class=\"trash-icon\"><span ng-click=\"sm.deleteSupport($index)\" class=\"glyphicon glyphicon-trash\"></span></div><div class=\"text-left isGamme\" ng-if=\"!main.hasBoissons(support)\"><div class=\"text-center instruction\">Mettre une gamme en avant</div><div class=\"radio\"><input type=\"radio\" name=\"isGamme{{$index}}\" ng-value=\"true\" ng-model=\"support.isGamme\" required=\"\" ng-change=\"main.changeIsGamme(support, $index)\" ng-class=\"{true: \'error\'}[main.submitted && supportForm.isGamme{{$index}}.$invalid]\"> <label>OUI</label></div><div class=\"radio\"><input type=\"radio\" name=\"isGamme{{$index}}\" ng-value=\"false\" ng-model=\"support.isGamme\" required=\"\" ng-change=\"main.changeIsGamme(support, $index)\" ng-class=\"{true: \'error\'}[main.submitted && supportForm.isGamme{{$index}}.$invalid]\"> <label>NON</label></div></div><div class=\"form-group row\"><div class=\"lot-boissons-gamme\" ng-if=\"main.hasBoissons(support)\"><div class=\"gamme-img-boissons ng-scope\"><gamme-display boissons-obj=\"support.boissons\" on-click=\"main.editGamme(support, $index)\"></gamme-display></div><div><a class=\"btn deleteBtn\" ng-click=\"main.cleanBoissons(support)\"><span class=\"glyphicon glyphicon-remove-sign\"></span><span>Supprimer la sélection</span></a></div></div></div></div></div><div class=\"suivant\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"sm.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-if=\"sm.isUpdate(gammeList)\" ng-click=\"main.save(gammeList)\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(gammeList)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form>");
$templateCache.put("app/sm/sm-03-contenu/sm-31-gamme-select/sm-31-gamme-select.html","<h2>Sélectionnez la gamme mise en avant sur ce support</h2><h3 class=\"support-name\">{{main.support.name}}</h3><gamme-selector boissons-obj=\"main.boissonsObj\"></gamme-selector><div class=\"suivant\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"sm.previousState()\">Annuler <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear disabled\" href=\"\" ng-if=\"sm.isUpdate()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate()\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Valider</a></div><script type=\"text/ng-template\" id=\"applyToAllSupport.html\"><div class=\"modal-body alert-delete-gamme\" id=\"modal-body-alert-delete-gamme\"> <div class=\"modal-header\"><h2 class=\"text-center\">Souhaitez-vous appliquer cette gamme à tous les supports ?</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\"> NON <span class=\"glyphicon glyphicon-remove-sign\" aria-hidden=\"true\"></span> </button> <button class=\"btn btn-default\" ng-click=\"$close()\"> <span class=\"glyphicon glyphicon-ok-sign\" aria-hidden=\"true\"></span> OUI </button> </div> </div></script>");
$templateCache.put("app/sm/sm-03-contenu/sm-32-edition/sm-32-edition.html","<alert-message></alert-message><h2>Editez les supports pour renseigner les informations</h2><div class=\"form-group group-sm-edition row\" ng-repeat=\"support in main.ctx.project.supports\" ng-form=\"editionForm\" ng-class=\"{true: \'error\'}[main.submitted && !main.isValidCreation(support)]\"><div class=\"part-left col-sm-6\"><div class=\"col-sm-12 name\">{{support.name}}</div><div class=\"col-sm-12 type\">{{support.type}}</div><div class=\"col-sm-12 matiere\">{{support.matiere}}</div><div class=\"col-sm-12 dimensions\">{{support.largeur}} x {{support.hauteur}} cm</div></div><div class=\"part-right col-sm-6\"><div class=\"trash-icon\"><span ng-click=\"sm.deleteSupport($index)\" class=\"glyphicon glyphicon-trash\"></span></div><a class=\"btn btn-default editCreation\" ng-click=\"main.editCreation(support, $index)\"><span class=\"glyphicon glyphicon-pencil\"></span><span>Éditer la création</span></a><div class=\"validity-icon\"><span class=\"glyphicon glyphicon-remove-sign\" ng-if=\"!main.isValidCreation(support)\" aria-hidden=\"true\"></span> <span class=\"glyphicon glyphicon-ok-sign\" ng-if=\"main.isValidCreation(support)\" aria-hidden=\"true\"></span></div></div></div><div class=\"suivant\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"sm.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-if=\"sm.isUpdate()\" ng-click=\"main.save()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate()\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div>");
$templateCache.put("app/sm/sm-03-contenu/sm-32-edition-update/sm-32-edition-update.html","<h2>Pour renseigner le contenu, prendre une photo de bonne qualité et ajouter des Post-it et commentaires si besoin</h2><div class=\"edition_update\"><h3 class=\"support-name\">{{main.support.name}}</h3><p class=\"help-block\">Merci de prendre une photo de bonne qualité et de vérifier la lisibilité du texte.</p><photo-upload ng-if=\"main.creation\" photos-obj=\"main.creation\" uploader=\"main.uploader\" file-type=\"\'photo_crea\'\"></photo-upload><photo-list ng-if=\"main.creation\" photos-obj=\"main.creation\" files-project=\"main.filesProject\"></photo-list><progress-bar-upload ng-show=\"main.uploader.queue.length\" uploader=\"main.uploader\" class=\"col-sm-12\"></progress-bar-upload><div class=\"suivant\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"sm.previousState()\">Précédent <span class=\"glyphicon glyphicon-remove-sign\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear disabled\" href=\"\" ng-if=\"sm.isUpdate()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate()\"><span class=\"glyphicon glyphicon-ok\" aria-hidden=\"true\"></span> Valider</a></div></div>");
$templateCache.put("app/vae/vae-02-creation/vae-21-id-projet/vae-21-id-projet.html","<id-projet project=\"main.ctx.project\" validate=\"main.validate()\" save=\"main.save()\" update-project=\"main.updateProject\" previous=\"main.previousState()\"></id-projet>");
$templateCache.put("app/vae/vae-02-creation/vae-22-choix-boards/vae-22-choix-boards.html","<loading-screen loading=\"main.loading\" class=\"projet-loading\"></loading-screen><form name=\"choix-boards\" class=\"form-horizontal choix-boards\"><h2>Sélectionner les boards de votre choix</h2><div id=\"regle-board\" class=\"text-left regle-choix-boards\"><p>Pour rappel, vous devez sélectionner au minimum 3 boards dont:<br>- Une pricelist ou une gamme<br>- Un MENU PET</p><p class=\"error-msg\" id=\"errorNbrBoard\" ng-if=\"main.submitted && main.countBoard < 3\">Vous devez choisir au moins 3 Boards.</p><p class=\"error-msg\" id=\"errorPETBoard\" ng-if=\"main.submitted && main.boardPET < 1\">Vous devez choisir au moins un MENU PET dans la liste des boards.</p><p class=\"error-msg\" id=\"errorGLBoard\" ng-if=\"main.submitted && main.boardGL < 1\">Vous devez choisir au moins une Pricelist ou une Gamme dans la liste des boards.</p></div><div class=\"form-group\" ng-repeat=\"(parent, enfants) in main.boards | groupBy:\'field_type_de_board\'\"><uib-accordion><div uib-accordion-group=\"\" class=\"panel-default row\" is-open=\"main.tabAccordion[$index]\" ng-init=\"main.isOpen($index)\"><uib-accordion-heading ng-init=\"main.textCategorieBoard(parent)\">Boards {{ main.textCategorieBoard(parent) }} <i class=\"pull-right glyphicon glyphicon-chevron-down\"></i></uib-accordion-heading><div ng-repeat=\"enfant in enfants\" ng-class=\"{\'col-sm-6 gamme-pricelist\': enfant.field_type_de_board == \'Gamme et Pricelist\', \'col-sm-4 menu\': enfant.field_type_de_board != \'Gamme et Pricelist\'}\"><label class=\"label-choix-board\"><img ng-src=\"{{ enfant.field_image_board }}\" alt=\"{{enfant.name}}\" title=\"{{enfant.name}}\" width=\"100%\"><div class=\"name-increment row\"><span class=\"boards-name\" ng-class=\"{\'col-sm-6\': enfant.field_type_de_board == \'Gamme et Pricelist\', \'col-sm-12\': enfant.field_type_de_board != \'Gamme et Pricelist\'}\"><span class=\"name\">{{ enfant.name }}</span></span> <span class=\"increment\" ng-class=\"{\'col-sm-6\': enfant.field_type_de_board == \'Gamme et Pricelist\', \'col-sm-12\': enfant.field_type_de_board != \'Gamme et Pricelist\'}\"><span class=\"glyphicon glyphicon-minus\" aria-hidden=\"true\" ng-click=\"main.decrement(enfant)\" ng-class=\"{\'disabled\': main.oldBoardsChoice[enfant.name].quantite == main.boardsChoice[enfant.name].quantite}\"></span> <span class=\"number-board\">{{ main.boardsChoice[enfant.name].quantite }}</span> <span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\" ng-click=\"main.increment(enfant)\"></span></span></div><span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\" ng-click=\"main.zoomBoard(enfant.field_image_board, enfant.name)\"></span></label></div></div></uib-accordion></div><div class=\"nbr-board\"><p><span class=\"count-board\">Nombre de board sélectionné&#8239;: <b>{{main.countBoard}}</b></span></p></div><div class=\"suivant\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"vae.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear disabled\" href=\"\" ng-if=\"vae.isUpdate()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate()\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form><script type=\"text/ng-template\" id=\"zoomBoards.html\"><div class=\"modal-body zoom-boards\" id=\"modal-body-zoom-boards\"> <span class=\"glyphicon glyphicon-remove\" ng-click=\"$close()\" aria-hidden=\"true\"></span> <img ng-src=\"{{ vm.img }}\" alt=\"{{ vm.boardName }}\" title=\"{{ vm.boardName }}\" style=\"width: 100%;\"/> </div></script>");
$templateCache.put("app/vae/vae-02-creation/vae-23-format/vae-23-format.html","<form class=\"format form-horizontal format-board\" name=\"format_board\"><h2>Sélectionner le format de votre choix pour chaque board</h2><div id=\"alert-message\"><div uib-alert=\"\" class=\"alert alert-fade\" type=\"{{main.alert.type}}\" close=\"main.closeAlert()\" ng-if=\"main.alert.msg != undefined\">{{main.alert.msg}}</div></div><div class=\"form-group row\" ng-if=\"main.ctx.project.type === \'Boards PVC\'\"><label>Vous pouvez également dupliquer 2 boards pour les faire imprimer en version stop-trottoir.</label></div><div id=\"errorFormat\"><p ng-if=\"main.submitted && format_board.$invalid\" class=\"error-msg text-left\">Choisir un format pour chaque board</p><p ng-if=\"main.submitted && main.nbStopTrottoir() > main.NB_MAX_STOPTROTTOIR\" class=\"error-msg text-left\">Le nombre de stop-trottoir est limité à 2. Veuillez en décocher de manière de revenir dans cette limite.</p></div><div class=\"form-group group-board-format row\" ng-repeat=\"boards in main.ctx.project.boards\"><div class=\"part-left col-sm-4\"><label class=\"col-sm-12\">{{ boards.displayName }}</label> <span class=\"image-board col-sm-12\"><img ng-src=\"{{ boards.imageBoard }}\" alt=\"{{ boards.displayName }}\"></span></div><div class=\"part-right col-sm-8\"><div class=\"trash-icon\"><span ng-click=\"main.deleteBoard($index)\" class=\"glyphicon glyphicon-trash\"></span></div><div class=\"form-group row\"><label class=\"col-sm-6\">Choix du format :</label><select name=\"formatBoard{{$index}}\" class=\"form-control col-sm-6 formatBoard\" ng-model=\"boards.format\" id=\"formatBoard\" ng-class=\"{true: \'error\'}[main.submitted && format_board.formatBoard{{$index}}.$invalid]\" required=\"\"><option value=\"\"></option><option ng-repeat=\"option in main.formatBoards\" value=\"{{option}}\">{{option}}</option></select><span class=\"glyphicon glyphicon-triangle-bottom\"></span></div><div class=\"form-group row\" ng-if=\"main.ctx.project.type === \'Boards PVC\'\"><div class=\"checkbox checkbox-custom checkbox-stoptrottoir\"><input type=\"checkbox\" name=\"optionStopTrottoir{{$index}}\" ng-model=\"boards.optionStopTrottoir\" ng-change=\"main.changeOptionStopTrottoir(boards.optionStopTrottoir, boards)\" ng-disabled=\"!boards.optionStopTrottoir && main.nbStopTrottoir() >= main.NB_MAX_STOPTROTTOIR\"><label></label></div><span class=\"label-trottoir\">AJOUTER UNE DUPLICATION STOP-TROTTOIR</span><select name=\"formatStopTrottoir{{$index}}\" class=\"form-control col-sm-6 formatBoard\" ng-model=\"boards.formatStopTrottoir\" ng-class=\"{true: \'error\'}[main.submitted && format_board.formatStopTrottoir{{$index}}.$invalid]\" ng-required=\"boards.optionStopTrottoir\" ng-disabled=\"!boards.optionStopTrottoir\"><option value=\"\"></option><option ng-repeat=\"option in main.formatStopTrottoirs\" value=\"{{option}}\">{{option}}</option></select><span ng-class=\"{ disabled: !boards.optionStopTrottoir }\" class=\"glyphicon glyphicon-triangle-bottom\"></span></div></div></div><div class=\"suivant\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"vae.previousState()\">Précédent <span class=\"glyphicon glyphicon-menu-left\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear disabled\" href=\"\" ng-if=\"vae.isUpdate()\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(format_board)\"><span class=\"glyphicon glyphicon-menu-right\" aria-hidden=\"true\"></span> Suivant</a></div></form><script type=\"text/ng-template\" id=\"confirmDeleBoard.html\"><div class=\"modal-body alert-delete-board\" id=\"modal-body-alert-delete-board\"> <div class=\"modal-header\"><h2 class=\"text-center\">Voulez vous vraiment supprimer ce board ?</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"$close()\">OUI</button> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">ANNULER</button> </div> </div></script>");
$templateCache.put("app/vae/vae-03-contenu/vae-31-contenu_gamme/vae-31-contenu_gamme-boissons.html","<div class=\"container gamme-boissons text-center wrapp creation-boards\"><ul class=\"nav nav-tabs sub-menu text-center\" ng-if=\"vae.ctx.project.type !== \'Digital\'\"><li class=\"col-sm-4 disabled\" ng-class=\"{active: vae.$state.is(\'vae.contenu.gamme-prix\')}\"><a disabled=\"\">PRIX</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: vae.$state.is(\'vae.contenu.gamme-boissons\')}\"><a disabled=\"\">BOISSONS</a></li></ul><ul class=\"nav nav-tabs sub-menu text-center\" ng-if=\"vae.ctx.project.type === \'Digital\'\"><li class=\"col-sm-4 disabled\" ng-class=\"{active: vae.$state.is(\'vae-digital.contenu.gamme-prix\')}\"><a disabled=\"\">PRIX</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: vae.$state.is(\'vae-digital.contenu.gamme-boissons\')}\"><a disabled=\"\">BOISSONS</a></li></ul><form name=\"boissons\" class=\"row\"><h2>SÉLECTIONNER LES BOISSONS A ASSOCIER AU PRIX</h2><h3 class=\"title-board\">BOARD {{ main.board.data.displayName }}</h3><div ng-if=\"main.submitted && main.nbrChecked < 1\" class=\"error-msg text-left\">Vous devez choisir les boissons de la gamme de prix</div><div class=\"form-group boisson well\" ng-repeat=\"(parent, enfants) in main.gammes | groupBy:\'name\'\"><div class=\"part-left\" ng-repeat=\"imgParent in enfants\" ng-if=\"$first\"><img ng-src=\"{{ imgParent.field_gamme_image_boissons_1 }}\" alt=\"\"></div><div class=\"part-right\"><div class=\"checkbox checkbox-custom\" ng-repeat=\"enfant in enfants | orderBy:\'weight_children\'\"><input type=\"checkbox\" name=\"{{parent}}-{{ $index }}\" ng-true-value=\"\'{{ enfant.name_1 }} {{ enfant.field_gamme_format_boissons }}\'\" ng-model=\"main.savePrixGamme.prix[main.savePrixGamme.index].boissons[parent][$index].name\" ng-change=\"main.onChangeBoissons(main.savePrixGamme.prix[main.savePrixGamme.index].boissons[parent], parent, enfant, $index)\"> <label><span class=\"gamme-name\">{{ enfant.name_1 }}</span> <span class=\"gamme-format\">{{ enfant.field_gamme_format_boissons }}</span></label> <span class=\"image\"><img ng-src=\"{{ enfant.field_gamme_image_boissons }}\" alt=\"\"></span></div></div></div><div class=\"col-sm-12 text-center buttons\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.canceled()\">Annuler <span class=\"glyphicon glyphicon-remove-sign\" aria-hidden=\"true\"></span></a><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate()\"><span class=\"glyphicon glyphicon-ok-sign\" aria-hidden=\"true\"></span> Valider</a></div></form></div>");
$templateCache.put("app/vae/vae-03-contenu/vae-31-contenu_gamme/vae-31-contenu_gamme-prix.html","<div class=\"container gamme-prix text-center wrapp creation-boards\"><ul class=\"nav nav-tabs sub-menu text-center\" ng-if=\"vae.ctx.project.type !== \'Digital\'\"><li class=\"col-sm-4 disabled\" ng-class=\"{active: vae.$state.is(\'vae.contenu.gamme-prix\')}\"><a disabled=\"\">PRIX</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: vae.$state.is(\'vae.contenu.gamme-boissons\')}\"><a disabled=\"\">BOISSONS</a></li></ul><ul class=\"nav nav-tabs sub-menu text-center\" ng-if=\"vae.ctx.project.type === \'Digital\'\"><li class=\"col-sm-4 disabled\" ng-class=\"{active: vae.$state.is(\'vae-digital.contenu.gamme-prix\')}\"><a disabled=\"\">PRIX</a></li><li class=\"col-sm-4 disabled\" ng-class=\"{active: vae.$state.is(\'vae-digital.contenu.gamme-boissons\')}\"><a disabled=\"\">BOISSONS</a></li></ul><form class=\"form-gamme-prix row form-horizontal\" name=\"gammeprix\"><h2>Ajouter un prix et sélectionner les boissons correspondantes</h2><h3 class=\"title-board\">BOARD {{ main.board.data.displayName }}</h3><p class=\"help-block\" id=\"errorPrix\" ng-class=\"{\'error-msg\': (main.btnLinkBoissons && gammeprix.$invalid) || (main.submitted && (gammeprix.$invalid || main.error))}\">Pour le board GAMME, vous devez renseigner le prix et la liste des boissons CCEP associées à prix. Pour réaliser cette action, veuillez ajouter un prix dans la colonne correspondante puis cliquer sur « AJOUTER DES BOISSONS ».<br>Si vous souhaitez ajouter un prix, veuillez cliquez sur « AJOUTER UN PRIX ».<br>Pour modififer la liste des boissons, cliquer sur celle-ci.</p><fieldset class=\"panel col-sm-12 form-group group-gamme-prix\" ng-repeat=\"gamme in main.brief\"><div class=\"part-left col-sm-4\"><div><label class=\"col-sm-12\">PRIX</label> <span class=\"col-sm-12 input-gamme-prix\"><input type=\"number\" placeholder=\"--,--\" ng-model=\"gamme.prix\" required=\"\" name=\"prix_gamme{{$index}}\" step=\"0.01\" ng-class=\"{true: \'error\'}[main.btnLinkBoissons && gammeprix.prix_gamme{{$index}}.$invalid]\"> €</span></div></div><div class=\"part-right col-sm-8\"><div class=\"trash-icon\"><span ng-click=\"main.deletePrix($index)\" class=\"glyphicon glyphicon-trash\"></span></div><div class=\"form-group row\"><a type=\"submit\" class=\"btn btn-default attach-boissons\" ng-if=\"!main.hasBoissons($index)\" href=\"\" ng-click=\"main.linkBoisson(gammeprix, $index, main.brief)\"><span class=\"glyphicon glyphicon-list\" aria-hidden=\"true\"></span> Ajouter des boissons</a><div class=\"lot-boissons-gamme\" ng-if=\"main.hasBoissons($index)\" ng-click=\"main.linkBoisson(gammeprix, $index, main.brief)\"><div class=\"gamme-img-boissons\" ng-repeat=\"(key,boissons) in gamme.boissons\"><div ng-repeat=\"boisson in boissons\" class=\"sub-class-image\"><img ng-src=\"{{ boisson.image }}\"></div></div></div></div></div></fieldset><div class=\"col-sm-12 text-center\"><a class=\"btn btn-link text-uppercase\" ng-click=\"main.addPrix()\">Ajouter un prix<br><span class=\"glyphicon glyphicon-plus-sign\" aria-hidden=\"true\"></span></a></div><div class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.cancel()\">Précédent <span class=\"glyphicon glyphicon-remove-sign\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save()\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate()\"><span class=\"glyphicon glyphicon-ok-sign\" aria-hidden=\"true\"></span> Valider</a></div></form></div><script type=\"text/ng-template\" id=\"confirmDelePrix.html\"><div class=\"modal-body alert-delete-gamme\" id=\"modal-body-alert-delete-gamme\"> <div class=\"modal-header\"><h2 class=\"text-center\">Voulez-vous vraiment supprimer ce prix ?</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\"> ANNULER <span class=\"glyphicon glyphicon-remove-sign\" aria-hidden=\"true\"></span> </button> <button class=\"btn btn-default\" ng-click=\"$close()\"> <span class=\"glyphicon glyphicon-ok-sign\" aria-hidden=\"true\"></span> OUI </button> </div> </div></script>");
$templateCache.put("app/vae/vae-03-contenu/vae-32-contenu_pricelist/vae-32-contenu_pricelist.html","<div class=\"container text-center pricelist\"><form class=\"form-pricelist row\" name=\"pricelist\"><h2>Veuillez prendre une photo ou renseigner manuellement la pricelist</h2><h3 class=\"title-board\">BOARD {{ main.board.data.displayName }}</h3><div class=\"errorPriceList\" id=\"errorPriceList\"><p class=\"text-left error-msg\" ng-if=\"main.submitted && main.errorPricelist\">Veuillez renseigner le contenu de la price liste à saisir.</p></div><div class=\"take-photo col-sm-12\"><p class=\"help-block\">Merci de prendre une photo de bonne qualité et de vérifier la lisibilité du texte.</p><fieldset class=\"col-sm-12 list-photo-added\" ng-if=\"main.hasPhoto\"><h4>Liste des photos déjà prises:</h4><ul class=\"list-group\"><uib-accordion close-others=\"true\"><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"(key,photo) in main.brief.photo\"><uib-accordion-heading>{{photo.name}}<i class=\"pull-right glyphicon glyphicon-chevron-down\"></i></uib-accordion-heading><table class=\"table\"><tr><td>Modifications: {{ photo.texte }}</td><td><a ng-click=\"main.modifCarte(photo)\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></a></td></tr><tr ng-if=\"photo.anno.length > 0\"><td><p>Post-It:</p><ol><li ng-repeat=\"(key,postit) in photo.anno\">{{ postit.text }}</li></ol></td><td><a ng-click=\"main.annotate(photo,key)\"><span class=\"glyphicon glyphicon-comment\" aria-hidden=\"true\"></span></a></td></tr></table></div></uib-accordion></ul></fieldset><fieldset class=\"item-photo-pricelist col-sm-12\" ng-repeat=\"(key,item) in main.uploader.queue | filter:{myplv_file_type: main.file_type}\"><div class=\"well index--{{$index}}\"><div class=\"form-group\"><input type=\"hidden\" ng-init=\"main.brief.photo[item.file.firtsName].name = item.file.name\" value=\"{{item.file.name}}\"> <label ng-bind=\"item.file.name\" class=\"col-sm-6\"></label><p ng-show=\"main.uploader.isHTML5\" nowrap=\"\" class=\"col-sm-3\">Taille : {{ item.file.size / 1024 / 1024|number:2 }} MB</p><div class=\"text-right\"><span ng-click=\"main.deletePhoto($index, item)\" class=\"glyphicon glyphicon-trash\"></span></div></div><div class=\"form-group row\"><label for=\"modification\" class=\"col-sm-3 control-label text-modif\">Modification à apporter&#8239;:</label><div class=\"col-sm-9\"><textarea class=\"form-control\" id=\"modification\" name=\"modification\" rows=\"8\" ng-model=\"main.brief.photo[item.file.firtsName].texte\"></textarea></div></div></div></fieldset><progress-bar-upload ng-show=\"main.uploader.queue.length\" uploader=\"main.uploader\" class=\"col-sm-12\"></progress-bar-upload><fieldset class=\"photo col-sm-12\"><div class=\"photo-action\"><div class=\"form-group\"><label for=\"photo\" class=\"col-sm-3 control-label\">Ajouter une photo&#8239;:</label><div class=\"\"><input type=\"file\" multiple=\"\" accept=\"application/pdf,image/*\" class=\"form-control\" id=\"photo\" name=\"photo\" nv-file-select=\"\" uploader=\"main.uploader\" options=\"{file_type:\'photo_pricelist\'}\" sn-model-file=\"main.file\"></div></div></div></fieldset></div><div class=\"manual-pricelist col-sm-8 col-sm-offset-2\"><textarea name=\"manualPricelist\" id=\"manualPricelist\" cols=\"30\" rows=\"20\" placeholder=\"Saisir la pricelist manuellement si vous ne pouvez pas prendre de photo\" ng-model=\"main.brief.texte\"></textarea></div><div class=\"form-group-btn\"><a type=\"submit\" class=\"btn btn-default btn-lg\" ng-click=\"main.cancel()\">Précédent <span class=\"glyphicon glyphicon-remove-sign\" aria-hidden=\"true\"></span></a><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate()\"><span class=\"glyphicon glyphicon-ok-sign\" aria-hidden=\"true\"></span> Valider</a></div></form></div><script type=\"text/ng-template\" id=\"confirmDelePhoto.html\"><div class=\"modal-body alert-delete-photo\" id=\"modal-body-alert-delete-photo\"> <div class=\"modal-header\"><h2 class=\"text-center\">Voulez vraiment supprimer cette photo ?</h2></div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"$close()\">OUI</button> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">ANNULER</button> </div> </div></script><script type=\"text/ng-template\" id=\"modifPhoto.html\"><div class=\"modal-body alert-modif-photo\" id=\"modal-body-alert-modif-photo\"> <div class=\"modal-header\"><h2 class=\"text-center\">Modification de la Pricelist</h2></div> <div class=\"modal-body\"> <textarea name=\"modifphoto\" id=\"\" cols=\"30\" rows=\"10\" ng-model=\"vm.photoModif\"></textarea> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default btn-cancel\" ng-click=\"$dismiss()\">ANNULER</button> <button class=\"btn btn-default\" ng-click=\"vm.validate()\">VALIDER</button> </div> </div></script>");
$templateCache.put("app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x2-items/vae-33-contenu_menu-double-2x2-items.html","<div class=\"container text-center simple-pet-2-items double-pet-22-items\"><form class=\"form-horizontal form-menu-sp-2-items\" name=\"doublepet2\"><h2>Renseigner le contenu du board menu</h2><h3 id=\"errorMenu2Items\">{{ main.board.data.displayName }}</h3><div class=\"error-msg text-left\"><p ng-if=\"main.submitted && doublepet2.$invalid\">Veuillez remplir les champs obligatoire.</p><p ng-if=\"main.submitted && main.checked < 2\">Le choix de 2 solides est obligatoire. Un pour chaque formule.</p></div><fieldset class=\"row group-data-menu\"><div class=\"part-left col-sm-8\"><div class=\"row\"><h4 class=\"col-sm-offset-2 col-sm-6\">Formule 1</h4></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet2.nomformule1.$invalid]\"><label for=\"nomformule1\" class=\"col-sm-6 control-label\">NOM DE LA FORMULE&#8239;1&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" placeholder=\"Exemple : formule sandwich\" name=\"nomformule1\" class=\"form-control\" id=\"nomformule1\" ng-model=\"main.brief.Formule1.nomFormule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && doublepet2.nomformule1.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet2.nomsolide1.$invalid]\"><label for=\"nomsolide1\" class=\"col-sm-6 control-label\">NOM DU SOLIDE&#8239;1&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" name=\"nomsolide1\" class=\"form-control\" id=\"nomsolide1\" ng-model=\"main.brief.Formule1.nomsolide\" required=\"\" placeholder=\"Exemple: un sandwich\" ng-class=\"{true: \'error\'}[main.submitted && doublepet2.nomsolide1.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet2.prixformule1.$invalid]\"><label for=\"prixformule1\" class=\"col-sm-6 control-label\">PRIX DE LA FORMULE&#8239;1&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixformule1\" class=\"form-control\" id=\"prixformule1\" ng-model=\"main.brief.Formule1.prixformule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && doublepet2.prixformule1.$invalid]\"></div></div><div class=\"form-group row\"><label for=\"prixbarre1\" class=\"col-sm-6 control-label\">PRIX BARRÉ&#8239;1&#8239;:</label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixbarre1\" class=\"form-control\" id=\"prixbarre1\" ng-model=\"main.brief.Formule1.prixbarre\"></div></div><div class=\"form-group row\" ng-if=\"!main.sansOption\"><label for=\"prixAutreFormule1\" class=\"col-sm-6 control-label\">{{ main.labelPrixAutreFormule }}&#8239;1&#8239;:<br><span class=\"help-block text-optionnel\">Optionnel</span></label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixAutreFormule1\" class=\"form-control\" id=\"prixAutreFormule1\" ng-model=\"main.brief.Formule1.prixAutreFormule\"></div></div><hr><div class=\"row\"><h4 class=\"col-sm-offset-2 col-sm-6\">Formule 2</h4></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet2.nomformule2.$invalid]\"><label for=\"nomformule2\" class=\"col-sm-6 control-label\">NOM DE LA FORMULE&#8239;2&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" placeholder=\"Exemple : formule sandwich\" name=\"nomformule2\" class=\"form-control\" id=\"nomformule2\" ng-model=\"main.brief.Formule2.nomFormule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && doublepet2.nomformule2.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet2.nomsolide2.$invalid]\"><label for=\"nomsolide2\" class=\"col-sm-6 control-label\">NOM DU SOLIDE&#8239;2&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" name=\"nomsolide2\" class=\"form-control\" id=\"nomsolide2\" ng-model=\"main.brief.Formule2.nomsolide\" required=\"\" placeholder=\"Exemple: un sandwich\" ng-class=\"{true: \'error\'}[main.submitted && doublepet2.nomsolide2.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet2.prixformule2.$invalid]\"><label for=\"prixformule2\" class=\"col-sm-6 control-label\">PRIX DE LA FORMULE&#8239;2&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixformule2\" class=\"form-control\" id=\"prixformule2\" ng-model=\"main.brief.Formule2.prixformule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && doublepet2.prixformule2.$invalid]\"></div></div><div class=\"form-group row\"><label for=\"prixbarre2\" class=\"col-sm-6 control-label\">PRIX BARRÉ&#8239;2&#8239;:</label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixbarre2\" class=\"form-control\" id=\"prixbarre2\" ng-model=\"main.brief.Formule2.prixbarre\"></div></div><div class=\"form-group row\" ng-if=\"!main.isCapri && !main.sansOption\"><label for=\"prixAutreFormule2\" class=\"col-sm-6 control-label\">{{ main.labelPrixAutreFormule }}&#8239;2&#8239;:<br><span class=\"help-block text-optionnel\">Optionnel</span></label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixAutreFormule2\" class=\"form-control\" id=\"prixAutreFormule2\" ng-model=\"main.brief.Formule2.prixAutreFormule\"></div></div></div><div class=\"part-right col-sm-3\"><img ng-src=\"{{ main.board.data.imageBoard }}\" alt=\"{{ main.board.data.displayName }}\"> <span class=\"help-block\">Visuel Illustratif</span></div></fieldset><span class=\"help-block text-uppercase\">Sélectionner le(s) visuel(s) de solides à intégrer.</span><fieldset class=\"switch-solide-choice\"><p>Choisir la formule à laquelle ajouter le visuel du solide associé.</p><div class=\"col-sm-12\"><a class=\"btn btn-default solides-formule\" ng-class=\"{true: \'formule-active\'}[main.choiceFormule == 1]\" ng-click=\"main.switchSolideFormule(1)\">Solides de la formule 1</a> <a class=\"btn btn-default solides-formule\" ng-class=\"{true: \'formule-active\'}[main.choiceFormule == 2]\" ng-click=\"main.switchSolideFormule(2)\">Solides de la formule 2</a></div><p class=\"help-block col-sm-12 text-center\">{{ main.texteChoiceSolide }}</p></fieldset><fieldset class=\"form-group form-menu-solide\" ng-repeat=\"(parent, enfants) in main.solide | groupBy:\'field_type_de_solide\'\"><uib-accordion><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"$first\"><uib-accordion-heading>{{ parent }}<i class=\"pull-right glyphicon glyphicon-chevron-down\"></i></uib-accordion-heading><div ng-repeat=\"enfant in enfants\" class=\"col-sm-3 solide-menu\"><div class=\"checkbox\" ng-if=\"main.choiceFormule == 1\"><input type=\"radio\" name=\"solide1\" id=\"solide1\" value=\"{{enfant.name}}\" ng-model=\"main.brief.solide1[parent][$index].name\" ng-change=\"main.solideChange(main.brief.solide1[parent][$index], parent, enfant, $index)\"> <label class=\"label-solide-menu\"><img ng-src=\"{{ enfant.field_image_visuel_solide }}\" alt=\"{{enfant.name}}\" title=\"{{enfant.name}}\" width=\"100%\" class=\"img-solide-menu\"><div class=\"name-solide-menu\"><span class=\"name\">{{ enfant.name }}</span> <span class=\"custom-check\"></span></div></label></div><div class=\"checkbox\" ng-if=\"main.choiceFormule == 2\"><input type=\"radio\" name=\"solide2\" id=\"solide2\" value=\"{{enfant.name}}\" ng-model=\"main.brief.solide2[parent][$index].name\" ng-change=\"main.solideChange(main.brief.solide2[parent][$index], parent, enfant, $index)\"> <label class=\"label-solide-menu\"><img ng-src=\"{{ enfant.field_image_visuel_solide }}\" alt=\"{{enfant.name}}\" title=\"{{enfant.name}}\" width=\"100%\" class=\"img-solide-menu\"><div class=\"name-solide-menu\"><span class=\"name\">{{ enfant.name }}</span> <span class=\"custom-check\"></span></div></label></div></div></div></uib-accordion></fieldset><div class=\"col-sm-12 text-center suivant\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.cancel()\">Annuler <span class=\"glyphicon glyphicon-remove-sign\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save()\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(doublepet2)\"><span class=\"glyphicon glyphicon-ok-sign\" aria-hidden=\"true\"></span> Valider</a></div></form></div>");
$templateCache.put("app/vae/vae-03-contenu/vae-33-contenu_menu-double-2x3-items/vae-33-contenu_menu-double-2x3-items.html","<div class=\"container text-center simple-pet-2-items double-pet-23-items\"><form class=\"form-horizontal form-menu-dp-23-items\" name=\"doublepet3\"><h2>Renseigner le contenu du board menu</h2><h3 id=\"errorMenu2Items\">{{ main.board.data.displayName }}</h3><div class=\"error-msg text-left\"><p ng-if=\"main.submitted && doublepet3.$invalid\">Veuillez remplir les champs obligatoire.</p><p ng-if=\"main.submitted && main.checked < 4\">Le choix de quatres solides est obligatoire. Deux pour chaque formule.</p></div><fieldset class=\"row group-data-menu\"><div class=\"part-left col-sm-8\"><div class=\"row\"><h4 class=\"col-sm-offset-2 col-sm-6\">Formule 1</h4></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet3.nomformule1.$invalid]\"><label for=\"nomformule1\" class=\"col-sm-6 control-label\">NOM DE LA FORMULE&#8239;1&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" placeholder=\"Exemple : formule sandwich\" name=\"nomformule1\" class=\"form-control\" id=\"nomformule1\" ng-model=\"main.brief.Formule1.nomFormule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && doublepet3.nomformule1.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet3.nomsolide11.$invalid]\"><label for=\"nomsolide11\" class=\"col-sm-6 control-label\">NOM DU SOLIDE&#8239;1.1&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" name=\"nomsolide11\" class=\"form-control\" id=\"nomsolide11\" ng-model=\"main.brief.Formule1.nomsolide1\" required=\"\" placeholder=\"Exemple: un sandwich\" ng-class=\"{true: \'error\'}[main.submitted && doublepet3.nomsolide11.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet3.nomsolide12.$invalid]\"><label for=\"nomsolide12\" class=\"col-sm-6 control-label\">NOM DU SOLIDE&#8239;1.2&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" name=\"nomsolide12\" class=\"form-control\" id=\"nomsolide12\" ng-model=\"main.brief.Formule1.nomsolide2\" required=\"\" placeholder=\"Exemple: un sandwich\" ng-class=\"{true: \'error\'}[main.submitted && doublepet3.nomsolide12.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet3.prixformule1.$invalid]\"><label for=\"prixformule1\" class=\"col-sm-6 control-label\">PRIX DE LA FORMULE&#8239;1&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixformule1\" class=\"form-control\" id=\"prixformule1\" ng-model=\"main.brief.Formule1.prixformule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && doublepet3.prixformule1.$invalid]\"></div></div><div class=\"form-group row\"><label for=\"prixbarre1\" class=\"col-sm-6 control-label\">PRIX BARRÉ&#8239;1&#8239;:</label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixbarre1\" class=\"form-control\" id=\"prixbarre1\" ng-model=\"main.brief.Formule1.prixbarre\"></div></div><div class=\"form-group row\"><label for=\"prixAutreFormule1\" class=\"col-sm-6 control-label\">{{ main.labelPrixAutreFormule }}&#8239;1&#8239;:<br><span class=\"help-block text-optionnel\">Optionnel</span></label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixAutreFormule1\" class=\"form-control\" id=\"prixAutreFormule1\" ng-model=\"main.brief.Formule1.prixAutreFormule\"></div></div><hr><div class=\"row\"><h4 class=\"col-sm-offset-2 col-sm-6\">Formule 2</h4></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet3.nomformule2.$invalid]\"><label for=\"nomformule2\" class=\"col-sm-6 control-label\">NOM DE LA FORMULE&#8239;2&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" placeholder=\"Exemple : formule sandwich\" name=\"nomformule2\" class=\"form-control\" id=\"nomformule2\" ng-model=\"main.brief.Formule2.nomFormule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && doublepet3.nomformule2.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet3.nomsolide21.$invalid]\"><label for=\"nomsolide21\" class=\"col-sm-6 control-label\">NOM DU SOLIDE&#8239;2.1&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" name=\"nomsolide21\" class=\"form-control\" id=\"nomsolide21\" ng-model=\"main.brief.Formule2.nomsolide1\" required=\"\" placeholder=\"Exemple: un sandwich\" ng-class=\"{true: \'error\'}[main.submitted && doublepet3.nomsolide21.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet3.nomsolide22.$invalid]\"><label for=\"nomsolide22\" class=\"col-sm-6 control-label\">NOM DU SOLIDE&#8239;2.2&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" name=\"nomsolide22\" class=\"form-control\" id=\"nomsolide22\" ng-model=\"main.brief.Formule2.nomsolide2\" required=\"\" placeholder=\"Exemple: un sandwich\" ng-class=\"{true: \'error\'}[main.submitted && doublepet3.nomsolide22.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet3.prixformule2.$invalid]\"><label for=\"prixformule2\" class=\"col-sm-6 control-label\">PRIX DE LA FORMULE&#8239;2&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixformule2\" class=\"form-control\" id=\"prixformule2\" ng-model=\"main.brief.Formule2.prixformule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && doublepet3.prixformule2.$invalid]\"></div></div><div class=\"form-group row\"><label for=\"prixbarre2\" class=\"col-sm-6 control-label\">PRIX BARRÉ&#8239;2&#8239;:</label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixbarre2\" class=\"form-control\" id=\"prixbarre2\" ng-model=\"main.brief.Formule2.prixbarre\"></div></div><div class=\"form-group row\"><label for=\"prixAutreFormule2\" class=\"col-sm-6 control-label\">{{ main.labelPrixAutreFormule }}&#8239;2&#8239;:<br><span class=\"help-block text-optionnel\">Optionnel</span></label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixAutreFormule2\" class=\"form-control\" id=\"prixAutreFormule2\" ng-model=\"main.brief.Formule2.prixAutreFormule\"></div></div></div><div class=\"part-right col-sm-3\"><img ng-src=\"{{ main.board.data.imageBoard }}\" alt=\"{{ main.board.data.displayName }}\"> <span class=\"help-block\">Visuel Illustratif</span></div></fieldset><span class=\"help-block text-uppercase\">Sélectionner le(s) visuel(s) de solides à intégrer.</span><fieldset class=\"switch-solide-choice\"><p>Choisir la formule à laquelle ajouter des visuels des solides associés.</p><div class=\"col-sm-12\"><a class=\"btn btn-default solides-formule\" ng-class=\"{true: \'formule-active\'}[main.choiceFormule == 1]\" ng-click=\"main.switchSolideFormule(1)\">Solides de la formule 1</a> <a class=\"btn btn-default solides-formule\" ng-class=\"{true: \'formule-active\'}[main.choiceFormule == 2]\" ng-click=\"main.switchSolideFormule(2)\">Solides de la formule 2</a></div><p class=\"help-block col-sm-12 text-center\">{{ main.texteChoiceSolide }}</p></fieldset><fieldset class=\"form-group form-menu-solide\" ng-repeat=\"(parent, enfants) in main.solide | groupBy:\'field_type_de_solide\'\"><uib-accordion><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"$first\"><uib-accordion-heading>{{ parent }}<i class=\"pull-right glyphicon glyphicon-chevron-down\"></i></uib-accordion-heading><div ng-repeat=\"enfant in enfants\" class=\"col-sm-3 solide-menu\"><div class=\"checkbox\" ng-if=\"main.choiceFormule == 1\"><input type=\"checkbox\" name=\"solide1\" id=\"solide1\" ng-true-value=\"\'{{enfant.name}}\'\" ng-model=\"main.brief.solide1[parent][$index].name\" ng-change=\"main.solideChange(main.brief.solide1[parent][$index], parent, enfant, $index)\" ng-disabled=\"main.checked1 == main.limit && main.brief.solide1[parent][$index] == undefined\"> <label class=\"label-solide-menu\"><img ng-src=\"{{ enfant.field_image_visuel_solide }}\" alt=\"{{enfant.name}}\" title=\"{{enfant.name}}\" width=\"100%\" class=\"img-solide-menu\"><div class=\"name-solide-menu\"><span class=\"name\">{{ enfant.name }}</span> <span class=\"custom-check\"></span></div></label></div><div class=\"checkbox\" ng-if=\"main.choiceFormule == 2\"><input type=\"checkbox\" name=\"solide2\" id=\"solide2\" ng-true-value=\"\'{{enfant.name}}\'\" ng-model=\"main.brief.solide2[parent][$index].name\" ng-change=\"main.solideChange(main.brief.solide2[parent][$index], parent, enfant, $index)\" ng-disabled=\"main.checked2 == main.limit && main.brief.solide2[parent][$index] == undefined\"> <label class=\"label-solide-menu\"><img ng-src=\"{{ enfant.field_image_visuel_solide }}\" alt=\"{{enfant.name}}\" title=\"{{enfant.name}}\" width=\"100%\" class=\"img-solide-menu\"><div class=\"name-solide-menu\"><span class=\"name\">{{ enfant.name }}</span> <span class=\"custom-check\"></span></div></label></div></div></div></uib-accordion></fieldset><div class=\"col-sm-12 text-center suivant\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.cancel()\">Annuler <span class=\"glyphicon glyphicon-remove-sign\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save()\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(doublepet3)\"><span class=\"glyphicon glyphicon-ok-sign\" aria-hidden=\"true\"></span> Valider</a></div></form></div>");
$templateCache.put("app/vae/vae-03-contenu/vae-33-contenu_menu-simple-3-items/vae-33-contenu_menu-simple-3-items.html","<div class=\"container text-center simple-pet-2-items simple-3-items\"><form class=\"form-horizontal form-menu-sp-2-items form-menu-simple-3-items\" name=\"simple3\"><h2>Renseigner le contenu du board menu</h2><h3 id=\"errorFormule\">{{ main.board.data.displayName }}</h3><div class=\"error-msg text-left\"><p ng-if=\"main.submitted && simple3.$invalid\">Veuillez remplir les champs obligatoire.</p><p ng-if=\"main.submitted && main.checked < 2\">Le choix de deux solides est obligatoire.</p></div><fieldset class=\"row group-data-menu\"><div class=\"part-left col-sm-8\"><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && simple3.nomformule.$invalid]\"><label for=\"nomformule\" class=\"col-sm-6 control-label\">NOM DE LA FORMULE&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" required=\"\" name=\"nomformule\" class=\"form-control\" id=\"nomformule\" ng-model=\"main.brief.nomFormule\" placeholder=\"Exemple : formule sandwich\" ng-class=\"{true: \'error\'}[main.submitted && simple3.nomformule.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && simple3.nomsolide.$invalid]\"><label for=\"nomsolide\" class=\"col-sm-6 control-label\">NOM DU SOLIDE 1&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" name=\"nomsolide\" class=\"form-control\" id=\"nomsolide\" required=\"\" ng-model=\"main.brief.nomsolide\" placeholder=\"Exemple: un sandwich\" ng-class=\"{true: \'error\'}[main.submitted && simple3.nomsolide.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && simple3.nomsolide.$invalid]\"><label for=\"nomsolide\" class=\"col-sm-6 control-label\">NOM DU SOLIDE 2&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" name=\"nomsolidebis\" class=\"form-control\" id=\"nomsolidebis\" required=\"\" ng-model=\"main.brief.nomsolidebis\" placeholder=\"Exemple: un sandwich\" ng-class=\"{true: \'error\'}[main.submitted && simple3.nomsolidebis.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && simple3.prixformule.$invalid]\"><label for=\"nomsolide\" class=\"col-sm-6 control-label\">PRIX DE LA FORMULE&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixformule\" class=\"form-control\" id=\"prixformule\" ng-model=\"main.brief.prixformule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && simple3.prixformule.$invalid]\"></div></div><div class=\"form-group row\"><label for=\"prixbarre\" class=\"col-sm-6 control-label\">PRIX BARRÉ&#8239;:</label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixbarre\" class=\"form-control\" id=\"prixbarre\" ng-model=\"main.brief.prixbarre\"></div></div><div class=\"form-group row\" ng-if=\"!main.sansOption\"><label for=\"prixAutreFormule\" class=\"col-sm-6 control-label\">{{ main.labelPrixAutreFormule }}&#8239;:<br><span class=\"help-block text-optionnel\">Optionnel</span></label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixAutreFormule\" class=\"form-control\" id=\"prixAutreFormule\" ng-model=\"main.brief.prixAutreFormule\"></div></div></div><div class=\"part-right col-sm-3\"><img ng-src=\"{{ main.board.data.imageBoard }}\" alt=\"{{ main.board.data.displayName }}\"> <span class=\"help-block\">Visuel Illustratif</span></div></fieldset><span class=\"help-block text-uppercase\">Sélectionner le(s) visuel(s) de solides à intégrer.</span><fieldset class=\"form-group form-menu-solide\" ng-repeat=\"(parent, enfants) in main.solide | groupBy:\'field_type_de_solide\'\"><uib-accordion><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"$first\"><uib-accordion-heading>{{ parent }}<i class=\"pull-right glyphicon glyphicon-chevron-down\"></i></uib-accordion-heading><div ng-repeat=\"enfant in enfants\" class=\"col-sm-3 solide-menu\"><div class=\"checkbox\"><input type=\"checkbox\" name=\"solide{{$index}}\" id=\"solide{{$index}}\" ng-true-value=\"\'{{enfant.name}}\'\" ng-model=\"main.brief.solide[parent][$index].name\" ng-change=\"main.solideChange(main.brief.solide[parent][$index], parent, enfant, $index)\" ng-disabled=\"main.checked == main.limit && main.brief.solide[parent][$index] == undefined\"> <label class=\"label-solide-menu\"><img ng-src=\"{{ enfant.field_image_visuel_solide }}\" alt=\"{{enfant.name}}\" title=\"{{enfant.name}}\" width=\"100%\" class=\"img-solide-menu\"><div class=\"name-solide-menu\"><span class=\"name\">{{ enfant.name }}</span> <span class=\"custom-check\"></span></div></label></div></div></div></uib-accordion></fieldset><div class=\"col-sm-12 text-center\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.cancel()\">Annuler <span class=\"glyphicon glyphicon-remove-sign\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save()\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(simple3)\"><span class=\"glyphicon glyphicon-ok-sign\" aria-hidden=\"true\"></span> Valider</a></div></form></div>");
$templateCache.put("app/vae/vae-03-contenu/vae-33-contenu_menu-simple-pet-2-items/vae-33-contenu_menu-simple-pet-2-items.html","<div class=\"container text-center simple-pet-2-items\"><form class=\"form-horizontal form-menu-sp-2-items\" name=\"simplepet2\"><h2>Renseigner le contenu du board menu</h2><h3 id=\"errorMenu2Items\">{{ main.board.data.displayName }}</h3><fieldset class=\"row group-data-menu\"><div class=\"part-left col-sm-8\"><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && simplepet2.nomformule.$invalid]\"><label for=\"nomformule\" class=\"col-sm-6 control-label\">NOM DE LA FORMULE&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" placeholder=\"Exemple : formule sandwich\" name=\"nomformule\" class=\"form-control\" id=\"nomformule\" ng-model=\"main.brief.nomFormule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && simplepet2.nomformule.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && simplepet2.nomsolide.$invalid]\"><label for=\"nomsolide\" class=\"col-sm-6 control-label\">NOM DU SOLIDE&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" name=\"nomsolide\" class=\"form-control\" id=\"nomsolide\" ng-model=\"main.brief.nomsolide\" required=\"\" placeholder=\"Exemple: un sandwich\" ng-class=\"{true: \'error\'}[main.submitted && simplepet2.nomsolide.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && simplepet2.prixformule.$invalid]\"><label for=\"nomsolide\" class=\"col-sm-6 control-label\">PRIX DE LA FORMULE&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixformule\" class=\"form-control\" id=\"prixformule\" ng-model=\"main.brief.prixformule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && simplepet2.prixformule.$invalid]\"></div></div><div class=\"form-group row\"><label for=\"prixbarre\" class=\"col-sm-6 control-label\">PRIX BARRÉ&#8239;:</label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixbarre\" class=\"form-control\" id=\"prixbarre\" ng-model=\"main.brief.prixbarre\"></div></div><div class=\"form-group row\" ng-if=\"!main.isCapri\"><label for=\"prixAutreFormule\" class=\"col-sm-6 control-label\">{{ main.labelPrixAutreFormule }}&#8239;:<br><span class=\"help-block text-optionnel\">Optionnel</span></label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixAutreFormule\" class=\"form-control\" id=\"prixAutreFormule\" ng-model=\"main.brief.prixAutreFormule\"></div></div></div><div class=\"part-right col-sm-3\"><img ng-src=\"{{ main.board.data.imageBoard }}\" alt=\"{{ main.board.data.displayName }}\"> <span class=\"help-block\">Visuel Illustratif</span></div></fieldset><div ng-if=\"main.submitted && simplepet2.solide.$invalid\" class=\"error-msg text-left\">Le choix d\'un solide est obligatoire</div><span class=\"help-block text-uppercase\">Sélectionner le(s) visuel(s) de solides à intégrer.</span><fieldset class=\"form-group form-menu-solide\" ng-repeat=\"(parent, enfants) in main.solide | groupBy:\'field_type_de_solide\'\"><uib-accordion><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"$first\"><uib-accordion-heading>{{ parent }}<i class=\"pull-right glyphicon glyphicon-chevron-down\"></i></uib-accordion-heading><div ng-repeat=\"enfant in enfants\" class=\"col-sm-3 solide-menu\"><div class=\"checkbox\"><input type=\"radio\" name=\"solide\" id=\"solide\" value=\"{{enfant.name}}\" ng-model=\"main.brief.nameSolide\" ng-change=\"main.solideChange(enfant.field_image_visuel_solide)\" required=\"\"> <label class=\"label-solide-menu\"><img ng-src=\"{{ enfant.field_image_visuel_solide }}\" alt=\"{{enfant.name}}\" title=\"{{enfant.name}}\" width=\"100%\" class=\"img-solide-menu\"><div class=\"name-solide-menu\"><span class=\"name\">{{ enfant.name }}</span> <span class=\"custom-check\"></span></div></label></div></div></div></uib-accordion></fieldset><div class=\"col-sm-12 text-center suivant\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.cancel()\">Annuler <span class=\"glyphicon glyphicon-remove-sign\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save()\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(simplepet2)\"><span class=\"glyphicon glyphicon-ok-sign\" aria-hidden=\"true\"></span> Valider</a></div></form></div>");
$templateCache.put("app/vae/vae-03-contenu/vae-33-contenu_menu-standard-2018/vae-33-contenu_menu-standard-2018.html","<div class=\"container text-center simple-pet-2-items double-pet-22-items\"><form class=\"form-horizontal form-menu-sp-2-items\" name=\"doublepet2\"><h2>Renseigner le contenu du board menu</h2><h3 id=\"errorMenu2Items\">{{ main.board.data.displayName }}</h3><div class=\"error-msg text-left\"><p ng-if=\"main.submitted && doublepet2.$invalid\">Veuillez remplir les champs obligatoire.</p><p ng-if=\"main.submitted && doublepet2.solid1_nok\">Veuillez sélectionner le solide de la formule.</p><p ng-if=\"main.submitted && doublepet2.solid2_nok\">Veuillez sélectionner le solide 2 de la formule.</p></div><fieldset class=\"row group-data-menu\"><div class=\"part-left col-sm-8\"><div class=\"row\"><h4 class=\"col-sm-offset-2 col-sm-6\">Formule</h4></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet2.nomformule1.$invalid]\"><label for=\"nomformule1\" class=\"col-sm-6 control-label\">NOM DE LA FORMULE&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" placeholder=\"Exemple : formule sandwich\" name=\"nomformule1\" class=\"form-control\" id=\"nomformule1\" ng-model=\"main.brief.Formule1.nomFormule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && doublepet2.nomformule1.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet2.nomsolide1.$invalid]\"><label for=\"nomsolide1\" class=\"col-sm-6 control-label\">NOM DU SOLIDE&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" name=\"nomsolide1\" class=\"form-control\" id=\"nomsolide1\" ng-model=\"main.brief.Formule1.nomsolide\" required=\"\" placeholder=\"Exemple: un sandwich\" ng-class=\"{true: \'error\'}[main.submitted && doublepet2.nomsolide1.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet2.prixformule1.$invalid]\"><label for=\"prixformule1\" class=\"col-sm-6 control-label\">PRIX DE LA FORMULE&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixformule1\" class=\"form-control\" id=\"prixformule1\" ng-model=\"main.brief.Formule1.prixformule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && doublepet2.prixformule1.$invalid]\"></div></div><hr><div class=\"row form-group\"><div class=\"checkbox checkbox-custom second-menu\"><input type=\"checkbox\" name=\"optionFormule2\" id=\"optionFormule2\" ng-model=\"main.formule2Enabled\" ng-change=\"main.toogleFormule2(main.formule2Enabled)\"><label><span>2ième solide optionnel</span></label></div></div><div ng-if=\"main.brief.Formule2\"><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet2.nomsolide2.$invalid]\"><label for=\"nomsolide2\" class=\"col-sm-6 control-label\">NOM DU SOLIDE&#8239;2&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"text\" name=\"nomsolide2\" class=\"form-control\" id=\"nomsolide2\" ng-model=\"main.brief.Formule2.nomsolide\" required=\"\" placeholder=\"Exemple: un sandwich\" ng-class=\"{true: \'error\'}[main.submitted && doublepet2.nomsolide2.$invalid]\"></div></div><div class=\"form-group row\" ng-class=\"{true: \'error-msg\'}[main.submitted && doublepet2.prixformule2.$invalid]\"><label for=\"prixformule2\" class=\"col-sm-6 control-label\">PRIX DU SUPPLEMENT SOLIDE&#8239;2&#8239;*&#8239;:</label><div class=\"col-sm-6\"><input type=\"tel\" name=\"prixformule2\" class=\"form-control\" id=\"prixformule2\" ng-model=\"main.brief.Formule2.prixformule\" required=\"\" ng-class=\"{true: \'error\'}[main.submitted && doublepet2.prixformule2.$invalid]\"></div></div></div></div><div class=\"part-right col-sm-3\"><img ng-src=\"{{ main.board.data.imageBoard }}\" alt=\"{{ main.board.data.displayName }}\"> <span class=\"help-block\">Visuel Illustratif</span></div></fieldset><span class=\"help-block text-uppercase\">Sélectionner le(s) visuel(s) de solides à intégrer.</span><fieldset class=\"switch-solide-choice\" ng-if=\"main.brief.Formule2\"><p>Choisir la formule à laquelle ajouter le visuel du solide associé.</p><div class=\"col-sm-12\"><a class=\"btn btn-default solides-formule\" ng-class=\"{true: \'formule-active\'}[main.choiceFormule == 1]\" ng-click=\"main.switchSolideFormule(1)\">solide formule</a> <a class=\"btn btn-default solides-formule\" ng-class=\"{true: \'formule-active\'}[main.choiceFormule == 2]\" ng-click=\"main.switchSolideFormule(2)\">solide supplément</a></div><p class=\"help-block col-sm-12 text-center\">{{ main.texteChoiceSolide }}</p></fieldset><fieldset class=\"form-group form-menu-solide\" ng-repeat=\"(parent, enfants) in main.solide | groupBy:\'field_type_de_solide\'\"><uib-accordion><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"$first\"><uib-accordion-heading>{{ parent }}<i class=\"pull-right glyphicon glyphicon-chevron-down\"></i></uib-accordion-heading><div ng-repeat=\"enfant in enfants\" class=\"col-sm-3 solide-menu\"><div class=\"checkbox\" ng-if=\"main.choiceFormule == 1\"><input type=\"radio\" name=\"solide1\" id=\"solide1\" value=\"{{enfant.name}}\" ng-model=\"main.brief.solide1[parent][$index].name\" ng-change=\"main.solideChange(main.brief.solide1[parent][$index], parent, enfant, $index)\"> <label class=\"label-solide-menu\"><img ng-src=\"{{ enfant.field_image_visuel_solide }}\" alt=\"{{enfant.name}}\" title=\"{{enfant.name}}\" width=\"100%\" class=\"img-solide-menu\"><div class=\"name-solide-menu\"><span class=\"name\">{{ enfant.name }}</span> <span class=\"custom-check\"></span></div></label></div><div class=\"checkbox\" ng-if=\"main.choiceFormule == 2\"><input type=\"radio\" name=\"solide2\" id=\"solide2\" value=\"{{enfant.name}}\" ng-model=\"main.brief.solide2[parent][$index].name\" ng-change=\"main.solideChange(main.brief.solide2[parent][$index], parent, enfant, $index)\"> <label class=\"label-solide-menu\"><img ng-src=\"{{ enfant.field_image_visuel_solide }}\" alt=\"{{enfant.name}}\" title=\"{{enfant.name}}\" width=\"100%\" class=\"img-solide-menu\"><div class=\"name-solide-menu\"><span class=\"name\">{{ enfant.name }}</span> <span class=\"custom-check\"></span></div></label></div></div></div></uib-accordion></fieldset><div class=\"col-sm-12 text-center suivant\"><a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.cancel()\">Annuler <span class=\"glyphicon glyphicon-remove-sign\" aria-hidden=\"true\"></span></a> <a type=\"submit\" class=\"btn btn-default btn-lg btn-clear\" href=\"\" ng-click=\"main.save()\" ng-if=\"main.updateProject\"><span class=\"glyphicon glyphicon-floppy-disk\" aria-hidden=\"true\"></span> Enregistrer</a> <a type=\"submit\" class=\"btn btn-default btn-lg\" href=\"\" ng-click=\"main.validate(doublepet2)\"><span class=\"glyphicon glyphicon-ok-sign\" aria-hidden=\"true\"></span> Valider</a></div></form></div>");}]);